/* @ds-bundle: {"format":4,"namespace":"OnePrintGalleryDesignSystem_ba4735","components":[{"name":"ArtworkCard","sourcePath":"components/commerce/ArtworkCard.jsx"},{"name":"CartDrawer","sourcePath":"components/commerce/CartDrawer.jsx"},{"name":"PersonalisationStepper","sourcePath":"components/commerce/PersonalisationStepper.jsx"},{"name":"PriceOptionsPanel","sourcePath":"components/commerce/PriceOptionsPanel.jsx"},{"name":"ProductCard","sourcePath":"components/commerce/ProductCard.jsx"},{"name":"StickyProductCTA","sourcePath":"components/commerce/StickyProductCTA.jsx"},{"name":"Badge","sourcePath":"components/core/Badge.jsx"},{"name":"BrushRule","sourcePath":"components/core/BrushRule.jsx"},{"name":"Button","sourcePath":"components/core/Button.jsx"},{"name":"Eyebrow","sourcePath":"components/core/Eyebrow.jsx"},{"name":"Icon","sourcePath":"components/core/Icon.jsx"},{"name":"IconButton","sourcePath":"components/core/IconButton.jsx"},{"name":"OneWordmark","sourcePath":"components/core/OneWordmark.jsx"},{"name":"Tag","sourcePath":"components/core/Tag.jsx"},{"name":"TextLink","sourcePath":"components/core/TextLink.jsx"},{"name":"TRANSFORMATIONS","sourcePath":"components/core/brandAssets.jsx"},{"name":"B2B_EXAMPLES","sourcePath":"components/core/brandAssets.jsx"},{"name":"BOOKS","sourcePath":"components/core/brandAssets.jsx"},{"name":"MOCKUPS","sourcePath":"components/core/brandAssets.jsx"},{"name":"ARTWORKS","sourcePath":"components/core/brandAssets.jsx"},{"name":"OBSIDIAN_WALL","sourcePath":"components/core/brandAssets.jsx"},{"name":"LOGO_ROUNDEL","sourcePath":"components/core/brandAssets.jsx"},{"name":"SIGNATURE","sourcePath":"components/core/brandAssets.jsx"},{"name":"REVIEWED","sourcePath":"components/core/commerce.jsx"},{"name":"PRICING","sourcePath":"components/core/commerce.jsx"},{"name":"FULFILMENT","sourcePath":"components/core/commerce.jsx"},{"name":"PHOTO_ALBUM","sourcePath":"components/core/commerce.jsx"},{"name":"ART_PRINTS","sourcePath":"components/core/commerce.jsx"},{"name":"CASE_STUDIES","sourcePath":"components/core/commerce.jsx"},{"name":"SHOP_STATS","sourcePath":"components/core/reviews.jsx"},{"name":"REVIEWS","sourcePath":"components/core/reviews.jsx"},{"name":"AudienceSelector","sourcePath":"components/editorial/AudienceSelector.jsx"},{"name":"EditorialSplit","sourcePath":"components/editorial/EditorialSplit.jsx"},{"name":"FaqAccordion","sourcePath":"components/editorial/FaqAccordion.jsx"},{"name":"FounderFeature","sourcePath":"components/editorial/FounderFeature.jsx"},{"name":"FullBleedBanner","sourcePath":"components/editorial/FullBleedBanner.jsx"},{"name":"Hero","sourcePath":"components/editorial/Hero.jsx"},{"name":"HowItWorksTimeline","sourcePath":"components/editorial/HowItWorksTimeline.jsx"},{"name":"Manifesto","sourcePath":"components/editorial/Manifesto.jsx"},{"name":"TestimonialFeature","sourcePath":"components/editorial/TestimonialFeature.jsx"},{"name":"CookieNotice","sourcePath":"components/feedback/CookieNotice.jsx"},{"name":"EmptyState","sourcePath":"components/feedback/EmptyState.jsx"},{"name":"ErrorState","sourcePath":"components/feedback/ErrorState.jsx"},{"name":"MediaPlaceholder","sourcePath":"components/feedback/MediaPlaceholder.jsx"},{"name":"Skeleton","sourcePath":"components/feedback/Skeleton.jsx"},{"name":"Checkbox","sourcePath":"components/forms/Checkbox.jsx"},{"name":"FormField","sourcePath":"components/forms/FormField.jsx"},{"name":"Input","sourcePath":"components/forms/Input.jsx"},{"name":"NewsletterForm","sourcePath":"components/forms/NewsletterForm.jsx"},{"name":"Radio","sourcePath":"components/forms/Radio.jsx"},{"name":"RadioCard","sourcePath":"components/forms/RadioCard.jsx"},{"name":"Select","sourcePath":"components/forms/Select.jsx"},{"name":"Textarea","sourcePath":"components/forms/Textarea.jsx"},{"name":"AnnouncementBar","sourcePath":"components/navigation/AnnouncementBar.jsx"},{"name":"Footer","sourcePath":"components/navigation/Footer.jsx"},{"name":"Header","sourcePath":"components/navigation/Header.jsx"},{"name":"MobileNav","sourcePath":"components/navigation/MobileNav.jsx"},{"name":"BeforeAfterSlider","sourcePath":"components/transformation/BeforeAfterSlider.jsx"},{"name":"PhotoUploader","sourcePath":"components/transformation/PhotoUploader.jsx"},{"name":"TransformationTriptych","sourcePath":"components/transformation/TransformationTriptych.jsx"}],"sourceHashes":{"components/commerce/ArtworkCard.jsx":"f24048e54271","components/commerce/CartDrawer.jsx":"9514302be316","components/commerce/PersonalisationStepper.jsx":"7d4e60bb59b0","components/commerce/PriceOptionsPanel.jsx":"0c794f11743a","components/commerce/ProductCard.jsx":"532222c7d343","components/commerce/StickyProductCTA.jsx":"a8773f553a9f","components/core/Badge.jsx":"0fbfa42777b1","components/core/BrushRule.jsx":"e99aed4b670e","components/core/Button.jsx":"a422d16482c3","components/core/Eyebrow.jsx":"6a4dd046729b","components/core/Icon.jsx":"a7cb5bbe3234","components/core/IconButton.jsx":"236538a55f3b","components/core/OneWordmark.jsx":"c14faadbee0d","components/core/Tag.jsx":"9e74a86933fa","components/core/TextLink.jsx":"1e8a8b0856a4","components/core/brandAssets.jsx":"df6116453736","components/core/commerce.jsx":"80444e4eefcc","components/core/reviews.jsx":"adbf47fbe550","components/editorial/AudienceSelector.jsx":"7e6e6bf3b9f2","components/editorial/EditorialSplit.jsx":"d929364cfe87","components/editorial/FaqAccordion.jsx":"687810ea743f","components/editorial/FounderFeature.jsx":"55176dd0c112","components/editorial/FullBleedBanner.jsx":"63d115d09a79","components/editorial/Hero.jsx":"74c5d5ad48fd","components/editorial/HowItWorksTimeline.jsx":"00c15b77a250","components/editorial/Manifesto.jsx":"6cb5de7b0bc6","components/editorial/TestimonialFeature.jsx":"b2083e2fdb7b","components/feedback/CookieNotice.jsx":"9e9dd6791f68","components/feedback/EmptyState.jsx":"ce25f706f67e","components/feedback/ErrorState.jsx":"61e0b6736f90","components/feedback/MediaPlaceholder.jsx":"ed1275fe0636","components/feedback/Skeleton.jsx":"b89950167d84","components/forms/Checkbox.jsx":"98e962fbb757","components/forms/FormField.jsx":"b9ac69042514","components/forms/Input.jsx":"d32e71122d8d","components/forms/NewsletterForm.jsx":"ae73894deae4","components/forms/Radio.jsx":"f456878bb93a","components/forms/RadioCard.jsx":"4be91a0f66b6","components/forms/Select.jsx":"2157df95f7b1","components/forms/Textarea.jsx":"e9d001a89e70","components/navigation/AnnouncementBar.jsx":"501bcd57e099","components/navigation/Footer.jsx":"fbd767853be1","components/navigation/Header.jsx":"23dc7951ff0a","components/navigation/MobileNav.jsx":"23ed345aae5e","components/transformation/BeforeAfterSlider.jsx":"e81566f3af55","components/transformation/PhotoUploader.jsx":"19e1d34deee9","components/transformation/TransformationTriptych.jsx":"3e7dbc94bf9c","shopify-theme/assets/opg-theme.js":"419458a78808","ui_kits/builder/Builder.jsx":"5326752f079d","ui_kits/builder/BuilderShell.jsx":"14967912d52a","ui_kits/pitch_deck/ArchitectureSlide.jsx":"d3506e671ebf","ui_kits/pitch_deck/AskSlide.jsx":"dd66e582e931","ui_kits/pitch_deck/BigQuoteSlide.jsx":"c1d918349c1d","ui_kits/pitch_deck/DifferenceSlide.jsx":"bea4ba158149","ui_kits/pitch_deck/FounderSlide.jsx":"6993850a0140","ui_kits/pitch_deck/HeroProductSlide.jsx":"6b02a35f4135","ui_kits/pitch_deck/ProblemSlide.jsx":"a8759d4d7e29","ui_kits/pitch_deck/RoadmapSlide.jsx":"888849bab623","ui_kits/pitch_deck/SectorsSlide.jsx":"abf985cdb4da","ui_kits/pitch_deck/SlideShell.jsx":"c719f25daafc","ui_kits/pitch_deck/TitleSlide.jsx":"d67e9b3a497a","ui_kits/website/CreatePage.jsx":"030c575a5e43","ui_kits/website/Homepage.jsx":"cd9755077d65","ui_kits/website/InfoPages.jsx":"52f4e6e512f8","ui_kits/website/MorePages.jsx":"1ea00a76a107","ui_kits/website/OneOfOneArtPage.jsx":"90e3cce8e377","ui_kits/website/OurStoryPage.jsx":"ee19c62eb648","ui_kits/website/PartnershipsPage.jsx":"ee72f2578ea1","ui_kits/website/PhotoAlbumPage.jsx":"dcbc3dfd797e","ui_kits/website/ProductPage.jsx":"e9ee56fb63cb","ui_kits/website/SectorPages.jsx":"c12e760dc04a","ui_kits/website/Shell.jsx":"4e453eff4036","ui_kits/website/hero/HeroScenes.jsx":"0daf6c2b7aa2","ui_kits/website/hero/animations-v3.jsx":"abf3d2b7d57d","ui_kits/website/hero/tweaks-panel.jsx":"d259e3a86f73","ui_kits/website/tweaks-panel.jsx":"d259e3a86f73"},"inlinedExternals":[],"unexposedExports":[{"name":"announcement","sourcePath":"components/core/commerce.jsx"},{"name":"asset","sourcePath":"components/core/brandAssets.jsx"},{"name":"book","sourcePath":"components/core/brandAssets.jsx"},{"name":"caseStudy","sourcePath":"components/core/commerce.jsx"},{"name":"controlStyle","sourcePath":"components/forms/Input.jsx"},{"name":"review","sourcePath":"components/core/reviews.jsx"},{"name":"transformation","sourcePath":"components/core/brandAssets.jsx"}]} */

(() => {

const __ds_ns = (window.OnePrintGalleryDesignSystem_ba4735 = window.OnePrintGalleryDesignSystem_ba4735 || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/core/Badge.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TONES = {
  edition: {
    background: 'transparent',
    color: 'var(--color-brand)',
    border: 'var(--color-brand)'
  },
  sold: {
    background: 'var(--opg-navy-900)',
    color: 'var(--opg-white)',
    border: 'var(--opg-navy-900)'
  },
  accent: {
    background: 'var(--color-accent)',
    color: 'var(--opg-white)',
    border: 'var(--color-accent)'
  },
  quiet: {
    background: 'var(--opg-paper)',
    color: 'var(--color-text-muted)',
    border: 'var(--color-border)'
  },
  onDark: {
    background: 'transparent',
    color: 'var(--opg-peach-300)',
    border: 'var(--opg-peach-300)'
  }
};
function Badge({
  tone = 'edition',
  children,
  style,
  ...rest
}) {
  const t = TONES[tone] || TONES.edition;
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-block',
      padding: '5px 10px 4px',
      borderRadius: 'var(--radius-xs)',
      background: t.background,
      color: t.color,
      border: `1px solid ${t.border}`,
      fontFamily: 'var(--font-sans)',
      fontSize: '0.6875rem',
      fontWeight: 700,
      letterSpacing: '0.14em',
      textTransform: 'uppercase',
      lineHeight: 1.2,
      whiteSpace: 'nowrap',
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Badge });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Badge.jsx", error: String((e && e.message) || e) }); }

// components/core/BrushRule.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* The only sanctioned use of --gradient-brush: a 2-4px rule. */
function BrushRule({
  thickness = 3,
  width = '100%',
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("span", _extends({
    "aria-hidden": "true",
    style: {
      display: 'block',
      width,
      height: Math.min(4, Math.max(2, thickness)),
      background: 'var(--gradient-brush)',
      borderRadius: 'var(--radius-xs)',
      ...style
    }
  }, rest));
}
Object.assign(__ds_scope, { BrushRule });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/BrushRule.jsx", error: String((e && e.message) || e) }); }

// components/core/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const BASE = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  fontFamily: 'var(--font-sans)',
  fontWeight: 700,
  letterSpacing: 'var(--tracking-button)',
  border: '1px solid transparent',
  borderRadius: 'var(--radius-sm)',
  cursor: 'pointer',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  transition: 'background-color var(--motion-fast) var(--ease-standard),color var(--motion-fast) var(--ease-standard),border-color var(--motion-fast) var(--ease-standard)'
};
const SIZES = {
  sm: {
    minHeight: '40px',
    padding: '0 18px',
    fontSize: '0.875rem'
  },
  md: {
    minHeight: 'var(--control-height)',
    padding: '0 26px',
    fontSize: '0.9375rem'
  },
  lg: {
    minHeight: 'var(--control-height-mobile)',
    padding: '0 32px',
    fontSize: '1rem'
  }
};
const VARIANTS = {
  primary: {
    background: 'var(--color-accent)',
    color: 'var(--opg-white)',
    hover: 'var(--color-accent-hover)'
  },
  secondary: {
    background: 'transparent',
    color: 'var(--color-brand)',
    borderColor: 'var(--color-brand)',
    hoverBg: 'var(--color-brand)',
    hoverColor: 'var(--opg-white)'
  },
  brand: {
    background: 'var(--color-brand)',
    color: 'var(--opg-white)',
    hover: 'var(--color-brand-hover)'
  },
  onDark: {
    background: 'var(--opg-white)',
    color: 'var(--opg-navy-900)',
    hover: 'var(--opg-paper)'
  },
  onDarkGhost: {
    background: 'transparent',
    color: 'var(--opg-white)',
    borderColor: 'var(--color-border-on-dark)',
    hoverBg: 'var(--opg-white)',
    hoverColor: 'var(--opg-navy-900)'
  }
};
function Button({
  variant = 'primary',
  size = 'md',
  href,
  fullWidth,
  disabled,
  loading,
  children,
  onClick,
  type = 'button',
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const v = VARIANTS[variant] || VARIANTS.primary;
  const active = hover && !disabled && !loading;
  const css = {
    ...BASE,
    ...SIZES[size],
    background: active ? v.hoverBg || v.hover || v.background : v.background,
    color: active && v.hoverColor ? v.hoverColor : v.color,
    borderColor: active && v.hoverBg ? v.hoverBg : v.borderColor || 'transparent',
    width: fullWidth ? '100%' : undefined,
    ...(disabled ? {
      background: 'var(--color-border)',
      color: 'var(--color-text-muted)',
      borderColor: 'transparent',
      cursor: 'not-allowed'
    } : null),
    ...(loading ? {
      cursor: 'progress'
    } : null),
    ...style
  };
  const content = loading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spin, null), children) : children;
  const handlers = {
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false)
  };
  if (href && !disabled) return /*#__PURE__*/React.createElement("a", _extends({
    href: href,
    style: css
  }, handlers, rest), content);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: type,
    style: css,
    disabled: disabled || loading,
    onClick: onClick
  }, handlers, rest), content);
}
function Spin() {
  return /*#__PURE__*/React.createElement("span", {
    style: {
      width: 15,
      height: 15,
      borderRadius: '50%',
      border: '1.75px solid currentColor',
      borderTopColor: 'transparent',
      animation: 'opg-spin 700ms linear infinite'
    }
  }, /*#__PURE__*/React.createElement("style", null, '@keyframes opg-spin{to{transform:rotate(360deg)}}'));
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Button.jsx", error: String((e && e.message) || e) }); }

// components/core/Eyebrow.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Eyebrow({
  children,
  onDark,
  accent,
  as = 'p',
  style,
  keep,
  ...rest
}) {
  if (!keep) return null;
  const Tag = as;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: accent ? 'var(--color-accent)' : onDark ? 'var(--opg-peach-300)' : 'var(--color-text-muted)',
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Eyebrow });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Eyebrow.jsx", error: String((e && e.message) || e) }); }

// components/core/Icon.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Lucide path data at 24x24, stroke-based. Only the glyphs listed in
   readme.md ICONOGRAPHY are included — one family, outline only, 1.75px stroke. */
const PATHS = {
  'arrow-right': ['M5 12h14', 'm12 5 7 7-7 7'],
  'arrow-left': ['m12 19-7-7 7-7', 'M19 12H5'],
  'arrow-up-right': ['M7 7h10v10'],
  'chevron-down': ['m6 9 6 6 6-6'],
  'chevron-up': ['m18 15-6-6-6 6'],
  'chevron-right': ['m9 18 6-6-6-6'],
  'chevron-left': ['m15 18-6-6 6-6'],
  x: ['M18 6 6 18', 'm6 6 12 12'],
  menu: ['M4 6h16', 'M4 12h16', 'M4 18h16'],
  search: ['M21 21l-4.34-4.34'],
  'shopping-bag': ['M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z', 'M3 6h18', 'M16 10a4 4 0 0 1-8 0'],
  user: ['M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2'],
  upload: ['M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', 'm17 8-5-5-5 5', 'M12 3v12'],
  image: ['m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21'],
  'trash-2': ['M3 6h18', 'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6', 'M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2', 'M10 11v6', 'M14 11v6'],
  'grip-vertical': [],
  check: ['M20 6 9 17l-5-5'],
  'alert-circle': ['M12 8v4', 'M12 16h.01'],
  loader: ['M12 2v4', 'm16.2 7.8 2.9-2.9', 'M18 12h4', 'm16.2 16.2 2.9 2.9', 'M12 18v4', 'm4.9 19.1 2.9-2.9', 'M2 12h4', 'm4.9 4.9 2.9 2.9'],
  instagram: ['M16.5 7.5v.001'],
  'music-2': ['M9 18V5l12-2v13'],
  tiktok: ['M15 3v11a4 4 0 1 1-4-4', 'M15 3a5 5 0 0 0 5 5'],
  mail: ['m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7'],
  plus: ['M5 12h14', 'M12 5v14'],
  minus: ['M5 12h14'],
  'move-vertical': ['M12 2v20', 'm8 6 4-4 4 4', 'm8 18 4 4 4-4'],
  star: ['M11.5 3.2a.6.6 0 0 1 1 0l2.1 4.4 4.8.7c.5.1.7.7.3 1l-3.5 3.4.8 4.8c.1.5-.4.9-.9.7L12 15.9l-4.3 2.3c-.4.2-.9-.2-.8-.7l.8-4.8-3.5-3.4c-.4-.3-.2-.9.3-1l4.8-.7z'],
  'maximize-2': ['M15 3h6v6', 'M9 21H3v-6', 'M21 3l-7 7', 'M3 21l7-7']
};
const CIRCLES = {
  search: [11, 11, 8],
  'alert-circle': [12, 12, 10],
  user: [12, 7, 4],
  image: [9, 9, 2],
  instagram: [12, 12, 4],
  'music-2': [6, 18, 3]
};
const RECTS = {
  instagram: [2, 2, 20, 20, 5]
};
const DOTS = {
  'grip-vertical': [[9, 5], [9, 12], [9, 19], [15, 5], [15, 12], [15, 19]]
};
function Icon({
  name,
  size = 20,
  strokeWidth = 1.75,
  label,
  style,
  ...rest
}) {
  const paths = PATHS[name];
  if (!paths) return null;
  const c = CIRCLES[name];
  const r = RECTS[name];
  const d = DOTS[name];
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": label ? undefined : true,
    role: label ? 'img' : undefined,
    "aria-label": label,
    style: {
      display: 'block',
      flex: 'none',
      ...style
    }
  }, rest), label ? /*#__PURE__*/React.createElement("title", null, label) : null, r ? /*#__PURE__*/React.createElement("rect", {
    x: r[0],
    y: r[1],
    width: r[2],
    height: r[3],
    rx: r[4]
  }) : null, c ? /*#__PURE__*/React.createElement("circle", {
    cx: c[0],
    cy: c[1],
    r: c[2]
  }) : null, paths.map((p, i) => /*#__PURE__*/React.createElement("path", {
    key: i,
    d: p
  })), d ? d.map(([cx, cy], i) => /*#__PURE__*/React.createElement("circle", {
    key: `d${i}`,
    cx: cx,
    cy: cy,
    r: "1",
    fill: "currentColor",
    stroke: "none"
  })) : null);
}
Object.assign(__ds_scope, { Icon });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Icon.jsx", error: String((e && e.message) || e) }); }

// components/commerce/PersonalisationStepper.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const STEPS = ['Choose', 'Personalise', 'Upload', 'Preview', 'Review'];
function PersonalisationStepper({
  steps = STEPS,
  current = 0,
  onStep,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("nav", _extends({
    "aria-label": "Personalisation progress",
    style: {
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("ol", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px 20px',
      alignItems: 'center'
    }
  }, steps.map((s, i) => {
    const done = i < current;
    const on = i === current;
    return /*#__PURE__*/React.createElement("li", {
      key: s,
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 9
      }
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => onStep && i <= current && onStep(i),
      "aria-current": on ? 'step' : undefined,
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: i <= current && onStep ? 'pointer' : 'default'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        width: 24,
        height: 24,
        borderRadius: '50%',
        display: 'grid',
        placeItems: 'center',
        border: `1px solid ${done || on ? 'var(--color-brand)' : 'var(--color-border-strong)'}`,
        background: done ? 'var(--color-brand)' : 'transparent',
        color: done ? 'var(--opg-white)' : on ? 'var(--color-brand)' : 'var(--color-text-muted)',
        fontFamily: 'var(--font-sans)',
        fontSize: '0.6875rem',
        fontWeight: 700,
        flex: 'none'
      }
    }, done ? /*#__PURE__*/React.createElement(__ds_scope.Icon, {
      name: "check",
      size: 13,
      strokeWidth: 2.4
    }) : i + 1), /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        fontWeight: on ? 700 : 500,
        color: on ? 'var(--color-brand)' : done ? 'var(--color-text)' : 'var(--color-text-muted)'
      }
    }, s)), i < steps.length - 1 ? /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true",
      style: {
        width: 22,
        height: 1,
        background: 'var(--color-border-strong)'
      }
    }) : null);
  })));
}
Object.assign(__ds_scope, { PersonalisationStepper });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/PersonalisationStepper.jsx", error: String((e && e.message) || e) }); }

// components/core/IconButton.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function IconButton({
  label,
  onDark,
  size = 44,
  active,
  children,
  onClick,
  href,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const css = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: size,
    height: size,
    minWidth: 'var(--touch-min)',
    minHeight: 'var(--touch-min)',
    background: 'transparent',
    border: '1px solid transparent',
    borderRadius: 'var(--radius-sm)',
    color: hover || active ? onDark ? 'var(--opg-white)' : 'var(--color-accent)' : onDark ? 'var(--color-text-on-dark-muted)' : 'var(--color-brand)',
    cursor: 'pointer',
    padding: 0,
    textDecoration: 'none',
    transition: 'color var(--motion-fast) var(--ease-standard)',
    ...style
  };
  const handlers = {
    'aria-label': label,
    title: label,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false)
  };
  if (href) return /*#__PURE__*/React.createElement("a", _extends({
    href: href,
    style: css
  }, handlers, rest), children);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    style: css,
    onClick: onClick
  }, handlers, rest), children);
}
Object.assign(__ds_scope, { IconButton });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/IconButton.jsx", error: String((e && e.message) || e) }); }

// components/core/Tag.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TONES = {
  neutral: {
    background: 'transparent',
    color: 'var(--color-text-muted)',
    border: 'var(--color-border-strong)'
  },
  brand: {
    background: 'transparent',
    color: 'var(--color-brand)',
    border: 'var(--color-brand)'
  },
  warm: {
    background: 'var(--color-accent-soft)',
    color: 'var(--opg-burgundy-600)',
    border: 'transparent'
  },
  onDark: {
    background: 'transparent',
    color: 'var(--opg-white)',
    border: 'var(--color-border-on-dark)'
  }
};
function Tag({
  tone = 'neutral',
  children,
  style,
  ...rest
}) {
  const t = TONES[tone] || TONES.neutral;
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '5px 12px',
      borderRadius: 'var(--radius-round)',
      background: t.background,
      color: t.color,
      border: `1px solid ${t.border}`,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 600,
      letterSpacing: '0.04em',
      lineHeight: 1.2,
      whiteSpace: 'nowrap',
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Tag });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Tag.jsx", error: String((e && e.message) || e) }); }

// components/core/TextLink.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function TextLink({
  href = '#',
  onDark,
  size = 'base',
  withArrow,
  children,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  return /*#__PURE__*/React.createElement("a", _extends({
    href: href,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      fontFamily: 'var(--font-sans)',
      fontWeight: 600,
      fontSize: size === 'sm' ? 'var(--text-sm)' : 'var(--text-base)',
      color: onDark ? 'var(--opg-white)' : hover ? 'var(--color-accent)' : 'var(--color-brand)',
      textDecoration: 'underline',
      textDecorationThickness: hover ? '2px' : '1px',
      textDecorationColor: onDark ? hover ? 'var(--opg-peach-300)' : 'var(--color-border-on-dark)' : 'currentColor',
      textUnderlineOffset: '0.22em',
      transition: 'color var(--motion-fast) var(--ease-standard),text-decoration-thickness var(--motion-fast) var(--ease-standard)',
      ...style
    }
  }, rest), children, withArrow ? /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-block',
      transform: hover ? 'translateX(3px)' : 'none',
      transition: 'transform var(--motion-fast) var(--ease-standard)'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "16",
    height: "16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 5 7 7-7 7"
  }))) : null);
}
Object.assign(__ds_scope, { TextLink });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/TextLink.jsx", error: String((e && e.message) || e) }); }

// components/core/brandAssets.jsx
try { (() => {
/* Real brand assets supplied by the shop owner, resolved relative to the page.
   Pages two levels deep (component cards, ui_kits/*, templates/*) need no setup.
   Anything at another depth sets window.OPG_ASSET_BASE before the bundle loads. */
const BASE = () => typeof window !== 'undefined' && window.OPG_ASSET_BASE || OPG_A('../../assets/');
function asset(path) {
  return BASE() + (/\.(png|jpe?g)$/i.test(path) ? 'web/' + path.replace(/\.(png|jpe?g)$/i, '.webp') : path);
}

/* Matched photo -> line-art pairs from real customer orders. */
const TRANSFORMATIONS = [{
  id: 'family',
  title: 'The whole family, cat included',
  before: 'transform/family-before.png',
  after: 'transform/family-after.png'
}, {
  id: 'colouring',
  title: 'Colouring at the dining table',
  before: 'transform/colouring-before.png',
  after: 'transform/colouring-after.png'
}, {
  id: 'baby-cat',
  title: 'Stacking cups, watched closely',
  before: 'transform/baby-cat-before.png',
  after: 'transform/baby-cat-after.png'
}, {
  id: 'football',
  title: 'Saturday morning football',
  before: 'transform/football-before.png',
  after: 'transform/football-after.png'
}, {
  id: 'getting-ready',
  title: 'Getting ready together',
  before: 'transform/getting-ready-before.png',
  after: 'transform/getting-ready-after.png'
}, {
  id: 'wedding',
  title: 'Their wedding day, forty years on',
  before: 'transform/wedding-before.png',
  after: 'transform/wedding-after.png'
}];

/* Partnership examples: schools and care homes. */
const B2B_EXAMPLES = {
  schools: [{
    title: 'Class photo',
    before: 'b2b/school-class-before.png',
    after: 'b2b/school-class-after.png'
  }, {
    title: 'Science lesson',
    before: 'b2b/school-science-before.png',
    after: 'b2b/school-science-after.png'
  }, {
    title: 'School garden',
    before: 'b2b/school-garden-before.png',
    after: 'b2b/school-garden-after.png'
  }],
  care: [{
    title: 'Afternoon tea',
    before: 'b2b/care-nanny-before.png',
    after: 'b2b/care-nanny-after.png',
    cover: 'b2b/care-nanny-cover.png'
  }]
};

/* Finished book covers. */
const BOOKS = [{
  id: 'luna',
  title: 'Adventures of Luna',
  front: 'books/luna-front.png',
  back: 'books/luna-back.png'
}, {
  id: 'jade',
  title: 'Jade’s Family Colouring Book',
  front: 'books/jade-front.png',
  back: 'books/jade-back.png'
}];

/* Supplied lifestyle mockups of a finished book. */
const MOCKUPS = {
  held: 'mockups/luna-held.jpg',
  // child holding the open book, face visible
  flatlay: 'mockups/luna-flatlay.jpg',
  // open spread on a desk, hands only
  beforeAfter: 'mockups/luna-before-after.jpg' // printed photo beside its colouring page
};

/* One-of-One artwork. */
const ARTWORKS = [{
  id: 'see-no-evil',
  title: 'See No Evil',
  collection: 'Highland Cows',
  medium: 'Poster · 24 × 36 in',
  src: 'art/see-no-evil.jpg'
}, {
  id: 'hear-no-evil',
  title: 'Hear No Evil',
  collection: 'Highland Cows',
  medium: 'Canvas · 12 × 18 in',
  src: 'art/hear-no-evil.jpg'
}, {
  id: 'speak-no-evil',
  title: 'Speak No Evil',
  collection: 'Highland Cows',
  medium: 'Poster · 24 × 36 in',
  src: 'art/speak-no-evil.jpg'
}, {
  id: 'highland-trio',
  title: 'See, Hear, Speak No Evil',
  collection: 'Highland Cows',
  medium: '18 × 12 in',
  src: 'art/highland-trio.jpg'
}, {
  id: 'the-boss',
  title: 'The Boss',
  collection: 'The Obsidian Society',
  src: 'art/obsidian-the-boss.jpg'
}, {
  id: 'boardroom',
  title: 'Boardroom',
  collection: 'The Obsidian Society',
  src: 'art/obsidian-boardroom.jpg'
}, {
  id: 'the-detective',
  title: 'The Detective',
  collection: 'The Obsidian Society',
  src: 'art/obsidian-the-detective.jpg'
}, {
  id: 'the-strategist',
  title: 'The Strategist',
  collection: 'The Obsidian Society',
  src: 'art/obsidian-the-strategist.jpg'
}, {
  id: 'the-assassin',
  title: 'The Assassin',
  collection: 'The Obsidian Society',
  src: 'art/obsidian-the-assassin.jpg'
}];
const OBSIDIAN_WALL = 'art/obsidian-society.jpg';
const LOGO_ROUNDEL = 'logo.png';
const SIGNATURE = 'signature.png';
function transformation(id) {
  return TRANSFORMATIONS.find(t => t.id === id) || TRANSFORMATIONS[0];
}
function book(id) {
  return BOOKS.find(b => b.id === id) || BOOKS[0];
}
Object.assign(__ds_scope, { asset, TRANSFORMATIONS, B2B_EXAMPLES, BOOKS, MOCKUPS, ARTWORKS, OBSIDIAN_WALL, LOGO_ROUNDEL, SIGNATURE, transformation, book });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/brandAssets.jsx", error: String((e && e.message) || e) }); }

// components/core/OneWordmark.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* The official circular mark is now the primary identity (doc 01 §18: use the
   supplied artwork unchanged, never redraw it). `mark` picks the lockup:
     'roundel' — artwork only, for tight spaces and favicons
     'lockup'  — artwork + typed name beside it, the default header treatment
     'type'    — type only, the legacy fallback for one-colour contexts */
function OneWordmark({
  size = 24,
  onDark,
  stacked = true,
  mark = 'lockup',
  style,
  ...rest
}) {
  const ink = onDark ? 'var(--opg-white)' : 'var(--color-brand)';
  const sub = onDark ? 'var(--opg-peach-300)' : 'var(--color-accent-warm)';
  const art = /*#__PURE__*/React.createElement("img", {
    src: __ds_scope.asset(__ds_scope.LOGO_ROUNDEL),
    alt: mark === 'roundel' ? 'One Print Gallery' : '',
    style: {
      height: size * (mark === 'roundel' ? 2.1 : 1.85),
      width: 'auto',
      display: 'block',
      flex: '0 0 auto'
    }
  });
  if (mark === 'roundel') return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      ...style
    }
  }, rest), art);
  const type = /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      flexDirection: stacked ? 'column' : 'row',
      alignItems: stacked ? 'flex-start' : 'baseline',
      gap: stacked ? `${size * 0.16}px` : `${size * 0.4}px`,
      lineHeight: 1
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: size,
      letterSpacing: '-0.015em',
      color: ink
    }
  }, "One Print"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontWeight: 700,
      fontSize: Math.max(8, size * 0.31),
      letterSpacing: 'var(--tracking-wordmark)',
      textIndent: 'var(--tracking-wordmark)',
      color: sub
    }
  }, "GALLERY"));
  if (mark === 'type') return /*#__PURE__*/React.createElement("span", _extends({
    "aria-label": "One Print Gallery",
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      textDecoration: 'none',
      ...style
    }
  }, rest), type);
  return /*#__PURE__*/React.createElement("span", _extends({
    "aria-label": "One Print Gallery",
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: size * 0.42,
      textDecoration: 'none',
      ...style
    }
  }, rest), art, type);
}
Object.assign(__ds_scope, { OneWordmark });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/OneWordmark.jsx", error: String((e && e.message) || e) }); }

// components/core/commerce.jsx
try { (() => {
/* Commercial facts read from the public Etsy shop and listings
   (etsy.com/shop/OnePrintGallery) on 21 Sep 2026. Never type a price or a delivery
   promise inline — change it here and every surface follows.
   GBP is the shop's base currency: the A5 10-page listing is £14.99; the rest of the
   ladder is the same listing's option pricing converted at the listing's own rate.
   Re-read the listing when prices move, and update REVIEWED. */
const REVIEWED = '21 Sep 2026';
const PRICING = {
  currency: '£',
  from: '£14.99',
  /* A5 prices, coil bound; A4 (the standard size) is +£3 — A4 10/15/20/25 = £17.99/£22.99/£27.99/£32.99 (Etsy, 27 Sep 2026). One photograph per page. */
  a4Extra: 3,
  pages: [{
    id: 'p10',
    count: 10,
    price: '£14.99'
  }, {
    id: 'p15',
    count: 15,
    price: '£19.99'
  }, {
    id: 'p20',
    count: 20,
    price: '£24.99'
  }, {
    id: 'p25',
    count: 25,
    price: '£29.99'
  }],
  formats: [{
    id: 'a4',
    title: 'A4 · 21 × 29.7 cm',
    description: 'Our standard size. More room for detail on every page, coil bound with a full-colour gloss cover.',
    meta: 'From £17.99'
  }, {
    id: 'a5',
    title: 'A5 · 14.8 × 21 cm',
    description: 'A smaller, travel-friendly size.',
    meta: 'From £14.99'
  }]
};
const FULFILMENT = {
  production: 'Made to order in 2–4 business days',
  shipping: 'Delivery typically 5–7 business days',
  shippingNote: 'Shipping calculated at checkout. Express delivery available.',
  shipsFrom: 'Ships from the United Kingdom',
  returns: 'Because every book is made to order, returns and cancellations are not accepted once production begins.',
  uploads: 'uploads@oneprintgallery.co.uk',
  uploadLimit: 'Every order includes all its photographs, one per page, uploaded before checkout.'
};

/* Personalised Colouring Photo Album — etsy.com/uk/listing/4563715248, read 22 Sep 2026.
   Etsy option ranges resolve exactly to: £24.99 base (A5, coil, 10 spreads)
   + £5 per extra 5 spreads + £5 for A4 + £10 for hardback. */
const PHOTO_ALBUM = {
  id: 'photo-album',
  title: 'Personalised Colouring Photo Album',
  promise: 'Your original photograph on the left, its matching colouring page on the right. Part photo album, part colouring book.',
  from: '£24.99',
  pages: [{
    count: 10
  }, {
    count: 15
  }, {
    count: 20
  }, {
    count: 25
  }, {
    count: 30
  }],
  bindings: [{
    id: 'coil',
    title: 'Coil bound',
    description: 'Opens flat for easy colouring'
  }, {
    id: 'hardback',
    title: 'Hardback',
    description: 'Premium photo-album finish'
  }],
  sizes: [{
    id: 'a4',
    title: 'A4'
  }, {
    id: 'a5',
    title: 'A5'
  }],
  priceFor({
    pages = 10,
    binding = 'coil',
    size = 'a5'
  } = {}) {
    return (24.99 + (pages - 10) / 5 * 5 + (size === 'a4' ? 5 : 0) + (binding === 'hardback' ? 10 : 0)).toFixed(2);
  },
  delivery: 'UK delivery charged at checkout · Ships from the United Kingdom',
  memories: ['Family photographs', 'Children and grandchildren', 'Weddings and anniversaries', 'Birthdays and celebrations', 'Holidays and adventures', 'New babies', 'Mum, Dad, Nan and Grandad', 'Brothers and sisters', 'Best friends', 'Pets', 'Sporting memories', 'School memories', 'Christmas', 'Remembrance photographs', 'Everyday family moments'],
  captions: ['Luna & Teddy', 'Mummy, Daddy, Luna & Ivy', 'Our Wedding Day', 'Summer Holiday 2026', 'The Johnson Family'],
  occasions: ['Birthdays', 'Christmas', "Mother's Day", "Father's Day", 'Weddings', 'Anniversaries', 'Grandparents', 'New parents', 'Retirement', 'Leaving gifts', 'Memory keepsakes'],
  faqs: [{
    q: 'How is this different from the colouring book?',
    a: 'The colouring book replaces each photo with its line art. The album keeps both: your original full-colour photograph on the left, with names or a caption underneath, and its matching colouring page on the right.'
  }, {
    q: 'What photos work best?',
    a: 'Your favourites. Phone snaps, slightly blurred shots, old prints and decades-old pictures all come out really well, so please do not stress about finding the best-quality version.'
  }, {
    q: 'How many photos do I need?',
    a: 'One per spread: 10, 15, 20, 25 or 30. A 10-photo album has 10 photo pages and 10 matching colouring pages.'
  }, {
    q: 'How do I send my photos?',
    a: 'Upload one photo per spread while you personalise your album, in the order you want them to appear. All your photos are needed before checkout, so nothing is held up later.'
  }, {
    q: 'Coil bound or hardback?',
    a: 'Coil bound opens flat, which makes colouring easier. Hardback has the premium feel of a traditional photo album.'
  }, {
    q: 'Can I return it?',
    a: 'Because every album is made from your own photographs, returns and exchanges are not accepted. If anything is wrong with your order, get in touch and we will put it right.'
  }],
  steps: [{
    title: 'Choose size and binding',
    body: 'A5 or A4, coil bound or hardback.'
  }, {
    title: 'Choose your photo count',
    body: '10, 15, 20, 25 or 30 spreads. Every photo gets its own colouring page.'
  }, {
    title: 'Add your personalisation',
    body: 'Your cover title, plus the names or a short caption under each photo.'
  }, {
    title: 'Send your photographs',
    body: 'Upload with your order, in the order you want them to appear.'
  }, {
    title: 'We create your album',
    body: 'Each photo is redrawn as line art and the album is prepared for print.'
  }]
};

/* Art prints — Highland Cows and The Obsidian Society. Size ladder read from
   etsy.com/uk/listing/4454937534 and /4452483319 on 22 Sep 2026 (identical ladders). */
const ART_PRINTS = {
  from: '£19.99',
  sizes: [{
    id: '12x18',
    title: '12 × 18 in',
    price: '£19.99'
  }, {
    id: '16x20',
    title: '16 × 20 in',
    price: '£24.99'
  }, {
    id: '18x24',
    title: '18 × 24 in',
    price: '£29.99'
  }, {
    id: '24x36',
    title: '24 × 36 in',
    price: '£34.99'
  }],
  sizeRange: '12 × 18 to 24 × 36 in',
  paper: 'Premium 200gsm semi-gloss silk paper, UV-ink printed',
  delivery: 'Typically arrives in 4–14 days',
  note: 'Frame not included.'
};
const announcement = () => `${FULFILMENT.production} · ${FULFILMENT.shipping}`;

/* Verified B2B work. Only entries the brand owner has confirmed permission for. */
const CASE_STUDIES = [{
  id: 'the-willows',
  audience: 'schools',
  client: 'The Willows',
  descriptor: 'Specialist SEN school, Hayes',
  headline: 'Ordered 50. Came back for 150 more.',
  body: 'The Willows commissioned a personalised colouring book built around their own school: its people, its spaces, the things pupils recognise. They ordered 50 copies, and after seeing them reordered a further 150.',
  metrics: [{
    value: '50',
    label: 'First order'
  }, {
    value: '150',
    label: 'Reorder'
  }],
  quote: 'I highly recommend this company for any educational or custom printing needs. They recently produced a bespoke, individualised colouring book for our school, and it has been a massive hit with staff, parents, and students alike. Seeing our school’s unique landmarks and ethos turned into beautiful illustrations was wonderful. The customer service was exceptional, updates were transparent, and delivery was prompt. It’s rare to find a business that blends high-quality manufacturing with such personal, attentive service.',
  quoteBy: 'Malcolm Shaw',
  quoteRole: 'Headteacher, The Willows',
  status: 'Testimonial and name used with permission.'
}];
function caseStudy(audience) {
  return CASE_STUDIES.find(c => c.audience === audience);
}
Object.assign(__ds_scope, { REVIEWED, PRICING, FULFILMENT, PHOTO_ALBUM, ART_PRINTS, announcement, CASE_STUDIES, caseStudy });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/commerce.jsx", error: String((e && e.message) || e) }); }

// components/commerce/StickyProductCTA.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Appears on mobile after the customer scrolls past the hero / product media. */
function StickyProductCTA({
  title = 'Personalised Photo Colouring Book',
  price = `From ${__ds_scope.PRICING.from}`,
  ctaLabel = 'Start Personalising',
  onCta,
  style,
  ...rest
}) {
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    const f = () => setShow(window.matchMedia('(max-width:1024px)').matches && window.scrollY > 700);
    f();
    window.addEventListener('scroll', f, { passive: true });
    window.addEventListener('resize', f);
    return () => { window.removeEventListener('scroll', f); window.removeEventListener('resize', f); };
  }, []);
  if (!show) return null;
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      position: 'sticky',
      bottom: 0,
      zIndex: 'var(--z-sticky)',
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--space-4)',
      padding: '12px var(--gutter)',
      background: 'var(--opg-white)',
      borderTop: '1px solid var(--color-border)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 0,
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, title), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, price)), /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "primary",
    size: "lg",
    onClick: onCta
  }, ctaLabel));
}
Object.assign(__ds_scope, { StickyProductCTA });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/StickyProductCTA.jsx", error: String((e && e.message) || e) }); }

// components/core/reviews.jsx
try { (() => {
/* Verified reviews from the One Print Gallery Etsy shop (etsy.com/shop/OnePrintGallery).
   Read from the public shop page on 21 Sep 2026. Shop stats at that date:
   5.0 average from 50 reviews, 201 sales, Star Seller, trading since 2025. */
const SHOP_STATS = {
  rating: 5.0,
  reviewCount: 50,
  sales: 201,
  starSeller: true,
  since: 2025,
  location: 'London, United Kingdom'
};
const REVIEWS = [{
  quote: 'Amazing quality and looks incredible, even better than I could have imagined — the designer was constantly messaging me for design input and changes.',
  attribution: 'Nathan',
  source: 'Etsy · verified purchase · Sep 2026',
  product: 'Personalised Photo Colouring Book'
}, {
  quote: 'The perfect gift for my Arsenal mad daughter. Leon went above and beyond to add extras to the book and to ensure it was delivered in good time.',
  attribution: 'Paul',
  source: 'Etsy · verified purchase · Sep 2026',
  product: 'Arsenal Champions 25/26 Colouring Book'
}, {
  quote: 'Better than expected. LOVE this and working with Leon.',
  attribution: 'Linda',
  source: 'Etsy · verified purchase · Sep 2026',
  product: 'Personalised Photo Colouring Book'
}, {
  quote: 'A lovely, original gift for my granddaughter.',
  attribution: 'Lynne',
  source: 'Etsy · verified purchase · Sep 2026',
  product: 'Personalised Photo Colouring Book (A5)'
}, {
  quote: 'Amazing! Great quality and expertly communicated and delivered. Thank you!',
  attribution: 'Etsy buyer',
  source: 'Etsy · verified purchase · Sep 2026',
  product: 'Personalised Photo Colouring Book'
}, {
  quote: 'It was awesome. My grandkids loved them.',
  attribution: 'Etsy buyer',
  source: 'Etsy · verified purchase · Jun 2026',
  product: 'Custom Photo Colouring Page'
}, {
  quote: 'Lovely item, arrived fast and well packaged. Thank you.',
  attribution: 'Susan',
  source: 'Etsy · verified purchase · Sep 2026',
  product: 'Personalised Family Photo Colouring Book (A5)'
}];
function review(i) {
  return REVIEWS[i % REVIEWS.length];
}
Object.assign(__ds_scope, { SHOP_STATS, REVIEWS, review });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/reviews.jsx", error: String((e && e.message) || e) }); }

// components/editorial/AudienceSelector.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const AUDIENCES = [{
  id: 'schools',
  label: 'Schools & SEN',
  headline: 'A school can become the content.',
  body: 'Bespoke colouring and activity books built around your school community, familiar spaces and people.',
  href: '/partnerships/schools-sen/',
  image: 'b2b/school-class-after.png',
  examples: __ds_scope.B2B_EXAMPLES.schools
}, {
  id: 'care',
  label: 'Care Homes',
  headline: 'Personal stories can become creative objects.',
  body: 'Creative keepsakes and activities built from familiar photographs, personal memories and the stories residents value.',
  href: '/partnerships/care-homes/',
  image: 'b2b/care-nanny-cover.png',
  examples: __ds_scope.B2B_EXAMPLES.care
}, {
  id: 'clubs',
  label: 'Football Clubs',
  headline: 'Turn club identity into something supporters can interact with.',
  body: 'Bespoke fan-engagement products built from club identity, matchday memories and supporter culture.',
  href: '/partnerships/football-clubs/',
  image: 'transform/football-after.png'
}, {
  id: 'orgs',
  label: 'Organisations',
  headline: 'Turn your people, place or story into something tangible.',
  body: 'Custom creative products built around your people, place or story.',
  href: '/partnerships/',
  image: 'transform/getting-ready-after.png'
}];
function AudienceSelector({
  audiences = AUDIENCES,
  initial = 'schools',
  style,
  ...rest
}) {
  const [active, setActive] = React.useState(initial);
  const current = audiences.find(a => a.id === active) || audiences[0];
  const cs = __ds_scope.caseStudy(current.id);
  const [ex, setEx] = React.useState(0);
  React.useEffect(() => setEx(0), [active]);
  const list = current.examples || [];
  const pair = list[Math.min(ex, list.length - 1)];
  const imgS = {
    width: '100%',
    objectFit: 'cover',
    borderRadius: 'var(--radius-md)',
    border: '1px solid var(--color-border)',
    background: 'var(--opg-white)',
    display: 'block'
  };
  const capS = {
    marginTop: 8,
    fontFamily: 'var(--font-sans)',
    fontSize: 'var(--text-xs)',
    fontWeight: 700,
    letterSpacing: 'var(--tracking-eyebrow)',
    textTransform: 'uppercase',
    color: 'var(--color-text-muted)'
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: 'grid',
      gap: 'var(--space-6)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    role: "tablist",
    "aria-label": "Partnership audiences",
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0',
      borderBottom: '1px solid var(--color-border)'
    }
  }, audiences.map(a => {
    const on = a.id === current.id;
    return /*#__PURE__*/React.createElement("button", {
      key: a.id,
      role: "tab",
      type: "button",
      "aria-selected": on,
      onClick: () => setActive(a.id),
      style: {
        padding: '14px 22px 13px',
        background: 'none',
        border: 'none',
        borderBottom: `2px solid ${on ? 'var(--color-accent)' : 'transparent'}`,
        marginBottom: -1,
        cursor: 'pointer',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        fontWeight: on ? 700 : 500,
        color: on ? 'var(--color-brand)' : 'var(--color-text-muted)',
        transition: 'color var(--motion-fast) var(--ease-standard)'
      }
    }, a.label);
  })), /*#__PURE__*/React.createElement("div", {
    role: "tabpanel",
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '7fr 5fr',
      gap: 'var(--space-6) var(--grid-gap-lg)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      lineHeight: 1.1,
      color: 'var(--color-brand)',
      maxWidth: '20ch'
    }
  }, current.headline), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '16px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)',
      maxWidth: '50ch'
    }
  }, current.body), cs ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-5)',
      padding: 'var(--space-5)',
      background: 'var(--opg-blush-100)',
      borderRadius: 'var(--radius-sm)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--opg-burgundy-600)'
    }
  }, cs.client, " \xB7 ", cs.descriptor), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '10px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.2,
      color: 'var(--color-brand)'
    }
  }, cs.headline), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '10px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)',
      maxWidth: '48ch'
    }
  }, cs.body), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-6)',
      marginTop: 'var(--space-5)'
    }
  }, cs.metrics.map(m => /*#__PURE__*/React.createElement("div", {
    key: m.label
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      lineHeight: 1,
      color: 'var(--color-accent-warm)'
    }
  }, m.value), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      marginTop: 6,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)'
    }
  }, m.label))))) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: '20px',
      marginTop: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.TextLink, {
    href: current.href,
    withArrow: true
  }, "Discuss a Project"), /*#__PURE__*/React.createElement(__ds_scope.TextLink, {
    href: current.href,
    size: "sm"
  }, "Request Information"))), /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      minWidth: 0
    }
  }, pair ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, pair.cover ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gap: 10
    }
  }, [['Original photo', pair.before], ['Colouring page', pair.after], ['Finished book', pair.cover]].map(([l, s]) => /*#__PURE__*/React.createElement("div", {
    key: l
  }, /*#__PURE__*/React.createElement("img", {
    src: __ds_scope.asset(s),
    alt: l,
    style: {
      ...imgS,
      aspectRatio: '5 / 7'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: capS
  }, l)))) : /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: __ds_scope.asset(pair.after),
    alt: pair.title + ' as a colouring page',
    style: {
      ...imgS,
      aspectRatio: '3 / 2'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 2fr',
      gap: 10,
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: __ds_scope.asset(pair.before),
    alt: pair.title + ' original photo',
    style: {
      ...imgS,
      aspectRatio: '3 / 2'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: capS
  }, "Original photo")), list.length > 1 ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8
    }
  }, list.map((p, i) => /*#__PURE__*/React.createElement("button", {
    key: p.title,
    type: "button",
    onClick: () => setEx(i),
    style: {
      padding: '8px 14px',
      borderRadius: 'var(--radius-round)',
      border: '1px solid ' + (i === ex ? 'var(--color-brand)' : 'var(--color-border)'),
      background: i === ex ? 'var(--color-brand)' : 'var(--opg-white)',
      color: i === ex ? 'var(--opg-white)' : 'var(--color-brand)',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 600,
      cursor: 'pointer'
    }
  }, p.title))) : null))) : /*#__PURE__*/React.createElement("img", {
    src: __ds_scope.asset(current.image),
    alt: "",
    style: {
      ...imgS,
      aspectRatio: '4 / 3'
    }
  }), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      marginTop: 10,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, cs ? cs.status : pair ? `Example ${current.label.toLowerCase()} project, shown with permission.` : `Illustrative transformation. ${current.label} case studies to follow.`))));
}
Object.assign(__ds_scope, { AudienceSelector });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/editorial/AudienceSelector.jsx", error: String((e && e.message) || e) }); }

// components/editorial/FaqAccordion.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const FAQS = [{
  q: 'What photos work best?',
  a: 'Honestly? Your favourites. Any kind of photo works: phone snaps, slightly blurred shots, old prints, even pictures that are decades old. Blur, grain and faded colour disappear in line-art, so they come out really well as colouring pages. Please do not stress about finding the best-quality version; just send the moments you love and we will take care of the rest.'
}, {
  q: 'How many photos do I need?',
  a: 'One photograph per page. The book option you choose sets the number, and the upload step shows your running count.'
}, {
  q: 'How do I upload my photos?',
  a: 'Upload happens inside the purchase journey, straight after you personalise your book. You can drag photos in on desktop or choose them from your phone.'
}, {
  q: 'Can I request a preview?',
  a: 'Yes. Choose "I would like to request a preview before print" during personalisation. Requesting a preview may affect production timing.'
}, {
  q: 'How are my photos used?',
  a: 'Your photos are used to create your personalised order and handled in line with our Privacy Policy.'
}, {
  q: 'Can you work with older or blurry photos?',
  a: 'Yes, and they often turn out beautifully. Old family prints, faded photos and less-than-sharp phone pictures all make lovely pages. For a printed photo, just take a picture of it with your phone and upload that.'
}];
function FaqAccordion({
  eyebrow,
  heading = 'Questions before you order',
  items = FAQS,
  tone = 'white',
  style,
  ...rest
}) {
  const [open, setOpen] = React.useState(0);
  const bg = {
    white: 'var(--opg-white)',
    paper: 'var(--opg-paper)'
  }[tone] || 'var(--opg-white)';
  return /*#__PURE__*/React.createElement("section", _extends({
    style: {
      background: bg,
      paddingBlock: 'var(--section-standard)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gridTemplateColumns: '4fr 8fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, eyebrow ? /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, null, eyebrow) : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 'var(--leading-heading)',
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)',
      maxWidth: '16ch'
    }
  }, heading)), /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      minWidth: 0
    }
  }, items.map((it, i) => {
    const on = open === i;
    return /*#__PURE__*/React.createElement("div", {
      key: it.q,
      style: {
        borderTop: '1px solid var(--color-border)',
        borderBottom: i === items.length - 1 ? '1px solid var(--color-border)' : 'none'
      }
    }, /*#__PURE__*/React.createElement("dt", {
      style: {
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-expanded": on,
      onClick: () => setOpen(on ? -1 : i),
      style: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 20,
        padding: '20px 0',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-lg)',
        fontWeight: 600,
        color: on ? 'var(--color-accent)' : 'var(--color-brand)',
        transition: 'color var(--motion-fast) var(--ease-standard)'
      }
    }, it.q, /*#__PURE__*/React.createElement("span", {
      style: {
        flex: 'none',
        transform: on ? 'rotate(180deg)' : 'none',
        transition: 'transform var(--motion-base) var(--ease-standard)'
      }
    }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
      name: "chevron-down",
      size: 20
    })))), on ? /*#__PURE__*/React.createElement("dd", {
      style: {
        margin: 0,
        paddingBottom: 24,
        maxWidth: '64ch',
        fontSize: 'var(--text-base)',
        lineHeight: 1.7,
        color: 'var(--color-text-muted)'
      }
    }, it.a) : null);
  }))));
}
Object.assign(__ds_scope, { FaqAccordion });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/editorial/FaqAccordion.jsx", error: String((e && e.message) || e) }); }

// components/editorial/FounderFeature.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function FounderFeature({
  eyebrow = 'Behind the Gallery',
  heading = 'Built around the idea that personal should actually feel personal.',
  body = 'One Print Gallery began with a simple idea: personal photographs should be able to become more than files sitting on a phone. What started with personalised colouring books grew into a wider ambition to create original art and keepsakes people can genuinely feel attached to.',
  signature = 'Leon, Founder',
  ctaLabel = 'Our Story',
  ctaHref = '/our-story/',
  imageSrc,
  tone = 'navy',
  reverse,
  style,
  ...rest
}) {
  const dark = tone === 'ink' || tone === 'navy';
  const bg = {
    paper: 'var(--opg-paper)',
    navy: 'var(--opg-navy-700)',
    ink: 'var(--opg-navy-900)'
  }[tone] || 'var(--opg-navy-700)';
  const text = /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    onDark: dark
  }, eyebrow), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 'var(--leading-heading)',
      letterSpacing: 'var(--tracking-display)',
      color: dark ? 'var(--opg-white)' : 'var(--color-brand)',
      maxWidth: '22ch'
    }
  }, heading), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '24px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.7,
      color: dark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)',
      maxWidth: '52ch'
    }
  }, body), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 'var(--space-6) 0 0',
      fontFamily: 'var(--font-display)',
      fontStyle: 'italic',
      fontSize: 'var(--text-xl)',
      color: dark ? 'var(--opg-peach-300)' : 'var(--color-accent-warm)'
    }
  }, signature), ctaLabel ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: dark ? 'onDarkGhost' : 'secondary',
    href: ctaHref
  }, ctaLabel)) : null);
  /* No founder portrait is used. The maker's mark and the verified trading record
     carry the credibility instead. */
  const stat = (value, label) => /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      lineHeight: 1,
      color: dark ? 'var(--opg-white)' : 'var(--color-brand)'
    }
  }, value), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 8,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: dark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)'
    }
  }, label));
  const visual = /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: 'var(--space-7)',
      justifyItems: 'start'
    }
  }, imageSrc ? /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: "Leon, founder of One Print Gallery",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)'
    }
  }) : /*#__PURE__*/React.createElement("img", {
    src: __ds_scope.asset(__ds_scope.LOGO_ROUNDEL),
    alt: "",
    style: {
      width: 'min(260px, 60%)',
      height: 'auto',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: __ds_scope.asset(__ds_scope.SIGNATURE),
    alt: "Designed with love by One Print Gallery",
    style: {
      width: 'min(420px, 100%)',
      height: 'auto',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(110px,1fr))',
      gap: 'var(--space-6)',
      width: '100%',
      paddingTop: 'var(--space-6)',
      borderTop: `1px solid ${dark ? 'rgba(255,255,255,.18)' : 'var(--color-border)'}`
    }
  }, stat(__ds_scope.SHOP_STATS.rating.toFixed(1), `${__ds_scope.SHOP_STATS.reviewCount} reviews`), stat(__ds_scope.SHOP_STATS.sales + '+', 'orders made'), stat('Star', 'Etsy star seller')));
  return /*#__PURE__*/React.createElement("section", _extends({
    style: {
      background: bg,
      paddingBlock: 'var(--section-editorial)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gridTemplateColumns: '5fr 7fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, reverse ? /*#__PURE__*/React.createElement(React.Fragment, null, text, visual) : /*#__PURE__*/React.createElement(React.Fragment, null, visual, text)));
}
Object.assign(__ds_scope, { FounderFeature });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/editorial/FounderFeature.jsx", error: String((e && e.message) || e) }); }

// components/editorial/HowItWorksTimeline.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const STEPS = [{
  title: 'Choose your book',
  body: 'Select the format and number of pages.'
}, {
  title: 'Personalise & upload',
  body: 'Add your details and choose the photographs you want included.'
}, {
  title: 'We create it',
  body: 'Your photographs are carefully transformed and refined, then your book is prepared for print.'
}, {
  title: "Preview if you'd like",
  body: 'Request an optional preview before print.'
}, {
  title: 'Printed & delivered',
  body: 'Your finished keepsake is produced and sent to you.'
}];
function HowItWorksTimeline({
  eyebrow,
  heading = 'From your camera roll to their colouring book.',
  steps = STEPS,
  tone = 'paper',
  marquee = true,
  speed = 40,
  style,
  ...rest
}) {
  const dark = tone === 'ink' || tone === 'navy';
  const bg = {
    white: 'var(--opg-white)',
    paper: 'var(--opg-paper)',
    navy: 'var(--opg-navy-700)',
    ink: 'var(--opg-navy-900)'
  }[tone] || 'var(--opg-paper)';
  return /*#__PURE__*/React.createElement("section", _extends({
    style: {
      background: bg,
      paddingBlock: 'var(--section-standard)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)'
    }
  }, eyebrow ? /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    onDark: dark
  }, eyebrow) : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      maxWidth: '24ch',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 'var(--leading-heading)',
      letterSpacing: 'var(--tracking-display)',
      color: dark ? 'var(--opg-white)' : 'var(--color-brand)'
    }
  }, heading)), marquee ? /*#__PURE__*/React.createElement("div", {
    className: "opg-hiw-marquee",
    style: {
      marginTop: 'var(--space-5)',
      overflow: 'hidden',
      maskImage: 'linear-gradient(90deg,transparent,#000 6%,#000 94%,transparent)',
      WebkitMaskImage: 'linear-gradient(90deg,transparent,#000 6%,#000 94%,transparent)'
    }
  }, /*#__PURE__*/React.createElement("style", null, `@keyframes opg-hiw-scroll{from{transform:translateX(0)}to{transform:translateX(-50%)}}.opg-hiw-track{animation:opg-hiw-scroll ${speed}s linear infinite}.opg-hiw-marquee:hover .opg-hiw-track{animation-play-state:paused}@media (prefers-reduced-motion:reduce){.opg-hiw-track{animation:none}.opg-hiw-marquee{overflow-x:auto}}`), /*#__PURE__*/React.createElement("ol", {
    className: "opg-hiw-track",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'flex',
      width: 'max-content'
    }
  }, [...steps, ...steps].map((s, i) => /*#__PURE__*/React.createElement("li", {
    key: i,
    "aria-hidden": i >= steps.length || undefined,
    style: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 'var(--space-7)',
      paddingBlock: 'var(--space-6)',
      paddingRight: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 300
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.2,
      color: dark ? 'var(--opg-white)' : 'var(--color-brand)'
    }
  }, s.title), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '8px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: dark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)'
    }
  }, s.body)), /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 32 30",
    width: "22",
    height: "21",
    style: {
      flex: 'none',
      overflow: 'visible'
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 'opg-hiw-heart-' + i,
    x1: "0",
    y1: "0",
    x2: "1",
    y2: "1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#ff3d8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8b4fd8"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 27.5C14 22 3 17.5 2.6 9.8 2.3 4.6 6.4 1.9 9.9 2.6c3 .6 5.2 3.3 6.1 6.2.9-3.4 3.4-6.6 7.2-6.8 3.9-.2 7 3 6.5 7.6-.8 7.2-9.3 11.4-13.2 17.9",
    fill: "none",
    stroke: 'url(#opg-hiw-heart-' + i + ')',
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))) : /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)'
    }
  }, /*#__PURE__*/React.createElement("ol", {
    "data-opg-cols": "",
    style: {
      listStyle: 'none',
      margin: 'var(--space-8) 0 0',
      padding: 0,
      display: 'grid',
      gridTemplateColumns: `repeat(${steps.length}, minmax(0,1fr))`,
      gap: 'var(--grid-gap-lg)'
    }
  }, steps.map((s, i) => /*#__PURE__*/React.createElement("li", {
    key: s.title,
    style: {
      minWidth: 0,
      paddingTop: 'var(--space-5)',
      borderTop: `1px solid ${dark ? 'var(--color-border-on-dark)' : 'var(--color-border-strong)'}`
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontWeight: 700,
      fontSize: 'var(--text-base)',
      lineHeight: 1.35,
      color: dark ? 'var(--opg-white)' : 'var(--color-brand)'
    }
  }, s.title), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '9px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.65,
      color: dark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)'
    }
  }, s.body))))));
}
Object.assign(__ds_scope, { HowItWorksTimeline });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/editorial/HowItWorksTimeline.jsx", error: String((e && e.message) || e) }); }

// components/editorial/Manifesto.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* The campaign platform line, set as a full type-driven field. */
function Manifesto({
  heading = 'There should only be one like yours.',
  body = 'One Print Gallery is being built around a simple idea: the things that mean the most should not feel mass-produced. From personalised books made from your memories to original one-of-one artwork, we create pieces designed for one person, one home or one owner.',
  ctaLabel,
  ctaHref,
  caps = true,
  tone = 'ink',
  style,
  ...rest
}) {
  const bg = {
    ink: 'var(--opg-navy-900)',
    navy: 'var(--opg-navy-700)',
    paper: 'var(--opg-paper)'
  }[tone] || 'var(--opg-navy-900)';
  const dark = tone !== 'paper';
  return /*#__PURE__*/React.createElement("section", _extends({
    style: {
      background: bg,
      paddingBlock: 'var(--section-editorial)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container-reading)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)',
      textAlign: 'center',
      display: 'grid',
      justifyItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.BrushRule, {
    width: 88
  }), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 'var(--space-6) 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-4xl)',
      lineHeight: 1.0,
      letterSpacing: caps ? '0.01em' : 'var(--tracking-hero)',
      textTransform: caps ? 'uppercase' : 'none',
      color: dark ? 'var(--opg-white)' : 'var(--color-brand)',
      maxWidth: '20ch'
    }
  }, heading), body ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 'var(--space-6) 0 0',
      fontSize: 'var(--text-lg)',
      lineHeight: 1.7,
      color: dark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)',
      maxWidth: '58ch'
    }
  }, body) : null, ctaLabel ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: dark ? 'onDark' : 'primary',
    size: "lg",
    href: ctaHref
  }, ctaLabel)) : null));
}
Object.assign(__ds_scope, { Manifesto });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/editorial/Manifesto.jsx", error: String((e && e.message) || e) }); }

// components/feedback/CookieNotice.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function CookieNotice({
  body = 'We use cookies to run the shop, remember your personalisation and understand how the site is used.',
  onAccept,
  onEssential,
  style,
  ...rest
}) {
  const [open, setOpen] = React.useState(true);
  if (!open) return null;
  return /*#__PURE__*/React.createElement("aside", _extends({
    "aria-label": "Cookie preferences",
    style: {
      display: 'grid',
      gap: '16px',
      gridTemplateColumns: 'minmax(0,1fr) auto',
      alignItems: 'center',
      padding: '20px 24px',
      background: 'var(--opg-navy-900)',
      color: 'var(--opg-white)',
      border: '1px solid var(--color-border-on-dark)',
      borderRadius: 'var(--radius-sm)',
      maxWidth: 780,
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-on-dark-muted)'
    }
  }, body, " ", /*#__PURE__*/React.createElement(__ds_scope.TextLink, {
    href: (window.OPG && OPG.real && OPG.real["/privacy/"]) || "/policies/privacy-policy",
    size: "sm",
    onDark: true
  }, "Privacy Policy")), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "onDarkGhost",
    size: "sm",
    onClick: () => {
      setOpen(false);
      onEssential && onEssential();
    }
  }, "Essential Only"), /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "onDark",
    size: "sm",
    onClick: () => {
      setOpen(false);
      onAccept && onAccept();
    }
  }, "Accept")));
}
Object.assign(__ds_scope, { CookieNotice });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/CookieNotice.jsx", error: String((e && e.message) || e) }); }

// components/feedback/EmptyState.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function EmptyState({
  icon = 'shopping-bag',
  heading,
  body,
  actionLabel,
  onAction,
  actionHref,
  secondary,
  onDark,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: 'grid',
      justifyItems: 'center',
      textAlign: 'center',
      gap: '14px',
      padding: 'var(--space-8) var(--space-5)',
      maxWidth: 460,
      marginInline: 'auto',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      color: onDark ? 'var(--opg-blue-400)' : 'var(--color-accent-cool)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: icon,
    size: 30,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      lineHeight: 1.1,
      color: onDark ? 'var(--opg-white)' : 'var(--color-brand)'
    }
  }, heading), body ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-base)',
      lineHeight: 1.6,
      color: onDark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)'
    }
  }, body) : null, actionLabel ? /*#__PURE__*/React.createElement("span", {
    style: {
      marginTop: 6
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: onDark ? 'onDark' : 'primary',
    href: actionHref,
    onClick: onAction
  }, actionLabel)) : null, secondary);
}
Object.assign(__ds_scope, { EmptyState });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/EmptyState.jsx", error: String((e && e.message) || e) }); }

// components/commerce/CartDrawer.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SEED = [{
  id: 1,
  title: 'Personalised Photo Colouring Book',
  options: ['A4 · 21 × 29.7 cm', '15 pages', '15 photos uploaded', 'Preview requested'],
  price: '£24.99'
}];
function CartDrawer({
  open = true,
  lines = SEED,
  onClose,
  style,
  ...rest
}) {
  if (!open) return null;
  return /*#__PURE__*/React.createElement("aside", _extends({
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Your bag",
    style: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      width: 'min(420px,100%)',
      zIndex: 'var(--z-drawer)',
      background: 'var(--opg-white)',
      borderLeft: '1px solid var(--color-border)',
      boxShadow: 'var(--shadow-float)',
      display: 'flex',
      flexDirection: 'column',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '16px 20px',
      borderBottom: '1px solid var(--color-border)',
      flex: 'none'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-brand)'
    }
  }, "Your bag"), /*#__PURE__*/React.createElement(__ds_scope.IconButton, {
    label: "Close bag",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "x",
    size: 22
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      overflow: 'auto',
      padding: lines.length ? '20px' : 0
    }
  }, lines.length === 0 ? /*#__PURE__*/React.createElement(__ds_scope.EmptyState, {
    icon: "shopping-bag",
    heading: "Your bag is empty.",
    body: "Your next keepsake is already in your camera roll.",
    actionLabel: "Create Your Book"
  }) : lines.map(l => /*#__PURE__*/React.createElement("div", {
    key: l.id,
    style: {
      display: 'grid',
      gridTemplateColumns: '78px minmax(0,1fr)',
      gap: '16px',
      paddingBottom: 20,
      borderBottom: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: l.img || __ds_scope.asset('books/luna-front.png'),
    alt: "",
    style: {
      width: '100%',
      aspectRatio: '1055 / 1491',
      objectFit: 'cover',
      borderRadius: 'var(--radius-xs)',
      boxShadow: '0 8px 16px -10px rgba(20,28,60,.5)',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-brand)',
      lineHeight: 1.4
    }
  }, l.title), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: '8px 0 0',
      padding: 0,
      display: 'grid',
      gap: 3
    }
  }, l.options.map(o => /*#__PURE__*/React.createElement("li", {
    key: o,
    style: {
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, o))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 12
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, l.price), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      gap: 2
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.IconButton, {
    label: "Edit personalisation",
    size: 36
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "chevron-right",
    size: 16
  })), /*#__PURE__*/React.createElement(__ds_scope.IconButton, {
    label: "Remove from bag",
    size: 36
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "trash-2",
    size: 16
  })))))))), lines.length ? /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 'none',
      padding: '20px',
      borderTop: '1px solid var(--color-border)',
      display: 'grid',
      gap: '14px'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      display: 'flex',
      justifyContent: 'space-between',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Subtotal"), /*#__PURE__*/React.createElement("span", null, "\xA3", lines.reduce((s, l) => s + (parseFloat(String(l.price).replace(/[^0-9.]/g, '')) || 0), 0).toFixed(2))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, "Delivery calculated at checkout."), /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "primary",
    size: "lg",
    fullWidth: true
  }, "Continue to Secure Checkout")) : null);
}
Object.assign(__ds_scope, { CartDrawer });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/CartDrawer.jsx", error: String((e && e.message) || e) }); }

// components/feedback/ErrorState.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ErrorState({
  tone = 'block',
  heading,
  body,
  retryLabel = 'Try Again',
  onRetry,
  style,
  ...rest
}) {
  if (tone === 'inline') {
    return /*#__PURE__*/React.createElement("p", _extends({
      role: "alert",
      style: {
        display: 'flex',
        gap: 9,
        alignItems: 'flex-start',
        margin: 0,
        padding: '13px 15px',
        border: '1px solid var(--color-error)',
        borderRadius: 'var(--radius-sm)',
        background: '#FDF4F5',
        color: 'var(--color-error)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        fontWeight: 600,
        lineHeight: 1.5,
        ...style
      }
    }, rest), /*#__PURE__*/React.createElement("span", {
      style: {
        marginTop: 1
      }
    }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
      name: "alert-circle",
      size: 17
    })), /*#__PURE__*/React.createElement("span", null, heading, body ? /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        fontWeight: 400,
        marginTop: 3
      }
    }, body) : null));
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "alert",
    style: {
      display: 'grid',
      justifyItems: 'center',
      textAlign: 'center',
      gap: '13px',
      padding: 'var(--space-8) var(--space-5)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      background: 'var(--opg-white)',
      maxWidth: 520,
      marginInline: 'auto',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-error)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "alert-circle",
    size: 28,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      lineHeight: 1.1,
      color: 'var(--color-brand)'
    }
  }, heading), body ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-base)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, body) : null, onRetry ? /*#__PURE__*/React.createElement("span", {
    style: {
      marginTop: 5
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "secondary",
    onClick: onRetry
  }, retryLabel)) : null);
}
Object.assign(__ds_scope, { ErrorState });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/ErrorState.jsx", error: String((e && e.message) || e) }); }

// components/feedback/MediaPlaceholder.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* No photography was supplied with the brand documents. This renders the brief's own
   bracketed placeholders at the correct ratio so no screen has to invent imagery. */
function MediaPlaceholder({
  label = '[SUPPLIED IMAGE]',
  ratio = '4 / 5',
  tone = 'paper',
  note,
  rounded = 'md',
  style,
  ...rest
}) {
  label = ''; note = null;
  const tones = {
    paper: {
      bg: 'var(--opg-paper)',
      fg: 'var(--color-text-muted)',
      line: 'var(--color-border)'
    },
    blush: {
      bg: 'var(--opg-blush-100)',
      fg: 'var(--opg-burgundy-600)',
      line: 'rgba(172,25,61,.22)'
    },
    navy: {
      bg: 'var(--opg-navy-700)',
      fg: 'rgba(255,255,255,.76)',
      line: 'rgba(255,255,255,.22)'
    },
    ink: {
      bg: 'var(--opg-navy-900)',
      fg: 'rgba(255,255,255,.7)',
      line: 'rgba(255,255,255,.18)'
    }
  };
  const t = tones[tone] || tones.paper;
  const radii = {
    none: '0',
    xs: 'var(--radius-xs)',
    md: 'var(--radius-md)',
    lg: 'var(--radius-lg)'
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    "aria-hidden": "true",
    style: {
      position: 'relative',
      width: '100%',
      aspectRatio: ratio,
      overflow: 'hidden',
      background: t.bg,
      border: `1px solid ${t.line}`,
      borderRadius: radii[rounded] ?? radii.md,
      display: 'grid',
      placeItems: 'center',
      padding: '20px',
      textAlign: 'center',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      inset: 0,
      display: 'none'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative',
      display: 'grid',
      gap: 6,
      justifyItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      color: t.fg
    }
  }, label), note ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 400,
      color: t.fg,
      opacity: 0.85,
      maxWidth: '30ch',
      lineHeight: 1.5
    }
  }, note) : null));
}
Object.assign(__ds_scope, { MediaPlaceholder });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/MediaPlaceholder.jsx", error: String((e && e.message) || e) }); }

// components/commerce/ArtworkCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Image-led gallery card. Sold work stays viewable as archive/proof — never deleted. */
function ArtworkCard({
  title = 'Untitled',
  collection = 'Highland Cows',
  medium,
  price = '',
  status = 'available',
  priceFrom = false,
  href = '/one-of-one-art/',
  imageSrc,
  placeholder = '[ONE-OF-ONE ARTWORK]',
  ratio = '4 / 5',
  badge = '1 of 1',
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const sold = status === 'sold';
  return /*#__PURE__*/React.createElement("a", _extends({
    href: href,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      display: 'block',
      textDecoration: 'none',
      color: 'inherit',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      overflow: 'hidden',
      background: 'var(--opg-paper)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      transform: hover && !sold ? 'scale(var(--image-scale-hover))' : 'none',
      transition: 'transform var(--motion-slow) var(--ease-editorial)',
      filter: sold ? 'saturate(.55)' : 'none'
    }
  }, imageSrc ? /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: title,
    style: {
      width: '100%',
      aspectRatio: ratio,
      objectFit: 'cover',
      display: 'block'
    }
  }) : /*#__PURE__*/React.createElement(__ds_scope.MediaPlaceholder, {
    label: placeholder,
    ratio: ratio,
    rounded: "none",
    style: {
      border: 'none'
    }
  })), sold ? /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      inset: 0,
      display: 'grid',
      placeItems: 'center',
      background: 'var(--overlay-flat)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--opg-white)',
      border: '1px solid var(--opg-white)',
      padding: '9px 14px'
    }
  }, "Sold · Retired")) : badge ? /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 14,
      left: 14
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Badge, {
    tone: "edition",
    style: {
      background: 'var(--opg-white)'
    }
  }, badge)) : null), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: '16px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.15,
      fontStyle: 'italic',
      color: hover && !sold ? 'var(--color-accent)' : 'var(--color-brand)',
      transition: 'color var(--motion-fast) var(--ease-standard)'
    }
  }, title), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '7px 0 0',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, collection, medium ? /*#__PURE__*/React.createElement("span", null, " \xB7 ", medium) : null), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '12px 0 0',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      fontWeight: 600,
      color: sold ? 'var(--color-text-muted)' : 'var(--color-text)'
    }
  }, sold ? 'No longer available' : price && price.startsWith('£') && priceFrom ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)',
      marginRight: 7
    }
  }, "From"), price) : price));
}
Object.assign(__ds_scope, { ArtworkCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/ArtworkCard.jsx", error: String((e && e.message) || e) }); }

// components/commerce/ProductCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ProductCard({
  title = 'Personalised Photo Colouring Book',
  promise = 'Your favourite photographs, carefully transformed into a book made only for you.',
  category = 'Personalised Keepsakes',
  price = __ds_scope.PRICING.from,
  priceFrom = true,
  label,
  href = '/personalised-colouring-books/',
  imageSrc,
  placeholder = '[SUPPLIED FINISHED BOOK]',
  ratio = '4 / 5',
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  return /*#__PURE__*/React.createElement("a", _extends({
    href: href,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      display: 'block',
      textDecoration: 'none',
      color: 'inherit',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      transform: hover ? 'scale(var(--image-scale-hover))' : 'none',
      transition: 'transform var(--motion-slow) var(--ease-editorial)'
    }
  }, imageSrc ? /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: title,
    style: {
      width: '100%',
      aspectRatio: ratio,
      objectFit: 'cover',
      display: 'block'
    }
  }) : /*#__PURE__*/React.createElement(__ds_scope.MediaPlaceholder, {
    label: placeholder,
    ratio: ratio,
    rounded: "none",
    style: {
      border: 'none'
    }
  })), label ? /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 14,
      left: 14
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Badge, {
    tone: "quiet"
  }, label)) : null), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '16px 0 0',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)'
    }
  }, category), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: '8px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.15,
      color: hover ? 'var(--color-accent)' : 'var(--color-brand)',
      transition: 'color var(--motion-fast) var(--ease-standard)'
    }
  }, title), promise ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '8px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)',
      maxWidth: '38ch'
    }
  }, promise) : null, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '14px 0 0',
      display: 'flex',
      gap: 7,
      alignItems: 'baseline',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      fontWeight: 600,
      color: 'var(--color-text)'
    }
  }, priceFrom ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)'
    }
  }, "From") : null, price));
}
Object.assign(__ds_scope, { ProductCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/ProductCard.jsx", error: String((e && e.message) || e) }); }

// components/editorial/EditorialSplit.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function EditorialSplit({
  eyebrow,
  heading,
  body,
  points,
  ctaLabel,
  ctaHref,
  linkLabel,
  linkHref,
  media,
  imageSrc,
  placeholder = '[SUPPLIED OPG TRANSFORMATION]',
  ratio = '4 / 5',
  reverse,
  tone = 'white',
  split = '5/7',
  bleed,
  children,
  style,
  ...rest
}) {
  const dark = tone === 'ink' || tone === 'navy';
  const bg = {
    white: 'var(--opg-white)',
    paper: 'var(--opg-paper)',
    blush: 'var(--opg-blush-100)',
    navy: 'var(--opg-navy-700)',
    ink: 'var(--opg-navy-900)'
  }[tone] || 'var(--opg-white)';
  const cols = {
    '5/7': '5fr 7fr',
    '7/5': '7fr 5fr',
    '4/8': '4fr 8fr',
    '8/4': '8fr 4fr'
  }[split] || '5fr 7fr';
  const text = /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, eyebrow ? /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    onDark: dark
  }, eyebrow) : null, heading ? /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 'var(--leading-heading)',
      letterSpacing: 'var(--tracking-display)',
      color: dark ? 'var(--opg-white)' : 'var(--color-brand)',
      maxWidth: '22ch'
    }
  }, heading) : null, body ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '22px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.65,
      color: dark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)',
      maxWidth: '52ch'
    }
  }, body) : null, points && points.length ? /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 'var(--space-6) 0 0',
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, points.map(p => /*#__PURE__*/React.createElement("div", {
    key: p.title
  }, /*#__PURE__*/React.createElement("dt", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: dark ? 'var(--opg-white)' : 'var(--color-brand)',
      lineHeight: 1.2
    }
  }, p.title), /*#__PURE__*/React.createElement("dd", {
    style: {
      margin: '7px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.65,
      color: dark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)',
      maxWidth: '48ch'
    }
  }, p.body)))) : null, children, ctaLabel || linkLabel ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '20px',
      alignItems: 'center',
      marginTop: 'var(--space-6)'
    }
  }, ctaLabel ? /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: dark ? 'onDark' : 'secondary',
    href: ctaHref
  }, ctaLabel) : null, linkLabel ? /*#__PURE__*/React.createElement(__ds_scope.TextLink, {
    href: linkHref,
    onDark: dark,
    withArrow: true
  }, linkLabel) : null) : null);
  const visual = /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      marginRight: bleed && !reverse ? 'calc(var(--gutter) * -1)' : undefined,
      marginLeft: bleed && reverse ? 'calc(var(--gutter) * -1)' : undefined
    }
  }, media || (imageSrc ? /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: "",
    style: {
      width: '100%',
      aspectRatio: ratio,
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)'
    }
  }) : /*#__PURE__*/React.createElement(__ds_scope.MediaPlaceholder, {
    label: placeholder,
    ratio: ratio,
    tone: dark ? 'ink' : 'paper'
  })));
  return /*#__PURE__*/React.createElement("section", _extends({
    style: {
      background: bg,
      paddingBlock: 'var(--section-standard)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gridTemplateColumns: cols,
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, reverse ? /*#__PURE__*/React.createElement(React.Fragment, null, visual, text) : /*#__PURE__*/React.createElement(React.Fragment, null, text, visual)));
}
Object.assign(__ds_scope, { EditorialSplit });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/editorial/EditorialSplit.jsx", error: String((e && e.message) || e) }); }

// components/editorial/FullBleedBanner.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Full-bleed campaign banner. Type over imagery always gets the controlled overlay. */
function FullBleedBanner({
  eyebrow,
  heading,
  body,
  ctaLabel,
  ctaHref,
  secondaryLabel,
  secondaryHref,
  imageSrc,
  placeholder = '[SUPPLIED HERO MOCKUP]',
  height = 'clamp(420px,58vh,680px)',
  align = 'center',
  level = 2,
  style,
  ...rest
}) {
  const HTag = level === 1 ? 'h1' : 'h2';
  return /*#__PURE__*/React.createElement("section", _extends({
    style: {
      position: 'relative',
      minHeight: height,
      display: 'grid',
      overflow: 'hidden',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0
    }
  }, imageSrc ? /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }) : /*#__PURE__*/React.createElement(__ds_scope.MediaPlaceholder, {
    label: placeholder,
    ratio: "16 / 7",
    tone: "navy",
    rounded: "none",
    style: {
      height: '100%',
      aspectRatio: 'auto',
      border: 'none'
    }
  })), /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      inset: 0,
      background: 'var(--overlay-image)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      alignSelf: 'end',
      maxWidth: 'var(--container)',
      width: '100%',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)',
      paddingBlock: 'var(--section-standard)',
      textAlign: align === 'center' ? 'center' : 'left',
      display: 'grid',
      justifyItems: align === 'center' ? 'center' : 'start'
    }
  }, eyebrow ? /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    onDark: true
  }, eyebrow) : null, heading ? /*#__PURE__*/React.createElement(HTag, {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-4xl)',
      lineHeight: 1.0,
      letterSpacing: 'var(--tracking-hero)',
      color: 'var(--opg-white)',
      maxWidth: '20ch'
    }
  }, heading) : null, body ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '20px 0 0',
      fontSize: 'var(--text-lg)',
      lineHeight: 1.6,
      color: 'var(--opg-white)',
      maxWidth: '48ch'
    }
  }, body) : null, ctaLabel || secondaryLabel ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '12px',
      marginTop: 'var(--space-6)',
      justifyContent: align === 'center' ? 'center' : 'flex-start'
    }
  }, ctaLabel ? /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "onDark",
    size: "lg",
    href: ctaHref
  }, ctaLabel) : null, secondaryLabel ? /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "onDarkGhost",
    size: "lg",
    href: secondaryHref
  }, secondaryLabel) : null) : null));
}
Object.assign(__ds_scope, { FullBleedBanner });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/editorial/FullBleedBanner.jsx", error: String((e && e.message) || e) }); }

// components/editorial/Hero.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Hero({
  eyebrow = null,
  heading = 'Your photos, transformed into meaningful keepsakes.',
  body = 'Create a personalised colouring book from the people, places and memories your child already knows, carefully transformed and refined by One Print Gallery.',
  primaryLabel = 'Create Your Colouring Book',
  secondaryLabel = 'See the Transformation',
  onPrimary,
  onSecondary,
  makerLine = 'Designed with love by One Print Gallery.',
  imageSrc = __ds_scope.asset('mockups/luna-held.jpg'),
  placeholder = '[SUPPLIED HERO MOCKUP]',
  ratio = '4 / 5',
  tone = 'paper',
  split = '5/7',
  style,
  ...rest
}) {
  const dark = tone === 'ink' || tone === 'navy';
  const bg = {
    paper: 'var(--opg-paper)',
    white: 'var(--opg-white)',
    navy: 'var(--opg-navy-700)',
    ink: 'var(--opg-navy-900)'
  }[tone] || 'var(--opg-paper)';
  const cols = {
    '5/7': '5fr 7fr',
    '7/5': '7fr 5fr',
    '4/8': '4fr 8fr'
  }[split] || '5fr 7fr';
  return /*#__PURE__*/React.createElement("section", _extends({
    style: {
      background: bg,
      paddingBlock: 'var(--section-editorial)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      maxWidth: 'var(--container-wide)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gridTemplateColumns: cols,
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      containerType: 'inline-size'
    }
  }, eyebrow ? /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    onDark: dark
  }, eyebrow) : null, /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      /* Container-relative so the headline stays safe inside a narrow column —
         --text-hero's vw clamp cannot know the column is a fraction of the page. */
      fontSize: 'min(var(--text-hero), 8.5cqw)',
      lineHeight: 'var(--leading-hero)',
      letterSpacing: 'var(--tracking-hero)',
      color: dark ? 'var(--opg-white)' : 'var(--color-brand)',
      maxWidth: '18ch'
    }
  }, heading), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '26px 0 0',
      fontSize: 'var(--text-lg)',
      lineHeight: 1.6,
      color: dark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)',
      maxWidth: '46ch'
    }
  }, body), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '12px',
      marginTop: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: dark ? 'onDark' : 'primary',
    size: "lg",
    onClick: onPrimary
  }, primaryLabel), secondaryLabel ? /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: dark ? 'onDarkGhost' : 'secondary',
    size: "lg",
    onClick: onSecondary
  }, secondaryLabel) : null), makerLine ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 'var(--space-6) 0 0',
      fontFamily: 'var(--font-display)',
      fontStyle: 'italic',
      fontSize: 'var(--text-base)',
      color: dark ? 'var(--opg-peach-300)' : 'var(--color-text-muted)'
    }
  }, makerLine) : null), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, imageSrc ? /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: "",
    style: {
      width: '100%',
      aspectRatio: ratio,
      objectFit: 'contain',
      objectPosition: 'center',
      borderRadius: 'var(--radius-md)'
    }
  }) : /*#__PURE__*/React.createElement(__ds_scope.MediaPlaceholder, {
    label: placeholder,
    ratio: ratio,
    tone: dark ? 'ink' : 'blush',
    note: "Premium book mockup with the source photo visible in composition"
  }))));
}
Object.assign(__ds_scope, { Hero });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/editorial/Hero.jsx", error: String((e && e.message) || e) }); }

// components/editorial/TestimonialFeature.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const FEATURED = __ds_scope.review(0);
function TestimonialFeature({
  eyebrow = 'What Customers Notice First',
  quote = FEATURED.quote,
  attribution = FEATURED.attribution,
  source = FEATURED.source,
  showMedia = true,
  imageSrc = __ds_scope.asset(__ds_scope.book('luna').front),
  placeholder = '[SUPPLIED FINISHED BOOK]',
  tone = 'blush',
  style,
  ...rest
}) {
  const dark = tone === 'ink' || tone === 'navy';
  const bg = {
    white: 'var(--opg-white)',
    paper: 'var(--opg-paper)',
    blush: 'var(--opg-blush-100)',
    navy: 'var(--opg-navy-700)',
    ink: 'var(--opg-navy-900)'
  }[tone] || 'var(--opg-blush-100)';
  return /*#__PURE__*/React.createElement("section", _extends({
    style: {
      background: bg,
      paddingBlock: 'var(--section-standard)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gridTemplateColumns: showMedia ? '7fr 5fr' : '1fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    onDark: dark
  }, eyebrow), /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 500,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.18,
      letterSpacing: '-0.01em',
      color: dark ? 'var(--opg-white)' : 'var(--opg-navy-900)',
      maxWidth: '30ch'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: dark ? 'var(--opg-peach-300)' : 'var(--color-accent-warm)'
    }
  }, "\u201C"), quote, /*#__PURE__*/React.createElement("span", {
    style: {
      color: dark ? 'var(--opg-peach-300)' : 'var(--color-accent-warm)'
    }
  }, "\u201D")), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      marginTop: 'var(--space-5)',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: dark ? 'var(--color-text-on-dark-muted)' : 'var(--opg-burgundy-600)'
    }
  }, attribution, source ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 400,
      color: dark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)'
    }
  }, " \xB7 ", source) : null)), showMedia ? /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, imageSrc ? /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: "",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'contain',
      borderRadius: 'var(--radius-md)'
    }
  }) : /*#__PURE__*/React.createElement(__ds_scope.MediaPlaceholder, {
    label: placeholder,
    ratio: "4 / 5",
    tone: dark ? 'ink' : 'paper',
    note: "Customer product image, permission required"
  })) : null));
}
Object.assign(__ds_scope, { TestimonialFeature });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/editorial/TestimonialFeature.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Skeleton.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Skeleton({
  variant = 'text',
  width = '100%',
  height,
  lines = 3,
  ratio = '4 / 5',
  style,
  ...rest
}) {
  const shimmer = {
    background: 'linear-gradient(90deg,var(--opg-mist) 0%,var(--opg-paper) 40%,var(--opg-mist) 80%)',
    backgroundSize: '260% 100%',
    animation: 'opg-shimmer 1400ms var(--ease-standard) infinite'
  };
  const keyframes = /*#__PURE__*/React.createElement("style", null, '@keyframes opg-shimmer{0%{background-position:120% 0}100%{background-position:-120% 0}}@media(prefers-reduced-motion:reduce){[data-opg-skeleton]{animation:none!important}}');
  if (variant === 'media') {
    return /*#__PURE__*/React.createElement("div", _extends({
      "data-opg-skeleton": true,
      "aria-hidden": "true",
      style: {
        width,
        aspectRatio: ratio,
        borderRadius: 'var(--radius-md)',
        ...shimmer,
        ...style
      }
    }, rest), keyframes);
  }
  if (variant === 'block') {
    return /*#__PURE__*/React.createElement("div", _extends({
      "data-opg-skeleton": true,
      "aria-hidden": "true",
      style: {
        width,
        height: height || 48,
        borderRadius: 'var(--radius-sm)',
        ...shimmer,
        ...style
      }
    }, rest), keyframes);
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    "aria-hidden": "true",
    style: {
      display: 'grid',
      gap: 9,
      width,
      ...style
    }
  }, rest), keyframes, Array.from({
    length: lines
  }).map((_, i) => /*#__PURE__*/React.createElement("span", {
    key: i,
    "data-opg-skeleton": true,
    style: {
      display: 'block',
      height: 11,
      borderRadius: 'var(--radius-xs)',
      width: i === lines - 1 ? '62%' : '100%',
      ...shimmer
    }
  })));
}
Object.assign(__ds_scope, { Skeleton });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Skeleton.jsx", error: String((e && e.message) || e) }); }

// components/forms/Checkbox.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Checkbox({
  id,
  label,
  hint,
  checked,
  onChange,
  disabled,
  onDark,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    style: {
      display: 'grid',
      gridTemplateColumns: '20px 1fr',
      gap: '12px',
      alignItems: 'start',
      minHeight: 'var(--touch-min)',
      paddingTop: '11px',
      cursor: disabled ? 'not-allowed' : 'pointer',
      ...style
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: "checkbox",
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    style: {
      gridArea: '1/1',
      appearance: 'none',
      width: 20,
      height: 20,
      margin: 0,
      borderRadius: 'var(--radius-xs)',
      border: `1px solid ${checked ? 'var(--color-brand)' : onDark ? 'var(--color-border-on-dark)' : 'var(--color-border-strong)'}`,
      background: checked ? 'var(--color-brand)' : 'transparent',
      display: 'grid',
      placeItems: 'center',
      cursor: 'inherit',
      flex: 'none',
      transition: 'background-color var(--motion-fast) var(--ease-standard),border-color var(--motion-fast) var(--ease-standard)'
    }
  }, rest)), /*#__PURE__*/React.createElement("span", {
    style: {
      gridArea: '1/2',
      display: 'block',
      marginTop: '-2px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.5,
      color: onDark ? 'var(--opg-white)' : 'var(--color-text)'
    }
  }, label), hint ? /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      marginTop: 3,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.5,
      color: onDark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)'
    }
  }, hint) : null), checked ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "13",
    height: "13",
    fill: "none",
    stroke: "var(--opg-white)",
    strokeWidth: "2.6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    style: {
      gridArea: '1/1',
      marginTop: 4,
      marginLeft: 4,
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6 9 17l-5-5"
  })) : null);
}
Object.assign(__ds_scope, { Checkbox });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Checkbox.jsx", error: String((e && e.message) || e) }); }

// components/forms/FormField.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Visible labels are mandatory — the brand spec forbids placeholder-only inputs. */
function FormField({
  label,
  htmlFor,
  hint,
  error,
  required,
  optional,
  onDark,
  children,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '7px',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("label", {
    htmlFor: htmlFor,
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: onDark ? 'var(--opg-white)' : 'var(--color-brand)',
      lineHeight: 1.35
    }
  }, label, required ? /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-accent)',
      marginLeft: 4
    },
    "aria-hidden": "true"
  }, "*") : null, optional ? /*#__PURE__*/React.createElement("span", {
    style: {
      color: onDark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)',
      fontWeight: 400,
      marginLeft: 6
    }
  }, "(optional)") : null), children, hint && !error ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.5,
      color: onDark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)'
    }
  }, hint) : null, error ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      display: 'flex',
      gap: 6,
      alignItems: 'flex-start',
      fontSize: 'var(--text-xs)',
      fontWeight: 600,
      lineHeight: 1.5,
      color: 'var(--color-error)'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "14",
    height: "14",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    "aria-hidden": "true",
    style: {
      marginTop: 2,
      flex: 'none'
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16h.01"
  })), error) : null);
}
Object.assign(__ds_scope, { FormField });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/FormField.jsx", error: String((e && e.message) || e) }); }

// components/forms/Input.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const controlStyle = (focused, invalid, onDark) => ({
  width: '100%',
  minHeight: 'var(--control-height)',
  padding: '12px 14px',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-base)',
  lineHeight: 1.4,
  color: onDark ? 'var(--opg-white)' : 'var(--color-text)',
  background: onDark ? 'rgba(255,255,255,.06)' : 'var(--opg-white)',
  border: `1px solid ${invalid ? 'var(--color-error)' : focused ? 'var(--color-focus)' : onDark ? 'var(--color-border-on-dark)' : 'var(--color-border-strong)'}`,
  borderRadius: 'var(--radius-sm)',
  outline: 'none',
  boxShadow: focused ? onDark ? 'var(--focus-ring-on-dark)' : 'var(--focus-ring)' : 'none',
  transition: 'border-color var(--motion-fast) var(--ease-standard),box-shadow var(--motion-fast) var(--ease-standard)'
});
function Input({
  invalid,
  onDark,
  style,
  ...rest
}) {
  const [f, setF] = React.useState(false);
  return /*#__PURE__*/React.createElement("input", _extends({
    onFocus: () => setF(true),
    onBlur: () => setF(false),
    "aria-invalid": invalid || undefined,
    style: {
      ...controlStyle(f, invalid, onDark),
      ...style
    }
  }, rest));
}
Object.assign(__ds_scope, { controlStyle, Input });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Input.jsx", error: String((e && e.message) || e) }); }

// components/forms/NewsletterForm.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function NewsletterForm({
  onDark,
  heading = 'Be first to see new work',
  body = 'Occasional emails about new transformations, one-of-one releases and seasonal order dates.',
  onSubmit,
  style,
  ...rest
}) {
  const [email, setEmail] = React.useState('');
  const [sent, setSent] = React.useState(() => window.OPG_POSTED === 'newsletter');
  return /*#__PURE__*/React.createElement("form", _extends({
    onSubmit: e => {
      e.preventDefault();
      if (email) {
        if (window.OPG_NEWS) { OPG_NEWS(email); return; }
        setSent(true);
        onSubmit && onSubmit(email);
      }
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      maxWidth: 460,
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.2,
      color: onDark ? 'var(--opg-white)' : 'var(--color-brand)'
    }
  }, heading), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '8px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: onDark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)'
    }
  }, body)), sent ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: onDark ? 'var(--opg-peach-300)' : 'var(--color-success)'
    }
  }, "Thank you. You're on the list.") : /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.FormField, {
    label: "Email address",
    htmlFor: "opg-newsletter",
    onDark: onDark,
    style: {
      flex: '1 1 220px'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Input, {
    id: "opg-newsletter",
    type: "email",
    required: true,
    value: email,
    onChange: e => setEmail(e.target.value),
    placeholder: "you@example.com",
    onDark: onDark
  })), /*#__PURE__*/React.createElement(__ds_scope.Button, {
    type: "submit",
    variant: onDark ? 'onDark' : 'brand'
  }, "Sign Up")));
}
Object.assign(__ds_scope, { NewsletterForm });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/NewsletterForm.jsx", error: String((e && e.message) || e) }); }

// components/forms/Radio.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Radio({
  id,
  name,
  label,
  hint,
  checked,
  onChange,
  value,
  disabled,
  onDark,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    style: {
      display: 'grid',
      gridTemplateColumns: '20px 1fr',
      gap: '12px',
      alignItems: 'start',
      minHeight: 'var(--touch-min)',
      paddingTop: '11px',
      cursor: disabled ? 'not-allowed' : 'pointer',
      ...style
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: "radio",
    name: name,
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    style: {
      appearance: 'none',
      width: 20,
      height: 20,
      margin: 0,
      borderRadius: '50%',
      border: `1px solid ${checked ? 'var(--color-brand)' : onDark ? 'var(--color-border-on-dark)' : 'var(--color-border-strong)'}`,
      background: 'transparent',
      boxShadow: checked ? 'inset 0 0 0 5px var(--color-brand)' : 'none',
      cursor: 'inherit',
      flex: 'none',
      transition: 'box-shadow var(--motion-fast) var(--ease-standard),border-color var(--motion-fast) var(--ease-standard)'
    }
  }, rest)), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      marginTop: '-2px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.5,
      color: onDark ? 'var(--opg-white)' : 'var(--color-text)'
    }
  }, label), hint ? /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      marginTop: 3,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.5,
      color: onDark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)'
    }
  }, hint) : null));
}
Object.assign(__ds_scope, { Radio });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Radio.jsx", error: String((e && e.message) || e) }); }

// components/forms/RadioCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function RadioCard({
  id,
  name,
  title,
  description,
  meta,
  value,
  checked,
  onChange,
  disabled,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      display: 'grid',
      gridTemplateColumns: '20px 1fr auto',
      gap: '14px',
      alignItems: 'start',
      padding: '18px 20px',
      borderRadius: 'var(--radius-sm)',
      border: `1px solid ${checked ? 'var(--color-brand)' : hover && !disabled ? 'var(--color-border-strong)' : 'var(--color-border)'}`,
      background: checked ? 'var(--opg-paper)' : 'var(--opg-white)',
      boxShadow: checked ? 'inset 0 0 0 1px var(--color-brand)' : 'none',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.55 : 1,
      transition: 'border-color var(--motion-fast) var(--ease-standard),background-color var(--motion-fast) var(--ease-standard)',
      ...style
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: "radio",
    name: name,
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    style: {
      appearance: 'none',
      width: 20,
      height: 20,
      margin: '2px 0 0',
      borderRadius: '50%',
      border: `1px solid ${checked ? 'var(--color-brand)' : 'var(--color-border-strong)'}`,
      boxShadow: checked ? 'inset 0 0 0 5px var(--color-brand)' : 'none',
      cursor: 'inherit',
      flex: 'none'
    }
  }, rest)), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      fontWeight: 600,
      color: 'var(--color-brand)',
      lineHeight: 1.4
    }
  }, title), description ? /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      marginTop: 5,
      fontSize: 'var(--text-sm)',
      lineHeight: 1.55,
      color: 'var(--color-text-muted)'
    }
  }, description) : null), meta ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      fontWeight: 600,
      color: 'var(--color-text)',
      whiteSpace: 'nowrap',
      marginTop: 1
    }
  }, meta) : null);
}
Object.assign(__ds_scope, { RadioCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/RadioCard.jsx", error: String((e && e.message) || e) }); }

// components/commerce/PriceOptionsPanel.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const FORMATS = __ds_scope.PRICING.formats;
const PAGES = __ds_scope.PRICING.pages.map(p => ({
  id: p.id,
  title: `${p.count} pages`,
  description: `${p.count} photographs, one per page.`,
  meta: p.price
}));
function PriceOptionsPanel({
  title = 'Personalised Photo Colouring Book',
  promise = 'Your favourite photographs, carefully transformed into recognisable colouring pages and professionally finished as a book made only for you.',
  price = `From ${__ds_scope.PRICING.from}`,
  proofPoints = ['Created from your own photographs', 'Carefully transformed and refined', 'Optional preview available by request'],
  formats = FORMATS,
  pageCounts = PAGES,
  ctaLabel = 'Start Personalising',
  part = 'all',
  reassurance = `${__ds_scope.FULFILMENT.production}. ${__ds_scope.FULFILMENT.shipping}, ${__ds_scope.FULFILMENT.shippingNote.toLowerCase()}`,
  onCta,
  style,
  ...rest
}) {
  const saved = (() => { try { return JSON.parse(sessionStorage.getItem('opg-pick-book') || '{}') || {}; } catch (e) { return {}; } })();
  const [fmt, setFmt] = React.useState((formats.find(f => f.id === saved.size) || formats[0])?.id);
  const [pg, setPg] = React.useState((pageCounts.find(p => p.id === 'p' + saved.pages) || pageCounts.find(p => p.id === 'p15') || pageCounts[0])?.id);
  React.useEffect(() => { const n = parseInt(String(pg).replace(/\D/g, ''), 10); if (fmt && n) try { sessionStorage.setItem('opg-pick-book', JSON.stringify({ size: fmt, pages: n })); } catch (e) {} }, [fmt, pg]);
  const head = React.createElement("div", null, React.createElement("h1", {
    style: { margin: 0, fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 'var(--text-3xl)', lineHeight: 1.05, letterSpacing: 'var(--tracking-display)', color: 'var(--color-brand)' }
  }, title), React.createElement("p", {
    style: { margin: '16px 0 0', fontSize: 'var(--text-base)', lineHeight: 1.65, color: 'var(--color-text-muted)', maxWidth: '46ch' }
  }, promise));
  const proof = React.createElement("ul", {
    style: { listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: '9px' }
  }, proofPoints.map(p => React.createElement("li", {
    key: p,
    style: { display: 'flex', gap: 10, alignItems: 'flex-start', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', lineHeight: 1.5, color: 'var(--color-text)' }
  }, React.createElement("span", { style: { color: 'var(--color-accent-warm)', marginTop: 2 } }, React.createElement(__ds_scope.Icon, { name: "check", size: 16 })), p)));
  const priceRow = React.createElement("p", {
    style: { margin: 0, display: 'flex', alignItems: 'baseline', gap: 12, ...(part === 'head' ? {} : { paddingTop: 'var(--space-5)', borderTop: '1px solid var(--color-border)' }) }
  }, React.createElement("span", { style: { fontFamily: 'var(--font-sans)', fontSize: 'var(--text-2xl)', fontWeight: 700, color: 'var(--color-text)' } }, price), React.createElement(__ds_scope.Badge, { tone: "quiet" }, "Made to order"));
  const legend = { padding: 0, marginBottom: 4, fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', fontWeight: 600, color: 'var(--color-brand)' };
  const fsStyle = { border: 'none', margin: 0, padding: 0, display: 'grid', gap: '10px' };
  const fmtSet = React.createElement("fieldset", { style: fsStyle }, React.createElement("legend", { style: legend }, "Choose your format"), formats.map(f => React.createElement(__ds_scope.RadioCard, {
    key: f.id, id: `fmt-${f.id}`, name: "opg-format", title: f.title, description: f.description, meta: f.meta, checked: fmt === f.id, onChange: () => setFmt(f.id)
  })));
  const pgSet = React.createElement("fieldset", { style: fsStyle }, React.createElement("legend", { style: legend }, "Number of pages"), pageCounts.map(f => React.createElement(__ds_scope.RadioCard, {
    key: f.id, id: `pg-${f.id}`, name: "opg-pages", title: f.title, description: f.description,
    meta: pageCounts === PAGES && fmt === 'a4' && /^£[\d.]+$/.test(f.meta) ? '£' + (parseFloat(f.meta.slice(1)) + (__ds_scope.PRICING.a4Extra || 0)).toFixed(2) : f.meta,
    checked: pg === f.id, onChange: () => setPg(f.id)
  })));
  const cta = React.createElement("div", { style: { display: 'grid', gap: '14px' } }, React.createElement(__ds_scope.Button, {
    variant: "primary", size: "lg", fullWidth: true, onClick: onCta
  }, ctaLabel), React.createElement("p", {
    style: { margin: 0, fontSize: 'var(--text-xs)', lineHeight: 1.6, color: 'var(--color-text-muted)' }
  }, "You'll choose your details and upload your photographs next. ", reassurance));
  const kids = part === 'head' ? [head, priceRow] : part === 'options' ? [proof, fmtSet, pgSet, cta] : [head, proof, priceRow, fmtSet, pgSet, cta];
  return React.createElement("div", _extends({
    style: { display: 'grid', gap: part === 'head' ? 'var(--space-4)' : 'var(--space-6)', ...style }
  }, rest), ...kids);
}
Object.assign(__ds_scope, { PriceOptionsPanel });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/PriceOptionsPanel.jsx", error: String((e && e.message) || e) }); }

// components/forms/Select.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Select({
  options = [],
  invalid,
  onDark,
  placeholder,
  style,
  ...rest
}) {
  const [f, setF] = React.useState(false);
  return /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative',
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement("select", _extends({
    onFocus: () => setF(true),
    onBlur: () => setF(false),
    "aria-invalid": invalid || undefined,
    style: {
      ...__ds_scope.controlStyle(f, invalid, onDark),
      appearance: 'none',
      paddingRight: '42px',
      cursor: 'pointer',
      ...style
    }
  }, rest), placeholder ? /*#__PURE__*/React.createElement("option", {
    value: ""
  }, placeholder) : null, options.map(o => {
    const value = typeof o === 'string' ? o : o.value;
    const label = typeof o === 'string' ? o : o.label;
    return /*#__PURE__*/React.createElement("option", {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "18",
    height: "18",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      right: 14,
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none',
      color: onDark ? 'var(--opg-white)' : 'var(--color-brand)'
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 9 6 6 6-6"
  })));
}
Object.assign(__ds_scope, { Select });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Select.jsx", error: String((e && e.message) || e) }); }

// components/forms/Textarea.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Textarea({
  invalid,
  onDark,
  rows = 5,
  style,
  ...rest
}) {
  const [f, setF] = React.useState(false);
  return /*#__PURE__*/React.createElement("textarea", _extends({
    rows: rows,
    onFocus: () => setF(true),
    onBlur: () => setF(false),
    "aria-invalid": invalid || undefined,
    style: {
      ...__ds_scope.controlStyle(f, invalid, onDark),
      minHeight: 'auto',
      resize: 'vertical',
      lineHeight: 1.6,
      ...style
    }
  }, rest));
}
Object.assign(__ds_scope, { Textarea });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Textarea.jsx", error: String((e && e.message) || e) }); }

// components/navigation/AnnouncementBar.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Maximum ONE live message. 32-40px tall. Never rotating. */
function AnnouncementBar({
  message = __ds_scope.announcement(),
  linkLabel,
  linkHref = '#',
  tone = 'ink',
  dismissible = true,
  style,
  ...rest
}) {
  const [open, setOpen] = React.useState(true);
  if (!open) return null;
  const tones = {
    ink: {
      background: 'var(--opg-navy-900)',
      color: 'var(--opg-white)'
    },
    blush: {
      background: 'var(--opg-blush-100)',
      color: 'var(--opg-navy-900)'
    }
  };
  const t = tones[tone] || tones.ink;
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "region",
    "aria-label": "Announcement",
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      minHeight: 'var(--announcement-height)',
      padding: dismissible ? '6px calc(var(--gutter) + 30px)' : '6px var(--gutter)',
      flexWrap: 'wrap',
      columnGap: '12px',
      rowGap: '2px',
      background: t.background,
      color: t.color,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 600,
      letterSpacing: '0.04em',
      textAlign: 'center',
      position: 'relative',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", null, message), linkLabel ? /*#__PURE__*/React.createElement(__ds_scope.TextLink, {
    href: linkHref,
    size: "sm",
    onDark: tone === 'ink',
    style: {
      fontSize: 'var(--text-xs)'
    }
  }, linkLabel) : null, dismissible ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": "Dismiss announcement",
    onClick: () => setOpen(false),
    style: {
      position: 'absolute',
      right: 'var(--gutter)',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: 'none',
      color: 'inherit',
      opacity: 0.7,
      cursor: 'pointer',
      padding: 6,
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "14",
    height: "14",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6 6 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 6 12 12"
  }))) : null);
}
Object.assign(__ds_scope, { AnnouncementBar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/AnnouncementBar.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Footer.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const COLUMNS = [{
  title: 'Shop',
  links: [['Personalised Colouring Books', '/personalised-colouring-books/'], ['Colouring Photo Album', '/photo-album/'], ['Create Your Book', '/personalised-colouring-books/create-your-book/'], ['Gallery', '/gallery/'], ['Art Collection', '/art-collection/'], ['Highland Cows', '/one-of-one-art/highland-cows/'], ['The Obsidian Society', '/one-of-one-art/obsidian-society/']]
}, {
  title: 'About',
  links: [['Our Story', '/our-story/'], ['How It Works', '/how-it-works/'], ['Reviews', '/reviews/']]
}, {
  title: 'Help',
  links: [['FAQ', '/faq/'], ['Contact', '/contact/'], ['Your Account', '/account/'], ['Search', '/search/'], ['Shipping', '/shipping/'], ['Photo Guidance', '/how-it-works/#photo-guidance'], ['Accessibility', '/accessibility/']]
}, {
  title: 'Partnerships',
  links: [['Schools & SEN', '/partnerships/schools-sen/'], ['Care Homes', '/partnerships/care-homes/'], ['Football Clubs', '/partnerships/football-clubs/'], ['Organisations', '/partnerships/']]
}];
function Footer({
  columns = COLUMNS,
  email = 'enquiries@oneprintgallery.co.uk',
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("footer", _extends({
    style: {
      background: 'var(--opg-navy-900)',
      color: 'var(--opg-white)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)',
      paddingBlock: 'var(--section-standard) var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(170px,1fr))',
      gap: 'var(--space-7) var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      gridColumn: 'span 2',
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.OneWordmark, {
    size: 26,
    onDark: true,
    stacked: false
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '18px 0 0',
      maxWidth: '34ch',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.7,
      color: 'var(--color-text-on-dark-muted)'
    }
  }, "Your photos, transformed into meaningful keepsakes. Personalised art, one-of-one keepsakes and creative partnerships."), /*#__PURE__*/React.createElement("a", {
    href: `mailto:${email}`,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      marginTop: 18,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--opg-white)',
      textDecoration: 'underline',
      textUnderlineOffset: '0.22em'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "mail",
    size: 16
  }), email), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: '18px',
      marginTop: 22
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://instagram.com/1oneprintgallery",
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 7,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-on-dark-muted)',
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "instagram",
    size: 17
  }), "@1oneprintgallery"), /*#__PURE__*/React.createElement("a", {
    href: "https://tiktok.com/@one.print.gallery",
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 7,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-on-dark-muted)',
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "tiktok",
    size: 17
  }), "@one.print.gallery"))), columns.map(col => /*#__PURE__*/React.createElement("nav", {
    key: col.title,
    "aria-label": col.title,
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '0 0 16px',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--opg-peach-300)'
    }
  }, col.title), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: '11px'
    }
  }, col.links.map(([label, href]) => /*#__PURE__*/React.createElement("li", {
    key: href
  }, /*#__PURE__*/React.createElement("a", {
    href: href,
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-on-dark-muted)',
      textDecoration: 'none'
    }
  }, label))))))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-9)',
      paddingTop: 'var(--space-7)',
      borderTop: '1px solid var(--color-border-on-dark)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.NewsletterForm, {
    onDark: true
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-7)',
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border-on-dark)',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px 20px',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      color: 'rgba(255,255,255,.58)'
    }
  }, "\xA9 ", new Date().getFullYear(), " One Print Gallery \xB7 Designed with love by One Print Gallery"), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '6px 16px'
    }
  }, [['Privacy', '/privacy/'], ['Terms', '/terms/'], ['Shipping', '/shipping/'], ['Refunds', '/refunds/'], ['Legal notice', '/legal-notice/'], ['Accessibility', '/accessibility/']].map(([l, h]) => /*#__PURE__*/React.createElement("a", {
    key: h,
    href: h,
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      color: 'rgba(255,255,255,.58)',
      textDecoration: 'none'
    }
  }, l))))));
}
Object.assign(__ds_scope, { Footer });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Footer.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Header.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const NAV = [{
  label: 'Colouring Books',
  href: '/personalised-colouring-books/'
}, {
  label: 'Photo Albums',
  href: '/photo-album/'
}, {
  label: 'Art Collection',
  href: '/art-collection/'
}, {
  label: 'Gallery',
  href: '/gallery/'
}, {
  label: 'How It Works',
  href: '/how-it-works/'
}, {
  label: 'Reviews',
  href: '/reviews/'
}, {
  label: 'Partnerships',
  href: '/partnerships/',
  children: [{ label: 'All partnerships', href: '/partnerships/' }, { label: 'Schools & SEN', href: '/partnerships/schools-sen/' }, { label: 'Care Homes', href: '/partnerships/care-homes/' }, { label: 'Football Clubs', href: '/partnerships/football-clubs/' }]
}, {
  label: 'Contact',
  href: '/contact/'
}];

/* Below 1340px the seven nav items, utilities and CTA stop fitting, so the header
   falls back to its own compact layout unless `compact` is set explicitly. */
function useNarrow(px = 1440) {
  const [narrow, setNarrow] = React.useState(() => typeof window !== 'undefined' && window.innerWidth < px);
  React.useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(`(max-width:${px - 1}px)`);
    const on = e => setNarrow(e.matches);
    setNarrow(mq.matches);
    mq.addEventListener ? mq.addEventListener('change', on) : mq.addListener(on);
    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', on) : mq.removeListener(on);
    };
  }, [px]);
  return narrow;
}
function Header({
  items = NAV,
  active,
  scrolled = true,
  cartCount = 0,
  compact: compactProp,
  onMenu,
  onCart,
  onSearch,
  onNavigate,
  style,
  ...rest
}) {
  const narrow = useNarrow();
  const [dd, setDd] = React.useState(null);
  const compact = compactProp === undefined ? narrow : compactProp;
  const solid = scrolled;
  return /*#__PURE__*/React.createElement("header", _extends({
    style: {
      position: 'relative',
      zIndex: 'var(--z-header)',
      background: solid ? 'var(--opg-white)' : 'transparent',
      borderBottom: `1px solid ${solid ? 'var(--color-border)' : 'transparent'}`,
      transition: 'background-color var(--motion-base) var(--ease-standard),border-color var(--motion-base) var(--ease-standard)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '24px',
      height: compact ? 'var(--header-height-mobile)' : 'var(--header-height)',
      maxWidth: 'var(--container-wide)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)'
    }
  }, compact ? /*#__PURE__*/React.createElement(__ds_scope.IconButton, {
    label: "Menu",
    onClick: onMenu,
    onDark: !solid
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "menu",
    size: 23
  })) : null, /*#__PURE__*/React.createElement("a", {
    href: "/",
    onClick: e => {
      if (onNavigate) {
        e.preventDefault();
        onNavigate('/');
      }
    },
    style: {
      textDecoration: 'none',
      marginRight: compact ? 0 : 8,
      marginInline: compact ? 'auto' : undefined
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.OneWordmark, {
    size: compact ? 18 : 21,
    onDark: !solid
  })), !compact ? /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Main",
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '28px',
      marginLeft: 'auto'
    }
  }, items.map(it => {
    const on = active === it.href;
    const link = /*#__PURE__*/React.createElement("a", {
      key: it.href,
      href: it.href,
      onClick: e => {
        if (onNavigate) {
          e.preventDefault();
          onNavigate(it.href);
        }
      },
      style: {
        fontFamily: 'var(--font-sans)',
        fontSize: '0.9375rem',
        fontWeight: on ? 700 : 500,
        color: solid ? 'var(--color-brand)' : 'var(--opg-white)',
        textDecoration: 'none',
        paddingBottom: 3,
        borderBottom: `2px solid ${on ? 'var(--color-accent)' : 'transparent'}`,
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4
      }
    }, it.label, it.children ? React.createElement(__ds_scope.Icon, { name: 'chevron-down', size: 15 }) : null);
    if (!it.children) return link;
    return React.createElement("span", { key: it.href, style: { position: 'relative', display: 'inline-flex' }, onMouseEnter: () => setDd(it.href), onMouseLeave: () => setDd(null), onFocus: () => setDd(it.href), onBlur: e => { if (!e.currentTarget.contains(e.relatedTarget)) setDd(null); }, onKeyDown: e => { if (e.key === 'Escape') setDd(null); } }, link, dd === it.href ? React.createElement("div", { className: 'opg-dd', style: { position: 'absolute', top: '100%', left: -14, paddingTop: 14, zIndex: 50 } }, React.createElement("div", { style: { minWidth: 220, display: 'grid', padding: 8, background: 'var(--opg-white)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-soft)' } }, it.children.map(c => React.createElement("a", { key: c.href, href: c.href, onClick: e => { setDd(null); if (onNavigate) { e.preventDefault(); onNavigate(c.href); } }, style: { display: 'block', padding: '10px 14px', borderRadius: 'var(--radius-sm)', fontFamily: 'var(--font-sans)', fontSize: '0.9375rem', fontWeight: 500, color: 'var(--color-brand)', textDecoration: 'none', whiteSpace: 'nowrap' } }, c.label)))) : null);
  })) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      marginLeft: compact ? 0 : '20px'
    }
  }, !compact ? /*#__PURE__*/React.createElement(__ds_scope.IconButton, {
    label: "Search",
    onClick: onSearch,
    onDark: !solid
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "search",
    size: 21
  })) : null, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.IconButton, {
    label: `Bag, ${cartCount} item${cartCount === 1 ? '' : 's'}`,
    onClick: onCart,
    onDark: !solid
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "shopping-bag",
    size: 21
  })), cartCount > 0 ? /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 6,
      right: 4,
      minWidth: 16,
      height: 16,
      padding: '0 4px',
      borderRadius: 'var(--radius-round)',
      background: 'var(--color-accent)',
      color: 'var(--opg-white)',
      fontFamily: 'var(--font-sans)',
      fontSize: '0.625rem',
      fontWeight: 700,
      display: 'grid',
      placeItems: 'center'
    }
  }, cartCount) : null), !compact ? /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 12
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "primary",
    size: "sm",
    onClick: () => onNavigate && onNavigate('/personalised-colouring-books/create-your-book/')
  }, "Create Your Book")) : null)));
}
Object.assign(__ds_scope, { Header });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Header.jsx", error: String((e && e.message) || e) }); }

// components/navigation/MobileNav.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const NAV = [{
  label: 'Colouring Books',
  href: '/personalised-colouring-books/'
}, {
  label: 'Photo Albums',
  href: '/photo-album/'
}, {
  label: 'Art Collection',
  href: '/art-collection/'
}, {
  label: 'Gallery',
  href: '/gallery/'
}, {
  label: 'How It Works',
  href: '/how-it-works/'
}, {
  label: 'Reviews',
  href: '/reviews/'
}, {
  label: 'Partnerships',
  href: '/partnerships/',
  children: [{ label: 'All partnerships', href: '/partnerships/' }, { label: 'Schools & SEN', href: '/partnerships/schools-sen/' }, { label: 'Care Homes', href: '/partnerships/care-homes/' }, { label: 'Football Clubs', href: '/partnerships/football-clubs/' }]
}, {
  label: 'Contact',
  href: '/contact/'
}];

/* Editorial, not a nested Shopify drawer: large text links, generous spacing,
   one featured transformation image, one clear CTA. */
function MobileNav({
  open = true,
  items = NAV,
  onClose,
  onNavigate,
  style,
  ...rest
}) {
  const [exp, setExp] = React.useState(null);
  if (!open) return null;
  const subRow = it => { const on = exp === it.href; return React.createElement("div", { key: it.href, style: { borderBottom: '1px solid var(--color-border)' } }, React.createElement("button", { type: 'button', 'aria-expanded': on, onClick: () => setExp(on ? null : it.href), style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '15px 0', margin: 0, background: 'none', border: 0, cursor: 'pointer', textAlign: 'left', fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: '1.65rem', lineHeight: 1.1, color: 'var(--color-brand)' } }, it.label, React.createElement(__ds_scope.Icon, { name: on ? 'chevron-up' : 'chevron-down', size: 20 })), on ? React.createElement("div", { style: { display: 'grid', gap: 2, padding: '0 0 14px 2px' } }, it.children.map(c => React.createElement("a", { key: c.href, href: c.href, onClick: e => { if (onNavigate) { e.preventDefault(); onNavigate(c.href); } }, style: { display: 'flex', alignItems: 'center', minHeight: 44, paddingLeft: 16, borderLeft: '2px solid var(--color-border-strong)', fontFamily: 'var(--font-sans)', fontSize: '1.0625rem', fontWeight: 600, color: 'var(--color-brand)', textDecoration: 'none' } }, c.label))) : null); };
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Menu",
    style: {
      position: 'absolute',
      inset: 0,
      zIndex: 'var(--z-drawer)',
      background: 'var(--opg-white)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 'var(--header-height-mobile)',
      paddingInline: 'var(--gutter)',
      borderBottom: '1px solid var(--color-border)',
      flex: 'none'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.OneWordmark, {
    size: 18
  }), /*#__PURE__*/React.createElement(__ds_scope.IconButton, {
    label: "Close menu",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "x",
    size: 23
  }))), /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Main",
    style: {
      display: 'grid',
      paddingInline: 'var(--gutter)',
      paddingTop: 'var(--space-6)'
    }
  }, items.map(it => it.children ? subRow(it) : /*#__PURE__*/React.createElement("a", {
    key: it.href,
    href: it.href,
    onClick: e => {
      if (onNavigate) {
        e.preventDefault();
        onNavigate(it.href);
      }
    },
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '15px 0',
      borderBottom: '1px solid var(--color-border)',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: '1.65rem',
      lineHeight: 1.1,
      color: 'var(--color-brand)',
      textDecoration: 'none'
    }
  }, it.label, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "chevron-right",
    size: 20
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 'var(--space-6) var(--gutter) var(--space-7)',
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "primary",
    size: "lg",
    fullWidth: true,
    onClick: () => { onClose && onClose(); onNavigate && onNavigate('/personalised-colouring-books/create-your-book/'); }
  }, "Create Your Book"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 6,
      borderRadius: 'var(--radius-md)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: __ds_scope.asset('transform/jade-family-before.png'),
    alt: "Original family photo",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: __ds_scope.asset('transform/jade-family-after.png'),
    alt: "The same photo as a finished colouring page",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      display: 'block',
      background: 'var(--opg-white)'
    }
  })), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontSize: 'var(--text-lg)',
      fontStyle: 'italic',
      color: 'var(--color-text-muted)'
    }
  }, "Designed with love by One Print Gallery.")));
}
Object.assign(__ds_scope, { MobileNav });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/MobileNav.jsx", error: String((e && e.message) || e) }); }

// components/transformation/BeforeAfterSlider.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const DEFAULT_PAIR = { before: 'transform/family-before-aligned.png', after: 'transform/family-after-aligned.png' };

/* The brand's required signature component. Draggable, keyboard accessible,
   touch-capable, labels stay visible, default position 50%, never autoplays. */
function BeforeAfterSlider({
  beforeLabel = 'Original photo',
  afterLabel = 'Carefully transformed by One Print Gallery',
  beforeSrc = __ds_scope.asset(DEFAULT_PAIR.before),
  afterSrc = __ds_scope.asset(DEFAULT_PAIR.after),
  beforePlaceholder = '[SUPPLIED BEFORE PHOTO]',
  afterPlaceholder = '[SUPPLIED OPG TRANSFORMATION]',
  ratio = '4 / 5',
  initial = 50,
  style,
  ...rest
}) {
  const [pos, setPos] = React.useState(initial);
  const [dragging, setDragging] = React.useState(false);
  const ref = React.useRef(null);
  const move = React.useCallback(clientX => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, (clientX - r.left) / r.width * 100)));
  }, []);
  React.useEffect(() => {
    if (!dragging) return;
    const mm = e => move(e.clientX);
    const tm = e => e.touches[0] && move(e.touches[0].clientX);
    const up = () => setDragging(false);
    window.addEventListener('mousemove', mm);
    window.addEventListener('mouseup', up);
    window.addEventListener('touchmove', tm, {
      passive: true
    });
    window.addEventListener('touchend', up);
    return () => {
      window.removeEventListener('mousemove', mm);
      window.removeEventListener('mouseup', up);
      window.removeEventListener('touchmove', tm);
      window.removeEventListener('touchend', up);
    };
  }, [dragging, move]);
  const onKey = e => {
    const step = e.shiftKey ? 10 : 2;
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      setPos(p => Math.max(0, p - step));
    }
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      setPos(p => Math.min(100, p + step));
    }
    if (e.key === 'Home') {
      e.preventDefault();
      setPos(0);
    }
    if (e.key === 'End') {
      e.preventDefault();
      setPos(100);
    }
  };
  const layer = {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  };
  return /*#__PURE__*/React.createElement("figure", _extends({
    style: {
      margin: 0,
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    ref: ref,
    onMouseDown: e => {
      setDragging(true);
      move(e.clientX);
    },
    onTouchStart: e => {
      setDragging(true);
      e.touches[0] && move(e.touches[0].clientX);
    },
    style: {
      position: 'relative',
      width: '100%',
      aspectRatio: ratio,
      minHeight: 320,
      overflow: 'hidden',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      background: 'var(--opg-paper)',
      cursor: dragging ? 'grabbing' : 'ew-resize',
      userSelect: 'none',
      touchAction: 'pan-y'
    }
  }, afterSrc ? /*#__PURE__*/React.createElement("img", {
    src: afterSrc,
    alt: afterLabel,
    style: layer
  }) : /*#__PURE__*/React.createElement(__ds_scope.MediaPlaceholder, {
    label: afterPlaceholder,
    ratio: ratio,
    tone: "paper",
    rounded: "none",
    style: {
      ...layer,
      aspectRatio: 'auto',
      border: 'none'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      clipPath: `inset(0 ${100 - pos}% 0 0)`
    }
  }, beforeSrc ? /*#__PURE__*/React.createElement("img", {
    src: beforeSrc,
    alt: beforeLabel,
    style: layer
  }) : /*#__PURE__*/React.createElement(__ds_scope.MediaPlaceholder, {
    label: beforePlaceholder,
    ratio: ratio,
    tone: "blush",
    rounded: "none",
    style: {
      ...layer,
      aspectRatio: 'auto',
      border: 'none'
    }
  })), /*#__PURE__*/React.createElement("span", {
    style: labelStyle('left')
  }, beforeLabel), /*#__PURE__*/React.createElement("span", {
    style: labelStyle('right')
  }, afterLabel), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: `${pos}%`,
      width: 2,
      marginLeft: -1,
      background: 'var(--opg-white)',
      boxShadow: '0 0 0 1px rgba(41,47,78,.18)'
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    role: "slider",
    "aria-label": "Reveal the original photograph",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": Math.round(pos),
    "aria-valuetext": `${Math.round(pos)}% original photo`,
    onKeyDown: onKey,
    onMouseDown: e => {
      e.stopPropagation();
      setDragging(true);
    },
    onTouchStart: e => {
      e.stopPropagation();
      setDragging(true);
    },
    style: {
      position: 'absolute',
      top: '50%',
      left: `${pos}%`,
      transform: 'translate(-50%,-50%)',
      width: 48,
      height: 48,
      borderRadius: '50%',
      border: '1px solid var(--opg-white)',
      background: 'var(--opg-navy-700)',
      color: 'var(--opg-white)',
      display: 'grid',
      placeItems: 'center',
      cursor: 'grab',
      padding: 0
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 8-4 4 4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 8 4 4-4 4"
  })))), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      marginTop: 14,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, "Drag to compare. Use the arrow keys for fine control."));
}
function labelStyle(side) {
  return {
    position: 'absolute',
    bottom: 16,
    [side]: 16,
    maxWidth: '44%',
    padding: '7px 12px',
    borderRadius: 'var(--radius-xs)',
    background: 'rgba(41,47,78,.88)',
    color: 'var(--opg-white)',
    fontFamily: 'var(--font-sans)',
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    lineHeight: 1.35,
    textAlign: side === 'right' ? 'right' : 'left',
    pointerEvents: 'none'
  };
}
Object.assign(__ds_scope, { BeforeAfterSlider });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/transformation/BeforeAfterSlider.jsx", error: String((e && e.message) || e) }); }

// components/transformation/PhotoUploader.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SEED = [{
  id: 1,
  name: 'beach-day.jpg',
  state: 'uploaded'
}, {
  id: 2,
  name: 'first-day-school.heic',
  state: 'uploaded'
}, {
  id: 3,
  name: 'grandad-garden.jpg',
  state: 'uploading',
  progress: 62
}, {
  id: 4,
  name: 'screenshot-2026.png',
  state: 'rejected',
  reason: "This looks like a screenshot. Send the original if you have it."
}];
const ACCEPT = /\.(jpe?g|png|heic|heif)$/i;
const opgFingerprint = async f => {
  const out = {};
  try { const d = await crypto.subtle.digest('SHA-256', await f.arrayBuffer()); out.sha = Array.from(new Uint8Array(d)).map(b => b.toString(16).padStart(2, '0')).join(''); } catch (e) {}
  try {
    const bmp = await createImageBitmap(f); const W = 17, H = 16;
    const S = 8, c = document.createElement('canvas'); c.width = W * S; c.height = H * S; const x = c.getContext('2d'); x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high'; x.drawImage(bmp, 0, 0, W * S, H * S);
    const d = x.getImageData(0, 0, W * S, H * S).data, g = new Array(W * H).fill(0);
    for (let py = 0; py < H * S; py++) for (let px = 0; px < W * S; px++) { const o = (py * W * S + px) * 4; g[((py / S) | 0) * W + ((px / S) | 0)] += d[o] * 0.299 + d[o + 1] * 0.587 + d[o + 2] * 0.114; }
    const bits = []; for (let y = 0; y < H; y++) for (let k = 0; k < W - 1; k++) bits.push(g[y * W + k] > g[y * W + k + 1] ? 1 : 0);
    out.dh = bits; out.ar = bmp.width / bmp.height; if (bmp.close) bmp.close();
  } catch (e) {}
  return out;
};
const opgSame = (a, b) => {
  if (a.sha && a.sha === b.sha) return true;
  if (a.dh && b.dh && Math.abs(Math.log(a.ar / b.ar)) < 0.04) { let n = 0; for (let i = 0; i < a.dh.length; i++) if (a.dh[i] !== b.dh[i]) n++; return n <= 24; }
  return false;
};
const opgMarkDup = (prev, id, fp) => {
  const list = prev.map(q => q.id === id ? { ...q, fp } : q);
  const me = list.find(q => q.id === id); if (!me || me.state === 'rejected') return list;
  const other = list.find(q => q.id !== id && q.state !== 'rejected' && q.fp && opgSame(q.fp, fp)); if (!other) return list;
  const loser = list.indexOf(me) > list.indexOf(other) ? me : other, keeper = loser === me ? other : me;
  const page = list.filter(z => z.state !== 'rejected').indexOf(keeper) + 1;
  return list.map(q => q.id === loser.id ? { ...q, state: 'rejected', dup: true, progress: undefined, reason: `This is the same photo as Page ${page}. Please remove it and choose a different photo.` } : q);
};

const MAX_MB = 25;
let uid = 1000;
function PhotoUploader({
  required = 15,
  photos = SEED,
  onChange,
  captions = false,
  captionPlaceholder = 'Names or a short caption',
  style,
  ...rest
}) {
  const [items, setItems] = React.useState(photos);
  const [over, setOver] = React.useState(false);
  const [drag, setDrag] = React.useState(null);
  const input = React.useRef(null);
  const timers = React.useRef([]);
  React.useEffect(() => () => timers.current.forEach(clearInterval), []);
  const commit = fn => setItems(prev => {
    const next = fn(prev);
    onChange && onChange(next);
    return next;
  });
  const ok = items.filter(p => p.state === 'uploaded').length;
  const live = items.filter(p => p.state !== 'rejected').length;
  const full = ok >= required;
  const room = Math.max(0, required - live);
  const simulate = id => {
    const t = setInterval(() => commit(prev => prev.map(p => {
      if (p.id !== id || p.state !== 'uploading') return p;
      const progress = Math.min(100, (p.progress || 0) + 12 + Math.random() * 22);
      if (progress >= 100) {
        clearInterval(t);
        return {
          ...p,
          state: 'uploaded',
          progress: 100
        };
      }
      return {
        ...p,
        progress: Math.round(progress)
      };
    })), 180);
    timers.current.push(t);
  };
  const add = files => {
    const list = Array.from(files || []);
    if (!list.length) return;
    const fresh = [];
    let slots = room;
    list.forEach(f => {
      const id = ++uid;
      const img = /^image\//.test(f.type) || ACCEPT.test(f.name);
      const src = img && /^image\/(jpe?g|png|webp|gif)/.test(f.type) ? URL.createObjectURL(f) : undefined;
      if (!img) fresh.push({
        id,
        name: f.name,
        state: 'rejected',
        reason: 'Please choose a JPG, PNG or HEIC photograph.'
      });else if (f.size > MAX_MB * 1048576) fresh.push({
        id,
        name: f.name,
        src,
        state: 'rejected',
        reason: `This file is over ${MAX_MB}MB. Try the version from your camera roll.`
      });else if (slots <= 0) fresh.push({
        id,
        name: f.name,
        src,
        state: 'rejected',
        reason: `Your book has ${required} pages. Remove one to use this photo, or choose more pages.`
      });else {
        slots--;
        fresh.push({
          id,
          name: f.name,
          src,
          file: f,
          state: 'uploading',
          progress: 4
        });
      }
    });
    commit(prev => [...prev, ...fresh]);
    fresh.filter(p => p.state === 'uploading').forEach(p => simulate(p.id));
    fresh.filter(p => p.file && p.state === 'uploading').forEach(p => opgFingerprint(p.file).then(fp => commit(prev => opgMarkDup(prev, p.id, fp))));
  };
  const remove = id => commit(prev => prev.filter(p => p.id !== id));
  const move = (from, to) => commit(prev => {
    if (to < 0 || to >= prev.length || from === to) return prev;
    const next = prev.slice();
    const [m] = next.splice(from, 1);
    next.splice(to, 0, m);
    return next;
  });
  const retry = id => {
    if (room <= 0) return;
    commit(prev => prev.map(p => p.id === id ? {
      ...p,
      state: 'uploading',
      progress: 4,
      reason: undefined
    } : p));
    simulate(id);
  };
  const caption = (id, v) => commit(prev => prev.map(p => p.id === id ? {
    ...p,
    caption: v
  } : p));
  let page = 0;
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: 'grid',
      gap: 'var(--space-5)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("input", {
    ref: input,
    type: "file",
    multiple: true,
    accept: "image/jpeg,image/png,image/heic,image/heif,.heic,.heif",
    hidden: true,
    onChange: e => {
      add(e.target.files);
      e.target.value = '';
    }
  }), /*#__PURE__*/React.createElement("div", {
    onDragOver: e => {
      if (drag !== null) return;
      e.preventDefault();
      setOver(true);
    },
    onDragLeave: () => setOver(false),
    onDrop: e => {
      if (drag !== null) return;
      e.preventDefault();
      setOver(false);
      add(e.dataTransfer.files);
    },
    style: {
      display: 'grid',
      justifyItems: 'center',
      gap: 10,
      textAlign: 'center',
      padding: 'var(--space-7) var(--space-5)',
      border: `1px ${over ? 'solid' : 'dashed'} ${full ? 'var(--color-border-strong)' : 'var(--color-brand)'}`,
      borderRadius: 'var(--radius-md)',
      background: over ? 'var(--opg-blush-100)' : full ? 'var(--opg-mist)' : 'var(--opg-paper)',
      transition: 'background var(--motion-fast) var(--ease-standard)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: full ? 'var(--color-text-muted)' : 'var(--color-brand)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: full ? 'check' : 'upload',
    size: 26,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-brand)',
      lineHeight: 1.2
    }
  }, full ? 'We have all your photos.' : over ? 'Drop them here' : 'Choose the photographs you want in the book'), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)',
      maxWidth: '46ch'
    }
  }, full ? 'You can still swap, reorder or remove any of them below.' : `Drag them here, or choose from your phone. JPG, PNG and HEIC accepted. Phone snaps and old prints are perfect.`), !full ? /*#__PURE__*/React.createElement("span", {
    style: {
      marginTop: 6
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "brand",
    size: "sm",
    onClick: () => input.current && input.current.click()
  }, live ? `Add ${room} more` : 'Upload Your Photos')) : null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      flexWrap: 'wrap',
      gap: '4px 12px',
      marginBottom: 8
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-brand)'
    }
  }, ok, " of ", required, " uploaded"), full ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'var(--color-success)'
    }
  }, "Ready") : items.length > 1 ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, "Drag to set the page order") : null), /*#__PURE__*/React.createElement("div", {
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": required,
    "aria-valuenow": ok,
    style: {
      height: 3,
      borderRadius: 'var(--radius-xs)',
      background: 'var(--color-border)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      height: '100%',
      width: `${Math.min(100, ok / required * 100)}%`,
      background: 'var(--gradient-brush)',
      transition: 'width var(--motion-base) var(--ease-standard)'
    }
  }))), items.length ? /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr)',
      gap: '10px'
    }
  }, items.map((p, i) => {
    const bad = p.state === 'rejected';
    const n = bad ? null : ++page;
    return /*#__PURE__*/React.createElement("li", {
      key: p.id,
      draggable: true,
      onDragStart: e => {
        setDrag(i);
        e.dataTransfer.effectAllowed = 'move';
      },
      onDragOver: e => {
        if (drag === null) return;
        e.preventDefault();
        if (drag !== i) {
          move(drag, i);
          setDrag(i);
        }
      },
      onDragEnd: () => setDrag(null),
      style: {
        display: 'grid',
        gridTemplateColumns: '22px 56px minmax(0,1fr) auto',
        gap: '12px',
        alignItems: 'center',
        padding: '10px 12px',
        border: `1px solid ${bad ? 'var(--color-error)' : drag === i ? 'var(--color-brand)' : 'var(--color-border)'}`,
        borderRadius: 'var(--radius-sm)',
        background: drag === i ? 'var(--opg-paper)' : 'var(--opg-white)',
        opacity: drag === i ? 0.85 : 1
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'var(--color-border-strong)',
        cursor: 'grab'
      },
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
      name: "grip-vertical",
      size: 18
    })), /*#__PURE__*/React.createElement("span", {
      style: {
        width: 56,
        height: 56,
        borderRadius: 'var(--radius-xs)',
        background: 'var(--opg-mist)',
        display: 'grid',
        placeItems: 'center',
        color: 'var(--color-text-muted)',
        overflow: 'hidden'
      }
    }, p.src ? /*#__PURE__*/React.createElement("img", {
      src: p.src,
      alt: "",
      style: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
        opacity: p.state === 'uploading' ? 0.55 : 1,
        filter: bad ? 'grayscale(1)' : 'none'
      }
    }) : /*#__PURE__*/React.createElement(__ds_scope.Icon, {
      name: "image",
      size: 20,
      strokeWidth: 1.5
    })), /*#__PURE__*/React.createElement("span", {
      style: {
        minWidth: 0,
        display: 'grid',
        gap: 6
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'flex',
        gap: 10,
        alignItems: 'baseline',
        minWidth: 0
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        flex: 1,
        minWidth: 0,
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        fontWeight: 600,
        color: 'var(--color-text)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'var(--color-text-muted)',
        fontWeight: 500
      }
    }, n ? `Page ${n} · ` : 'Not added · '), p.name), /*#__PURE__*/React.createElement("span", {
      style: {
        flex: 'none',
        fontFamily: 'var(--font-sans)',
        fontSize: '0.6875rem',
        fontWeight: 700,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        color: p.state === 'uploaded' ? 'var(--color-success)' : bad ? 'var(--color-error)' : 'var(--color-text-muted)'
      }
    }, p.state === 'uploaded' ? 'Uploaded' : p.state === 'uploading' ? `${p.progress}%` : 'Not used')), p.state === 'uploading' ? /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        height: 2,
        background: 'var(--color-border)',
        borderRadius: 'var(--radius-xs)'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        height: '100%',
        width: `${p.progress}%`,
        background: 'var(--color-accent-warm)',
        transition: 'width 160ms linear'
      }
    })) : null, bad ? /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 'var(--text-xs)',
        fontWeight: 600,
        lineHeight: 1.45,
        color: 'var(--color-error)'
      }
    }, p.reason, room > 0 && p.src && !/over|JPG/.test(p.reason || '') && !p.dup ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => retry(p.id),
      style: {
        padding: 0,
        border: 0,
        background: 'none',
        font: 'inherit',
        color: 'var(--color-brand)',
        textDecoration: 'underline',
        cursor: 'pointer'
      }
    }, "Use it now")) : null) : null), /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/React.createElement(__ds_scope.IconButton, {
      label: `Move ${p.name} up`,
      size: 36,
      onClick: () => move(i, i - 1),
      disabled: i === 0,
      style: {
        opacity: i === 0 ? 0.3 : 1
      }
    }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
      name: "chevron-up",
      size: 17
    })), /*#__PURE__*/React.createElement(__ds_scope.IconButton, {
      label: `Move ${p.name} down`,
      size: 36,
      onClick: () => move(i, i + 1),
      disabled: i === items.length - 1,
      style: {
        opacity: i === items.length - 1 ? 0.3 : 1
      }
    }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
      name: "chevron-down",
      size: 17
    })), /*#__PURE__*/React.createElement(__ds_scope.IconButton, {
      label: `Remove ${p.name}`,
      size: 36,
      onClick: () => remove(p.id)
    }, /*#__PURE__*/React.createElement(__ds_scope.Icon, {
      name: "trash-2",
      size: 17
    }))), captions && !bad ? /*#__PURE__*/React.createElement("input", {
      value: p.caption || '',
      onChange: e => caption(p.id, e.target.value),
      placeholder: captionPlaceholder,
      "aria-label": `Names or caption for page ${n}`,
      maxLength: 40,
      style: {
        gridColumn: '1 / -1',
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        padding: '11px 12px',
        border: '1.5px solid var(--color-border-strong)',
        borderRadius: 'var(--radius-xs)',
        fontFamily: 'var(--font-sans)',
        fontSize: '16px',
        color: 'var(--color-text)',
        background: 'var(--opg-white)'
      }
    }) : null);
  })) : null, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, "Your photos are used only to create your personalised order and are handled in line with our Privacy Policy."));
}
Object.assign(__ds_scope, { PhotoUploader });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/transformation/PhotoUploader.jsx", error: String((e && e.message) || e) }); }

// components/transformation/TransformationTriptych.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const PAIR = __ds_scope.transformation('colouring');
const DEFAULTS = [{
  label: 'Original photo',
  src: __ds_scope.asset(PAIR.before),
  tone: 'blush'
}, {
  label: 'Carefully transformed and refined',
  src: __ds_scope.asset(PAIR.after),
  tone: 'paper'
}, {
  label: 'Finished book',
  src: __ds_scope.asset(__ds_scope.book('luna').front),
  tone: 'paper'
}];

/* Original -> transformation -> finished object, for pages where a slider is not ideal. */
function TransformationTriptych({
  stages = DEFAULTS,
  ratio = '4 / 5',
  numbered = true,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("ol", _extends({
    "data-opg-cols": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: `repeat(${stages.length}, minmax(0,1fr))`,
      gap: 'var(--grid-gap-lg)',
      ...style
    }
  }, rest), stages.map((s, i) => /*#__PURE__*/React.createElement("li", {
    key: s.label,
    style: {
      minWidth: 0
    }
  }, s.src ? /*#__PURE__*/React.createElement("img", {
    src: s.src,
    alt: s.label,
    style: {
      width: '100%',
      aspectRatio: ratio,
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)'
    }
  }) : /*#__PURE__*/React.createElement(__ds_scope.MediaPlaceholder, {
    label: s.placeholder,
    ratio: ratio,
    tone: s.tone || 'paper'
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 10,
      alignItems: 'baseline',
      marginTop: 16
    }
  }, numbered ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-lg)',
      color: 'var(--color-accent-warm)',
      lineHeight: 1
    }
  }, String(i + 1).padStart(2, '0')) : null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-brand)'
    }
  }, s.label)), s.note ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '8px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, s.note) : null)));
}
Object.assign(__ds_scope, { TransformationTriptych });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/transformation/TransformationTriptych.jsx", error: String((e && e.message) || e) }); }

// shopify-theme/assets/opg-theme.js
try { (() => {
/* One Print Gallery theme scripts: before/after sliders + Create Your Book builder. No dependencies. */
(function () {
  'use strict';

  document.addEventListener('input', function (e) {
    var r = e.target;
    if (r.classList && r.classList.contains('opg-ba__range')) r.closest('.opg-ba').style.setProperty('--pos', r.value + '%');
  });
  var canDT = function () {
    try {
      var d = new DataTransfer();
      d.items.add(new File(['x'], 'x.txt'));
      return d.files.length === 1;
    } catch (e) {
      return false;
    }
  }();
  var STEPS = ['Choose', 'Personalise', 'Upload', 'Preview', 'Review'];
  var PREVIEWABLE = /^image\/(jpe?g|png|webp|gif)$/;
  var COMPRESSIBLE = /^image\/(jpe?g|png|webp)$/;
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[c];
    });
  }
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }
  function shrink(file) {
    if (!window.createImageBitmap || !COMPRESSIBLE.test(file.type) || file.size < 2.5 * 1048576) return Promise.resolve(file);
    return createImageBitmap(file, {
      imageOrientation: 'from-image'
    }).catch(function () {
      return createImageBitmap(file);
    }).then(function (bmp) {
      var sc = Math.min(1, 3200 / Math.max(bmp.width, bmp.height));
      var c = document.createElement('canvas');
      c.width = Math.round(bmp.width * sc);
      c.height = Math.round(bmp.height * sc);
      var x = c.getContext('2d');
      x.fillStyle = '#fff';
      x.fillRect(0, 0, c.width, c.height);
      x.drawImage(bmp, 0, 0, c.width, c.height);
      return new Promise(function (res) {
        c.toBlob(function (b) {
          res(b && b.size < file.size ? new File([b], file.name.replace(/\.[^.]+$/, '') + '.jpg', {
            type: 'image/jpeg',
            lastModified: Date.now()
          }) : file);
        }, 'image/jpeg', 0.88);
      });
    }).catch(function () {
      return file;
    });
  }
  function Builder(root) {
    this.root = root;
    this.d = JSON.parse(root.querySelector('[data-bb-data]').textContent);
    this.form = root.querySelector('[data-bb-form]');
    this.step = 0;
    this.reached = 0;
    this.p = 0;
    this.pages = null;
    this.qty = 1;
    this.slots = [];
    this.spare = [];
    this.sending = false;
    this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: this.d.currency || 'GBP'
    });
    this.init();
  }
  var B = Builder.prototype;
  B.$ = function (s) {
    return this.root.querySelector(s);
  };
  B.$$ = function (s) {
    return Array.prototype.slice.call(this.root.querySelectorAll(s));
  };
  B.prod = function () {
    return this.d.products[this.p];
  };
  B.pagesOf = function (v) {
    var n = parseInt(v.options[this.prod().pi], 10);
    return isNaN(n) ? null : n;
  };
  B.variant = function () {
    var self = this;
    var vs = this.prod().variants.filter(function (v) {
      return self.pagesOf(v) === self.pages;
    });
    return vs.filter(function (v) {
      return v.available;
    })[0] || vs[0] || null;
  };
  B.fmt = function (cents) {
    return this.money.format(cents / 100);
  };
  B.filled = function () {
    return this.slots.filter(function (s) {
      return s.file && !s.busy;
    }).length;
  };
  B.busy = function () {
    return this.slots.some(function (s) {
      return s.busy;
    });
  };
  B.init = function () {
    var self = this;
    this.$$('[name="bb-size"]').forEach(function (r) {
      r.addEventListener('change', function () {
        self.setProduct(+r.value);
      });
    });
    this.$('[data-bb-pages]').addEventListener('change', function (e) {
      if (e.target.name === 'bb-pages') {
        self.pages = +e.target.value;
        self.update();
      }
    });
    this.$('[data-bb-minus]').addEventListener('click', function () {
      self.qty = Math.max(1, self.qty - 1);
      self.update();
    });
    this.$('[data-bb-plus]').addEventListener('click', function () {
      self.qty = Math.min(20, self.qty + 1);
      self.update();
    });
    this.$('[data-bb-title]').addEventListener('input', function (e) {
      self.$('[data-bb-cover-title]').textContent = e.target.value || 'Your cover title';
      self.summary();
      self.clearErr();
    });
    var cover = this.$('[data-bb-cover]');
    cover.addEventListener('change', function () {
      self.coverChanged();
    });
    this.$('[data-bb-cover-clear]').addEventListener('click', function () {
      cover.value = '';
      self.coverChanged();
    });
    var bulk = this.$('[data-bb-bulk]');
    bulk.addEventListener('change', function () {
      self.addMany(bulk.files);
      bulk.value = '';
    });
    var drop = this.$('[data-bb-drop]');
    if (canDT) {
      ['dragenter', 'dragover'].forEach(function (t) {
        drop.addEventListener(t, function (e) {
          e.preventDefault();
          drop.classList.add('is-over');
        });
      });
      ['dragleave', 'drop'].forEach(function (t) {
        drop.addEventListener(t, function () {
          drop.classList.remove('is-over');
        });
      });
      drop.addEventListener('drop', function (e) {
        e.preventDefault();
        self.addMany(e.dataTransfer.files);
      });
    } else {
      drop.hidden = true; // older browsers: one photo per slot
    }
    this.$$('[data-bb-preview]').forEach(function (r) {
      r.addEventListener('change', function () {
        self.clearErr();
        self.summary();
      });
    });
    this.$('[data-bb-rights]').addEventListener('change', function () {
      self.clearErr();
    });
    this.$$('[data-bb-goto]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.dataset.bbGoto;
        if (i <= self.reached) self.go(i);
      });
    });
    this.$('[data-bb-next]').addEventListener('click', function () {
      self.next();
    });
    this.$('[data-bb-back]').addEventListener('click', function () {
      self.go(Math.max(0, self.step - 1));
    });
    this.form.addEventListener('submit', function (e) {
      if (!self.sending) {
        e.preventDefault();
        self.next();
      }
    });
    this.setProduct(0);
    this.go(0, true);
  };
  B.setProduct = function (i) {
    var self = this;
    this.p = i;
    var counts = [];
    this.prod().variants.forEach(function (v) {
      var n = self.pagesOf(v);
      if (n && counts.indexOf(n) < 0) counts.push(n);
    });
    counts.sort(function (a, b) {
      return a - b;
    });
    if (counts.indexOf(this.pages) < 0) this.pages = counts.indexOf(this.d.default_pages) >= 0 ? this.d.default_pages : counts[0];
    var noun = this.d.noun || 'page';
    this.$('[data-bb-pages]').innerHTML = counts.map(function (n) {
      var vs = self.prod().variants.filter(function (v) {
        return self.pagesOf(v) === n;
      });
      var v = vs.filter(function (x) {
        return x.available;
      })[0] || vs[0];
      var out = !v.available;
      return '<label class="opg-rc' + (out ? ' is-out' : '') + '"><input type="radio" name="bb-pages" value="' + n + '"' + (n === self.pages ? ' checked' : '') + (out ? ' disabled' : '') + '><span><span class="opg-rc__t">' + n + ' ' + noun + 's</span><span class="opg-rc__d">' + (out ? 'Sold out' : self.fmt(v.price) + ' · ' + n + ' photos') + '</span></span></label>';
    }).join('');
    var img = this.$('[data-bb-sum-img]');
    if (img && this.prod().image) img.src = this.prod().image;
    this.update();
  };
  B.update = function () {
    var v = this.variant();
    if (v) this.$('[data-bb-variant]').value = v.id;
    this.$('[data-bb-qty-input]').value = this.qty;
    this.$('[data-bb-qty]').textContent = this.qty;
    this.resize(this.pages || 0);
    this.summary();
  };

  /* ---------- photo slots: each slot is a real <input type=file name="properties[Photo NN]"> ---------- */
  B.resize = function (n) {
    var self = this,
      list = this.$('[data-bb-slots]');
    while (this.slots.length < n) {
      var s = this.makeSlot(this.slots.length);
      list.appendChild(s.el);
      this.slots.push(s);
      if (canDT && this.spare.length) this.setFile(s, this.spare.shift());
    }
    while (this.slots.length > n) {
      var x = this.slots.pop();
      if (x.file) this.spare.unshift(x.file);
      if (x.url) URL.revokeObjectURL(x.url);
      x.el.remove();
    }
    this.slots.forEach(function (s, i) {
      s.i = i;
      s.input.name = 'properties[Photo ' + pad(i + 1) + ']';
      s.num.textContent = i + 1;
      s.empty.textContent = 'Photo ' + (i + 1);
      s.input.setAttribute('aria-label', 'Photo ' + (i + 1));
      self.paint(s);
    });
    this.$$('[data-bb-n]').forEach(function (e) {
      e.textContent = n;
    });
    this.photoStatus();
  };
  B.makeSlot = function () {
    var self = this,
      li = document.createElement('li');
    li.className = 'opg-bb__slot';
    li.innerHTML = '<label class="opg-bb__pick"><input type="file" accept="image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif"><img alt="" hidden><span class="opg-bb__num"></span><span class="opg-bb__empty"></span><span class="opg-bb__fname"></span></label>' + '<div class="opg-bb__tools"><button type="button" data-a="l" aria-label="Move earlier">‹</button><button type="button" data-a="x" aria-label="Remove photo">✕</button><button type="button" data-a="r" aria-label="Move later">›</button></div>';
    var s = {
      el: li,
      input: li.querySelector('input'),
      img: li.querySelector('img'),
      num: li.querySelector('.opg-bb__num'),
      empty: li.querySelector('.opg-bb__empty'),
      fname: li.querySelector('.opg-bb__fname'),
      file: null,
      busy: false,
      url: null,
      i: 0
    };
    s.input.addEventListener('change', function () {
      var f = s.input.files && s.input.files[0];
      if (f) self.take(s, f);else self.setFile(s, null);
    });
    li.querySelector('.opg-bb__tools').addEventListener('click', function (e) {
      var a = e.target.closest('button');
      if (!a) return;
      if (a.dataset.a === 'x') {
        self.setFile(s, null);
        s.input.value = '';
        self.photoStatus();
      } else self.swap(s.i, s.i + (a.dataset.a === 'l' ? -1 : 1));
    });
    return s;
  };
  B.take = function (s, f) {
    var self = this,
      max = (this.d.max_mb || 20) * 1048576;
    s.busy = true;
    s.file = f;
    this.paint(s);
    this.photoStatus();
    shrink(f).then(function (nf) {
      s.busy = false;
      if (nf.size > max) {
        self.setFile(s, null);
        s.input.value = '';
        self.photoStatus(f.name + ' is too large (over ' + self.d.max_mb + 'MB). Please choose a smaller copy.');
        return;
      }
      if (nf !== f || !canDT) {
        self.setFile(s, nf);
      } else {
        self.setFile(s, nf);
      }
      self.photoStatus();
    });
  };
  B.setFile = function (s, f) {
    s.file = f || null;
    if (canDT) {
      var dt = new DataTransfer();
      if (f) dt.items.add(f);
      s.input.files = dt.files;
    }
    if (s.url) {
      URL.revokeObjectURL(s.url);
      s.url = null;
    }
    if (f && PREVIEWABLE.test(f.type)) s.url = URL.createObjectURL(f);
    this.paint(s);
  };
  B.paint = function (s) {
    s.el.classList.toggle('is-filled', !!s.file);
    s.el.classList.toggle('is-busy', !!s.busy);
    s.img.hidden = !s.url;
    if (s.url) s.img.src = s.url;
    s.fname.textContent = s.file && !s.url ? s.file.name : '';
    var tools = s.el.querySelector('.opg-bb__tools');
    tools.hidden = !s.file || s.busy;
    tools.querySelector('[data-a="l"]').disabled = !canDT || s.i === 0;
    tools.querySelector('[data-a="r"]').disabled = !canDT || s.i === this.slots.length - 1;
  };
  B.swap = function (i, j) {
    if (!canDT || j < 0 || j >= this.slots.length) return;
    var a = this.slots[i],
      b = this.slots[j],
      fa = a.file,
      fb = b.file;
    this.setFile(a, fb);
    this.setFile(b, fa);
    b.input.focus && b.el.querySelector('.opg-bb__tools button[data-a="' + (j < i ? 'l' : 'r') + '"]').focus();
  };
  B.addMany = function (files) {
    var self = this,
      list = Array.prototype.slice.call(files || []),
      left = 0;
    list.forEach(function (f) {
      var s = self.slots.filter(function (x) {
        return !x.file && !x.busy;
      })[0];
      if (!s) {
        left++;
        return;
      }
      self.take(s, f);
    });
    this.photoStatus(left ? left + ' photo' + (left > 1 ? 's' : '') + ' didn’t fit. Your book has ' + this.slots.length + ' pages. Remove some, or go back and choose more pages.' : '');
  };
  B.photoStatus = function (msg) {
    var n = this.slots.length,
      ok = this.filled();
    this.$('[data-bb-filled]').textContent = ok;
    this.$('[data-bb-bar]').style.width = (n ? ok / n * 100 : 0) + '%';
    var el = this.$('[data-bb-photo-msg]');
    if (typeof msg === 'string' && msg) {
      el.textContent = msg;
      el.className = 'opg-bb__note is-warn';
    } else if (this.busy()) {
      el.textContent = 'Preparing your photos…';
      el.className = 'opg-bb__note';
    } else if (ok < n) {
      el.textContent = 'Your book has ' + n + ' pages, so we need all ' + n + ' photos before you can continue (' + (n - ok) + ' to go).';
      el.className = 'opg-bb__note';
    } else {
      el.textContent = 'All ' + n + ' photos added. Use ‹ › to change the order.';
      el.className = 'opg-bb__note is-ok';
    }
    if (this.step === 2) this.clearErr();
    this.summary();
  };
  B.coverChanged = function () {
    var f = this.$('[data-bb-cover]').files[0];
    this.$('[data-bb-cover-label]').textContent = f ? f.name : 'Upload a photo for the front cover';
    this.$('[data-bb-coverpick]').classList.toggle('is-filled', !!f);
    this.$('[data-bb-cover-clear]').hidden = !f;
    this.$('[data-bb-cover-note]').textContent = f ? 'We’ll build the cover artwork around this photo.' : 'No need to choose. If you skip this, we’ll pick the photo we feel works best for the cover.';
  };

  /* ---------- steps ---------- */
  B.valid = function (i) {
    if (i === 0) {
      var v = this.variant();
      return !!v && v.available;
    }
    if (i === 1) return !!this.$('[data-bb-title]').value.trim();
    if (i === 2) return !this.busy() && this.filled() === this.slots.length;
    if (i === 3) return this.$$('[data-bb-preview]').some(function (r) {
      return r.checked;
    });
    if (i === 4) return this.$('[data-bb-rights]').checked;
    return true;
  };
  B.panel = function (i) {
    return this.$('[data-bb-step="' + i + '"]');
  };
  B.clearErr = function () {
    this.$$('[data-bb-err]').forEach(function (e) {
      e.hidden = true;
    });
  };
  B.showErr = function () {
    var e = this.panel(this.step).querySelector('[data-bb-err]');
    if (!e) return;
    if (this.step === 2) e.textContent = this.busy() ? 'Hang on, a photo is still being prepared.' : 'Please add all ' + this.slots.length + ' photos to continue (' + (this.slots.length - this.filled()) + ' to go).';
    e.hidden = false;
    e.setAttribute('role', 'alert');
    var f = this.panel(this.step).querySelector('input:not([type=hidden])');
    if (this.step === 1 && f) f.focus();
  };
  B.go = function (i, quiet) {
    var self = this;
    this.step = i;
    this.reached = Math.max(this.reached, i);
    for (var k = 0; k < 5; k++) this.panel(k).hidden = k !== i;
    this.$$('[data-bb-goto]').forEach(function (b, k) {
      b.disabled = k > self.reached;
      if (k === i) b.setAttribute('aria-current', 'step');else b.removeAttribute('aria-current');
      b.classList.toggle('is-done', k < self.reached && k !== i);
    });
    this.$('[data-bb-num]').textContent = i + 1;
    this.$('[data-bb-back]').hidden = i === 0;
    this.$('[data-bb-next]').textContent = i === 4 ? this.d.final_label || 'Add to Basket & Checkout' : 'Continue to ' + STEPS[i + 1];
    this.clearErr();
    if (i === 4) this.review();
    if (!quiet) window.scrollTo({
      top: this.root.getBoundingClientRect().top + window.scrollY - 90,
      behavior: 'smooth'
    });
  };
  B.next = function () {
    if (!this.valid(this.step)) {
      this.showErr();
      return;
    }
    if (this.step < 4) {
      this.go(this.step + 1);
      return;
    }
    for (var i = 0; i < 4; i++) if (!this.valid(i)) {
      this.go(i);
      this.showErr();
      return;
    }
    this.submit();
  };
  B.submit = function () {
    this.sending = true;
    this.$$('input[type=file]').forEach(function (f) {
      if (!f.files || !f.files.length) f.removeAttribute('name');
    });
    this.$('[data-bb-bulk]').removeAttribute('name');
    var btn = this.$('[data-bb-next]');
    btn.disabled = true;
    btn.textContent = 'Uploading…';
    this.$('[data-bb-sending]').hidden = false;
    this.form.submit();
  };
  B.lines = function () {
    var p = this.prod(),
      v = this.variant(),
      n = this.slots.length;
    var g = function (s) {
      var e = this.$(s);
      return e ? e.value.trim() : '';
    }.bind(this);
    var prev = this.$$('[data-bb-preview]').filter(function (r) {
      return r.checked;
    })[0];
    var cover = this.$('[data-bb-cover]').files[0];
    var out = [['Product', p.title], ['Format', p.label], ['Pages', n + ' colouring ' + (this.d.noun || 'page') + 's'], ['Photos', this.filled() + ' of ' + n + ' added'], ['Cover title', g('[data-bb-title]') || '—'], ['Cover photo', cover ? cover.name : 'We’ll choose the best one'], ['Cover colour', g('[data-bb-colour]') || 'Our choice']];
    if (g('[data-bb-name]')) out.push(['Back cover', g('[data-bb-name]')]);
    out.push(['Preview', prev ? prev.value : '—'], ['Quantity', String(this.qty)]);
    if (v) out.push(['Total', this.fmt(v.price * this.qty)]);
    return out;
  };
  B.review = function () {
    this.$('[data-bb-review]').innerHTML = this.lines().map(function (l) {
      return '<dt>' + esc(l[0]) + '</dt><dd>' + esc(l[1]) + '</dd>';
    }).join('');
    this.$('[data-bb-order]').innerHTML = this.slots.map(function (s, i) {
      return '<li><span>' + (s.url ? '<img src="' + s.url + '" alt="">' : '<em>' + esc(s.file ? s.file.name.split('.').pop().toUpperCase() : '') + '</em>') + '</span><small>' + (i + 1) + '</small></li>';
    }).join('');
  };
  B.summary = function () {
    var v = this.variant(),
      t = this.$('[data-bb-title]').value.trim(),
      l = this.lines();
    this.$('[data-bb-sum-title]').textContent = t || this.prod().title;
    var prev = this.$$('[data-bb-preview]').filter(function (r) {
      return r.checked;
    })[0];
    this.$('[data-bb-sum-lines]').innerHTML = [l[1][1], l[2][1], l[3][1]].concat(prev ? [prev.value.indexOf('Yes') === 0 ? 'Preview requested' : 'No preview'] : []).map(function (x) {
      return '<li class="opg-xs">' + esc(x) + '</li>';
    }).join('');
    this.$('[data-bb-sum-qty]').textContent = v && this.qty > 1 ? this.qty + ' × ' + this.fmt(v.price) : 'Total';
    this.$('[data-bb-sum-total]').textContent = v ? this.fmt(v.price * this.qty) : '—';
  };
  function boot(scope) {
    (scope || document).querySelectorAll('[data-opg-builder]').forEach(function (el) {
      if (!el.__opg) el.__opg = new Builder(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () {
    boot();
  });else boot();
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
})(); } catch (e) { __ds_ns.__errors.push({ path: "shopify-theme/assets/opg-theme.js", error: String((e && e.message) || e) }); }

// ui_kits/builder/Builder.jsx
try { (() => {
function Builder() {
  const [step, setStep] = React.useState(0);
  const [fmt, setFmt] = React.useState('sq');
  const [pg, setPg] = React.useState('p15');
  const [title, setTitle] = React.useState("Ella's Year");
  const [name, setName] = React.useState('Ella');
  const [message, setMessage] = React.useState('');
  const [preview, setPreview] = React.useState('yes');
  const [consent, setConsent] = React.useState(false);
  const format = FORMATS.find(f => f.id === fmt);
  const pages = PAGES.find(p => p.id === pg);
  const summary = [['Format', format.title.split(' · ')[0]], ['Pages', pages.title], ['Cover title', title || '—'], ['Photos', step >= 2 ? `${pages.count} of ${pages.count}` : '—'], ['Preview', preview === 'yes' ? 'Requested' : 'Not needed']];
  if (step === 0) return /*#__PURE__*/React.createElement(StepShell, {
    step: step,
    setStep: setStep,
    summary: summary,
    eyebrow: "Step One",
    heading: "Choose your book",
    body: "Pick the format and the number of pages. One photograph becomes one page.",
    onNext: () => setStep(1)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("fieldset", {
    style: {
      border: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: '10px'
    }
  }, /*#__PURE__*/React.createElement("legend", {
    style: {
      padding: 0,
      marginBottom: 4,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-brand)'
    }
  }, "Format"), FORMATS.map(f => /*#__PURE__*/React.createElement(RadioCard, {
    key: f.id,
    id: `f-${f.id}`,
    name: "fmt",
    title: f.title,
    description: f.description,
    meta: f.meta,
    checked: fmt === f.id,
    onChange: () => setFmt(f.id)
  }))), /*#__PURE__*/React.createElement("fieldset", {
    style: {
      border: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: '10px'
    }
  }, /*#__PURE__*/React.createElement("legend", {
    style: {
      padding: 0,
      marginBottom: 4,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-brand)'
    }
  }, "Number of pages"), PAGES.map(p => /*#__PURE__*/React.createElement(RadioCard, {
    key: p.id,
    id: `p-${p.id}`,
    name: "pg",
    title: p.title,
    description: p.description,
    meta: p.meta,
    checked: pg === p.id,
    onChange: () => setPg(p.id)
  })))));
  if (step === 1) return /*#__PURE__*/React.createElement(StepShell, {
    step: step,
    setStep: setStep,
    summary: summary,
    eyebrow: "Step Two",
    heading: "Personalise the cover",
    body: "Add the details that make the book theirs. You can change these before you check out.",
    onNext: () => setStep(2)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)',
      maxWidth: 480
    }
  }, /*#__PURE__*/React.createElement(FormField, {
    label: "Book title",
    htmlFor: "b-title",
    hint: "This appears on the front cover.",
    required: true
  }, /*#__PURE__*/React.createElement(Input, {
    id: "b-title",
    value: title,
    onChange: e => setTitle(e.target.value)
  })), /*#__PURE__*/React.createElement(FormField, {
    label: "Who is it for?",
    htmlFor: "b-name",
    hint: "We use this on the cover and the inside title page.",
    optional: true
  }, /*#__PURE__*/React.createElement(Input, {
    id: "b-name",
    value: name,
    onChange: e => setName(e.target.value)
  })), /*#__PURE__*/React.createElement(FormField, {
    label: "Inside message",
    htmlFor: "b-msg",
    hint: "A short line for the inside cover. Around 140 characters works best.",
    optional: true
  }, /*#__PURE__*/React.createElement(Textarea, {
    id: "b-msg",
    rows: 3,
    value: message,
    onChange: e => setMessage(e.target.value),
    placeholder: "For Ella, from all of us."
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 'var(--space-5)',
      background: 'var(--opg-blush-100)',
      borderRadius: 'var(--radius-sm)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontSize: 'var(--text-2xl)',
      fontWeight: 600,
      color: 'var(--opg-navy-900)',
      lineHeight: 1.1
    }
  }, title || 'Your title here'), name ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '8px 0 0',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      color: 'var(--opg-burgundy-600)'
    }
  }, "Made for ", name) : null, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '14px 0 0',
      fontSize: 'var(--text-xs)',
      color: 'var(--opg-burgundy-600)'
    }
  }, "Live text preview. The finished artwork is prepared after your photos are transformed."))));
  if (step === 2) return /*#__PURE__*/React.createElement(StepShell, {
    step: step,
    setStep: setStep,
    summary: summary,
    eyebrow: "Step Three",
    heading: "Upload your photographs",
    body: `Choose ${pages.count} photographs, one for each page. Drag to reorder them into the order you want the book to read.`,
    onNext: () => setStep(3)
  }, /*#__PURE__*/React.createElement(PhotoUploader, {
    required: pages.count
  }));
  if (step === 3) return /*#__PURE__*/React.createElement(StepShell, {
    step: step,
    setStep: setStep,
    summary: summary,
    eyebrow: "Step Four",
    heading: "Would you like a preview?",
    body: "You can approve your book before it goes to print, or leave it with us.",
    onNext: () => setStep(4)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: '10px',
      maxWidth: 560
    }
  }, /*#__PURE__*/React.createElement(RadioCard, {
    id: "pv-no",
    name: "pv",
    title: "Create my book without a preview",
    description: "We transform, refine and print your book. This is the fastest route.",
    checked: preview === 'no',
    onChange: () => setPreview('no')
  }), /*#__PURE__*/React.createElement(RadioCard, {
    id: "pv-yes",
    name: "pv",
    title: "I'd like to request a preview before print",
    description: "We'll send a preview for you to approve. Requesting a preview may affect production timing.",
    checked: preview === 'yes',
    onChange: () => setPreview('yes')
  })));
  return /*#__PURE__*/React.createElement(StepShell, {
    step: 4,
    setStep: setStep,
    summary: summary,
    eyebrow: "Step Five",
    heading: "Check your book over",
    body: "Everything you have chosen, in one place. Nothing is printed until you check out.",
    nextLabel: "Continue to Secure Checkout",
    nextDisabled: !consent,
    onNext: () => setStep(0)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      overflow: 'hidden'
    }
  }, [['Product', 'Personalised Photo Colouring Book'], ['Format', format.title], ['Pages', pages.title], ['Photographs uploaded', `${pages.count} of ${pages.count}`], ['Page order', 'As arranged in step three'], ['Cover title', title || '—'], ['Made for', name || '—'], ['Inside message', message || 'None'], ['Preview preference', preview === 'yes' ? 'Preview requested before print' : 'No preview needed'], ['Price', '£19.99']].map(([k, v], i) => /*#__PURE__*/React.createElement("div", {
    key: k,
    style: {
      display: 'grid',
      gridTemplateColumns: '200px 1fr',
      gap: 18,
      padding: '14px 18px',
      background: i % 2 ? 'var(--opg-paper)' : 'var(--opg-white)',
      borderTop: i ? '1px solid var(--color-border)' : 'none'
    }
  }, /*#__PURE__*/React.createElement("dt", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, k), /*#__PURE__*/React.createElement("dd", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-text)'
    }
  }, v)))), /*#__PURE__*/React.createElement(Checkbox, {
    id: "b-consent",
    checked: consent,
    onChange: e => setConsent(e.target.checked),
    label: "I have the right to use the photographs I'm uploading.",
    hint: "Your photos are used to create your personalised order and handled in line with our Privacy Policy."
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)',
      maxWidth: '62ch'
    }
  }, "Your photographs stay attached to this order. After checkout you'll get a confirmation showing your personalisation summary and what happens next. Books are made to order in 2\u20134 business days, with delivery typically 5\u20137 business days.")));
}
Object.assign(window, {
  Builder
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/builder/Builder.jsx", error: String((e && e.message) || e) }); }

// ui_kits/builder/BuilderShell.jsx
try { (() => {
const {
  Header,
  Footer,
  PersonalisationStepper,
  PhotoUploader,
  RadioCard,
  FormField,
  Input,
  Textarea,
  Checkbox,
  Button,
  TextLink,
  Eyebrow,
  Badge,
  MediaPlaceholder,
  Icon
} = window.OnePrintGalleryDesignSystem_ba4735;
const FORMATS = [{
  id: 'sq',
  title: 'Square · 21 × 21 cm',
  description: 'Our most popular format for younger children.',
  meta: null
}, {
  id: 'a4',
  title: 'A4 portrait · 21 × 29.7 cm',
  description: 'More room for detail on each page.',
  meta: null
}];
const PAGES = [{
  id: 'p15',
  title: '15 pages',
  description: '15 photographs, one per page.',
  meta: null,
  count: 15
}, {
  id: 'p25',
  title: '25 pages',
  description: '25 photographs, one per page.',
  meta: null,
  count: 25
}];
function StepShell({
  step,
  setStep,
  eyebrow,
  heading,
  body,
  children,
  summary,
  nextLabel = 'Continue',
  onNext,
  nextDisabled
}) {
  return /*#__PURE__*/React.createElement("main", {
    style: {
      background: 'var(--opg-white)',
      minHeight: '70vh',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)'
    }
  }, /*#__PURE__*/React.createElement(PersonalisationStepper, {
    current: step,
    onStep: setStep
  }), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '7fr 4fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start',
      marginTop: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, null, eyebrow) : null, /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: '16px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)',
      maxWidth: '22ch'
    }
  }, heading), body ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '18px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)',
      maxWidth: '54ch'
    }
  }, body) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-7)'
    }
  }, children), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '20px',
      alignItems: 'center',
      marginTop: 'var(--space-8)',
      paddingTop: 'var(--space-6)',
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    onClick: onNext,
    disabled: nextDisabled
  }, nextLabel), step > 0 ? /*#__PURE__*/React.createElement(TextLink, {
    href: "#",
    onClick: e => {
      e.preventDefault();
      setStep(step - 1);
    }
  }, "Back a step") : null)), /*#__PURE__*/React.createElement("aside", {
    "data-opg-sticky": "",
    style: {
      minWidth: 0,
      position: 'sticky',
      top: 'calc(var(--header-height) + 24px)',
      padding: 'var(--space-6)',
      background: 'var(--opg-paper)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/books/luna-front.png"),
    alt: "Your book, as chosen",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'contain',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 'var(--space-5) 0 0',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 700,
      color: 'var(--color-brand)'
    }
  }, "Personalised Photo Colouring Book"), /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: '14px 0 0',
      display: 'grid',
      gap: '9px'
    }
  }, summary.map(([k, v]) => /*#__PURE__*/React.createElement("div", {
    key: k,
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 14,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)'
    }
  }, /*#__PURE__*/React.createElement("dt", {
    style: {
      color: 'var(--color-text-muted)'
    }
  }, k), /*#__PURE__*/React.createElement("dd", {
    style: {
      margin: 0,
      color: 'var(--color-text)',
      fontWeight: 600,
      textAlign: 'right'
    }
  }, v)))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 'var(--space-5) 0 0',
      paddingTop: 'var(--space-4)',
      borderTop: '1px solid var(--color-border-strong)',
      display: 'flex',
      justifyContent: 'space-between',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Total"), /*#__PURE__*/React.createElement("span", null, "\xA319.99"))))));
}
Object.assign(window, {
  StepShell,
  FORMATS,
  PAGES
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/builder/BuilderShell.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/ArchitectureSlide.jsx
try { (() => {
function ArchitectureSlide() {
  const cats = [['Personalised Photo Colouring Books', 'Hero category. The current front door to the brand.'], ['Personalised Keepsakes', 'Expands without changing the master identity.'], ['One-of-One Art', 'Highland Cows, The Obsidian Society and future releases.'], ['Creative Partnerships', 'Schools & SEN, care homes, football clubs, organisations.']];
  return /*#__PURE__*/React.createElement(Slide, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(Pad, null, /*#__PURE__*/React.createElement(Eyebrow, null, "The Brand Opportunity"), /*#__PURE__*/React.createElement(H, {
    size: 56,
    max: "22ch",
    style: {
      marginTop: 24
    }
  }, "Colouring books are the beginning, not the boundary."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4,1fr)',
      gap: 32,
      marginTop: 56,
      flex: 1,
      minHeight: 0,
      alignContent: 'start'
    }
  }, cats.map(([t, b], i) => /*#__PURE__*/React.createElement("div", {
    key: t,
    style: {
      paddingTop: 22,
      borderTop: '2px solid ' + (i === 0 ? 'var(--color-accent)' : 'var(--color-border-strong)')
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 26,
      lineHeight: 1,
      color: i === 0 ? 'var(--color-accent)' : 'var(--color-accent-warm)'
    }
  }, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: '18px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 26,
      lineHeight: 1.12,
      color: 'var(--color-brand)'
    }
  }, t), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '14px 0 0',
      fontSize: 16,
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, b)))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontSize: 24,
      fontStyle: 'italic',
      color: 'var(--color-brand)'
    }
  }, "The same principle connects every category: create something that feels singular.")), /*#__PURE__*/React.createElement(SlideMark, {
    n: "07"
  }));
}
Object.assign(window, {
  ArchitectureSlide
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/ArchitectureSlide.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/AskSlide.jsx
try { (() => {
function AskSlide() {
  return /*#__PURE__*/React.createElement(Slide, {
    tone: "ink"
  }, /*#__PURE__*/React.createElement(Pad, {
    style: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '7fr 5fr',
      gap: 64,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, {
    onDark: true
  }, "The Ask"), /*#__PURE__*/React.createElement(H, {
    onDark: true,
    size: 60,
    max: "18ch",
    style: {
      marginTop: 26
    }
  }, "What could we create around your people, place or story?"), /*#__PURE__*/React.createElement(Body, {
    onDark: true,
    size: 20,
    max: "42ch",
    style: {
      marginTop: 30
    }
  }, "Help us build the premium one-of-one personalised art and keepsake brand."), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: '36px 0 0',
      padding: 0,
      display: 'grid',
      gap: 10
    }
  }, ['Growth capital', 'Ecommerce and technology', 'Production scale', 'Customer acquisition', 'Strategic introductions'].map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      display: 'flex',
      gap: 12,
      fontSize: 17,
      color: 'var(--opg-white)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--opg-peach-300)'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "arrow-right",
    size: 18
  })), t))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '34px 0 0',
      fontSize: 14,
      color: 'rgba(255,255,255,.55)'
    }
  }, "Insert the actual funding ask only once decided.")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 20,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(Badge, {
    tone: "onDark"
  }, "1 of 1"), /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/books/jade-front.png"),
    alt: "A finished one-of-one keepsake",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)'
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontSize: 26,
      fontStyle: 'italic',
      color: 'var(--opg-peach-300)'
    }
  }, "Designed with love by One Print Gallery.")))), /*#__PURE__*/React.createElement(SlideMark, {
    onDark: true,
    n: "18"
  }));
}
Object.assign(window, {
  AskSlide
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/AskSlide.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/BigQuoteSlide.jsx
try { (() => {
function BigQuoteSlide() {
  return /*#__PURE__*/React.createElement(Slide, {
    tone: "ink"
  }, /*#__PURE__*/React.createElement(Pad, {
    style: {
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(BrushRule, {
    width: 110
  }), /*#__PURE__*/React.createElement(H, {
    onDark: true,
    size: 82,
    caps: true,
    max: "18ch",
    style: {
      marginTop: 42,
      lineHeight: 0.97
    }
  }, "There should only be one like yours."), /*#__PURE__*/React.createElement(Body, {
    onDark: true,
    size: 22,
    max: "56ch",
    style: {
      marginTop: 42,
      textAlign: 'center'
    }
  }, "Personalised products are unique because the source memories are unique. Original art will increasingly follow a true one-of-one model: one piece, one owner, no repeat edition.")), /*#__PURE__*/React.createElement(SlideMark, {
    onDark: true,
    n: "08"
  }));
}
Object.assign(window, {
  BigQuoteSlide
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/BigQuoteSlide.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/DifferenceSlide.jsx
try { (() => {
function DifferenceSlide() {
  return /*#__PURE__*/React.createElement(Slide, {
    tone: "white"
  }, /*#__PURE__*/React.createElement(Pad, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: 40
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, null, "The Difference"), /*#__PURE__*/React.createElement(H, {
    size: 58,
    max: "14ch",
    style: {
      marginTop: 24
    }
  }, "Not a cartoon filter. A keepsake.")), /*#__PURE__*/React.createElement(Body, {
    size: 18,
    max: "34ch",
    style: {
      paddingBottom: 8
    }
  }, "Our differentiation is the standard of visual refinement and the human quality check around every transformation.")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 52,
      flex: 1,
      minHeight: 0
    }
  }, /*#__PURE__*/React.createElement(TransformationTriptych, {
    ratio: "4 / 3"
  }))), /*#__PURE__*/React.createElement(SlideMark, {
    n: "05"
  }));
}
Object.assign(window, {
  DifferenceSlide
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/DifferenceSlide.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/FounderSlide.jsx
try { (() => {
function FounderSlide() {
  return /*#__PURE__*/React.createElement(Slide, {
    tone: "navy"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 7fr',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '76px 0 76px 88px',
      display: 'grid',
      alignContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/logo.png"),
    alt: "",
    style: {
      width: 'min(280px,100%)',
      height: 'auto'
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/signature.png"),
    alt: "Designed with love by One Print Gallery",
    style: {
      marginTop: 36,
      width: '100%',
      height: 'auto'
    }
  })), /*#__PURE__*/React.createElement(Pad, {
    style: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    onDark: true
  }, "Founder"), /*#__PURE__*/React.createElement(H, {
    onDark: true,
    size: 50,
    max: "20ch",
    style: {
      marginTop: 24
    }
  }, "Built by Leon around one simple standard: personal should feel personal."), /*#__PURE__*/React.createElement(Body, {
    onDark: true,
    size: 19,
    max: "42ch",
    style: {
      marginTop: 28
    }
  }, "One Print Gallery grew from a hands-on personalised product business into a broader creative brand vision. The founder remains visible because service, creative judgement and quality control are part of the value proposition."), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: '36px 0 0',
      padding: 0,
      display: 'grid',
      gap: 11
    }
  }, ['Trading since 2025 · London', '201+ orders · 5.0 from 50 reviews', 'Etsy Star Seller'].map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      fontSize: 14,
      fontWeight: 700,
      letterSpacing: '0.1em',
      color: 'var(--opg-peach-300)'
    }
  }, t))))), /*#__PURE__*/React.createElement(SlideMark, {
    onDark: true,
    n: "16"
  }));
}
Object.assign(window, {
  FounderSlide
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/FounderSlide.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/HeroProductSlide.jsx
try { (() => {
function HeroProductSlide() {
  return /*#__PURE__*/React.createElement(Slide, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 7fr',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(Pad, {
    style: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, null, "Hero Product"), /*#__PURE__*/React.createElement(H, {
    size: 52,
    max: "16ch",
    style: {
      marginTop: 24
    }
  }, "Personalised Photo Colouring Books"), /*#__PURE__*/React.createElement(Body, {
    size: 20,
    style: {
      marginTop: 26,
      maxWidth: '38ch'
    }
  }, "A customer's own photographs become the pages of a professionally finished colouring book."), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: '40px 0 0',
      padding: 0,
      display: 'grid',
      gap: 16
    }
  }, ['Created from the customer\u2019s photographs', 'Realistic, recognisable transformation style', 'Carefully transformed and refined by One Print Gallery'].map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      display: 'flex',
      gap: 14,
      fontSize: 18,
      lineHeight: 1.45,
      color: 'var(--color-text)',
      paddingBottom: 16,
      borderBottom: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-accent-warm)',
      marginTop: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    size: 20
  })), t)))), /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--opg-paper)',
      padding: '76px 88px 76px 0',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 20,
      alignContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/books/luna-front.png"),
    alt: "Front cover",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'contain',
      borderRadius: 'var(--radius-md)',
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 20
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/books/jade-front.png"),
    alt: "A second finished book",
    style: {
      width: '100%',
      aspectRatio: '1 / 1',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)'
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/transform/colouring-after.png"),
    alt: "Line-art page detail",
    style: {
      width: '100%',
      aspectRatio: '1 / 1',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  })))), /*#__PURE__*/React.createElement(SlideMark, {
    n: "04"
  }));
}
Object.assign(window, {
  HeroProductSlide
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/HeroProductSlide.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/ProblemSlide.jsx
try { (() => {
function ProblemSlide() {
  return /*#__PURE__*/React.createElement(Slide, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(Pad, null, /*#__PURE__*/React.createElement(Eyebrow, null, "The Simple Problem"), /*#__PURE__*/React.createElement(H, {
    max: "22ch",
    style: {
      marginTop: 26
    }
  }, "We take more photos than ever. Most of them never become anything."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 40,
      marginTop: 48,
      flex: 1,
      minHeight: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateRows: '1fr auto',
      gap: 18,
      minHeight: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/transform/family-before.png"),
    alt: "A family photograph on a phone",
    style: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-blush-100)',
      minHeight: 0
    }
  }), /*#__PURE__*/React.createElement(Body, {
    size: 18,
    max: "34ch"
  }, "Family memories live on phones and in cloud folders.")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateRows: '1fr auto',
      gap: 18,
      minHeight: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/books/luna-front.png"),
    alt: "A finished personalised colouring book",
    style: {
      height: '100%',
      width: '100%',
      objectFit: 'contain',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)',
      minHeight: 0
    }
  }), /*#__PURE__*/React.createElement(Body, {
    size: 18,
    max: "34ch"
  }, "The opportunity: turn real memories into objects people use, gift and keep.")))), /*#__PURE__*/React.createElement(SlideMark, {
    n: "02"
  }));
}
Object.assign(window, {
  ProblemSlide
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/ProblemSlide.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/RoadmapSlide.jsx
try { (() => {
function RoadmapSlide() {
  const p = [['Phase 1', 'Hero', 'Rebuilt conversion-first site · colouring-book growth · transformation content · stronger owned journey.'], ['Phase 2', 'Proof', 'Reviews and UGC · referral · creator programme · B2B case studies.'], ['Phase 3', 'Expansion', 'One-of-one art · deeper internationalisation · strategic partnerships · repeatable B2B.'], ['Phase 4', 'Brand', 'One Print Gallery recognised as a destination for singular art and keepsakes.']];
  return /*#__PURE__*/React.createElement(Slide, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(Pad, null, /*#__PURE__*/React.createElement(Eyebrow, null, "Growth Roadmap"), /*#__PURE__*/React.createElement(H, {
    size: 56,
    max: "22ch",
    style: {
      marginTop: 24
    }
  }, "Make the hero product famous. Build the world around it."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 54,
      flex: 1,
      minHeight: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 3,
      background: 'var(--gradient-brush)',
      borderRadius: 2
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4,1fr)',
      gap: 32,
      marginTop: 30
    }
  }, p.map(([n, t, b]) => /*#__PURE__*/React.createElement("div", {
    key: n
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontSize: 13,
      fontWeight: 700,
      letterSpacing: '0.14em',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)'
    }
  }, n), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: '12px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 34,
      lineHeight: 1,
      color: 'var(--color-brand)'
    }
  }, t), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '16px 0 0',
      fontSize: 16,
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, b)))))), /*#__PURE__*/React.createElement(SlideMark, {
    n: "17"
  }));
}
Object.assign(window, {
  RoadmapSlide
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/RoadmapSlide.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/SectorsSlide.jsx
try { (() => {
function SectorsSlide() {
  const s = [['Schools & SEN', 'A school can become the content.', 'transform/colouring-after.png', 'The Willows, Hayes: 50 copies, reordered 150'], ['Care Homes', 'Personal stories become creative objects.', 'transform/family-after.png'], ['Football Clubs', 'Club identity, made interactive.', 'transform/football-after.png'], ['Organisations', 'Your people, place or story, made tangible.', 'transform/getting-ready-after.png']];
  return /*#__PURE__*/React.createElement(Slide, {
    tone: "white"
  }, /*#__PURE__*/React.createElement(Pad, null, /*#__PURE__*/React.createElement(Eyebrow, null, "B2B Opportunity"), /*#__PURE__*/React.createElement(H, {
    size: 54,
    max: "24ch",
    style: {
      marginTop: 24
    }
  }, "The same creative system can serve communities, not just individual customers."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4,1fr)',
      gap: 26,
      marginTop: 48,
      flex: 1,
      minHeight: 0
    }
  }, s.map(([t, b, f, proof]) => /*#__PURE__*/React.createElement("div", {
    key: t,
    style: {
      display: 'grid',
      gridTemplateRows: '1fr auto',
      gap: 16,
      minHeight: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: OPG_A('../../assets/') + f,
    alt: "",
    style: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)',
      minHeight: 0
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 13,
      fontWeight: 700,
      letterSpacing: '0.14em',
      textTransform: 'uppercase',
      color: 'var(--color-accent-warm)'
    }
  }, t), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '9px 0 0',
      fontFamily: 'var(--font-display)',
      fontSize: 22,
      lineHeight: 1.15,
      color: 'var(--color-brand)'
    }
  }, b), proof ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '10px 0 0',
      fontSize: 13,
      lineHeight: 1.4,
      fontWeight: 700,
      color: 'var(--opg-burgundy-600)'
    }
  }, proof) : null))))), /*#__PURE__*/React.createElement(SlideMark, {
    n: "12"
  }));
}
Object.assign(window, {
  SectorsSlide
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/SectorsSlide.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/SlideShell.jsx
try { (() => {
const {
  OneWordmark,
  Eyebrow,
  Badge,
  BrushRule,
  MediaPlaceholder,
  TransformationTriptych,
  Icon
} = window.OnePrintGalleryDesignSystem_ba4735;

/* 16:9 slide frame. One slide per file so each can be previewed at 1280x720. */
function Slide({
  tone = 'paper',
  children,
  style
}) {
  const bg = {
    paper: 'var(--opg-paper)',
    white: 'var(--opg-white)',
    navy: 'var(--opg-navy-700)',
    ink: 'var(--opg-navy-900)',
    blush: 'var(--opg-blush-100)'
  }[tone];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: 1280,
      height: 720,
      background: bg,
      position: 'relative',
      overflow: 'hidden',
      fontFamily: 'var(--font-sans)',
      display: 'flex',
      flexDirection: 'column',
      ...style
    }
  }, children);
}
const Pad = ({
  children,
  style
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    flex: 1,
    minHeight: 0,
    padding: '76px 88px',
    display: 'flex',
    flexDirection: 'column',
    ...style
  }
}, children);
const SlideMark = ({
  onDark,
  n
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    position: 'absolute',
    left: 88,
    bottom: 40,
    right: 88,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}, /*#__PURE__*/React.createElement(OneWordmark, {
  size: 15,
  onDark: onDark,
  stacked: false
}), n ? /*#__PURE__*/React.createElement("span", {
  style: {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: '0.14em',
    color: onDark ? 'rgba(255,255,255,.5)' : 'var(--color-border-strong)'
  }
}, n) : null);
const H = ({
  children,
  onDark,
  size = 62,
  max = '20ch',
  caps,
  style
}) => /*#__PURE__*/React.createElement("h2", {
  style: {
    margin: 0,
    fontFamily: 'var(--font-display)',
    fontWeight: 600,
    fontSize: size,
    lineHeight: 0.98,
    letterSpacing: caps ? '0.01em' : '-0.02em',
    textTransform: caps ? 'uppercase' : 'none',
    color: onDark ? 'var(--opg-white)' : 'var(--color-brand)',
    maxWidth: max,
    ...style
  }
}, children);
const Body = ({
  children,
  onDark,
  size = 21,
  max = '46ch',
  style
}) => /*#__PURE__*/React.createElement("p", {
  style: {
    margin: 0,
    fontSize: size,
    lineHeight: 1.6,
    color: onDark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)',
    maxWidth: max,
    ...style
  }
}, children);
Object.assign(window, {
  Slide,
  Pad,
  SlideMark,
  H,
  Body
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/SlideShell.jsx", error: String((e && e.message) || e) }); }

// ui_kits/pitch_deck/TitleSlide.jsx
try { (() => {
function TitleSlide() {
  return /*#__PURE__*/React.createElement(Slide, {
    tone: "ink"
  }, /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/books/jade-front.png"),
    alt: "",
    style: {
      position: 'absolute',
      right: 0,
      top: 0,
      height: '100%',
      width: '44%',
      objectFit: 'cover',
      objectPosition: 'center top'
    }
  }), /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(90deg, var(--opg-navy-900) 0%, var(--opg-navy-900) 52%, rgba(17,21,42,.72) 62%, rgba(17,21,42,.15) 100%)'
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: OPG_A("../../assets/logo.png"),
    alt: "",
    style: {
      position: 'absolute',
      left: 88,
      top: 64,
      height: 96,
      width: 'auto'
    }
  }), /*#__PURE__*/React.createElement(Pad, {
    style: {
      position: 'relative',
      justifyContent: 'flex-end',
      paddingBottom: 120,
      maxWidth: '62%'
    }
  }, /*#__PURE__*/React.createElement(BrushRule, {
    width: 96
  }), /*#__PURE__*/React.createElement(H, {
    onDark: true,
    size: 92,
    caps: true,
    max: "14ch",
    style: {
      marginTop: 30,
      letterSpacing: '0.02em',
      lineHeight: 0.95
    }
  }, "One Print Gallery"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '28px 0 0',
      fontFamily: 'var(--font-display)',
      fontSize: 32,
      fontStyle: 'italic',
      color: 'var(--opg-white)'
    }
  }, "Your photos, transformed into meaningful keepsakes."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '20px 0 0',
      fontSize: 16,
      fontWeight: 700,
      letterSpacing: '0.16em',
      textTransform: 'uppercase',
      color: 'var(--opg-peach-300)'
    }
  }, "Personalised art \xB7 One-of-one keepsakes \xB7 Creative partnerships")), /*#__PURE__*/React.createElement(SlideMark, {
    onDark: true
  }));
}
Object.assign(window, {
  TitleSlide
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/pitch_deck/TitleSlide.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/CreatePage.jsx
try { (() => {
const CDS = window.OnePrintGalleryDesignSystem_ba4735;
const {
  PersonalisationStepper: CStepper,
  PhotoUploader: CUploader,
  RadioCard: CRadioCard,
  Radio: CRadio,
  Checkbox: CCheckbox,
  FormField: CField,
  Input: CInput,
  Textarea: CTextarea,
  Button: CButton,
  Icon: CIcon,
  Eyebrow: CEyebrow,
  IconButton: CIconButton
} = CDS;
const C_PRICING = CDS.PRICING,
  C_FUL = CDS.FULFILMENT,
  C_ALBUM = CDS.PHOTO_ALBUM;
const cLabel = {
  margin: '0 0 10px',
  padding: 0,
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-sm)',
  fontWeight: 600,
  color: 'var(--color-brand)'
};
const cH2 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-2xl)',
  lineHeight: 1.1,
  letterSpacing: 'var(--tracking-display)',
  color: 'var(--color-brand)'
};
const cBody = {
  margin: 0,
  fontSize: 'var(--text-sm)',
  lineHeight: 1.65,
  color: 'var(--color-text-muted)'
};
const cFieldset = {
  border: 'none',
  margin: 0,
  padding: 0,
  display: 'grid',
  gap: 10
};
const money = n => '£' + Number(n).toFixed(2);
function orderPrice(o) {
  if (o.product === 'album') return Number(C_ALBUM.priceFor({
    pages: o.pages,
    binding: o.binding,
    size: o.size
  }));
  const p = C_PRICING.pages.find(x => x.count === o.pages) || C_PRICING.pages[0];
  return parseFloat(p.price.replace('£', '')) + (o.size === 'a4' ? C_PRICING.a4Extra ?? 3 : 0);
}
function orderLines(o) {
  const ok = o.photos.filter(p => p.state === 'uploaded').length;
  return [['Product', o.product === 'album' ? C_ALBUM.title : 'Personalised Photo Colouring Book'], ['Format', (o.size === 'a4' ? 'A4 · 21 × 29.7 cm' : 'A5 · 14.8 × 21 cm') + (o.product === 'album' ? ` · ${o.binding === 'hardback' ? 'Hardback' : 'Coil bound'}` : ' · Coil bound')], ['Pages', o.product === 'album' ? `${o.pages} photo pages + ${o.pages} colouring pages` : `${o.pages} colouring pages`], ['Photos', `${ok} of ${o.pages} uploaded`], ['Cover title', o.title || '—'], ['Cover photo', o.cover ? o.cover.name : 'We’ll choose the best one'], ['Cover colour', o.colour || 'Our choice'], ...(o.name ? [['Back cover', o.name]] : []), ['Preview', o.preview === 'yes' ? 'Preview requested before print' : 'No preview, straight to production'], ['Quantity', String(o.qty)]];
}
const C_SIZES = C_PRICING.formats;
const C_STEPS = ['Choose', 'Personalise', 'Upload', 'Preview', 'Review'];
function CreatePage({
  go,
  product = 'book'
}) {
  const [step, setStep] = React.useState(0);
  const [o, setO] = React.useState({
    product,
    size: 'a4',
    pages: 15,
    binding: 'coil',
    qty: 1,
    title: '',
    name: '',
    colour: '',
    cover: null,
    message: '',
    photos: [],
    preview: '',
    rights: false
  });
  const set = (k, v) => setO(s => ({
    ...s,
    [k]: v
  }));
  const [tried, setTried] = React.useState(false);
  const unit = orderPrice(o),
    total = unit * o.qty;
  const ok = o.photos.filter(p => p.state === 'uploaded').length;
  const busy = o.photos.some(p => p.state === 'uploading');
  const album = o.product === 'album';
  const valid = [true, !!o.title.trim(), ok === o.pages && !busy, !!o.preview, o.rights][step];
  const top = () => window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  const next = () => {
    if (!valid) {
      setTried(true);
      return;
    }
    setTried(false);
    if (step === 4) {
      window.__opgOrder = {
        ...o,
        unit,
        total
      };
      go('/order-confirmed/');
      return;
    }
    setStep(step + 1);
    top();
  };
  const back = () => {
    setTried(false);
    setStep(Math.max(0, step - 1));
    top();
  };
  const pageOpts = C_PRICING.pages.map(p => p.count);
  return /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "compact"
  }, /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Breadcrumb",
    style: {
      marginBottom: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    style: {
      color: 'inherit'
    }
  }, "Home"), " \xB7 ", /*#__PURE__*/React.createElement("a", {
    href: album ? '/photo-album/' : '/personalised-colouring-books/',
    style: {
      color: 'inherit'
    }
  }, album ? 'Colouring Photo Album' : 'Personalised Colouring Books'), " \xB7 Create Your Book")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 'var(--space-5) var(--space-8)',
      alignItems: 'end',
      justifyContent: 'space-between',
      marginBottom: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(CEyebrow, null, "Step ", step + 1, " of 5"), /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)'
    }
  }, "Create Your ", album ? 'Album' : 'Book')), /*#__PURE__*/React.createElement(CStepper, {
    steps: C_STEPS,
    current: step,
    onStep: i => {
      setStep(i);
      setTried(false);
    }
  })), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,4fr)',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      padding: 'clamp(22px,3.5vw,44px)',
      display: 'grid',
      gap: 'var(--space-7)'
    }
  }, step === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: cH2
  }, "Choose your book"), /*#__PURE__*/React.createElement("p", {
    style: cBody
  }, "Prices update as you choose. You can change anything later, right up to checkout.")), /*#__PURE__*/React.createElement("fieldset", {
    style: cFieldset
  }, /*#__PURE__*/React.createElement("legend", {
    style: cLabel
  }, "What are we making?"), /*#__PURE__*/React.createElement(CRadioCard, {
    id: "c-book",
    name: "c-product",
    title: "Personalised Photo Colouring Book",
    description: "Every photo redrawn as a colouring page.",
    meta: `From ${C_PRICING.from}`,
    checked: !album,
    onChange: () => set('product', 'book')
  }), /*#__PURE__*/React.createElement(CRadioCard, {
    id: "c-album",
    name: "c-product",
    title: "Colouring Photo Album",
    description: "Your photo on the left, its colouring page on the right.",
    meta: `From ${C_ALBUM.from}`,
    checked: album,
    onChange: () => set('product', 'album')
  })), /*#__PURE__*/React.createElement("fieldset", {
    style: cFieldset
  }, /*#__PURE__*/React.createElement("legend", {
    style: cLabel
  }, "Size"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 10
    }
  }, C_SIZES.map(f => /*#__PURE__*/React.createElement(CRadioCard, {
    key: f.id,
    id: `c-size-${f.id}`,
    name: "c-size",
    title: f.title,
    description: f.description,
    checked: o.size === f.id,
    onChange: () => set('size', f.id)
  })))), album ? /*#__PURE__*/React.createElement("fieldset", {
    style: cFieldset
  }, /*#__PURE__*/React.createElement("legend", {
    style: cLabel
  }, "Binding"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 10
    }
  }, C_ALBUM.bindings.map(b => /*#__PURE__*/React.createElement(CRadioCard, {
    key: b.id,
    id: `c-bind-${b.id}`,
    name: "c-bind",
    title: b.title,
    description: b.description,
    meta: b.id === 'hardback' ? '+ £10.00' : null,
    checked: o.binding === b.id,
    onChange: () => set('binding', b.id)
  })))) : null, /*#__PURE__*/React.createElement("fieldset", {
    style: cFieldset
  }, /*#__PURE__*/React.createElement("legend", {
    style: cLabel
  }, album ? 'Number of spreads' : 'Number of pages'), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(140px,1fr))',
      gap: 10
    }
  }, pageOpts.map(n => /*#__PURE__*/React.createElement(CRadioCard, {
    key: n,
    id: `c-pg-${n}`,
    name: "c-pages",
    title: `${n} ${album ? 'spreads' : 'pages'}`,
    description: `${money(orderPrice({
      ...o,
      pages: n
    }))} · ${n} photos`,
    checked: o.pages === n,
    onChange: () => set('pages', n)
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: cLabel
  }, "Quantity"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      border: '1px solid var(--color-border-strong)',
      borderRadius: 'var(--radius-sm)'
    }
  }, /*#__PURE__*/React.createElement(CIconButton, {
    label: "One fewer",
    onClick: () => set('qty', Math.max(1, o.qty - 1))
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "minus",
    size: 16
  })), /*#__PURE__*/React.createElement("span", {
    "aria-live": "polite",
    style: {
      minWidth: 40,
      textAlign: 'center',
      fontFamily: 'var(--font-sans)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, o.qty), /*#__PURE__*/React.createElement(CIconButton, {
    label: "One more",
    onClick: () => set('qty', Math.min(20, o.qty + 1))
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "plus",
    size: 16
  }))), /*#__PURE__*/React.createElement("p", {
    style: {
      ...cBody,
      marginTop: 10,
      fontSize: 'var(--text-xs)'
    }
  }, "Extra copies are printed from the same photos. Lovely for grandparents."))) : null, step === 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: cH2
  }, "Your cover"), /*#__PURE__*/React.createElement("p", {
    style: cBody
  }, "Tell us what the cover should say. We design the cover artwork for you from your photos.")), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,.8fr)',
      gap: 'var(--space-6)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(CField, {
    label: "Cover title",
    htmlFor: "c-title",
    required: true,
    hint: "Up to 40 characters.",
    error: tried && !o.title.trim() ? 'Please add a title for the cover.' : undefined
  }, /*#__PURE__*/React.createElement(CInput, {
    id: "c-title",
    value: o.title,
    maxLength: 40,
    placeholder: "The Adventures of Luna",
    invalid: tried && !o.title.trim(),
    onChange: e => set('title', e.target.value)
  })), /*#__PURE__*/React.createElement(CField, {
    label: "Cover colour",
    htmlFor: "c-colour",
    optional: true,
    hint: "A colour, or a few, you\u2019d like the cover to use. Leave blank and we\u2019ll choose one to suit your photos."
  }, /*#__PURE__*/React.createElement(CInput, {
    id: "c-colour",
    value: o.colour,
    maxLength: 60,
    placeholder: "e.g. Pastel pink, or their favourite team\u2019s colours",
    onChange: e => set('colour', e.target.value)
  })), /*#__PURE__*/React.createElement(CField, {
    label: "Who is it for?",
    htmlFor: "c-name",
    optional: true,
    hint: "Used for a small dedication on the back cover."
  }, /*#__PURE__*/React.createElement(CInput, {
    id: "c-name",
    value: o.name,
    maxLength: 40,
    placeholder: "For Nanny, with love",
    onChange: e => set('name', e.target.value)
  })), /*#__PURE__*/React.createElement(CField, {
    label: "Cover preferences",
    htmlFor: "c-msg",
    optional: true,
    hint: "Any personal interests, or a personal message you\u2019d like to add to the back cover."
  }, /*#__PURE__*/React.createElement(CTextarea, {
    id: "c-msg",
    rows: 4,
    value: o.message,
    onChange: e => set('message', e.target.value)
  }))), /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    style: {
      aspectRatio: '1055 / 1491',
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      borderRadius: '2px 6px 6px 2px',
      boxShadow: '0 18px 36px -22px rgba(20,28,60,.45)',
      display: 'grid',
      gridTemplateRows: 'auto 1fr auto',
      padding: '12% 10%',
      position: 'relative',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: 14,
      background: 'repeating-linear-gradient(180deg, var(--color-border-strong) 0 3px, transparent 3px 9px)'
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      textAlign: 'center',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'clamp(20px,2.4vw,30px)',
      lineHeight: 1.05,
      color: 'var(--color-brand)',
      textWrap: 'balance',
      overflowWrap: 'anywhere'
    }
  }, o.title || 'Your cover title'), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '10% 0',
      border: '1px dashed var(--color-border-strong)',
      borderRadius: 4,
      display: 'grid',
      placeItems: 'center',
      color: 'var(--color-text-muted)',
      fontSize: 'var(--text-xs)',
      textAlign: 'center',
      padding: 10
    }
  }, o.cover ? 'Cover artwork drawn from your chosen photo' : 'Cover artwork drawn from your photos'), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      textAlign: 'center',
      fontFamily: 'var(--font-sans)',
      fontSize: '0.6875rem',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-accent-warm)'
    }
  }, "One Print Gallery")), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      ...cBody,
      fontSize: 'var(--text-xs)'
    }
  }, "Text preview only. Your finished cover is designed by hand."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 8,
      marginTop: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      ...cLabel,
      margin: 0
    }
  }, "Front cover photo ", /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 400,
      color: 'var(--color-text-muted)'
    }
  }, "(optional)")), /*#__PURE__*/React.createElement("input", {
    id: "c-cover",
    type: "file",
    accept: "image/jpeg,image/png,image/heic,image/heif,.heic,.heif",
    hidden: true,
    onChange: e => {
      const f = e.target.files && e.target.files[0];
      if (f) set('cover', {
        name: f.name,
        src: /^image\/(jpe?g|png|webp|gif)/.test(f.type) ? URL.createObjectURL(f) : null
      });
      e.target.value = '';
    }
  }), o.cover ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '56px minmax(0,1fr) auto',
      gap: 12,
      alignItems: 'center',
      padding: '10px 12px',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-sm)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 56,
      height: 56,
      borderRadius: 'var(--radius-xs)',
      background: 'var(--opg-mist)',
      overflow: 'hidden',
      display: 'grid',
      placeItems: 'center',
      color: 'var(--color-text-muted)'
    }
  }, o.cover.src ? /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: o.cover.src,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }) : /*#__PURE__*/React.createElement(CIcon, {
    name: "image",
    size: 20
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 0,
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-text)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, o.cover.name), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => document.getElementById('c-cover').click(),
    style: {
      padding: 0,
      border: 0,
      background: 'none',
      font: 'inherit',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-brand)',
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  }, "Change"), /*#__PURE__*/React.createElement(CIconButton, {
    label: "Remove cover photo",
    size: 36,
    onClick: () => set('cover', null)
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "trash-2",
    size: 17
  })))) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => document.getElementById('c-cover').click(),
    style: {
      display: 'flex',
      gap: 12,
      alignItems: 'center',
      padding: '14px 16px',
      border: '1px dashed var(--color-brand)',
      borderRadius: 'var(--radius-sm)',
      background: 'var(--opg-paper)',
      color: 'var(--color-brand)',
      font: 'inherit',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      cursor: 'pointer',
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "upload",
    size: 20,
    strokeWidth: 1.5
  }), "Upload a photo for the front cover"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, o.cover ? 'We’ll build the cover artwork around this photo.' : 'No need to choose. If you skip this, we’ll pick the photo we feel works best for the cover.'))))) : null, step === 2 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: cH2
  }, "Upload ", o.pages, " photographs"), /*#__PURE__*/React.createElement("p", {
    style: cBody
  }, "One photo per ", album ? 'spread' : 'page', ", in the order you want them. Phone snaps, blurry shots and old prints all work beautifully. Choose the moments, not the sharpest file.", album ? ' Add the names or a short caption to print under each photo.' : '')), /*#__PURE__*/React.createElement(CUploader, {
    required: o.pages,
    photos: o.photos,
    captions: album,
    onChange: ps => set('photos', ps)
  }), !busy && ok !== o.pages ? /*#__PURE__*/React.createElement("p", {
    role: tried ? 'alert' : undefined,
    style: {
      ...cBody,
      padding: '12px 14px',
      borderRadius: 'var(--radius-sm)',
      background: tried ? 'transparent' : 'var(--opg-blush-100)',
      border: tried ? '1px solid var(--color-error)' : '1px solid transparent',
      color: tried ? 'var(--color-error)' : 'var(--color-text-muted)',
      fontWeight: tried ? 600 : 400
    }
  }, ok < o.pages ? `Your ${album ? 'album' : 'book'} has ${o.pages} pages, so we need all ${o.pages} photos before you can continue (${o.pages - ok} to go).` : `You have ${ok - o.pages} more photo${ok - o.pages > 1 ? 's' : ''} than pages. Remove ${ok - o.pages}, or go back and choose more pages.`) : null, tried && busy ? /*#__PURE__*/React.createElement("p", {
    role: "alert",
    style: {
      ...cBody,
      color: 'var(--color-error)',
      fontWeight: 600
    }
  }, "Hang on, a photo is still uploading.") : null) : null, step === 3 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: cH2
  }, "Would you like a preview?"), /*#__PURE__*/React.createElement("p", {
    style: cBody
  }, "Every page is checked by hand before print either way. A preview simply lets you see the pages yourself first.")), /*#__PURE__*/React.createElement("fieldset", {
    style: {
      ...cFieldset,
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("legend", {
    style: {
      position: 'absolute',
      width: 1,
      height: 1,
      overflow: 'hidden',
      clip: 'rect(0 0 0 0)'
    }
  }, "Preview preference"), /*#__PURE__*/React.createElement(CRadioCard, {
    id: "c-prev-no",
    name: "c-prev",
    title: "Create my book without a preview",
    description: `We go straight into production. ${C_FUL.production}.`,
    checked: o.preview === 'no',
    onChange: () => set('preview', 'no')
  }), /*#__PURE__*/React.createElement(CRadioCard, {
    id: "c-prev-yes",
    name: "c-prev",
    title: "I'd like to request a preview before print",
    description: "We email your pages for approval. Production starts once you reply, so timing depends on how quickly you approve.",
    checked: o.preview === 'yes',
    onChange: () => set('preview', 'yes')
  })), tried && !valid ? /*#__PURE__*/React.createElement("p", {
    role: "alert",
    style: {
      ...cBody,
      color: 'var(--color-error)',
      fontWeight: 600
    }
  }, "Choose one option to continue.") : null) : null, step === 4 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: cH2
  }, "Check everything"), /*#__PURE__*/React.createElement("p", {
    style: cBody
  }, "This is exactly what we will make. Tap any step above to change it.")), /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      display: 'grid',
      gridTemplateColumns: 'minmax(110px,auto) minmax(0,1fr)',
      borderTop: '1px solid var(--color-border)'
    }
  }, orderLines(o).map(([k, v]) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: k
  }, /*#__PURE__*/React.createElement("dt", {
    style: {
      padding: '13px 16px 13px 0',
      borderBottom: '1px solid var(--color-border)',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, k), /*#__PURE__*/React.createElement("dd", {
    style: {
      margin: 0,
      padding: '13px 0',
      borderBottom: '1px solid var(--color-border)',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-text)',
      overflowWrap: 'anywhere'
    }
  }, v)))), ok ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: cLabel
  }, "Page order"), /*#__PURE__*/React.createElement("ol", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(72px,1fr))',
      gap: 10
    }
  }, o.photos.filter(p => p.state === 'uploaded').map((p, i) => /*#__PURE__*/React.createElement("li", {
    key: p.id,
    style: {
      display: 'grid',
      gap: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      aspectRatio: '1',
      borderRadius: 'var(--radius-xs)',
      background: 'var(--opg-mist)',
      overflow: 'hidden',
      display: 'grid',
      placeItems: 'center',
      color: 'var(--color-text-muted)'
    }
  }, p.src ? /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: p.src,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }) : /*#__PURE__*/React.createElement(CIcon, {
    name: "image",
    size: 18
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '0.6875rem',
      color: 'var(--color-text-muted)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, i + 1, p.caption ? ` · ${p.caption}` : ''))))) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(CCheckbox, {
    id: "c-rights",
    checked: o.rights,
    onChange: e => set('rights', e.target.checked),
    label: "These are my photographs, or I have permission to use them.",
    hint: C_FUL.returns
  }), tried && !valid ? /*#__PURE__*/React.createElement("p", {
    role: "alert",
    style: {
      ...cBody,
      color: 'var(--color-error)',
      fontWeight: 600
    }
  }, "Please confirm to continue.") : null)) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border)'
    }
  }, step > 0 ? /*#__PURE__*/React.createElement(CButton, {
    variant: "secondary",
    onClick: back
  }, "Back") : /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement(CButton, {
    variant: "primary",
    size: "lg",
    onClick: next
  }, step === 4 ? 'Continue to Secure Checkout' : `Continue to ${C_STEPS[step + 1]}`))), /*#__PURE__*/React.createElement("aside", {
    "data-opg-sticky": "",
    style: {
      minWidth: 0,
      position: 'sticky',
      top: 'calc(var(--header-height) + 24px)',
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--opg-blush-100)',
      padding: 'var(--space-6)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: album ? OPG_A('../../assets/web/books/jade-front.webp') : OPG_A('../../assets/web/books/luna-front.webp'),
    alt: "",
    style: {
      width: '46%',
      aspectRatio: '1122 / 1402',
      objectFit: 'cover',
      borderRadius: 3,
      boxShadow: '0 16px 30px -16px rgba(20,28,60,.5)',
      transform: 'rotate(-2deg)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 'var(--space-5) var(--space-6) var(--space-6)',
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.15,
      color: 'var(--color-brand)'
    }
  }, o.title || (album ? C_ALBUM.title : 'Personalised Photo Colouring Book')), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: 5
    }
  }, orderLines(o).slice(1, 4).map(([k, v]) => /*#__PURE__*/React.createElement("li", {
    key: k,
    style: {
      fontSize: 'var(--text-xs)',
      lineHeight: 1.5,
      color: 'var(--color-text-muted)'
    }
  }, v)), o.preview ? /*#__PURE__*/React.createElement("li", {
    style: {
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, o.preview === 'yes' ? 'Preview requested' : 'No preview') : null), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      paddingTop: 14,
      borderTop: '1px solid var(--color-border)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      fontFamily: 'var(--font-sans)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, o.qty > 1 ? `${o.qty} × ${money(unit)}` : 'Total'), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-2xl)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, money(total))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, album ? C_ALBUM.delivery : `${C_FUL.production}. ${C_FUL.shippingNote}`))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      display: 'flex',
      gap: 10,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-accent-warm)'
    }
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "check",
    size: 16
  })), "Every page is checked by a person before it is printed."))));
}
function OrderConfirmedPage({
  go
}) {
  const o = window.__opgOrder || {
    product: 'book',
    size: 'a4',
    pages: 15,
    binding: 'coil',
    qty: 1,
    title: 'The Adventures of Luna',
    photos: Array.from({
      length: 15
    }, (_, i) => ({
      id: i,
      state: 'uploaded'
    })),
    preview: 'yes'
  };
  const ok = o.photos.filter(p => p.state === 'uploaded').length;
  const steps = [['Confirmation email', 'A copy of this summary is on its way to your inbox now.'], ['We check your photos', 'Every photograph is looked at by a person. If one needs a second look, we will get in touch.'], o.preview === 'yes' ? ['Your preview', 'We email your pages for approval. Production begins as soon as you reply.'] : ['We create your pages', 'Each photo is redrawn as line art and refined by hand.'], ['Printed and posted', `${C_FUL.production}. ${C_FUL.shipping}.`]];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "standard"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 760,
      display: 'grid',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 48,
      height: 48,
      borderRadius: '50%',
      background: 'var(--color-brand)',
      color: 'var(--opg-white)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "check",
    size: 24,
    strokeWidth: 2.2
  })), /*#__PURE__*/React.createElement(CEyebrow, null, "Order OPG-10482"), /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-4xl)',
      lineHeight: 1.02,
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)',
      textWrap: 'balance'
    }
  }, "We\u2019ve got your order. Here\u2019s what happens next."), /*#__PURE__*/React.createElement("p", {
    style: {
      ...cBody,
      fontSize: 'var(--text-base)',
      maxWidth: '54ch'
    }
  }, "Thank you. ", o.title ? `“${o.title}” ` : 'Your book ', "is in our hands now, and we will look after every page."))), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    style: {
      ...cH2,
      marginBottom: 'var(--space-6)'
    }
  }, "What happens next"), /*#__PURE__*/React.createElement("ol", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: 0
    }
  }, steps.map(([t, b], i) => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      display: 'grid',
      gridTemplateColumns: '44px minmax(0,1fr)',
      gap: 16,
      paddingBlock: 18,
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-accent-warm)',
      lineHeight: 1
    }
  }, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-sans)',
      fontWeight: 700,
      color: 'var(--color-brand)'
    }
  }, t), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      marginTop: 6,
      ...cBody
    }
  }, b)))))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 'var(--space-6)',
      background: 'var(--opg-paper)',
      borderRadius: 'var(--radius-md)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: cLabel
  }, "Your personalisation"), /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      display: 'grid',
      gridTemplateColumns: 'auto minmax(0,1fr)',
      gap: '8px 16px',
      fontSize: 'var(--text-sm)'
    }
  }, orderLines(o).map(([k, v]) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: k
  }, /*#__PURE__*/React.createElement("dt", {
    style: {
      color: 'var(--color-text-muted)'
    }
  }, k), /*#__PURE__*/React.createElement("dd", {
    style: {
      margin: 0,
      fontWeight: 600,
      color: 'var(--color-text)',
      overflowWrap: 'anywhere'
    }
  }, v))))), /*#__PURE__*/React.createElement("p", {
    style: {
      ...cBody
    }
  }, "Questions about your order? Email ", /*#__PURE__*/React.createElement("a", {
    href: "mailto:enquiries@oneprintgallery.co.uk",
    style: {
      color: 'var(--color-brand)',
      fontWeight: 600
    }
  }, "enquiries@oneprintgallery.co.uk"), " and a real person will reply."), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border)',
      display: 'grid',
      gap: 10,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      ...cBody
    }
  }, "Know someone with a camera roll full of memories?"), /*#__PURE__*/React.createElement(CButton, {
    variant: "secondary",
    size: "sm",
    onClick: () => go('/')
  }, "Share One Print Gallery"))))));
}
Object.assign(window, {
  CreatePage,
  OrderConfirmedPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/CreatePage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Homepage.jsx
try { (() => {
function Homepage({
  go,
  onCart
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeroFilm, {
    page: "home"
  }), /*#__PURE__*/React.createElement(Hero, {
    onPrimary: () => go('/create/'),
    onSecondary: () => go('/how-it-works/')
  }), /*#__PURE__*/React.createElement(HowItWorksTimeline, {
    tone: "white",
    style: {
      paddingBottom: 0
    }
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "5/7",
    eyebrow: "See the Difference",
    heading: "Not just converted. Carefully refined.",
    body: "Drag to compare the original photograph with the finished One Print Gallery transformation. We focus on recognisable faces, clothing, places and details so the page still feels like your memory.",
    linkLabel: "See more transformations",
    linkHref: "/gallery/",
    media: /*#__PURE__*/React.createElement(BeforeAfterSlider, {
      ratio: "4 / 5"
    })
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '7fr 5fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-thumbs": "",
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '16px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/mockups/luna-flatlay.webp"),
    alt: "Adventures of Luna open on a desk beside its cover",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: '16px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/transform/family-after.webp"),
    alt: "A finished line-art page from a personalised book",
    style: {
      width: '100%',
      aspectRatio: '1 / 1',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/transform/colouring-after.webp"),
    alt: "Line-art detail from a finished page",
    style: {
      width: '100%',
      aspectRatio: '1 / 1',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)',
      maxWidth: '20ch'
    }
  }, "A colouring book nobody else could own."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '22px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)',
      maxWidth: '46ch'
    }
  }, "Every page starts with your photographs, turning familiar people and places into a creative activity that becomes a keepsake in its own right."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 'var(--space-6) 0 0',
      display: 'flex',
      alignItems: 'baseline',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)'
    }
  }, "From"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-2xl)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, "\xA314.99")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '12px',
      marginTop: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    onClick: () => go('/product/')
  }, "Start Personalising"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "lg",
    onClick: () => go('/product/')
  }, "See the Book"))))), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "7/5",
    reverse: true,
    eyebrow: "Old Photos Welcome",
    heading: "Faded, creased, forty years old. Still perfect.",
    body: "This wedding photo was snapped on a phone, glare and all, straight off the mantelpiece. Line art doesn't need a flawless original. Send the photos you love and we'll bring out the faces, the lace and the flowers.",
    linkLabel: "Photo guidance",
    linkHref: "/how-it-works/",
    media: /*#__PURE__*/React.createElement(BeforeAfterSlider, {
      ratio: "4 / 5",
      beforeSrc: OPG_A("../../assets/web/transform/wedding-before-aligned.webp"),
      afterSrc: OPG_A("../../assets/web/transform/wedding-after-aligned.webp")
    })
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "paper",
    split: "7/5",
    eyebrow: "New \xB7 Colouring Photo Album",
    heading: "Keep the photograph. Colour it too.",
    body: "Every spread pairs your original photo, with names or a caption underneath, beside its matching colouring page. Part photo album, part colouring book. A4 or A5, coil bound or hardback, from \xA324.99 with free UK delivery.",
    linkLabel: "See the Photo Album",
    linkHref: "/photo-album/",
    imageSrc: OPG_A("../../assets/web/mockups/luna-before-after.webp")
  }), /*#__PURE__*/React.createElement(TestimonialFeature, {
    tone: "navy"
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "7/5",
    reverse: true,
    eyebrow: "Why One Print Gallery",
    heading: "Personalised should mean more than a name on a template.",
    points: [{
      title: 'Real memories',
      body: 'Your photographs create the content. We never drop a name into a stock template.'
    }, {
      title: 'Recognisable style',
      body: 'Realistic, clean line-art that preserves meaningful detail rather than forcing every photograph into a cartoon look.'
    }, {
      title: 'Human care',
      body: 'Every order is treated as a personal project, with support available when you need it.'
    }],
    imageSrc: OPG_A("../../assets/web/transform/baby-cat-after.webp")
  }), /*#__PURE__*/React.createElement(UsVsThem, {
    tone: "paper",
    onCta: () => go('/create/')
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Transformation Gallery",
    heading: "Photo in. Keepsake out.",
    body: "A curated selection of finished projects. Each one begins with a customer's own photographs, shown with their permission."
  }), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, [{
    t: 'Our wedding day',
    f: 'jade-wedding-after.webp'
  }, {
    t: 'Three generations on the sofa',
    f: 'jade-family-after.webp'
  }, {
    t: 'Their wedding day, forty years on',
    f: 'wedding-after.webp'
  }, {
    t: 'The whole family, cat included',
    f: 'family-after.webp'
  }, {
    t: 'Colouring at the dining table',
    f: 'colouring-after.webp'
  }, {
    t: 'Saturday morning football',
    f: 'football-after.webp'
  }].map(({
    t,
    f
  }) => /*#__PURE__*/React.createElement("li", {
    key: t
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/transform/') + f,
    alt: t,
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '14px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-lg)',
      color: 'var(--color-brand)'
    }
  }, t), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '4px 0 0',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, "Original photo \xB7 Transformation \xB7 Finished book")))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(TextLink, {
    href: "/gallery/",
    withArrow: true
  }, "See the full gallery"))), /*#__PURE__*/React.createElement(Manifesto, null), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "One of One",
    heading: "Original art, printed to order.",
    body: "Two collections designed by One Print Gallery: the Highland Cows and The Obsidian Society. Premium posters in four sizes, from \xA319.99."
  }), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ArtworkCard, {
    badge: "Art Print",
    price: "\xA319.99",
    priceFrom: true,
    medium: "12 \xD7 18 to 24 \xD7 36 in",
    title: "See No Evil",
    collection: "Highland Cows",
    imageSrc: OPG_A("../../assets/web/art/see-no-evil.webp"),
    ratio: "2 / 3",
    href: window.opgArtHref ? opgArtHref("See No Evil", "Highland Cows") : "/one-of-one-art/"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ArtworkCard, {
    badge: "Art Print",
    price: "\xA319.99",
    priceFrom: true,
    medium: "12 \xD7 18 to 24 \xD7 36 in",
    title: "Hear No Evil",
    collection: "Highland Cows",
    imageSrc: OPG_A("../../assets/web/art/hear-no-evil.webp"),
    ratio: "2 / 3",
    href: window.opgArtHref ? opgArtHref("Hear No Evil", "Highland Cows") : "/one-of-one-art/"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ArtworkCard, {
    badge: "Art Print",
    price: "\xA319.99",
    priceFrom: true,
    medium: "12 \xD7 18 to 24 \xD7 36 in",
    title: "The Detective",
    collection: "The Obsidian Society",
    imageSrc: OPG_A("../../assets/web/art/obsidian-the-detective.webp"),
    ratio: "2 / 3",
    href: window.opgArtHref ? opgArtHref("The Detective", "The Obsidian Society") : "/one-of-one-art/"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ArtworkCard, {
    badge: "Art Print",
    price: "\xA319.99",
    priceFrom: true,
    medium: "12 \xD7 18 to 24 \xD7 36 in",
    title: "The Boss",
    collection: "The Obsidian Society",
    imageSrc: OPG_A("../../assets/web/art/obsidian-the-boss.webp"),
    ratio: "2 / 3",
    href: window.opgArtHref ? opgArtHref("The Boss", "The Obsidian Society") : "/one-of-one-art/"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: () => go('/one-of-one-art/')
  }, "Explore One-of-One Art"))), /*#__PURE__*/React.createElement(FounderFeature, null), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    heading: "Made for more than one kind of customer.",
    body: "We also develop bespoke colouring, keepsake and creative projects for schools, SEN settings, care homes, football clubs and organisations."
  }), /*#__PURE__*/React.createElement(AudienceSelector, null)), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "compact"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Customer Creations",
    heading: "The reaction is the product.",
    max: "18ch"
  }), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))',
      gap: '16px'
    }
  }, ['transform/family-before.webp', 'transform/colouring-before.webp', 'transform/baby-cat-before.webp', 'transform/getting-ready-before.webp', 'transform/football-before.webp', 'books/jade-front.webp'].map(f => /*#__PURE__*/React.createElement("li", {
    key: f
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/') + f,
    alt: "",
    style: {
      width: '100%',
      aspectRatio: '9 / 16',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }))))), /*#__PURE__*/React.createElement(FaqAccordion, {
    tone: "paper",
    eyebrow: "Before You Order"
  }), /*#__PURE__*/React.createElement(FullBleedBanner, {
    align: "center",
    heading: "Your next keepsake is already in your camera roll.",
    ctaLabel: "Create Your Book",
    secondaryLabel: "See How It Works"
  }));
}
Object.assign(window, {
  Homepage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Homepage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/InfoPages.jsx
try { (() => {
const IDS = window.OnePrintGalleryDesignSystem_ba4735;
const {
  Eyebrow: IEyebrow,
  Button: IButton,
  ArtworkCard: IArtwork
} = IDS;
const I_FUL = IDS.FULFILMENT,
  I_ALBUM = IDS.PHOTO_ALBUM,
  I_ART = IDS.ART_PRINTS;
const I_EMAIL = 'enquiries@oneprintgallery.co.uk';
const I_UPDATED = 'September 2026';
const iH1 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-4xl)',
  lineHeight: 1.02,
  letterSpacing: 'var(--tracking-display)',
  color: 'var(--color-brand)',
  textWrap: 'balance'
};
const iH2 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-2xl)',
  lineHeight: 1.15,
  color: 'var(--color-brand)'
};
const iP = {
  margin: 0,
  fontSize: 'var(--text-base)',
  lineHeight: 1.7,
  color: 'var(--color-text)',
  maxWidth: '66ch',
  textWrap: 'pretty'
};
const iLink = {
  color: 'var(--color-brand)',
  fontWeight: 600
};
function InfoIntro({
  eyebrow,
  heading,
  body
}) {
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-paper)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement(IEyebrow, null, eyebrow), /*#__PURE__*/React.createElement("h1", {
    style: iH1
  }, heading), body ? /*#__PURE__*/React.createElement("p", {
    style: {
      ...iP,
      color: 'var(--color-text-muted)',
      maxWidth: '58ch'
    }
  }, body) : null));
}

/* Long-form reading page: a list of { h, p: [..] | node } blocks. */
function InfoDoc({
  eyebrow,
  heading,
  body,
  blocks
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoIntro, {
    eyebrow: eyebrow,
    heading: heading,
    body: body
  }), /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container-reading)',
      margin: '0 auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gap: 'var(--space-8)'
    }
  }, blocks.map(b => /*#__PURE__*/React.createElement("div", {
    key: b.h,
    style: {
      display: 'grid',
      gap: 12,
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: iH2
  }, b.h), (Array.isArray(b.p) ? b.p : [b.p]).map((t, i) => /*#__PURE__*/React.createElement("p", {
    key: i,
    style: iP
  }, t)))), /*#__PURE__*/React.createElement("p", {
    style: {
      ...iP,
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, "Last updated ", I_UPDATED, ". Questions? Email ", /*#__PURE__*/React.createElement("a", {
    href: 'mailto:' + I_EMAIL,
    style: iLink
  }, I_EMAIL), "."))));
}
function ShippingPage() {
  return /*#__PURE__*/React.createElement(InfoDoc, {
    eyebrow: "Shipping",
    heading: "Made to order, posted with care.",
    body: "Every book is made from your photographs, so it\u2019s produced when you order, then packed and posted from the United Kingdom.",
    blocks: [{
      h: 'Colouring books',
      p: [`${I_FUL.production}. ${I_FUL.shipping} after that.`, I_FUL.shippingNote]
    }, {
      h: 'Colouring photo albums',
      p: [`${I_FUL.production}.`, I_ALBUM.delivery + '.']
    }, {
      h: 'One-of-One art prints',
      p: [`Printed to order. ${I_ART.delivery}.`, I_ART.note]
    }, {
      h: 'If you request a preview',
      p: 'We email your pages for approval first. Production starts as soon as you reply, so the dates above count from your approval.'
    }, {
      h: 'Tracking',
      p: 'We email you when your order is posted, with tracking where the service includes it.'
    }, {
      h: 'Something wrong with your order?',
      p: [I_FUL.returns, `If anything arrives damaged or isn’t right, email ${I_EMAIL} within 14 days of delivery with your order number and a photo, and we’ll put it right.`]
    }]
  });
}
function PrivacyPage() {
  return /*#__PURE__*/React.createElement(InfoDoc, {
    eyebrow: "Privacy",
    heading: "Your photos stay yours.",
    body: "We only use your photographs and details to make and deliver your order.",
    blocks: [{
      h: 'Who we are',
      p: `One Print Gallery is a UK business making personalised colouring books, photo albums and art prints. For anything about your data, email ${I_EMAIL}.`
    }, {
      h: 'What we collect',
      p: ['The details you give us when you order: your name, email, delivery address and phone number if you add one.', 'The photographs you upload, and any names, captions or messages for your book.', 'Payment is handled securely by our checkout provider. We never see or store your full card details.']
    }, {
      h: 'How we use it',
      p: ['To make, check and deliver your order, and to contact you about it.', 'To send marketing emails, only if you’ve said yes. Every email has an unsubscribe link.']
    }, {
      h: 'Your photographs',
      p: ['Your photos are seen only by the people making your book. We never sell them, share them or use them to train software.', 'We never show your photos or finished pages publicly (in our gallery or on social media) without your written permission.', 'We delete your uploaded photos once your order has been delivered and any questions about it are settled.']
    }, {
      h: 'Who we share it with',
      p: 'Only the services we need to run the shop: our website and checkout provider, our printer and our delivery couriers. Each gets just enough to do their part.'
    }, {
      h: 'Cookies',
      p: 'We use essential cookies to keep your bag and checkout working. We only use analytics or marketing cookies if you agree to them.'
    }, {
      h: 'Your rights',
      p: `Under UK data protection law you can ask to see the information we hold about you, correct it, or ask us to delete it. Email ${I_EMAIL} and we’ll reply within one month. You can also complain to the Information Commissioner’s Office (ico.org.uk).`
    }]
  });
}
function TermsPage() {
  return /*#__PURE__*/React.createElement(InfoDoc, {
    eyebrow: "Terms",
    heading: "Terms of sale.",
    body: "The short version: tell us about any problem and we\u2019ll put it right. The details are below.",
    blocks: [{
      h: 'Your order',
      p: ['When you place an order you’ll receive a confirmation email. Your order is accepted once we’ve checked your photos and started production.', 'Prices are shown in pounds sterling and include VAT where it applies. Delivery charges are shown at checkout.']
    }, {
      h: 'Your photographs',
      p: ['By uploading photos you confirm you own them or have permission to use them, including permission from anyone who appears in them.', 'We won’t make pages from photos that are offensive or unlawful, or that use other people’s protected artwork, logos or characters. If a photo can’t be used, we’ll contact you before going any further.']
    }, {
      h: 'Personalised items',
      p: [I_FUL.returns, 'This doesn’t affect your legal rights if an item is faulty or not as described.']
    }, {
      h: 'Previews and changes',
      p: 'If you request a preview, please check names, captions and pages carefully. Once you approve it, we print exactly what you’ve approved.'
    }, {
      h: 'Faulty or damaged items',
      p: `Email ${I_EMAIL} within 14 days of delivery with your order number and a photo of the problem. We’ll reprint or refund it.`
    }, {
      h: 'One-of-One art',
      p: 'Artwork designs remain the property of One Print Gallery. Buying a print doesn’t give you the right to copy or resell the design.'
    }, {
      h: 'Law',
      p: 'These terms are governed by the law of England and Wales.'
    }]
  });
}
function AccessibilityPage() {
  return /*#__PURE__*/React.createElement(InfoDoc, {
    eyebrow: "Accessibility",
    heading: "A shop everyone can use.",
    body: "We want everyone to be able to order a keepsake, whatever device or assistive technology they use.",
    blocks: [{
      h: 'Our aim',
      p: 'We design and test this website against the Web Content Accessibility Guidelines (WCAG) 2.2, level AA.'
    }, {
      h: 'What we’ve done',
      p: ['Text and buttons meet colour-contrast guidelines, and buttons are large enough to tap easily.', 'Every page works with a keyboard, with a visible focus outline.', 'Images have text descriptions, and forms have clear labels and error messages.', 'Animations stay still if your device is set to reduce motion.']
    }, {
      h: 'Where we’re still improving',
      p: 'The before-and-after slider can also be moved with the arrow keys. If any part of ordering is hard to use, we can take your order by email instead.'
    }, {
      h: 'Tell us',
      p: `If something doesn’t work for you, email ${I_EMAIL}. We’ll reply within two working days and help you place your order another way if needed.`
    }]
  });
}
const I_COLLECTIONS = {
  'highland-cows': {
    name: 'Highland Cows',
    eyebrow: 'One of One · Collection',
    heading: 'See, hear and speak no evil.',
    body: 'Three Highland calves, each covering eyes, ears or mouth. A gentle take on the Three Wise Monkeys, drawn in detailed pencil style. Beautiful alone, better as a set of three.'
  },
  'obsidian-society': {
    name: 'The Obsidian Society',
    eyebrow: 'One of One · Collection',
    heading: 'The Obsidian Society.',
    body: 'Five dark, cinematic portraits, numbered No. I to No. V. Designed to hang together as a series or stand alone as a statement piece.'
  }
};
const I_WORKS = [['See No Evil', 'Highland Cows', 'see-no-evil.webp'], ['Hear No Evil', 'Highland Cows', 'hear-no-evil.webp'], ['Speak No Evil', 'Highland Cows', 'speak-no-evil.webp'], ['The Boss', 'The Obsidian Society', 'obsidian-the-boss.webp', 'No. I'], ['Boardroom', 'The Obsidian Society', 'obsidian-boardroom.webp', 'No. II'], ['The Detective', 'The Obsidian Society', 'obsidian-the-detective.webp', 'No. III'], ['The Strategist', 'The Obsidian Society', 'obsidian-the-strategist.webp', 'No. IV'], ['The Assassin', 'The Obsidian Society', 'obsidian-the-assassin.webp', 'No. V']];
function CollectionPage({
  id,
  go
}) {
  const c = I_COLLECTIONS[id];
  const works = I_WORKS.filter(w => w[1] === c.name);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoIntro, {
    eyebrow: c.eyebrow,
    heading: c.heading,
    body: c.body
  }), /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gap: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))',
      gap: 'var(--space-8) var(--grid-gap-lg)'
    }
  }, works.map(([title, collection, f, no]) => /*#__PURE__*/React.createElement("li", {
    key: title
  }, /*#__PURE__*/React.createElement(IArtwork, {
    badge: "Art Print",
    status: "available",
    ratio: "2 / 3",
    price: I_ART.from,
    priceFrom: true,
    title: title,
    collection: collection,
    medium: (no ? no + ' · ' : '') + I_ART.sizeRange,
    imageSrc: OPG_A('../../assets/web/art/') + f,
    href: "/one-of-one-art/"
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10,
      paddingTop: 'var(--space-6)',
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      ...iP,
      color: 'var(--color-text-muted)'
    }
  }, I_ART.paper, ". ", I_ART.delivery, ". ", I_ART.note), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IButton, {
    variant: "secondary",
    onClick: () => go('/one-of-one-art/')
  }, "See all One-of-One art"))))));
}
Object.assign(window, {
  ShippingPage,
  PrivacyPage,
  TermsPage,
  AccessibilityPage,
  CollectionPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/InfoPages.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/MorePages.jsx
try { (() => {
const MDS = window.OnePrintGalleryDesignSystem_ba4735;
const {
  Eyebrow: MEyebrow,
  Button: MButton,
  BeforeAfterSlider: MSlider,
  FaqAccordion: MFaq,
  FullBleedBanner: MBanner,
  FormField: MField,
  Input: MInput,
  Select: MSelect,
  Textarea: MTextarea,
  Icon: MIcon,
  IconButton: MIconButton,
  EmptyState: MEmpty,
  TextLink: MLink
} = MDS;
const M_REVIEWS = MDS.REVIEWS || [],
  M_STATS = MDS.SHOP_STATS || {
    rating: 5,
    reviewCount: 50,
    sales: 201
  },
  M_FUL = MDS.FULFILMENT,
  M_PRICING = MDS.PRICING,
  M_ALBUM = MDS.PHOTO_ALBUM;
const mH1 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-4xl)',
  lineHeight: 1.02,
  letterSpacing: 'var(--tracking-display)',
  color: 'var(--color-brand)',
  textWrap: 'balance'
};
const mBody = {
  margin: 0,
  fontSize: 'var(--text-base)',
  lineHeight: 1.65,
  color: 'var(--color-text-muted)',
  maxWidth: '58ch'
};
const mImg = {
  width: '100%',
  objectFit: 'cover',
  borderRadius: 'var(--radius-md)',
  border: '1px solid var(--color-border)',
  background: 'var(--opg-white)',
  display: 'block'
};
const PageIntro = ({
  eyebrow,
  heading,
  body,
  tone = 'paper',
  children
}) => /*#__PURE__*/React.createElement(Section, {
  tone: tone,
  pad: "standard"
}, /*#__PURE__*/React.createElement("div", {
  style: {
    display: 'grid',
    gap: 18,
    maxWidth: 820
  }
}, eyebrow ? /*#__PURE__*/React.createElement(MEyebrow, null, eyebrow) : null, /*#__PURE__*/React.createElement("h1", {
  style: mH1
}, heading), body ? /*#__PURE__*/React.createElement("p", {
  style: mBody
}, body) : null, children));
const Chips = ({
  items,
  value,
  onChange,
  label
}) => /*#__PURE__*/React.createElement("div", {
  role: "group",
  "aria-label": label,
  style: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8
  }
}, items.map(it => {
  const on = it === value;
  return /*#__PURE__*/React.createElement("button", {
    key: it,
    type: "button",
    "aria-pressed": on,
    onClick: () => onChange(it),
    style: {
      minHeight: 40,
      padding: '0 16px',
      borderRadius: 'var(--radius-round)',
      border: `1px solid ${on ? 'var(--color-brand)' : 'var(--color-border-strong)'}`,
      background: on ? 'var(--color-brand)' : 'transparent',
      color: on ? 'var(--opg-white)' : 'var(--color-brand)',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      cursor: 'pointer'
    }
  }, it);
}));

/* ——— Transformation gallery ——— */
const GALLERY = [{
  id: 'jade-family',
  title: 'Three generations on the sofa',
  tags: ['Family', 'Children'],
  before: 'jade-family-before-aligned',
  after: 'jade-family-after-aligned',
  dir: 'transform'
}, {
  id: 'jade-wedding',
  title: 'Their wedding day',
  tags: ['Weddings', 'Family'],
  before: 'jade-wedding-before',
  after: 'jade-wedding-after',
  dir: 'transform',
  landscape: true
}, {
  id: 'baby',
  title: 'First time sitting up',
  tags: ['Children', 'Family'],
  before: 'baby-before-aligned',
  after: 'baby-after-aligned',
  dir: 'transform'
}, {
  id: 'pets',
  title: 'Best friends, fast asleep',
  tags: ['Pets'],
  before: 'pets-before-aligned',
  after: 'pets-after-aligned',
  dir: 'transform'
}, {
  id: 'cake',
  title: 'Make a wish',
  tags: ['Moments', 'Family'],
  before: 'cake-before-aligned',
  after: 'cake-after-aligned',
  dir: 'transform'
}, {
  id: 'family',
  title: 'A family afternoon',
  tags: ['Family'],
  before: 'family-before-aligned',
  after: 'family-after-aligned',
  dir: 'transform'
}, {
  id: 'colouring',
  title: 'Colouring together',
  tags: ['Children', 'Family'],
  before: 'colouring-before-aligned',
  after: 'colouring-after-aligned',
  dir: 'transform'
}, {
  id: 'cat',
  title: 'Window seat',
  tags: ['Pets'],
  before: 'cat-before-aligned',
  after: 'cat-after-aligned',
  dir: 'transform'
}, {
  id: 'skyline',
  title: 'The view from up there',
  tags: ['Places'],
  before: 'skyline-before',
  after: 'skyline-after',
  dir: 'transform'
}, {
  id: 'concert',
  title: 'Front row',
  tags: ['Moments'],
  before: 'concert-before',
  after: 'concert-after',
  dir: 'transform'
}, {
  id: 'tickets',
  title: 'The night we went',
  tags: ['Moments'],
  before: 'tickets-before-aligned',
  after: 'tickets-after-aligned',
  dir: 'transform'
}, {
  id: 'football',
  title: 'Matchday',
  tags: ['Sport', 'Children'],
  before: 'football-before',
  after: 'football-after',
  dir: 'transform'
}, {
  id: 'gaming',
  title: 'Game on',
  tags: ['Moments', 'Children'],
  before: 'gaming-before-aligned',
  after: 'gaming-after-aligned',
  dir: 'transform'
}, {
  id: 'roast',
  title: 'Sunday roast',
  tags: ['Moments'],
  before: 'roast-before-aligned',
  after: 'roast-after-aligned',
  dir: 'transform'
}, {
  id: 'wedding',
  title: 'The wedding day',
  tags: ['Weddings'],
  before: 'wedding-before-aligned',
  after: 'wedding-after-aligned',
  dir: 'transform'
}, {
  id: 'getting-ready',
  title: 'Getting ready',
  tags: ['Weddings', 'Family'],
  before: 'getting-ready-before-aligned',
  after: 'getting-ready-after-aligned',
  dir: 'transform'
}, {
  id: 'sunrise-bench',
  title: 'Sunrise by the lake',
  tags: ['Places'],
  before: 'sunrise-bench-before-aligned',
  after: 'sunrise-bench-after-aligned',
  dir: 'transform'
}, {
  id: 'lake-path',
  title: 'A walk by the water',
  tags: ['Places'],
  before: 'lake-path-before-aligned',
  after: 'lake-path-after-aligned',
  dir: 'transform'
}, {
  id: 'forest',
  title: 'Into the woods',
  tags: ['Places'],
  before: 'forest-before',
  after: 'forest-after',
  dir: 'transform'
}, {
  id: 'rose',
  title: 'From the garden',
  tags: ['Nature'],
  before: 'rose-before-aligned',
  after: 'rose-after-aligned',
  dir: 'transform'
}, {
  id: 'butterfly',
  title: 'A visitor on the leaf',
  tags: ['Nature'],
  before: 'butterfly-before',
  after: 'butterfly-after',
  dir: 'transform'
}, {
  id: 'baby-cat',
  title: 'Little ones',
  tags: ['Pets', 'Children'],
  before: 'baby-cat-before-aligned',
  after: 'baby-cat-after-aligned',
  dir: 'transform'
}, {
  id: 'nanny',
  title: 'Nanny’s photographs',
  tags: ['Family'],
  before: 'care-nanny-before-aligned',
  after: 'care-nanny-after-aligned',
  dir: 'b2b'
}];
const COVERS = [{
  id: 'luna',
  name: 'Starry & magical',
  cat: 'Children',
  best: 'Children’s books, bedtime keepsakes',
  front: OPG_A('../../assets/web/books/luna-front.webp'),
  back: OPG_A('../../assets/web/books/luna-back.webp')
}, {
  id: 'jade',
  name: 'Black & gold',
  cat: 'Family',
  best: 'Weddings, anniversaries, family books',
  front: OPG_A('../../assets/web/books/jade-front.webp'),
  back: OPG_A('../../assets/web/books/jade-back.webp')
}, {
  id: 'amelia-princess',
  name: 'Pastel princess',
  cat: 'Children',
  best: 'Dress-up days, little dreamers',
  front: OPG_A('../../assets/web/covers/amelia-princess.webp'),
  back: OPG_A('../../assets/web/covers/amelia-princess-back.webp')
}, {
  id: 'luna-kawaii',
  name: 'Cute & kawaii',
  cat: 'Children',
  best: 'Favourite characters, toys and games',
  front: OPG_A('../../assets/web/covers/luna-kawaii.webp'),
  back: OPG_A('../../assets/web/covers/luna-kawaii-back.webp')
}, {
  id: 'ella-family',
  name: 'Soft & playful',
  cat: 'Family',
  best: 'Family books for younger children',
  front: OPG_A('../../assets/web/covers/ella-family.webp'),
  back: OPG_A('../../assets/web/covers/ella-family-back.webp')
}, {
  id: 'ava-sienna-kai',
  name: 'Midnight hearts',
  cat: 'Children',
  best: 'Siblings, cousins, back to school',
  front: OPG_A('../../assets/web/covers/ava-sienna-kai.webp'),
  back: OPG_A('../../assets/web/covers/ava-sienna-kai-back.webp')
}, {
  id: 'sienna-16th',
  name: 'Pink party',
  cat: 'Birthdays',
  best: 'Sweet sixteens and big birthdays',
  front: OPG_A('../../assets/web/covers/sienna-16th.webp')
}, {
  id: 'chloe-party',
  name: 'Celebration',
  cat: 'Birthdays',
  best: 'Birthdays, new cars, family milestones',
  front: OPG_A('../../assets/web/covers/chloe-party.webp'),
  back: OPG_A('../../assets/web/covers/chloe-party-back.webp')
}, {
  id: 'sophia-glam',
  name: 'Leopard & glam',
  cat: 'Birthdays',
  best: 'Girls’ nights, hen parties, best friends',
  front: OPG_A('../../assets/web/covers/sophia-glam.webp')
}, {
  id: 'anniversary-hubby',
  name: 'Golden anniversary',
  cat: 'Couples',
  best: 'Anniversaries, with their hobbies woven in',
  front: OPG_A('../../assets/web/covers/anniversary-hubby.webp'),
  back: OPG_A('../../assets/web/covers/anniversary-hubby-back.webp')
}, {
  id: 'oliver-james',
  name: 'Spring romance',
  cat: 'Couples',
  best: 'Valentine’s Day, couples',
  front: OPG_A('../../assets/web/covers/oliver-james.webp'),
  back: OPG_A('../../assets/web/covers/oliver-james-back.webp')
}, {
  id: 'mason-daisy',
  name: 'Country & western',
  cat: 'Couples',
  best: 'Couples, holidays, date nights',
  front: OPG_A('../../assets/web/covers/mason-daisy.webp'),
  back: OPG_A('../../assets/web/covers/mason-daisy-back.webp')
}, {
  id: 'sophia-graduation',
  name: 'Graduation blue',
  cat: 'Occasions',
  best: 'Graduations and proud moments',
  front: OPG_A('../../assets/web/covers/sophia-graduation.webp'),
  back: OPG_A('../../assets/web/covers/sophia-graduation-back.webp')
}, {
  id: 'bella-fathers-day',
  name: 'Father’s Day',
  cat: 'Occasions',
  best: 'Father’s Day, Mother’s Day, grandparents',
  front: OPG_A('../../assets/web/covers/bella-fathers-day.webp')
}, {
  id: 'amelia-travel',
  name: 'Travel scrapbook',
  cat: 'Occasions',
  best: 'Gap years, holidays, adventures',
  front: OPG_A('../../assets/web/covers/amelia-travel.webp')
}];
function CoverCard({
  c
}) {
  const [back, setBack] = React.useState(false);
  return /*#__PURE__*/React.createElement("li", {
    style: {
      display: 'grid',
      gap: 14,
      alignContent: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      aspectRatio: '1 / 1.414',
      borderRadius: '3px 8px 8px 3px',
      overflow: 'hidden',
      boxShadow: '0 22px 40px -22px rgba(20,28,60,.55)',
      background: 'var(--opg-white)'
    }
  }, c.fit === 'contain' ? /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: c.front,
    alt: "",
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      inset: '-10%',
      width: '120%',
      height: '120%',
      objectFit: 'cover',
      filter: 'blur(18px) saturate(1.1)',
      opacity: .9
    }
  }) : null, /*#__PURE__*/React.createElement("img", {
    src: back ? c.back : c.front,
    alt: `${c.name} cover, ${back ? 'back' : 'front'}`,
    loading: "lazy",
    style: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: c.fit === 'contain' ? 'contain' : 'cover',
      objectPosition: 'center top',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: 18,
      background: 'linear-gradient(90deg, rgba(0,0,0,.25), rgba(0,0,0,0))',
      pointerEvents: 'none'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 6
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.2,
      color: 'var(--color-brand)'
    }
  }, c.name), c.back ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setBack(!back),
    style: {
      flex: 'none',
      padding: 0,
      border: 0,
      background: 'none',
      font: 'inherit',
      fontSize: 'var(--text-xs)',
      fontWeight: 600,
      color: 'var(--color-accent)',
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  }, back ? 'See front' : 'See back') : null), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-accent-warm)'
    }
  }, "Great for"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-sm)',
      lineHeight: 1.55,
      color: 'var(--color-text)'
    }
  }, c.best)));
}
function GalleryPage({
  go
}) {
  const [f, setF] = React.useState('All');
  const [cf, setCf] = React.useState('All');
  const covers = COVERS.filter(c => cf === 'All' || c.cat === cf);
  const [open, setOpen] = React.useState(GALLERY[0].id);
  const list = GALLERY.filter(g => f === 'All' || g.tags.includes(f));
  const cur = GALLERY.find(g => g.id === open) || GALLERY[0];
  const src = (g, k) => OPG_A(`../../assets/web/${g.dir}/${g[k]}.webp`);
  const thumb = (g, k) => OPG_A(`../../assets/web/thumbs/${g.dir}/${g[k]}.webp`);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageIntro, {
    eyebrow: "Gallery",
    heading: "Real photos. Real pages.",
    body: "Every page here started as a customer\u2019s everyday photograph. Compare the originals with the finished colouring pages, then browse cover styles for inspiration."
  }, /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Gallery sections",
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
      marginTop: 8
    }
  }, [['Transformations', 'g-transform'], ['Cover styles', 'g-covers']].map(([l, id]) => /*#__PURE__*/React.createElement("a", {
    key: id,
    href: `#${id}`,
    onClick: e => {
      e.preventDefault();
      const el = document.getElementById(id);
      if (el) window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - 90,
        behavior: 'smooth'
      });
    },
    style: {
      minHeight: 40,
      display: 'inline-flex',
      alignItems: 'center',
      padding: '0 16px',
      borderRadius: 'var(--radius-round)',
      border: '1px solid var(--color-border-strong)',
      color: 'var(--color-brand)',
      textDecoration: 'none',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600
    }
  }, l)))), /*#__PURE__*/React.createElement("div", {
    id: "g-transform"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "compact"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, cur.landscape ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1.33fr) minmax(0,1fr)',
      gap: 12,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: src(cur, 'before'),
    alt: "Original photo",
    style: {
      ...mImg,
      aspectRatio: '1402 / 1122'
    }
  }), /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: src(cur, 'after'),
    alt: "Finished colouring page",
    style: {
      ...mImg,
      aspectRatio: '1055 / 1491'
    }
  })) : /*#__PURE__*/React.createElement(MSlider, {
    key: cur.id,
    beforeSrc: src(cur, 'before'),
    afterSrc: src(cur, 'after'),
    ratio: "4 / 5"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 16
    }
  }, /*#__PURE__*/React.createElement(MEyebrow, null, cur.tags.join(' · ')), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      color: 'var(--color-brand)'
    }
  }, cur.title), /*#__PURE__*/React.createElement("p", {
    style: mBody
  }, "Faces, clothing and the small details that make it theirs, kept recognisable, then simplified into lines a child can colour."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 8
    }
  }, /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    size: "lg",
    onClick: () => go('/create/')
  }, "Create Your Book"))))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      color: 'var(--color-brand)'
    }
  }, "More transformations"), /*#__PURE__*/React.createElement(Chips, {
    label: "Filter gallery",
    items: ['All', 'Family', 'Children', 'Weddings', 'Pets', 'Moments', 'Places', 'Nature', 'Sport'],
    value: f,
    onChange: setF
  })), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(240px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, list.map(g => /*#__PURE__*/React.createElement("li", {
    key: g.id
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => {
      setOpen(g.id);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    "aria-label": `Compare ${g.title}`,
    style: {
      display: 'grid',
      gap: 12,
      width: '100%',
      padding: 0,
      border: 0,
      background: 'none',
      textAlign: 'left',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 4,
      borderRadius: 'var(--radius-md)',
      overflow: 'hidden',
      outline: g.id === open ? '2px solid var(--color-brand)' : 'none',
      outlineOffset: 3
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: thumb(g, 'before'),
    alt: "",
    style: {
      width: '100%',
      aspectRatio: '3 / 4',
      objectFit: 'cover',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: thumb(g, 'after'),
    alt: "",
    style: {
      width: '100%',
      aspectRatio: '3 / 4',
      objectFit: 'cover',
      display: 'block',
      background: 'var(--opg-white)'
    }
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-brand)'
    }
  }, g.title)))))), /*#__PURE__*/React.createElement("div", {
    id: "g-covers"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "blush"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Cover Styles",
    heading: "Find a cover that feels like them.",
    body: "Every cover is designed by hand around your photos, their name and the things they love. Pick a style you like when you order, or tell us their interests and favourite colours and we\u2019ll create something to suit."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(Chips, {
    label: "Filter cover styles",
    items: ['All', 'Children', 'Birthdays', 'Couples', 'Family', 'Occasions'],
    value: cf,
    onChange: setCf
  })), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))',
      gap: 'var(--space-8) var(--grid-gap-lg)',
      alignItems: 'start'
    }
  }, covers.map(c => /*#__PURE__*/React.createElement(CoverCard, {
    key: c.id,
    c: c
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-8)',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    size: "lg",
    onClick: () => go('/create/')
  }, "Create Your Book"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, "You can describe your cover style in step 2."))), /*#__PURE__*/React.createElement(MBanner, {
    align: "center",
    heading: "Your next keepsake is already in your camera roll.",
    ctaLabel: "Create Your Book",
    ctaHref: "/create/"
  }));
}

/* ——— Reviews ——— */
const REVIEW_TOPICS = {
  'Colouring Books': r => /colouring book/i.test(r.product || ''),
  Quality: r => /quality|incredible|better than|beautiful/i.test(r.quote),
  'Customer Service': r => /leon|communicat|messag|delivered|above and beyond/i.test(r.quote),
  'Gift Reactions': r => /gift|loved|grand|daughter|son/i.test(r.quote)
};
function ReviewsPage({
  go
}) {
  const [f, setF] = React.useState('All');
  const list = M_REVIEWS.filter(r => f === 'All' || REVIEW_TOPICS[f](r));
  const lead = M_REVIEWS[0];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "standard"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'end'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement(MEyebrow, null, "Reviews"), /*#__PURE__*/React.createElement("h1", {
    style: mH1
  }, "In their words."), /*#__PURE__*/React.createElement("p", {
    style: mBody
  }, "Verified reviews from customers who have already turned their photos into books. Read in full on our Etsy shop.")), /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(3,minmax(0,1fr))',
      gap: 'var(--space-5)'
    }
  }, [[M_STATS.rating.toFixed(1), 'Average rating'], [M_STATS.reviewCount, 'Verified reviews'], [M_STATS.sales, 'Books and prints sold']].map(([v, l]) => /*#__PURE__*/React.createElement("div", {
    key: l,
    style: {
      paddingTop: 14,
      borderTop: '1px solid var(--color-border-strong)'
    }
  }, /*#__PURE__*/React.createElement("dd", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1,
      color: 'var(--color-brand)'
    }
  }, v), /*#__PURE__*/React.createElement("dt", {
    style: {
      marginTop: 8,
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, l)))))), lead ? /*#__PURE__*/React.createElement(Section, {
    tone: "navy",
    pad: "standard"
  }, /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      maxWidth: 900,
      display: 'grid',
      gap: 22
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      gap: 4,
      color: 'var(--opg-peach-300)'
    }
  }, [0, 1, 2, 3, 4].map(i => /*#__PURE__*/React.createElement(MIcon, {
    key: i,
    name: "star",
    size: 20,
    style: {
      fill: 'currentColor'
    }
  }))), /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 500,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.18,
      color: 'var(--opg-white)',
      textWrap: 'pretty'
    }
  }, "\u201C", lead.quote, "\u201D"), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-on-dark-muted)'
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--opg-white)'
    }
  }, lead.attribution), " \xB7 ", lead.source))) : null, /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement(Chips, {
    label: "Filter reviews",
    items: ['All', ...Object.keys(REVIEW_TOPICS)],
    value: f,
    onChange: setF
  })), list.length ? /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      columns: '300px 3',
      columnGap: 'var(--grid-gap-lg)'
    }
  }, list.map((r, i) => /*#__PURE__*/React.createElement("li", {
    key: i,
    style: {
      breakInside: 'avoid',
      marginBottom: 'var(--grid-gap-lg)',
      padding: 'var(--space-6)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      background: 'var(--opg-white)',
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      gap: 3,
      color: 'var(--color-accent-warm)'
    }
  }, [0, 1, 2, 3, 4].map(k => /*#__PURE__*/React.createElement(MIcon, {
    key: k,
    name: "star",
    size: 15,
    style: {
      fill: 'currentColor'
    }
  }))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 500,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.3,
      color: 'var(--color-brand)'
    }
  }, "\u201C", r.quote, "\u201D"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--color-text)'
    }
  }, r.attribution), " \xB7 ", r.product, /*#__PURE__*/React.createElement("br", null), r.source)))) : /*#__PURE__*/React.createElement(MEmpty, {
    icon: "star",
    heading: "No reviews in this group yet.",
    body: "Try another filter, or be the first."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(MLink, {
    href: "https://www.etsy.com/shop/OnePrintGallery#reviews",
    withArrow: true
  }, "Read all ", M_STATS.reviewCount, " reviews on Etsy"))), /*#__PURE__*/React.createElement(MBanner, {
    align: "center",
    heading: "Ready to make one of your own?",
    ctaLabel: "Create Your Book",
    ctaHref: "/create/"
  }));
}

/* ——— Journal ——— */
const JOURNAL = [{
  cat: 'Photo Tips',
  title: 'Any photo works: choosing pictures for a colouring book',
  dek: 'Why blurry phone snaps and faded prints make some of the best pages, and the few we’d skip.',
  img: OPG_A('../../assets/web/mockups/luna-before-after.webp')
}, {
  cat: 'Behind the Gallery',
  title: 'How a photograph becomes a colouring page',
  dek: 'From your upload to the finished line art: what we keep, what we simplify, and why a person checks every page.',
  img: OPG_A('../../assets/web/transform/family-after.webp')
}, {
  cat: 'Gift Ideas',
  title: 'A gift for grandparents that gets coloured together',
  dek: 'Family photos, one book, two generations with the pencils out.',
  img: OPG_A('../../assets/web/mockups/luna-held.webp')
}, {
  cat: 'Customer Stories',
  title: 'The Willows: 50 books, then 150 more',
  dek: 'How a specialist SEN school in Hayes built a colouring book around its own people and places.',
  img: OPG_A('../../assets/web/b2b/school-class-after.webp')
}, {
  cat: 'One-of-One Art',
  title: 'The Highland Cows trio',
  dek: 'See no evil, hear no evil, speak no evil: the story behind the series.',
  img: OPG_A('../../assets/web/art/highland-trio.webp')
}, {
  cat: 'Partnerships',
  title: 'Familiar photos in care homes',
  dek: 'Why recognisable faces and places turn a colouring session into a conversation.',
  img: OPG_A('../../assets/web/b2b/care-nanny-cover.webp')
}];
function JournalPage() {
  const [f, setF] = React.useState('All');
  const list = JOURNAL.filter(a => f === 'All' || a.cat === f);
  const [lead, ...rest] = list;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageIntro, {
    eyebrow: "Journal",
    heading: "Notes from the gallery.",
    body: "Photo tips, gift ideas and the stories behind the pages."
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "compact"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(Chips, {
    label: "Journal categories",
    items: ['All', ...Array.from(new Set(JOURNAL.map(a => a.cat)))],
    value: f,
    onChange: setF
  })), lead ? /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => e.preventDefault(),
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)',
      gap: 'var(--space-6) var(--grid-gap-xl)',
      alignItems: 'center',
      textDecoration: 'none',
      marginBottom: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: lead.img,
    alt: "",
    style: {
      ...mImg,
      aspectRatio: '16 / 10'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(MEyebrow, null, lead.cat), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.08,
      color: 'var(--color-brand)'
    }
  }, lead.title), /*#__PURE__*/React.createElement("span", {
    style: mBody
  }, lead.dek), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-accent)',
      display: 'inline-flex',
      gap: 6,
      alignItems: 'center'
    }
  }, "Read the article ", /*#__PURE__*/React.createElement(MIcon, {
    name: "arrow-right",
    size: 16
  })))) : null, /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(260px,1fr))',
      gap: 'var(--space-7) var(--grid-gap-lg)'
    }
  }, rest.map(a => /*#__PURE__*/React.createElement("li", {
    key: a.title
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => e.preventDefault(),
    style: {
      display: 'grid',
      gap: 12,
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: a.img,
    alt: "",
    style: {
      ...mImg,
      aspectRatio: '4 / 3'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: '0.6875rem',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-accent-warm)'
    }
  }, a.cat), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.2,
      color: 'var(--color-brand)'
    }
  }, a.title), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, a.dek)))))));
}

/* ——— FAQ ——— */
const FAQ_GROUPS = () => [{
  id: 'ordering',
  title: 'Ordering',
  items: [{
    q: 'What sizes and page counts can I choose?',
    a: `A4 (our standard size) or A5, with 10, 15, 20 or 25 pages. Books start from ${M_PRICING.from}; the photo album starts from ${M_ALBUM.from}.`
  }, {
    q: 'Can I order more than one copy?',
    a: 'Yes. Choose the quantity when you create your book. Extra copies are printed from the same photographs.'
  }, {
    q: 'Do you make books for schools, care homes or clubs?',
    a: 'We do. Visit Partnerships to tell us about your project and we will reply with ideas, timings and a quote.'
  }]
}, {
  id: 'photos',
  title: 'Your photos',
  items: [{
    q: 'What photos work best?',
    a: 'Your favourites. Phone snaps, slightly blurred shots, old prints and decades-old pictures all come out really well, so please do not stress about finding the best-quality version.'
  }, {
    q: 'How do I send my photos?',
    a: 'Upload them while you create your book, in the order you want them to appear. You need one photo per page (so 10 for a 10-page book) before you can check out, which means nothing is held up waiting for photos later.'
  }, {
    q: 'What happens to my photos afterwards?',
    a: 'They are used only to create your order and handled in line with our Privacy Policy.'
  }]
}, {
  id: 'preview',
  title: 'Preview & production',
  items: [{
    q: 'Can I see my book before it is printed?',
    a: 'Yes. Choose “request a preview” while personalising. We email your pages for approval and start production once you reply.'
  }, {
    q: 'How long does it take?',
    a: `${M_FUL.production}. Requesting a preview may add time while you approve.`
  }]
}, {
  id: 'delivery',
  title: 'Delivery',
  items: [{
    q: 'How long does delivery take?',
    a: `${M_FUL.shipping}. ${M_FUL.shippingNote}`
  }, {
    q: 'Where do you ship from?',
    a: `${M_FUL.shipsFrom}. We ship internationally.`
  }]
}, {
  id: 'returns',
  title: 'Returns',
  items: [{
    q: 'Can I return my book?',
    a: `${M_FUL.returns} If anything is wrong with your order, get in touch and we will put it right.`
  }]
}];
function FaqPage({
  go
}) {
  const groups = FAQ_GROUPS();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageIntro, {
    eyebrow: "FAQ",
    heading: "Questions, answered.",
    body: "Everything you might want to know before you order. Can\u2019t see yours? We\u2019re a message away."
  }, /*#__PURE__*/React.createElement("nav", {
    "aria-label": "FAQ topics",
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
      marginTop: 8
    }
  }, groups.map(g => /*#__PURE__*/React.createElement("a", {
    key: g.id,
    href: `#faq-${g.id}`,
    onClick: e => {
      e.preventDefault();
      const el = document.getElementById('faq-' + g.id);
      if (el) window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - 90,
        behavior: 'smooth'
      });
    },
    style: {
      minHeight: 40,
      display: 'inline-flex',
      alignItems: 'center',
      padding: '0 16px',
      borderRadius: 'var(--radius-round)',
      border: '1px solid var(--color-border-strong)',
      color: 'var(--color-brand)',
      textDecoration: 'none',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600
    }
  }, g.title)))), groups.map((g, i) => /*#__PURE__*/React.createElement("div", {
    key: g.id,
    id: `faq-${g.id}`
  }, /*#__PURE__*/React.createElement(MFaq, {
    tone: i % 2 ? 'paper' : 'white',
    eyebrow: g.title,
    heading: g.title === 'Ordering' ? 'Ordering your book' : g.title,
    items: g.items
  }))), /*#__PURE__*/React.createElement(Section, {
    tone: "blush",
    pad: "compact"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 20,
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      color: 'var(--color-brand)'
    }
  }, "Still wondering about something?"), /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    onClick: () => go('/contact/')
  }, "Contact Us"))));
}

/* ——— Contact ——— */
function ContactPage({
  go
}) {
  const [sent, setSent] = React.useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageIntro, {
    eyebrow: "Contact",
    heading: "Talk to a real person.",
    body: "Questions about an order, a photo you\u2019re unsure of, or a gift with a deadline? Send us a note and Leon or the team will reply."
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,4fr)',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, sent ? /*#__PURE__*/React.createElement("div", {
    role: "status",
    style: {
      padding: 'var(--space-7)',
      background: 'var(--opg-blush-100)',
      borderRadius: 'var(--radius-md)',
      display: 'grid',
      gap: 12,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 40,
      height: 40,
      borderRadius: '50%',
      background: 'var(--color-brand)',
      color: 'var(--opg-white)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(MIcon, {
    name: "check",
    size: 20
  })), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      color: 'var(--color-brand)'
    }
  }, "Thank you. Your message is with us."), /*#__PURE__*/React.createElement("p", {
    style: mBody
  }, "We\u2019ve sent a copy to your inbox. If it\u2019s about an existing order, we\u2019ll look it up before we reply.")) : /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      const f = e.currentTarget;
      const lines = Array.from(f.elements).filter(el => el.id && el.value).map(el => {
        const l = f.querySelector('label[for="' + el.id + '"]');
        return (l ? l.textContent.replace(/\s*(\*|Optional|Required)\s*$/i, '').trim() : el.id) + ': ' + el.value;
      });
      window.location.href = 'mailto:enquiries@oneprintgallery.co.uk?subject=' + encodeURIComponent('Website enquiry') + '&body=' + encodeURIComponent(lines.join('\n'));
      setSent(true);
    },
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(MField, {
    label: "Your name",
    htmlFor: "ct-name",
    required: true
  }, /*#__PURE__*/React.createElement(MInput, {
    id: "ct-name",
    required: true,
    autoComplete: "name"
  })), /*#__PURE__*/React.createElement(MField, {
    label: "Email",
    htmlFor: "ct-email",
    required: true
  }, /*#__PURE__*/React.createElement(MInput, {
    id: "ct-email",
    type: "email",
    required: true,
    autoComplete: "email"
  })), /*#__PURE__*/React.createElement(MField, {
    label: "What is it about?",
    htmlFor: "ct-topic"
  }, /*#__PURE__*/React.createElement(MSelect, {
    id: "ct-topic",
    options: ['An existing order', 'A question before ordering', 'Photos and preview', 'One-of-One art', 'Something else'],
    placeholder: "Choose one"
  })), /*#__PURE__*/React.createElement(MField, {
    label: "Order number",
    htmlFor: "ct-order",
    optional: true
  }, /*#__PURE__*/React.createElement(MInput, {
    id: "ct-order",
    placeholder: "OPG-"
  })), /*#__PURE__*/React.createElement(MField, {
    label: "Your message",
    htmlFor: "ct-msg",
    required: true,
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(MTextarea, {
    id: "ct-msg",
    rows: 6,
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    size: "lg",
    type: "submit"
  }, "Send Message"))), /*#__PURE__*/React.createElement("aside", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, [['mail', 'General & orders', 'enquiries@oneprintgallery.co.uk', 'mailto:enquiries@oneprintgallery.co.uk'], ['instagram', 'Instagram', '@1oneprintgallery', 'https://instagram.com/1oneprintgallery']].map(([ic, l, v, h]) => /*#__PURE__*/React.createElement("div", {
    key: l,
    style: {
      display: 'grid',
      gridTemplateColumns: '24px minmax(0,1fr)',
      gap: 14,
      paddingBottom: 'var(--space-5)',
      borderBottom: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-accent-warm)',
      paddingTop: 2
    }
  }, /*#__PURE__*/React.createElement(MIcon, {
    name: ic,
    size: 20
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, l), /*#__PURE__*/React.createElement("a", {
    href: h,
    style: {
      display: 'block',
      marginTop: 4,
      fontFamily: 'var(--font-sans)',
      fontWeight: 600,
      color: 'var(--color-brand)',
      overflowWrap: 'anywhere'
    }
  }, v)))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, "Planning something for a school, care home or club? ", /*#__PURE__*/React.createElement("a", {
    href: "/partnerships/",
    style: {
      color: 'var(--color-brand)',
      fontWeight: 600
    }
  }, "Discuss a project"), ".")))));
}

/* ——— Cart ——— */
function CartPage({
  go
}) {
  const [lines, setLines] = React.useState([{
    id: 1,
    title: 'Personalised Photo Colouring Book',
    img: OPG_A('../../assets/web/books/luna-front.webp'),
    options: ['The Adventures of Luna', 'A4 · 21 × 29.7 cm', '15 pages · 15 photos uploaded', 'Preview requested'],
    price: 24.99,
    qty: 1
  }]);
  const setQty = (id, d) => setLines(ls => ls.map(l => l.id === id ? {
    ...l,
    qty: Math.max(1, l.qty + d)
  } : l));
  const sub = lines.reduce((s, l) => s + l.price * l.qty, 0);
  if (!lines.length) return /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement(MEmpty, {
    icon: "shopping-bag",
    heading: "Your bag is empty.",
    body: "Your next keepsake is already in your camera roll.",
    actionLabel: "Create Your Book",
    onAction: () => go('/create/')
  }));
  return /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      ...mH1,
      fontSize: 'var(--text-3xl)',
      marginBottom: 'var(--space-7)'
    }
  }, "Your bag"), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,4fr)',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, lines.map(l => /*#__PURE__*/React.createElement("li", {
    key: l.id,
    style: {
      display: 'grid',
      gridTemplateColumns: '110px minmax(0,1fr)',
      gap: 'var(--space-5)',
      padding: 'var(--space-5)',
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: l.img,
    alt: "",
    style: {
      width: '100%',
      aspectRatio: '1122 / 1402',
      objectFit: 'cover',
      borderRadius: 3
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10,
      alignContent: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.2,
      color: 'var(--color-brand)'
    }
  }, l.title), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, "\xA3", (l.price * l.qty).toFixed(2))), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: 3
    }
  }, l.options.map(o => /*#__PURE__*/React.createElement("li", {
    key: o,
    style: {
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, o))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 4
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      border: '1px solid var(--color-border-strong)',
      borderRadius: 'var(--radius-sm)'
    }
  }, /*#__PURE__*/React.createElement(MIconButton, {
    label: "One fewer",
    onClick: () => setQty(l.id, -1)
  }, /*#__PURE__*/React.createElement(MIcon, {
    name: "minus",
    size: 15
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 32,
      textAlign: 'center',
      fontWeight: 700
    }
  }, l.qty), /*#__PURE__*/React.createElement(MIconButton, {
    label: "One more",
    onClick: () => setQty(l.id, 1)
  }, /*#__PURE__*/React.createElement(MIcon, {
    name: "plus",
    size: 15
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      gap: 16
    }
  }, /*#__PURE__*/React.createElement(MLink, {
    href: "/create/"
  }, "Edit personalisation"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setLines(ls => ls.filter(x => x.id !== l.id)),
    style: {
      padding: 0,
      border: 0,
      background: 'none',
      font: 'inherit',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)',
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  }, "Remove"))))))), /*#__PURE__*/React.createElement("aside", {
    "data-opg-sticky": "",
    style: {
      position: 'sticky',
      top: 'calc(var(--header-height) + 24px)',
      padding: 'var(--space-6)',
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Subtotal"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-text)',
      fontWeight: 600
    }
  }, "\xA3", sub.toFixed(2))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Shipping"), /*#__PURE__*/React.createElement("span", null, "Calculated at checkout")), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      paddingTop: 14,
      borderTop: '1px solid var(--color-border)',
      display: 'flex',
      justifyContent: 'space-between',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-lg)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Total"), /*#__PURE__*/React.createElement("span", null, "\xA3", sub.toFixed(2))), /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    size: "lg",
    fullWidth: true,
    onClick: () => {
      window.__opgOrder = null;
      go('/order-confirmed/');
    }
  }, "Continue to Secure Checkout"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, M_FUL.production, ". ", M_FUL.returns))));
}

/* ——— 404 ——— */
function NotFoundPage({
  go
}) {
  return /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 18,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(MEyebrow, null, "Page not found"), /*#__PURE__*/React.createElement("h1", {
    style: mH1
  }, "This page hasn\u2019t been drawn yet."), /*#__PURE__*/React.createElement("p", {
    style: mBody
  }, "The link may be old, or the page may have moved. Let\u2019s get you back to something worth colouring."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      marginTop: 6
    }
  }, /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    onClick: () => go('/')
  }, "Back to Home"), /*#__PURE__*/React.createElement(MButton, {
    variant: "secondary",
    onClick: () => go('/create/')
  }, "Create Your Book"))), /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/transform/colouring-after.webp"),
    alt: "",
    style: {
      ...mImg,
      aspectRatio: '4 / 5'
    }
  })));
}
Object.assign(window, {
  GalleryPage,
  ReviewsPage,
  JournalPage,
  FaqPage,
  ContactPage,
  CartPage,
  NotFoundPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/MorePages.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/OneOfOneArtPage.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function OneOfOneArtPage({
  go
}) {
  const [filter, setFilter] = React.useState('All work');
  const A = OPG_A('../../assets/web/art/');
  const P = window.OnePrintGalleryDesignSystem_ba4735.ART_PRINTS;
  const works = [{
    title: 'See No Evil',
    collection: 'Highland Cows',
    imageSrc: A + 'see-no-evil.webp'
  }, {
    title: 'Hear No Evil',
    collection: 'Highland Cows',
    imageSrc: A + 'hear-no-evil.webp'
  }, {
    title: 'Speak No Evil',
    collection: 'Highland Cows',
    imageSrc: A + 'speak-no-evil.webp'
  }, {
    title: 'The Boss',
    collection: 'The Obsidian Society',
    medium: 'No. I',
    imageSrc: A + 'obsidian-the-boss.webp'
  }, {
    title: 'Boardroom',
    collection: 'The Obsidian Society',
    medium: 'No. II',
    imageSrc: A + 'obsidian-boardroom.webp'
  }, {
    title: 'The Detective',
    collection: 'The Obsidian Society',
    medium: 'No. III',
    imageSrc: A + 'obsidian-the-detective.webp'
  }, {
    title: 'The Strategist',
    collection: 'The Obsidian Society',
    medium: 'No. IV',
    imageSrc: A + 'obsidian-the-strategist.webp'
  }, {
    title: 'The Assassin',
    collection: 'The Obsidian Society',
    medium: 'No. V',
    imageSrc: A + 'obsidian-the-assassin.webp'
  }].map(w => ({
    status: 'available',
    ratio: '2 / 3',
    badge: 'Art Print',
    price: P.from,
    priceFrom: true,
    ...w,
    medium: (w.medium && w.medium.startsWith('No.') ? w.medium + ' · ' : '') + P.sizeRange
  }));
  const shown = filter === 'All work' ? works : works.filter(w => w.collection === filter);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'relative',
      width: '100%',
      aspectRatio: '16 / 9',
      overflow: 'hidden',
      background: 'var(--opg-navy-900, #1c2340)'
    }
  }, /*#__PURE__*/React.createElement("video", {
    src: "hero/video/one-of-one.mp4",
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
    preload: "auto",
    tabIndex: -1,
    style: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
      pointerEvents: 'none'
    }
  })), /*#__PURE__*/React.createElement(Hero, {
    tone: "ink",
    split: "7/5",
    eyebrow: "One of One",
    heading: "Original art, printed to order.",
    body: "Two collections designed by One Print Gallery, the Highland Cows and The Obsidian Society, printed on premium 200gsm silk paper in four sizes.",
    primaryLabel: "View Available Work",
    secondaryLabel: null,
    makerLine: null,
    imageSrc: OPG_A("../../assets/web/art/speak-no-evil.webp"),
    ratio: "2 / 3"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '8fr 4fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/art/highland-trio.webp"),
    alt: "See, Hear, Speak No Evil: three Highland calves",
    style: {
      width: '100%',
      aspectRatio: '3 / 2',
      objectFit: 'cover',
      display: 'block',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(Badge, {
    tone: "edition"
  }, "Featured Collection"), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: '18px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontStyle: 'italic',
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      color: 'var(--color-brand)'
    }
  }, "See, Hear, Speak No Evil"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '12px 0 0',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, "Highland Cows \xB7 Three posters, sold individually"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '22px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.7,
      color: 'var(--color-text-muted)',
      maxWidth: '44ch'
    }
  }, "Three Highland calves, each covering eyes, ears or mouth. A gentle take on the Three Wise Monkeys, drawn in detailed pencil style with a soft sketch-fade border. Beautiful alone, better as a set."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 'var(--space-6) 0 0',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-2xl)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)',
      marginRight: 10
    }
  }, "From"), P.from), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '6px 0 0',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, "Each poster ", P.sizeRange, " \xB7 ", P.delivery), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg"
  }, "Choose a Size")), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '16px 0 0',
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, P.paper, ". ", P.note)))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "The Collections",
    heading: "Available work"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      marginBottom: 'var(--space-7)'
    }
  }, ['All work', 'Highland Cows', 'The Obsidian Society'].map(f => /*#__PURE__*/React.createElement("button", {
    key: f,
    type: "button",
    onClick: () => setFilter(f),
    style: {
      background: 'none',
      border: 'none',
      padding: 0,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Tag, {
    tone: filter === f ? 'brand' : 'neutral'
  }, f)))), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(230px,1fr))',
      gap: 'var(--space-8) var(--grid-gap-lg)'
    }
  }, shown.map(w => /*#__PURE__*/React.createElement("li", {
    key: w.title
  }, /*#__PURE__*/React.createElement(ArtworkCard, _extends({}, w, {
    href: (window.opgArtHref ? opgArtHref(w.title, w.collection) : "/one-of-one-art/")
  })))))), /*#__PURE__*/React.createElement(Manifesto, {
    tone: "navy",
    caps: false,
    heading: "Collect one, or assemble the set.",
    body: "Every piece is designed to hang alone or as part of its collection: three Highland calves, or all five members of The Obsidian Society."
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "5/7",
    eyebrow: "Print Details",
    heading: "Made to hang for years.",
    points: [{
      title: 'Four sizes',
      body: P.sizes.map(s => s.title + ': ' + s.price).join(' · ')
    }, {
      title: 'Premium paper',
      body: '200gsm semi-gloss silk, printed with UV inks for deep blacks and crisp detail.'
    }, {
      title: 'Frame not included',
      body: 'Sized to standard frames so it drops straight in.'
    }],
    imageSrc: OPG_A("../../assets/web/art/obsidian-society.webp"),
    reverse: true
  }));
}
Object.assign(window, {
  OneOfOneArtPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/OneOfOneArtPage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/OurStoryPage.jsx
try { (() => {
const {
  Eyebrow: OSEyebrow,
  Button: OSButton,
  BrushRule: OSBrushRule,
  BeforeAfterSlider: OSSlider,
  Manifesto: OSManifesto,
  FullBleedBanner: OSBanner
} = window.OnePrintGalleryDesignSystem_ba4735;
const osImg = {
  width: '100%',
  objectFit: 'cover',
  borderRadius: 'var(--radius-md)',
  border: '1px solid var(--color-border)',
  background: 'var(--opg-white)',
  display: 'block'
};
const osP = {
  margin: 0,
  fontSize: 'var(--text-lg)',
  lineHeight: 1.75,
  color: 'var(--color-text)',
  textWrap: 'pretty'
};
const OS_CHAPTERS = [{
  n: '01',
  title: 'Colouring became our calm.',
  body: ['My son has autism and ADHD. Some days the world is loud for him, and finding something that helps him settle isn’t always easy.', 'Colouring turned out to be one of those things. We’d sit together at the dining table, pencils out, and I watched him slow down, focus and find his own quiet. It became our time.'],
  img: 'transform/colouring-after.webp',
  alt: 'Line-art page of a child colouring at the dining table'
}, {
  n: '02',
  title: 'Then we ran out of books worth colouring.',
  body: ['We went through every generic colouring book you could think of: animals, vehicles, cartoon characters, patterns. They did the job for a while, but none of them were really his.', 'I kept thinking: what if the pages were him? His family, his favourite places, his birthday party last year. Something he’d recognise and actually want to pick up.'],
  img: 'transform/family-after.webp',
  alt: 'Line-art page of a whole family, cat included'
}, {
  n: '03',
  title: 'Art, meet technology.',
  body: ['I’ve always had two passions: art and technology. For years they lived in separate parts of my life. Making a book for my son was the first time they came together properly.', 'I found a way to turn our own photographs into clean, detailed line art, with recognisable faces, real places, the little details that make a memory yours. The first book I made was for him. One Print Gallery grew from there.'],
  img: 'transform/football-after.webp',
  alt: 'Line-art page of Saturday morning football'
}];
const OS_VALUES = [{
  t: 'Made from your memories',
  b: 'Every page starts with your photographs. No stock templates with a name dropped in.'
}, {
  t: 'Made by a parent',
  b: 'I know what it means to find something that genuinely works for your child. Every order gets that same care.'
}, {
  t: 'Made for everyone',
  b: 'Children, grandparents, schools and care homes: anyone who deserves something that’s truly theirs.'
}];
function OurStoryPage({
  go
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeroFilm, {
    page: "story"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container-reading)',
      display: 'grid',
      gap: 'var(--space-6)',
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(OSEyebrow, null, "Our Story"), /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-4xl)',
      lineHeight: 1.0,
      letterSpacing: 'var(--tracking-hero)',
      color: 'var(--color-brand)',
      maxWidth: '16ch',
      textWrap: 'balance'
    }
  }, "It started at the dining table, with my son and a box of pencils."), /*#__PURE__*/React.createElement("p", {
    style: {
      ...osP,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-text-muted)',
      maxWidth: '52ch'
    }
  }, "One Print Gallery isn\u2019t a factory or a template shop. It\u2019s a dad who found something that helped his son, and wanted to make it personal."), /*#__PURE__*/React.createElement(OSBrushRule, {
    width: 88
  }))), OS_CHAPTERS.map((c, i) => /*#__PURE__*/React.createElement(Section, {
    key: c.n,
    tone: i % 2 ? 'paper' : 'white',
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: i % 2 ? '5fr 6fr' : '6fr 5fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      order: i % 2 ? 2 : 1,
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-accent-warm)',
      lineHeight: 1
    }
  }, c.n), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 'var(--leading-heading)',
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)',
      maxWidth: '18ch',
      textWrap: 'balance'
    }
  }, c.title), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)',
      maxWidth: '54ch'
    }
  }, c.body.map(p => /*#__PURE__*/React.createElement("p", {
    key: p,
    style: osP
  }, p)))), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      order: i % 2 ? 1 : 2
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/') + c.img,
    alt: c.alt,
    style: {
      ...osImg,
      aspectRatio: '4 / 5'
    }
  }))))), /*#__PURE__*/React.createElement(Section, {
    tone: "blush",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: '0 auto',
      maxWidth: 'var(--container-reading)',
      textAlign: 'center',
      display: 'grid',
      justifyItems: 'center',
      gap: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontStyle: 'italic',
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.2,
      color: 'var(--color-brand)',
      maxWidth: '24ch',
      textWrap: 'balance'
    }
  }, "\u201CThe first time he saw himself on the page, he didn\u2019t want to put the pencils down.\u201D"), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)'
    }
  }, "Leon, Founder"))), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 6fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(OSSlider, {
    ratio: "4 / 5",
    beforeSrc: OPG_A("../../assets/web/transform/wedding-before-aligned.webp"),
    afterSrc: OPG_A("../../assets/web/transform/wedding-after-aligned.webp")
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "What We Make Now",
    heading: "The same care, for every family.",
    body: "What began as one book for my son now reaches families, grandparents, schools and care homes. Every order is still made the way that first one was: from real photographs, refined by hand until it feels like the memory."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '12px'
    }
  }, /*#__PURE__*/React.createElement(OSButton, {
    variant: "primary",
    size: "lg",
    onClick: () => go('/personalised-colouring-books/')
  }, "Colouring Books"), /*#__PURE__*/React.createElement(OSButton, {
    variant: "secondary",
    size: "lg",
    onClick: () => go('/photo-album/')
  }, "Photo Albums"))))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement("ul", {
    "data-opg-cols": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
      gap: 'var(--space-6) var(--grid-gap-lg)'
    }
  }, OS_VALUES.map(v => /*#__PURE__*/React.createElement("li", {
    key: v.t,
    style: {
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border-strong)'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-brand)'
    }
  }, v.t), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '10px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)',
      maxWidth: '40ch'
    }
  }, v.b)))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-8)',
      display: 'grid',
      justifyItems: 'start',
      gap: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/signature.webp"),
    alt: "Designed with love by One Print Gallery",
    style: {
      width: 'min(380px,100%)',
      height: 'auto',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontStyle: 'italic',
      fontSize: 'var(--text-xl)',
      color: 'var(--color-accent-warm)'
    }
  }, "Leon, Founder"))), /*#__PURE__*/React.createElement(OSManifesto, null), /*#__PURE__*/React.createElement(OSBanner, {
    align: "center",
    heading: "Your next keepsake is already in your camera roll.",
    ctaLabel: "Create Your Book",
    secondaryLabel: "See How It Works"
  }));
}
Object.assign(window, {
  OurStoryPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/OurStoryPage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/PartnershipsPage.jsx
try { (() => {
const {
  Eyebrow: PEyebrow,
  Button: PButton,
  BeforeAfterSlider: PSlider,
  FormField: PField,
  Input: PInput,
  Select: PSelect,
  Textarea: PTextarea,
  Icon: PIcon,
  CASE_STUDIES: P_CASES
} = window.OnePrintGalleryDesignSystem_ba4735;
const pImg = {
  width: '100%',
  objectFit: 'cover',
  borderRadius: 'var(--radius-md)',
  border: '1px solid var(--color-border)',
  background: 'var(--opg-white)',
  display: 'block'
};
const pCap = {
  marginTop: 10,
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-xs)',
  fontWeight: 700,
  letterSpacing: 'var(--tracking-eyebrow)',
  textTransform: 'uppercase',
  color: 'var(--color-text-muted)'
};
const pH3 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-2xl)',
  lineHeight: 1.1,
  color: 'var(--color-brand)'
};
const pBody = {
  margin: 0,
  fontSize: 'var(--text-base)',
  lineHeight: 1.7,
  color: 'var(--color-text-muted)',
  maxWidth: '52ch'
};
const P_SCHOOL = [{
  t: 'Class photo',
  b: 'b2b/school-class-before.webp',
  a: 'b2b/school-class-after.webp'
}, {
  t: 'Science lesson',
  b: 'b2b/school-science-before.webp',
  a: 'b2b/school-science-after.webp'
}, {
  t: 'School garden',
  b: 'b2b/school-garden-before.webp',
  a: 'b2b/school-garden-after.webp'
}];
const P_STEPS = [{
  t: 'A conversation',
  b: 'Tell us about your setting, who the books are for and roughly how many you need.'
}, {
  t: 'Your photos',
  b: 'Send the photographs you want included, with any permissions already in place. Any photo works.'
}, {
  t: 'A proof to approve',
  b: 'We transform every page and send a digital proof. Nothing is printed until you’re happy.'
}, {
  t: 'Printed and delivered',
  b: 'Books are printed to order and delivered to your door, ready to hand out.'
}];
const P_TYPES = ['School', 'SEN setting', 'Care home', 'Football club', 'Charity or organisation', 'Something else'];
const P_QTY = ['Under 25', '25–50', '50–150', '150+', 'Not sure yet'];
function PartnershipsPage({
  go
}) {
  const [sent, setSent] = React.useState(false);
  const [ex, setEx] = React.useState(0);
  const toForm = () => {
    const el = document.getElementById('enquire');
    if (el) window.scrollTo({
      top: el.getBoundingClientRect().top + window.scrollY - 20,
      behavior: 'smooth'
    });
  };
  const cs = (P_CASES || []).find(c => c.audience === 'schools');
  const pair = P_SCHOOL[ex];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeroFilm, {
    page: "partner"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 6fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: 'var(--space-6)',
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, "Partnerships"), /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-4xl)',
      lineHeight: 1.0,
      letterSpacing: 'var(--tracking-hero)',
      color: 'var(--color-brand)',
      maxWidth: '15ch',
      textWrap: 'balance'
    }
  }, "Colouring books built around your people."), /*#__PURE__*/React.createElement("p", {
    style: {
      ...pBody,
      fontSize: 'var(--text-lg)'
    }
  }, "We make bespoke colouring books for schools, SEN settings, care homes, clubs and organisations, with every page drawn from your own photographs, so the people colouring them recognise what they see."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(PButton, {
    variant: "primary",
    size: "lg",
    onClick: toForm
  }, "Discuss a Project"), /*#__PURE__*/React.createElement(PButton, {
    variant: "secondary",
    size: "lg",
    onClick: () => go('/our-story/')
  }, "Our Story"))), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(PSlider, {
    ratio: "3 / 2",
    beforeSrc: OPG_A("../../assets/web/b2b/school-class-before.webp"),
    afterSrc: OPG_A("../../assets/web/b2b/school-class-after.webp")
  })))), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, "Who We Work With"), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.08,
      color: 'var(--color-brand)'
    }
  }, "Find out how it works for you.")), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, [['Schools & SEN', 'Welcome and transition books, leavers’ keepsakes and calm, familiar resources for your pupils.', '/partnerships/schools-sen/', OPG_A('../../assets/web/b2b/school-garden-after.webp')], ['Care Homes', 'Personal books made from residents’ own photographs and life stories, for activities, visits and keepsakes.', '/partnerships/care-homes/', OPG_A('../../assets/web/b2b/care-nanny-after.webp')], ['Football Clubs', 'An official club colouring book for the club shop and matchday, with a low-risk trial to start.', '/partnerships/football-clubs/', OPG_A('../../assets/web/clubs/celebrate-before.webp')]].map(([t, b, h, img]) => /*#__PURE__*/React.createElement("li", {
    key: h
  }, /*#__PURE__*/React.createElement("a", {
    href: h,
    style: {
      display: 'grid',
      gap: 14,
      textDecoration: 'none',
      color: 'inherit'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: img,
    alt: "",
    style: {
      ...pImg,
      aspectRatio: '4 / 3'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-brand)'
    }
  }, t), /*#__PURE__*/React.createElement("span", {
    style: {
      ...pBody,
      fontSize: 'var(--text-sm)'
    }
  }, b), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-accent)',
      textDecoration: 'underline'
    }
  }, "Learn more"))))))), cs ? /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-navy-700)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gridTemplateColumns: '7fr 5fr',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, {
    onDark: true
  }, cs.client, " \xB7 ", cs.descriptor), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: '18px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 'var(--leading-heading)',
      color: 'var(--opg-white)',
      maxWidth: '18ch'
    }
  }, cs.headline), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '20px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.7,
      color: 'var(--color-text-on-dark-muted)',
      maxWidth: '52ch'
    }
  }, cs.body)), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'flex',
      gap: 'var(--space-8)'
    }
  }, cs.metrics.map(m => /*#__PURE__*/React.createElement("div", {
    key: m.label
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-4xl)',
      lineHeight: 1,
      color: 'var(--opg-peach-300)'
    }
  }, m.value), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-text-on-dark-muted)'
    }
  }, m.label)))), cs.quote ? /*#__PURE__*/React.createElement("figure", {
    style: {
      gridColumn: '1 / -1',
      margin: 'var(--space-6) 0 0',
      paddingTop: 'var(--space-7)',
      borderTop: '1px solid rgba(255,255,255,.18)',
      display: 'grid',
      gap: 18,
      maxWidth: '68ch'
    }
  }, /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontStyle: 'italic',
      fontSize: 'var(--text-xl)',
      lineHeight: 1.45,
      color: 'var(--opg-white)',
      textWrap: 'pretty'
    }
  }, "\u201C", cs.quote, "\u201D"), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-on-dark-muted)'
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--opg-peach-300)',
      fontWeight: 700
    }
  }, cs.quoteBy), " \xB7 ", cs.quoteRole)) : null)) : null, /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 7fr',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, "Schools & SEN"), /*#__PURE__*/React.createElement("h2", {
    style: {
      ...pH3,
      fontSize: 'var(--text-3xl)',
      maxWidth: '16ch'
    }
  }, "A school can become the content."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "Class photos, school trips, the garden, the science lab. Pupils colour pages of their own classmates, teachers and spaces: the places they know every day."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "Order a single book for the whole class, or a personalised copy for every pupil."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
      marginTop: 'var(--space-2)'
    }
  }, P_SCHOOL.map((p, i) => /*#__PURE__*/React.createElement("button", {
    key: p.t,
    type: "button",
    onClick: () => setEx(i),
    style: {
      padding: '9px 16px',
      borderRadius: 'var(--radius-round)',
      border: '1px solid ' + (i === ex ? 'var(--color-brand)' : 'var(--color-border)'),
      background: i === ex ? 'var(--color-brand)' : 'var(--opg-white)',
      color: i === ex ? 'var(--opg-white)' : 'var(--color-brand)',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      cursor: 'pointer'
    }
  }, p.t)))), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/') + pair.b,
    alt: pair.t + ', original photo',
    style: {
      ...pImg,
      aspectRatio: '3 / 2'
    }
  }), /*#__PURE__*/React.createElement("figcaption", {
    style: pCap
  }, "Original photo")), /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/') + pair.a,
    alt: pair.t + ', as a colouring page',
    style: {
      ...pImg,
      aspectRatio: '3 / 2'
    }
  }), /*#__PURE__*/React.createElement("figcaption", {
    style: pCap
  }, "Colouring page"))))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '7fr 5fr',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gap: 12
    }
  }, [['Original photo', 'b2b/care-nanny-before.webp'], ['Colouring page', 'b2b/care-nanny-after.webp'], ['Finished book', 'b2b/care-nanny-cover.webp']].map(([l, s]) => /*#__PURE__*/React.createElement("figure", {
    key: l,
    style: {
      margin: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/') + s,
    alt: l,
    style: {
      ...pImg,
      aspectRatio: '5 / 7'
    }
  }), /*#__PURE__*/React.createElement("figcaption", {
    style: pCap
  }, l)))), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, "Care Homes"), /*#__PURE__*/React.createElement("h2", {
    style: {
      ...pH3,
      fontSize: 'var(--text-3xl)',
      maxWidth: '16ch'
    }
  }, "Personal stories, made into something to share."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "A book of a resident\u2019s own life (their wedding day, their children, the places they loved) to colour with family, carers or friends. Old, faded and creased photos all work beautifully."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "A thoughtful gift from families, or an activity for residents built around the memories that matter to them.")))), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("ul", {
    "data-opg-cols": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))',
      gap: 'var(--space-7) var(--grid-gap-lg)'
    }
  }, [{
    e: 'Football Clubs',
    h: 'Club identity, made interactive.',
    b: 'Matchday memories, the ground, the squad and supporter culture. Fan products that supporters actually pick up. Club marks and player imagery must be licensed.',
    img: 'transform/football-after.webp'
  }, {
    e: 'Organisations',
    h: 'Your people, place or story.',
    b: 'Charities, community groups and businesses: custom colouring books for events, anniversaries, fundraising and team gifts.',
    img: 'transform/getting-ready-after.webp'
  }].map(c => /*#__PURE__*/React.createElement("li", {
    key: c.e,
    style: {
      display: 'grid',
      gridTemplateColumns: '2fr 3fr',
      gap: 'var(--space-5)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/') + c.img,
    alt: "",
    style: {
      ...pImg,
      aspectRatio: '4 / 5'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, c.e), /*#__PURE__*/React.createElement("h3", {
    style: pH3
  }, c.h), /*#__PURE__*/React.createElement("p", {
    style: {
      ...pBody,
      fontSize: 'var(--text-sm)'
    }
  }, c.b)))))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "How Partnerships Work",
    heading: "Four steps. We handle the difficult one."
  }), /*#__PURE__*/React.createElement("ol", {
    "data-opg-cols": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(210px,1fr))',
      gap: 'var(--space-6) var(--grid-gap-lg)'
    }
  }, P_STEPS.map((s, i) => /*#__PURE__*/React.createElement("li", {
    key: s.t,
    style: {
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border-strong)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-accent-warm)',
      lineHeight: 1
    }
  }, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: '14px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-brand)'
    }
  }, s.t), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '8px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)',
      maxWidth: '34ch'
    }
  }, s.b))))), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    id: "enquire",
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 7fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, "Discuss a Project"), /*#__PURE__*/React.createElement("h2", {
    style: {
      ...pH3,
      fontSize: 'var(--text-3xl)',
      maxWidth: '14ch'
    }
  }, "Tell us what you have in mind."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "No commitment. We\u2019ll reply within two working days with ideas, timings and a quote.")), sent ? /*#__PURE__*/React.createElement("div", {
    role: "status",
    style: {
      minWidth: 0,
      padding: 'var(--space-7)',
      background: 'var(--opg-blush-100)',
      borderRadius: 'var(--radius-md)',
      display: 'grid',
      gap: 12,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 40,
      height: 40,
      borderRadius: '50%',
      background: 'var(--color-brand)',
      color: 'var(--opg-white)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(PIcon, {
    name: "check",
    size: 20,
    strokeWidth: 2.25
  })), /*#__PURE__*/React.createElement("h3", {
    style: pH3
  }, "Thank you. We\u2019ve got it."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "We\u2019ll be in touch within two working days.")) : /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      const f = e.currentTarget;
      const lines = Array.from(f.elements).filter(el => el.id && el.value).map(el => {
        const l = f.querySelector('label[for="' + el.id + '"]');
        return (l ? l.textContent.replace(/\s*(\*|Optional|Required)\s*$/i, '').trim() : el.id) + ': ' + el.value;
      });
      window.location.href = 'mailto:enquiries@oneprintgallery.co.uk?subject=' + encodeURIComponent('Partnership enquiry') + '&body=' + encodeURIComponent(lines.join('\n'));
      setSent(true);
    },
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(PField, {
    label: "Your name",
    htmlFor: "p-name",
    required: true
  }, /*#__PURE__*/React.createElement(PInput, {
    id: "p-name",
    required: true,
    autoComplete: "name"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Email",
    htmlFor: "p-email",
    required: true
  }, /*#__PURE__*/React.createElement(PInput, {
    id: "p-email",
    type: "email",
    required: true,
    autoComplete: "email"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Organisation",
    htmlFor: "p-org",
    required: true
  }, /*#__PURE__*/React.createElement(PInput, {
    id: "p-org",
    required: true,
    autoComplete: "organization"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Type of organisation",
    htmlFor: "p-type"
  }, /*#__PURE__*/React.createElement(PSelect, {
    id: "p-type",
    options: P_TYPES,
    placeholder: "Choose one"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Roughly how many books?",
    htmlFor: "p-qty",
    optional: true
  }, /*#__PURE__*/React.createElement(PSelect, {
    id: "p-qty",
    options: P_QTY,
    placeholder: "Choose one"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Ideal delivery date",
    htmlFor: "p-date",
    optional: true
  }, /*#__PURE__*/React.createElement(PInput, {
    id: "p-date",
    type: "date"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Tell us about your project",
    htmlFor: "p-msg",
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(PTextarea, {
    id: "p-msg",
    rows: 5
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(PButton, {
    variant: "primary",
    size: "lg",
    type: "submit"
  }, "Send Enquiry"))))));
}
Object.assign(window, {
  PartnershipsPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/PartnershipsPage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/PhotoAlbumPage.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PhotoAlbumPage({
  go
}) {
  const DS = window.OnePrintGalleryDesignSystem_ba4735;
  const A = DS.PHOTO_ALBUM;
  const {
    StickyProductCTA
  } = DS;
  const [pages, setPages] = React.useState(A.pages[0].count);
  const [binding, setBinding] = React.useState(A.bindings[0].id);
  const [size, setSize] = React.useState(A.sizes[0].id);
  const [main, setMain] = React.useState(0);
  const price = A.priceFor({
    pages,
    binding,
    size
  });
  const media = [{
    src: OPG_A('../../assets/web/mockups/luna-before-after.webp'),
    note: 'Photo beside its colouring page'
  }, {
    src: OPG_A('../../assets/web/mockups/luna-flatlay.webp'),
    note: 'Open spread'
  }, {
    src: OPG_A('../../assets/web/transform/family-before.webp'),
    note: 'Your photograph'
  }, {
    src: OPG_A('../../assets/web/transform/family-after.webp'),
    note: 'Its colouring page'
  }];
  const label = {
    fontFamily: 'var(--font-sans)',
    fontSize: 'var(--text-xs)',
    fontWeight: 700,
    letterSpacing: 'var(--tracking-eyebrow)',
    textTransform: 'uppercase',
    color: 'var(--color-text-muted)',
    margin: '0 0 10px'
  };
  const Choice = ({
    on,
    onClick,
    title,
    meta
  }) => /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClick,
    "aria-pressed": on,
    style: {
      display: 'grid',
      gap: 3,
      textAlign: 'left',
      padding: '12px 14px',
      minHeight: 44,
      cursor: 'pointer',
      background: on ? 'var(--opg-paper)' : 'var(--opg-white)',
      border: `1px solid ${on ? 'var(--color-brand)' : 'var(--color-border)'}`,
      borderRadius: 'var(--radius-md)',
      fontFamily: 'var(--font-sans)',
      color: 'var(--color-text)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-sm)',
      fontWeight: 600
    }
  }, title), meta ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)',
      lineHeight: 1.45
    }
  }, meta) : null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeroFilm, {
    page: "album"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "standard"
  }, /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Breadcrumb",
    style: {
      marginBottom: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => {
      e.preventDefault();
      go('/');
    },
    style: {
      color: 'inherit'
    }
  }, "Home"), " \xB7 Personalised Colouring Photo Album")), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '60fr 40fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: '14px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: media[main].src,
    alt: media[main].note,
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("ul", {
    "data-opg-thumbs": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(72px,1fr))',
      gap: '12px'
    }
  }, media.map((m, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setMain(i),
    "aria-label": m.note,
    "aria-current": i === main,
    style: {
      display: 'block',
      width: '100%',
      padding: 0,
      background: 'none',
      border: `1px solid ${i === main ? 'var(--color-brand)' : 'transparent'}`,
      borderRadius: 'var(--radius-md)',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: m.src,
    alt: "",
    style: {
      display: 'block',
      width: '100%',
      aspectRatio: '1 / 1',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)'
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    "data-opg-sticky": "",
    style: {
      minWidth: 0,
      position: 'sticky',
      top: 'calc(var(--header-height) + 24px)',
      display: 'grid',
      gap: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, null, "New \xB7 Photo Album"), /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: '16px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)'
    }
  }, A.title), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '14px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)',
      maxWidth: '44ch'
    }
  }, A.promise)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: label
  }, "Photo spreads"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4,1fr)',
      gap: 8
    }
  }, A.pages.map(p => /*#__PURE__*/React.createElement(Choice, {
    key: p.count,
    on: pages === p.count,
    onClick: () => setPages(p.count),
    title: String(p.count)
  }))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '8px 0 0',
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, pages, " photo pages + ", pages, " matching colouring pages")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: label
  }, "Binding"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 8
    }
  }, A.bindings.map(b => /*#__PURE__*/React.createElement(Choice, {
    key: b.id,
    on: binding === b.id,
    onClick: () => setBinding(b.id),
    title: b.title,
    meta: b.description
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: label
  }, "Size"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 8
    }
  }, A.sizes.map(s => /*#__PURE__*/React.createElement(Choice, {
    key: s.id,
    on: size === s.id,
    onClick: () => setSize(s.id),
    title: s.title
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-2xl)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, "\xA3", price), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '6px 0 0',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, A.delivery), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    onClick: () => go('/create-album/'),
    style: {
      width: '100%'
    }
  }, "Personalise Your Album")), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '12px 0 0',
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, "You will add a cover title and the names or caption for each photo next. ", DS.FULFILMENT.uploadLimit))))), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "paper",
    split: "7/5",
    eyebrow: "What Makes It Different",
    heading: "The photograph stays. The colouring page joins it.",
    points: [{
      title: 'Left page',
      body: 'Your original full-colour photograph, album-style, with names or a caption underneath.'
    }, {
      title: 'Right page',
      body: 'The same moment redrawn as detailed line art, ready to colour.'
    }, {
      title: 'Kept together',
      body: 'When the colouring is finished, the real memory is still right beside it.'
    }],
    imageSrc: OPG_A("../../assets/web/mockups/luna-before-after.webp")
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "How To Order",
    heading: "Five steps from camera roll to album."
  }), /*#__PURE__*/React.createElement("ol", {
    "data-opg-cols": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))',
      gap: 'var(--space-6) var(--grid-gap-lg)'
    }
  }, A.steps.map((s, i) => /*#__PURE__*/React.createElement("li", {
    key: s.title,
    style: {
      paddingTop: 'var(--space-4)',
      borderTop: '1px solid var(--color-border-strong)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-lg)',
      color: 'var(--color-accent-warm)',
      lineHeight: 1
    }
  }, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      marginTop: 10,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-brand)'
    }
  }, s.title), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      marginTop: 6,
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, s.body))))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 7fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Your Whole Story",
    heading: "It doesn't need one theme.",
    body: "Mix the everyday with the milestones. Every spread is a different memory, and all of them are yours."
  }), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px'
    }
  }, (A.memories || []).map(m => /*#__PURE__*/React.createElement("li", {
    key: m
  }, /*#__PURE__*/React.createElement(Tag, {
    tone: "neutral"
  }, m)))))), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/mockups/luna-flatlay.webp"),
    alt: "An open colouring album with pencils",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, null, "Personalisation"), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: '18px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)',
      maxWidth: '18ch'
    }
  }, "A title on the cover. A caption under every photo."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '20px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)',
      maxWidth: '46ch'
    }
  }, "Tell us the cover title, your preferred cover colour and any special interests. Then add the names or a short caption for each photo, for example:"), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: '18px 0 0',
      padding: 0,
      display: 'grid',
      gap: 0
    }
  }, (A.captions || []).map(c => /*#__PURE__*/React.createElement("li", {
    key: c,
    style: {
      padding: '11px 0',
      borderBottom: '1px solid var(--color-border)',
      fontFamily: 'var(--font-display)',
      fontStyle: 'italic',
      fontSize: 'var(--text-lg)',
      color: 'var(--color-brand)'
    }
  }, c))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '16px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, "Please double-check the spelling of every name, date and caption. We print exactly what you send.")))), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "blush",
    split: "5/7",
    reverse: true,
    eyebrow: "Photo Guidance",
    heading: "Any photo works. Send your favourites.",
    body: "Phone snaps, slightly blurred shots, old prints, even decades-old pictures all come out really well. The original photo sits beside its colouring page, so the memory matters more than the quality of the file. Send them in the order you want them to appear.",
    imageSrc: OPG_A("../../assets/web/transform/family-before.webp")
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "compact"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "A Gift That Becomes Part Of The Memory",
    heading: "For every kind of occasion."
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      maxWidth: '70ch',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      lineHeight: 1.9,
      color: 'var(--color-text-muted)'
    }
  }, (A.occasions || []).join(' · '))), /*#__PURE__*/React.createElement(Manifesto, {
    tone: "navy",
    caps: false,
    heading: "A creative activity today. A keepsake for years to come.",
    body: "Children colour the pages; parents and grandparents keep the finished album. Part photo album, part colouring book, part family keepsake."
  }), /*#__PURE__*/React.createElement(FaqAccordion, _extends({
    heading: "Questions before you order"
  }, A.faqs ? {
    items: A.faqs
  } : {})), /*#__PURE__*/React.createElement(StickyProductCTA, {
    title: A.title,
    price: 'From ' + A.from,
    ctaLabel: "Personalise Your Album",
    onCta: () => window.scrollTo(0, 0)
  }));
}
Object.assign(window, {
  PhotoAlbumPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/PhotoAlbumPage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/ProductPage.jsx
try { (() => {
function ProductPage({
  go
}) {
  const [main, setMain] = React.useState(0);
  const media = [{
    src: OPG_A('../../assets/web/mockups/luna-held.webp'),
    note: 'In hand',
    fit: 'cover'
  }, {
    src: OPG_A('../../assets/web/mockups/luna-flatlay.webp'),
    note: 'Open spread',
    fit: 'cover'
  }, {
    src: OPG_A('../../assets/web/mockups/luna-before-after.webp'),
    note: 'Photo beside its page',
    fit: 'cover'
  }, {
    src: OPG_A('../../assets/web/books/luna-front.webp'),
    note: 'Front cover',
    fit: 'contain'
  }, {
    src: OPG_A('../../assets/web/books/luna-back.webp'),
    note: 'Back cover',
    fit: 'contain'
  }, {
    src: OPG_A('../../assets/web/transform/colouring-after.webp'),
    note: 'Interior page',
    fit: 'cover'
  }, {
    src: OPG_A('../../assets/web/transform/colouring-before.webp'),
    note: 'Source photograph',
    fit: 'cover'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeroFilm, {
    page: "colouring"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "standard"
  }, /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Breadcrumb",
    style: {
      marginBottom: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => {
      e.preventDefault();
      go('/');
    },
    style: {
      color: 'inherit'
    }
  }, "Home"), " \xB7 Personalised Colouring Books")), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '60fr 40fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: '14px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: media[main].src,
    alt: media[main].note,
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: media[main].fit,
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("ul", {
    "data-opg-thumbs": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(72px,1fr))',
      gap: '12px'
    }
  }, media.map((m, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setMain(i),
    "aria-label": m.note,
    "aria-current": i === main,
    style: {
      display: 'block',
      width: '100%',
      padding: 0,
      background: 'none',
      border: `1px solid ${i === main ? 'var(--color-brand)' : 'transparent'}`,
      borderRadius: 'var(--radius-md)',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: m.src,
    alt: m.note,
    style: {
      display: 'block',
      width: '100%',
      aspectRatio: '1 / 1',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)'
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, null, "See the Difference"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 16
    }
  }, /*#__PURE__*/React.createElement(BeforeAfterSlider, {
    ratio: "4 / 5"
  })))), /*#__PURE__*/React.createElement("div", {
    "data-opg-sticky": "",
    style: {
      minWidth: 0,
      position: 'sticky',
      top: 'calc(var(--header-height) + 24px)'
    }
  }, /*#__PURE__*/React.createElement(PriceOptionsPanel, {
    onCta: () => go('/create/')
  })))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "How It Works",
    heading: "Your photographs become the pages."
  }), /*#__PURE__*/React.createElement(TransformationTriptych, null)), /*#__PURE__*/React.createElement(UsVsThem, {
    tone: "white",
    onCta: () => go('/create/')
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "7/5",
    eyebrow: "Photo Guidance",
    heading: "Any photo works. Send your favourites.",
    body: "Phone snaps, slightly blurred shots, old prints, even decades-old pictures. They all come out really well as colouring pages, because blur, grain and faded colour disappear in line-art. No need to hunt for the perfect, highest-quality file. Choose the moments that matter and we will take care of the rest.",
    linkLabel: "Read the full photo guide",
    linkHref: "/how-it-works/",
    imageSrc: OPG_A("../../assets/web/mockups/luna-before-after.webp"),
    reverse: true
  }), /*#__PURE__*/React.createElement(TestimonialFeature, {
    tone: "blush",
    showMedia: false
  }), /*#__PURE__*/React.createElement(FaqAccordion, {
    heading: "Questions before you order"
  }), /*#__PURE__*/React.createElement(StickyProductCTA, {
    onCta: () => go('/create/')
  }));
}
function HowItWorksPage({
  go
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FullBleedBanner, {
    eyebrow: "How It Works",
    heading: "From your camera roll to their colouring book.",
    body: "Every book begins with photographs you already love. Here is exactly what happens between your upload and the finished keepsake.",
    height: "clamp(380px,48vh,560px)"
  }), /*#__PURE__*/React.createElement(HowItWorksTimeline, {
    tone: "white",
    eyebrow: "The Process",
    heading: "Five steps, and we handle the difficult one."
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Photo Guidance",
    heading: "Any photo works. Send your favourites.",
    body: "You do not need professional or perfect photographs. Line-art is forgiving, so choose the moments that mean something rather than the sharpest file."
  }), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 'var(--grid-gap-xl)'
    }
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: '12px'
    }
  }, ['Phone photos, straight from your camera roll', 'Slightly blurred or out-of-focus shots', 'Old prints (just snap them with your phone)', 'Faded, grainy or decades-old pictures', 'Busy backgrounds and everyday moments'].map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      display: 'flex',
      gap: 11,
      paddingBottom: 12,
      borderBottom: '1px solid var(--color-border)',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      color: 'var(--color-text)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-success)',
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    size: 17
  })), t))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/mockups/luna-before-after.webp"),
    alt: "An everyday phone photo printed beside its finished colouring page",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '16px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)'
    }
  }, "Not sure about one? Send it anyway. If a photo ever needs a second look, we will get in touch before anything is printed.")))), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "5/7",
    eyebrow: "The Standard",
    heading: "Not a cartoon filter. A keepsake.",
    body: "The category can be served by automated conversions that produce generic or heavily cartooned results. Our difference is the standard of visual refinement and the human quality check around every transformation.",
    media: /*#__PURE__*/React.createElement(BeforeAfterSlider, {
      ratio: "4 / 5"
    })
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "paper",
    split: "7/5",
    reverse: true,
    eyebrow: "Preview",
    heading: "Request a preview before print",
    body: "If you would like to see your book before it is printed, choose the preview option during personalisation. Requesting a preview may affect production timing, as books are normally made to order in 2\u20134 business days.",
    ctaLabel: "Create Your Book",
    ctaHref: "#",
    imageSrc: OPG_A("../../assets/web/transform/football-after.webp")
  }), /*#__PURE__*/React.createElement(FaqAccordion, {
    tone: "white"
  }), /*#__PURE__*/React.createElement(FullBleedBanner, {
    align: "center",
    heading: "Your next keepsake is already in your camera roll.",
    ctaLabel: "Create Your Book"
  }));
}
const {
  PriceOptionsPanel,
  StickyProductCTA,
  Icon
} = window.OnePrintGalleryDesignSystem_ba4735;
Object.assign(window, {
  ProductPage,
  HowItWorksPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/ProductPage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/SectorPages.jsx
try { (() => {
const SDS = window.OnePrintGalleryDesignSystem_ba4735;
const {
  Eyebrow: SEyebrow,
  Button: SButton,
  BeforeAfterSlider: SSlider,
  FormField: SField,
  Input: SInput,
  Select: SSelect,
  Textarea: STextarea
} = SDS;
const S_STATS = SDS.SHOP_STATS || {};
const S_EMAIL = 'enquiries@oneprintgallery.co.uk',
  S_PHONE = '07732 226747';
const sH1 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-4xl)',
  lineHeight: 1.02,
  letterSpacing: 'var(--tracking-display)',
  color: 'var(--color-brand)',
  textWrap: 'balance'
};
const sH2 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-3xl)',
  lineHeight: 1.08,
  color: 'var(--color-brand)',
  textWrap: 'balance'
};
const sH3 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-xl)',
  lineHeight: 1.2,
  color: 'var(--color-brand)'
};
const sP = {
  margin: 0,
  fontSize: 'var(--text-base)',
  lineHeight: 1.7,
  color: 'var(--color-text-muted)',
  maxWidth: '62ch',
  textWrap: 'pretty'
};
const sWrap = {
  maxWidth: 'var(--container)',
  margin: '0 auto',
  paddingInline: 'var(--gutter)'
};
const sEy = {
  margin: 0,
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-xs)',
  fontWeight: 700,
  letterSpacing: 'var(--tracking-eyebrow)',
  textTransform: 'uppercase',
  color: 'var(--color-accent-warm)'
};
const A = OPG_A('../../assets/web/');
const SECTORS = {
  'schools-sen': {
    eyebrow: 'Partnerships · Schools & SEN',
    heading: 'Familiar faces. Familiar places.',
    body: 'Personalised colouring books and pages made from your school’s own photographs. A calm, creative resource for transition, wellbeing and celebration.',
    pair: {
      before: 'b2b/school-class-before.webp',
      after: 'b2b/school-class-after.webp'
    },
    inUse: {
      src: 'b2b/school-desk.webp',
      ratio: '4 / 5',
      eyebrow: 'In the classroom',
      heading: 'A calm activity with a story they recognise.',
      body: 'Pupils colour their own school, classmates and moments. A quiet, focused activity that also becomes a keepsake to take home.'
    },
    why: [['Personal and recognisable', 'Built around your people, spaces and moments rather than generic stock scenes.'], ['Calm creative time', 'A screen-free, self-paced activity that fits naturally into quiet or independent time.'], ['School–home connection', 'A keepsake gives families a natural prompt to talk about school memories and milestones.'], ['Flexible format', 'Complete books or individual pages, depending on what your school needs.']],
    optionsHeading: 'A pupil-featured edition or a school-only edition.',
    options: [['Pupil-featured', 'Class photos, classroom activities, trips, leavers and celebrations. We supply parent consent forms for the school to issue before any photographs are shared.'], ['School-only', 'Your building, classrooms, playgrounds and any staff happy to feature: a recognisable resource without including pupils.']],
    feature: {
      eyebrow: 'SEND & transition',
      heading: 'Familiar visuals can make change feel more understandable.',
      body: ['For some pupils, especially autistic children and young people, a new classroom, teacher or school brings uncertainty. A personalised colouring book complements your existing transition resources by turning those same familiar spaces into a calm activity a child can revisit at their own pace.', 'We worked with The Willows School Academy Trust, a specialist SEND school, on a bespoke colouring book built around their own school: 50 copies, followed by a reorder of 150.'],
      list: ['Starting school: the classroom, cloakroom, hall and the adults a child will meet', 'Moving class or key stage: made familiar before the change happens', 'Moving school: key spaces at the new school, revisited over the summer']
    },
    quote: {
      text: 'It has been a massive hit with staff, parents, and students alike. Seeing our school’s unique landmarks and ethos turned into beautiful illustrations was wonderful.',
      by: 'Malcolm Shaw · Headteacher, The Willows'
    },
    adapt: ['A4 or A5 page size', 'Larger colourable areas', 'Fine or bolder outlines', 'Names and captions optional', 'Simplified backgrounds', 'Single-sided pages'],
    uses: ['Welcome and transition books', 'Leavers’ keepsakes', 'Class or year-group books', 'Quiet-time activities', 'Fairs and fundraising', 'Personalised worksheets built around a pupil’s interests'],
    photos: 'Everyday phone photos are exactly what we work from. Slightly blurred shots, awkward angles and busy backgrounds are fine. Around 20–30 images is plenty for a 20-page book. Not sure about a photo? Send it and we’ll tell you honestly.',
    orgLabel: 'School or trust',
    msgHint: 'e.g. A welcome book for our new Reception class, featuring the classroom and staff.',
    trust: ['Parent consent forms supplied for pupil-featured editions', 'The school decides exactly which photographs are shared', 'A digital proof before anything is printed', 'Original artwork only, no trademarked characters or logos']
  },
  'care-homes': {
    eyebrow: 'Partnerships · Care Homes',
    heading: 'Meaningful activities, made personal.',
    body: 'Colouring books made from a resident’s own photographs, family moments, favourite places and life story. A creative activity and a keepsake that belongs to them.',
    pair: {
      before: 'b2b/care-nanny-before-aligned.webp',
      after: 'b2b/care-nanny-after-aligned.webp'
    },
    inUse: {
      src: 'b2b/care-table.webp',
      ratio: '4 / 5',
      eyebrow: 'In the activity room',
      heading: 'Something to share around the table.',
      body: 'Familiar faces and places give residents, staff and visiting family something to talk about while they colour together.'
    },
    why: [['Connection', 'Familiar images can encourage conversation and shared memories with staff, relatives and other residents.'], ['Choice', 'Each book can reflect the resident’s interests, culture, career, family, pets, music and important places.'], ['Keepsake', 'Enjoyed in activity sessions, revisited over time, and kept by the resident or their family.'], ['Shared time', 'Something to do together on a family visit, rather than sitting opposite one another.']],
    optionsHeading: 'Designed around the person, not the template.',
    options: [['Single resident book', '10–25 personalised pages with premium covers. Ideal for birthdays, welcome gifts and family keepsakes.'], ['Small pilot', 'A first project for 3–5 residents, so your activity team can try the idea before expanding.'], ['Shared home edition', 'Your garden, lounge, staff, activities and celebrations: one home-specific book, printed in a batch.'], ['Seasonal or community edition', 'Christmas, anniversaries, local history or fundraising, with families or local sponsors.']],
    feature: {
      eyebrow: 'Older photographs work just as well',
      heading: 'Faded, creased or slightly blurred is fine.',
      body: ['The photographs that mean most to a resident are often decades old: a print from an album, a frame on a windowsill, or a phone snap of one. Because every page is redrawn by hand rather than run through a filter, soft or damaged detail is interpreted and firmed up instead of lost.', 'These books are a creative engagement tool that complements your home’s own activity and wellbeing programme. They are not a medical treatment or therapy.'],
      list: ['Prints, albums, slides and newspaper cuttings', 'Phone photos of framed pictures', 'No professional scanning needed']
    },
    adapt: ['A4 or A5', 'Lay-flat coil binding', 'Large text', 'Bold or fine outlines', 'Simplified backgrounds', 'Larger colour areas', 'One-sided pages', 'Names and captions'],
    quote: {
      text: 'The elderly recipient can’t believe what an amazing book it is. She is in a care home and 94 years old in a few weeks, and colouring is her daily activity, so this has elevated the task exponentially.',
      by: 'Verified Etsy buyer'
    },
    orgLabel: 'Care home or organisation',
    msgHint: 'e.g. A small pilot for three residents, using photos from their families.',
    trust: ['Photographs supplied by the home or family, with permission in place', 'A digital proof before anything is printed', 'Only approved content appears in the finished book', 'A data processing agreement and process summary available on request']
  },
  'football-clubs': {
    eyebrow: 'Partnerships · Football Clubs',
    heading: 'The official club colouring book.',
    body: 'A family-friendly matchday keepsake built around your crest, your ground and your fans. Hand-produced in the UK, with a low-risk trial to test demand first.',
    pair: {
      before: 'clubs/celebrate-after.webp',
      after: 'clubs/celebrate-before.webp',
      ratio: '4 / 3'
    },
    inside: [['clubs/inside-kit.webp', 'Kit design'], ['clubs/inside-wordsearch.webp', 'Club wordsearch'], ['clubs/inside-spot.webp', 'Spot the difference']],
    inUse: {
      src: 'clubs/club-shop.webp',
      ratio: '4 / 3',
      eyebrow: 'On the shelf',
      heading: 'Made to sit alongside your merchandise.',
      body: 'Printed with premium covers in your club colours, so it looks at home in the club shop, on a matchday stall or in a gift bundle.'
    },
    covers: ['clubs/riverdale-cover-1.webp', 'clubs/riverdale-cover-2.webp', 'clubs/riverdale-cover-3.webp'],
    pairs: [['clubs/match-before.webp', 'clubs/match-after.webp', 'Sunday league action'], ['clubs/stadium-before.webp', 'clubs/stadium-after.webp', 'The view from the stand']],
    why: [['Fills a gap in the club shop', 'Most club shops are all kits and training wear. A book gives young fans something to do and keep.'], ['Something for every fan', 'An affordable add-on next to kits and training wear, so more families leave the shop with something.'], ['Ready for big moments', 'Promotion pushes, cup runs and anniversaries make natural special editions fans want to keep.'], ['Players drawn as line art', 'From first team to academy, players see themselves drawn, usually only done for top-flight professionals.']],
    optionsHeading: 'What’s inside.',
    options: [['Club pages', 'Your crest, your ground, home and away kits, supporter and fan-culture pages.'], ['Matchday activities', 'Player-inspired action scenes, a commemorative page, wordsearches and “design your own kit”.'], ['Four formats', 'A4 or A5, paperback or coil bound, every edition 15–20 pages with premium front and back covers.']],
    feature: {
      eyebrow: 'Where the partnership grows',
      heading: 'The colouring book is just the start.',
      body: ['The same design and print setup carries across the club, the Academy and the Foundation. All badge use, kit details, player likenesses, sponsor logos and “official” wording are approved by the club before printing, and anything involving children’s photographs follows your safeguarding policy in full.'],
      list: ['Commemorative editions for a promotion, cup run or anniversary', 'Foundation and schools: calming sheets and SEN-friendly activities', 'Academy Player of the Match and Player of the Season awards', 'A girls’ football activity edition', 'Summer-camp packs and sponsor-funded editions']
    },
    orgLabel: 'Club',
    msgHint: 'e.g. A trial batch of 25–50 books for the club shop this season.',
    trust: ['Club approval on every badge, kit and player likeness', 'Safeguarding and consent handled before any child’s photo is used', 'A sample cover and pages approved before printing', 'Designed and hand-produced in the UK']
  }
};
function SectorPage({
  id,
  go
}) {
  const s = SECTORS[id];
  const [sent, setSent] = React.useState(false);
  const contact = () => {
    const el = document.getElementById('quote');
    if (el) window.scrollTo({
      top: el.getBoundingClientRect().top + window.scrollY - 80,
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-paper)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      ...sWrap,
      display: 'grid',
      gridTemplateColumns: 'minmax(0,6fr) minmax(0,5fr)',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 18,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(SEyebrow, null, s.eyebrow), /*#__PURE__*/React.createElement("h1", {
    style: sH1
  }, s.heading), /*#__PURE__*/React.createElement("p", {
    style: {
      ...sP,
      fontSize: 'var(--text-lg)'
    }
  }, s.body), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      marginTop: 8
    }
  }, /*#__PURE__*/React.createElement(SButton, {
    variant: "primary",
    size: "lg",
    onClick: contact
  }, "Get a Quote"), /*#__PURE__*/React.createElement(SButton, {
    variant: "secondary",
    size: "lg",
    onClick: () => {
      window.location.href = 'mailto:' + S_EMAIL;
    }
  }, "Email Us"))), /*#__PURE__*/React.createElement(SSlider, {
    beforeSrc: A + s.pair.before,
    afterSrc: A + s.pair.after,
    ratio: s.pair.ratio || '4 / 5'
  }))), s.covers ? /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...sWrap,
      display: 'grid',
      gap: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: sEy
  }, "Sample covers"), /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, "Your crest. Your ground. Your fans."), /*#__PURE__*/React.createElement("p", {
    style: sP
  }, "Sample editions for a fictional club, Riverdale FC. Yours would feature your own crest, kit and ground, approved by the club before printing.")), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, s.covers.map(c => /*#__PURE__*/React.createElement("li", {
    key: c
  }, /*#__PURE__*/React.createElement("img", {
    src: A + c,
    alt: "Sample club colouring book cover",
    loading: "lazy",
    style: {
      width: '100%',
      aspectRatio: '1 / 1.414',
      objectFit: 'cover',
      borderRadius: '3px 8px 8px 3px',
      boxShadow: '0 22px 40px -22px rgba(20,28,60,.55)',
      display: 'block'
    }
  })))), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,440px),1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, s.pairs.map(([b, a, t]) => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement(SSlider, {
    beforeSrc: A + b,
    afterSrc: A + a,
    ratio: "4 / 3"
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      ...sH3,
      fontSize: 'var(--text-lg)'
    }
  }, t)))), s.inside ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)',
      paddingTop: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: sEy
  }, "Inside the book"), /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, "Colouring, puzzles and activities."), /*#__PURE__*/React.createElement("p", {
    style: sP
  }, "Alongside the colouring pages, each edition can include club-themed activity pages like these.")), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, s.inside.map(([src, t]) => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: A + src,
    alt: 'Sample activity page: ' + t,
    loading: "lazy",
    style: {
      width: '100%',
      aspectRatio: '1 / 1.414',
      objectFit: 'cover',
      borderRadius: 6,
      border: '1px solid rgba(0,0,0,.1)',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      ...sH3,
      fontSize: 'var(--text-lg)'
    }
  }, t))))) : null)) : null, s.inUse ? /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...sWrap,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,340px),1fr))',
      gap: 'var(--space-8)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: A + s.inUse.src,
    alt: "",
    loading: "lazy",
    style: {
      width: '100%',
      aspectRatio: s.inUse.ratio,
      objectFit: 'cover',
      borderRadius: 12,
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12,
      alignContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: sEy
  }, s.inUse.eyebrow), /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, s.inUse.heading), /*#__PURE__*/React.createElement("p", {
    style: sP
  }, s.inUse.body)))) : null, /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...sWrap,
      display: 'grid',
      gap: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, "Why it works."), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 'var(--space-7) var(--grid-gap-lg)'
    }
  }, s.why.map(([t, b], i) => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      display: 'grid',
      gap: 10,
      alignContent: 'start',
      paddingTop: 16,
      borderTop: '1px solid var(--color-border-strong)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 700,
      color: 'var(--color-accent-warm)'
    }
  }, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("h3", {
    style: sH3
  }, t), /*#__PURE__*/React.createElement("p", {
    style: {
      ...sP,
      fontSize: 'var(--text-sm)'
    }
  }, b)))))), /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-blush-100)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...sWrap,
      display: 'grid',
      gap: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, s.optionsHeading), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, s.options.map(([t, b]) => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      display: 'grid',
      gap: 10,
      alignContent: 'start',
      padding: 'var(--space-6)',
      background: 'var(--opg-white)',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: sH3
  }, t), /*#__PURE__*/React.createElement("p", {
    style: {
      ...sP,
      fontSize: 'var(--text-sm)'
    }
  }, b)))))), /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      ...sWrap,
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: sEy
  }, s.feature.eyebrow), /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, s.feature.heading), s.feature.body.map((t, i) => /*#__PURE__*/React.createElement("p", {
    key: i,
    style: sP
  }, t)), /*#__PURE__*/React.createElement("ul", {
    style: {
      margin: 0,
      paddingLeft: 20,
      display: 'grid',
      gap: 8
    }
  }, s.feature.list.map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      fontSize: 'var(--text-base)',
      lineHeight: 1.6,
      color: 'var(--color-text)'
    }
  }, t)))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-6)'
    }
  }, s.adapt ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 14,
      padding: 'var(--space-6)',
      background: 'var(--opg-paper)',
      borderRadius: 'var(--radius-md)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: sEy
  }, "Adaptable to every reader"), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8
    }
  }, s.adapt.map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      padding: '7px 12px',
      borderRadius: 'var(--radius-round)',
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text)'
    }
  }, t)))) : null, s.uses ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: sEy
  }, "Ways schools use them"), /*#__PURE__*/React.createElement("ul", {
    style: {
      margin: 0,
      paddingLeft: 20,
      display: 'grid',
      gap: 6
    }
  }, s.uses.map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text)'
    }
  }, t)))) : null, s.photos ? /*#__PURE__*/React.createElement("p", {
    style: {
      ...sP,
      fontSize: 'var(--text-sm)',
      paddingTop: 16,
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--color-brand)'
    }
  }, "Your photos don\u2019t need to be perfect. "), s.photos) : null, s.quote ? /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      display: 'grid',
      gap: 12,
      paddingTop: 16,
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontStyle: 'italic',
      fontSize: 'var(--text-xl)',
      lineHeight: 1.35,
      color: 'var(--color-brand)'
    }
  }, "\u201C", s.quote.text, "\u201D"), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)'
    }
  }, s.quote.by)) : null))), /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-paper)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...sWrap,
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, "Handled with care."), /*#__PURE__*/React.createElement("ul", {
    style: {
      margin: 0,
      paddingLeft: 20,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))',
      gap: '8px var(--grid-gap-lg)'
    }
  }, s.trust.map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      fontSize: 'var(--text-base)',
      lineHeight: 1.6,
      color: 'var(--color-text)'
    }
  }, t))), S_STATS.rating ? /*#__PURE__*/React.createElement("p", {
    style: {
      ...sP,
      fontSize: 'var(--text-sm)'
    }
  }, S_STATS.rating.toFixed(1), "\u2605 from ", S_STATS.reviewCount, " verified Etsy reviews \xB7 Every page drawn by hand in the UK.") : null)), /*#__PURE__*/React.createElement("section", {
    id: "quote",
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-editorial)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      ...sWrap,
      display: 'grid',
      gridTemplateColumns: 'minmax(0,5fr) minmax(0,7fr)',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 16,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(SEyebrow, null, "Get a Quote"), /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, "A quote built around your needs."), /*#__PURE__*/React.createElement("p", {
    style: sP
  }, "Every project is different, so we price each one on the page count, size, binding and quantity you need. Tell us a little about yours and Leon will reply personally with ideas, timings and a fixed quote before any artwork begins."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-base)',
      lineHeight: 1.8
    }
  }, "Prefer email or a call?", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: 'mailto:' + S_EMAIL,
    style: {
      color: 'var(--color-brand)',
      fontWeight: 600
    }
  }, S_EMAIL), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: 'tel:' + S_PHONE.replace(/\s/g, ''),
    style: {
      color: 'var(--color-brand)',
      fontWeight: 600
    }
  }, S_PHONE))), sent ? /*#__PURE__*/React.createElement("div", {
    role: "status",
    style: {
      display: 'grid',
      gap: 12,
      padding: 'var(--space-7)',
      background: 'var(--opg-paper)',
      borderRadius: 'var(--radius-md)'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      ...sH3,
      fontSize: 'var(--text-2xl)'
    }
  }, "Thank you. Your enquiry is with us."), /*#__PURE__*/React.createElement("p", {
    style: {
      ...sP,
      fontSize: 'var(--text-sm)'
    }
  }, "Leon will be in touch within two working days with some ideas and a quote.")) : /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      const f = e.currentTarget;
      const lines = Array.from(f.elements).filter(el => el.id && el.value).map(el => {
        const l = f.querySelector('label[for="' + el.id + '"]');
        return (l ? l.textContent.replace(/\s*(\*|Optional|Required)\s*$/i, '').trim() : el.id) + ': ' + el.value;
      });
      window.location.href = 'mailto:enquiries@oneprintgallery.co.uk?subject=' + encodeURIComponent('Quote request — ' + s.eyebrow.replace('Partnerships · ', '')) + '&body=' + encodeURIComponent(lines.join('\n'));
      setSent(true);
    },
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(SField, {
    label: "Your name",
    htmlFor: "s-name",
    required: true
  }, /*#__PURE__*/React.createElement(SInput, {
    id: "s-name",
    required: true,
    autoComplete: "name"
  })), /*#__PURE__*/React.createElement(SField, {
    label: "Email",
    htmlFor: "s-email",
    required: true
  }, /*#__PURE__*/React.createElement(SInput, {
    id: "s-email",
    type: "email",
    required: true,
    autoComplete: "email"
  })), /*#__PURE__*/React.createElement(SField, {
    label: s.orgLabel,
    htmlFor: "s-org",
    required: true
  }, /*#__PURE__*/React.createElement(SInput, {
    id: "s-org",
    required: true,
    autoComplete: "organization"
  })), /*#__PURE__*/React.createElement(SField, {
    label: "Phone",
    htmlFor: "s-phone",
    optional: true
  }, /*#__PURE__*/React.createElement(SInput, {
    id: "s-phone",
    type: "tel",
    autoComplete: "tel"
  })), /*#__PURE__*/React.createElement(SField, {
    label: "Roughly how many books?",
    htmlFor: "s-qty",
    optional: true
  }, /*#__PURE__*/React.createElement(SSelect, {
    id: "s-qty",
    options: ['Just one or a few', 'Under 25', '25–50', '50–150', '150+', 'Not sure yet'],
    placeholder: "Choose one"
  })), /*#__PURE__*/React.createElement(SField, {
    label: "Ideal delivery date",
    htmlFor: "s-date",
    optional: true
  }, /*#__PURE__*/React.createElement(SInput, {
    id: "s-date",
    type: "date"
  })), /*#__PURE__*/React.createElement(SField, {
    label: "Tell us what you have in mind",
    htmlFor: "s-msg",
    required: true,
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(STextarea, {
    id: "s-msg",
    rows: 5,
    required: true,
    placeholder: s.msgHint
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(SButton, {
    variant: "primary",
    size: "lg",
    type: "submit"
  }, "Request a Quote"))))));
}
Object.assign(window, {
  SectorPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/SectorPages.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Shell.jsx
try { (() => {
const {
  AnnouncementBar,
  Header,
  MobileNav,
  Footer,
  Hero,
  EditorialSplit,
  HowItWorksTimeline,
  TestimonialFeature,
  FounderFeature,
  Manifesto,
  FaqAccordion,
  AudienceSelector,
  FullBleedBanner,
  BeforeAfterSlider,
  TransformationTriptych,
  ProductCard,
  ArtworkCard,
  MediaPlaceholder,
  Eyebrow,
  Button,
  TextLink,
  Tag,
  Badge,
  CartDrawer,
  Icon
} = window.OnePrintGalleryDesignSystem_ba4735;
const HeroFilm = ({
  page
}) => /*#__PURE__*/React.createElement("div", {
  "aria-hidden": "true",
  style: {
    position: 'relative',
    width: '100%',
    aspectRatio: '21 / 9',
    overflow: 'hidden',
    background: page === 'album' ? '#364370' : 'var(--opg-paper)'
  }
}, /*#__PURE__*/React.createElement("iframe", {
  src: `hero/Hero Banners.html?page=${page}&embed=1`,
  title: "",
  tabIndex: -1,
  style: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    border: 0,
    pointerEvents: 'none'
  }
}));
const Section = ({
  tone = 'white',
  pad = 'standard',
  children,
  style
}) => /*#__PURE__*/React.createElement("section", {
  style: {
    background: {
      white: 'var(--opg-white)',
      paper: 'var(--opg-paper)',
      blush: 'var(--opg-blush-100)',
      navy: 'var(--opg-navy-700)',
      ink: 'var(--opg-navy-900)'
    }[tone],
    paddingBlock: pad === 'compact' ? 'var(--section-compact)' : pad === 'editorial' ? 'var(--section-editorial)' : 'var(--section-standard)',
    ...style
  }
}, /*#__PURE__*/React.createElement("div", {
  style: {
    maxWidth: 'var(--container)',
    marginInline: 'auto',
    paddingInline: 'var(--gutter)'
  }
}, children));
const SectionHead = ({
  eyebrow,
  heading,
  body,
  onDark,
  align = 'left',
  max = '24ch'
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    display: 'grid',
    gap: '18px',
    justifyItems: align === 'center' ? 'center' : 'start',
    textAlign: align,
    marginBottom: 'var(--space-8)'
  }
}, eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
  onDark: onDark
}, eyebrow) : null, /*#__PURE__*/React.createElement("h2", {
  style: {
    margin: 0,
    fontFamily: 'var(--font-display)',
    fontWeight: 600,
    fontSize: 'var(--text-3xl)',
    lineHeight: 'var(--leading-heading)',
    letterSpacing: 'var(--tracking-display)',
    color: onDark ? 'var(--opg-white)' : 'var(--color-brand)',
    maxWidth: max
  }
}, heading), body ? /*#__PURE__*/React.createElement("p", {
  style: {
    margin: 0,
    fontSize: 'var(--text-base)',
    lineHeight: 1.65,
    color: onDark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)',
    maxWidth: '58ch'
  }
}, body) : null);

/* Section 3 — compact proof row. Words, not an app-icon strip. */
const ProofRow = () => /*#__PURE__*/React.createElement(Section, {
  tone: "paper",
  pad: "compact"
}, /*#__PURE__*/React.createElement("ul", {
  "data-opg-cols": "",
  style: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))',
    gap: 'var(--space-5) var(--grid-gap-lg)'
  }
}, ['Created from your own photos', 'Carefully transformed & refined', 'Optional preview by request', 'Made to order in 2–4 business days'].map((p, i) => /*#__PURE__*/React.createElement("li", {
  key: p,
  style: {
    paddingTop: 'var(--space-4)',
    borderTop: '1px solid var(--color-border-strong)'
  }
}, /*#__PURE__*/React.createElement("span", {
  style: {
    display: 'block',
    fontFamily: 'var(--font-display)',
    fontWeight: 600,
    fontSize: 'var(--text-lg)',
    color: 'var(--color-accent-warm)',
    lineHeight: 1
  }
}, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("span", {
  style: {
    display: 'block',
    marginTop: 10,
    fontFamily: 'var(--font-sans)',
    fontSize: 'var(--text-sm)',
    fontWeight: 600,
    color: 'var(--color-brand)',
    lineHeight: 1.45
  }
}, p)))));

/* Us vs them — personalised vs generic. Ours is the raised navy card; theirs recedes. */
const UVT_OURS = ['Made from your own family photos', 'Completely one of a kind', 'Every page starts a conversation', 'A keepsake worth keeping once it’s coloured'];
const UVT_THEIRS = ['Mass-produced stock designs', 'The same book on every shelf', 'No personal connection to the pages', 'Easily forgotten in a drawer'];
const UsVsThem = ({
  tone = 'paper',
  onCta,
  genericSrc = OPG_A('../../assets/web/compare/traditional-book.webp')
}) => {
  const pv = 'clamp(24px,3.5vw,40px)';
  const pad = {
    paddingInline: pv
  };
  const card = {
    minWidth: 0,
    gridRow: '1 / span 7',
    display: 'grid',
    gridTemplateRows: 'subgrid',
    borderRadius: 'var(--radius-lg, 16px)',
    overflow: 'hidden'
  };
  const media = {
    position: 'relative',
    background: 'var(--opg-paper)',
    padding: 'clamp(24px,4vw,44px)',
    display: 'grid',
    placeItems: 'center'
  };
  const cover = {
    width: '70%',
    aspectRatio: '1122 / 1402',
    objectFit: 'cover',
    borderRadius: 4,
    display: 'block'
  };
  const li = {
    display: 'flex',
    gap: 14,
    alignItems: 'center',
    padding: '14px 0',
    fontSize: 'var(--text-base)',
    lineHeight: 1.5
  };
  const tag = {
    fontFamily: 'var(--font-sans)',
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: 'var(--tracking-eyebrow)',
    textTransform: 'uppercase'
  };
  const ttl = {
    margin: 0,
    fontFamily: 'var(--font-display)',
    fontWeight: 600,
    fontSize: 'var(--text-2xl)',
    lineHeight: 1.1
  };
  return /*#__PURE__*/React.createElement(Section, {
    tone: tone,
    pad: "editorial"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    align: "center",
    max: "22ch",
    eyebrow: "Personalised vs Traditional",
    heading: "Why choose us over a traditional colouring book."
  }), /*#__PURE__*/React.createElement("div", {
    className: "opg-uvt",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)',
      gridTemplateRows: 'auto auto repeat(4, auto) 1fr',
      columnGap: 'clamp(12px,2.5vw,32px)',
      maxWidth: 1120,
      marginInline: 'auto'
    }
  }, /*#__PURE__*/React.createElement("article", {
    style: {
      ...card,
      gridColumn: 1,
      background: 'var(--opg-navy-700)',
      color: 'var(--opg-white)',
      boxShadow: '0 30px 60px -28px rgba(10,20,50,.55)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: media
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/books/luna-front.webp"),
    alt: "Adventures of Luna, a personalised colouring book cover",
    style: {
      ...cover,
      boxShadow: '0 22px 40px -18px rgba(10,20,50,.45)',
      transform: 'rotate(-2deg)'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      ...tag,
      position: 'absolute',
      top: 18,
      left: 18,
      padding: '7px 12px',
      borderRadius: 'var(--radius-round)',
      background: 'var(--opg-navy-700)',
      color: 'var(--opg-peach-300)'
    }
  }, "One of One")), /*#__PURE__*/React.createElement("div", {
    style: {
      ...pad,
      paddingTop: pv,
      paddingBottom: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      ...tag,
      margin: 0,
      color: 'var(--opg-peach-300)'
    }
  }, "One Print Gallery"), /*#__PURE__*/React.createElement("h3", {
    style: {
      ...ttl,
      marginTop: 10,
      color: 'var(--opg-white)'
    }
  }, "Personalised Colouring Book")), UVT_OURS.map((t, i) => /*#__PURE__*/React.createElement("div", {
    key: t,
    style: {
      ...pad,
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...li,
      flex: 1,
      borderTop: i ? '1px solid rgba(255,255,255,.14)' : 'none',
      fontWeight: 600
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 'none',
      width: 26,
      height: 26,
      borderRadius: '50%',
      background: 'var(--opg-peach-300)',
      color: 'var(--opg-navy-700)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    size: 15,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("span", null, t)))), /*#__PURE__*/React.createElement("div", {
    style: {
      ...pad,
      paddingBottom: pv
    }
  }, onCta ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-5)',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "onDark",
    size: "lg",
    onClick: onCta
  }, "Create Your Book"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-on-dark-muted)'
    }
  }, "From \xA314.99")) : null)), /*#__PURE__*/React.createElement("article", {
    style: {
      ...card,
      gridColumn: 2,
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: media
  }, genericSrc ? /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: genericSrc,
    alt: "A traditional mass-market colouring book cover",
    style: {
      ...cover,
      boxShadow: '0 12px 24px -16px rgba(10,20,50,.35)',
      filter: 'saturate(.6)',
      opacity: .88
    }
  }) : /*#__PURE__*/React.createElement(MediaPlaceholder, {
    label: "[GENERIC COLOURING BOOK PHOTO]",
    ratio: "4 / 3",
    rounded: "none"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      ...tag,
      position: 'absolute',
      top: 18,
      left: 18,
      padding: '7px 12px',
      borderRadius: 'var(--radius-round)',
      background: 'var(--opg-white)',
      color: 'var(--color-text-muted)',
      border: '1px solid var(--color-border)'
    }
  }, "Standard")), /*#__PURE__*/React.createElement("div", {
    style: {
      ...pad,
      paddingTop: pv,
      paddingBottom: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      ...tag,
      margin: 0,
      color: 'var(--color-text-muted)'
    }
  }, "Off the shelf"), /*#__PURE__*/React.createElement("h3", {
    style: {
      ...ttl,
      marginTop: 10,
      color: 'var(--color-text-muted)'
    }
  }, "Traditional Colouring Book")), UVT_THEIRS.map((t, i) => /*#__PURE__*/React.createElement("div", {
    key: t,
    style: {
      ...pad,
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...li,
      flex: 1,
      borderTop: i ? '1px solid var(--color-border)' : 'none',
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 'none',
      width: 26,
      height: 26,
      borderRadius: '50%',
      border: '1px solid var(--color-border-strong)',
      color: 'var(--color-text-muted)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "x",
    size: 14,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("span", null, t)))), /*#__PURE__*/React.createElement("div", {
    style: {
      ...pad,
      paddingBottom: pv
    }
  }))));
};
Object.assign(window, {
  Section,
  SectionHead,
  ProofRow,
  UsVsThem,
  HeroFilm
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Shell.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/hero/HeroScenes.jsx
try { (() => {
const MOTION = {
  enter: Easing.easeInOutCubic,
  draw: Easing.easeInOutSine,
  pop: Easing.easeOutBack
};
const HERO_W = 2520,
  HERO_H = 1080;
const SKIN = '#f3c2a0',
  SKIN2 = '#f0b894';

// blobs: [x%, y%, w%, h%, colour, rot] in line-art coordinates
const HERO_PAIRS = {
  family: {
    photo: 'img/family-photo.webp',
    line: 'img/family-line.webp',
    colour: 'img/family-colour.webp',
    cb: {
      l: -1,
      t: 0,
      w: 101,
      h: 104
    },
    a: 1122 / 1402,
    la: {
      l: -3.4,
      t: -0.3,
      w: 104,
      h: 104.3
    },
    blobs: [[36, 20, 22, 18, '#efe0c4', 8], [10, 40, 18, 30, '#9a6647', -10], [20, 28, 26, 9, '#9a6647', 4], [20, 42, 15, 13, SKIN, -6], [39, 38, 18, 8, '#b07a52', 6], [38, 47, 13, 10, SKIN2, 10], [11, 71, 17, 22, '#c3b2ea', -8], [31, 74, 36, 32, '#dca26a', 12], [62, 25, 22, 8, '#6f4d36', -4], [64, 38, 16, 16, SKIN, 8], [88, 26, 16, 28, '#c9a67f', -12], [90, 68, 18, 40, '#7f8dc6', 6], [69, 47, 22, 8, '#e4b86e', -6], [70, 54, 15, 12, SKIN2, 4], [76, 69, 26, 16, '#f4c0c8', -10]]
  },
  kitchen: {
    photo: 'img/kitchen-photo.webp',
    line: 'img/kitchen-line.webp',
    colour: 'img/kitchen-colour.webp',
    cb: {
      l: 0,
      t: 0,
      w: 100,
      h: 102.5
    },
    a: 1122 / 1402,
    la: {
      l: -8.9,
      t: 3.6,
      w: 109.3,
      h: 93.3
    },
    blobs: [[10, 17, 20, 14, '#f2d59b', 6], [78, 24, 22, 22, '#cbc4ec', -8], [26, 23, 17, 26, '#9a6647', -10], [40, 9, 30, 9, '#9a6647', 4], [57, 25, 12, 22, '#9a6647', 8], [46, 24, 15, 16, SKIN, -4], [67, 29, 18, 8, '#e4b86e', -6], [65, 37, 13, 10, SKIN2, 6], [66, 48, 22, 14, '#f4b8c1', -10], [28, 66, 34, 44, '#f0a58a', 8], [92, 37, 12, 14, '#9cc59a', -6], [95, 45, 10, 7, '#aab4d8', 4], [87, 60, 14, 17, '#b6c7e6', -8], [77, 71, 13, 5, '#e78155', 6], [79, 77, 20, 8, '#f2c879', -4]]
  }
};
HERO_PAIRS.selfie = {
  photo: 'img/selfie-photo.webp',
  line: 'img/selfie-line.webp',
  colour: 'img/selfie-colour.webp',
  a: 1402 / 1122,
  la: {
    l: 0,
    t: 0,
    w: 100,
    h: 100
  },
  blobs: [[12, 24, 20, 16], [42, 12, 44, 18], [88, 22, 22, 24], [58, 30, 20, 18], [26, 42, 34, 44], [42, 44, 20, 20], [66, 60, 24, 22], [86, 56, 22, 22], [30, 82, 56, 30], [76, 86, 46, 26]]
};
HERO_PAIRS.grandad = {
  photo: 'img/grandad-photo.webp',
  line: 'img/grandad-line.webp',
  colour: 'img/grandad-colour.webp',
  a: 1402 / 1122,
  la: {
    l: 4.4,
    t: -12.3,
    w: 87.7,
    h: 148
  },
  colourSpace: 'photo',
  blobs: []
};
HERO_PAIRS.school = {
  photo: 'img/school-photo.webp',
  line: 'img/school-line.webp',
  colour: 'img/school-colour.webp',
  a: 1536 / 1024,
  la: {
    l: 0,
    t: 0,
    w: 100,
    h: 100
  },
  cb: {
    l: 0,
    t: -2.2,
    w: 96.8,
    h: 104
  },
  feather: 14,
  blobs: []
};
const LINE_ONLY = {
  l: 0,
  t: 0,
  w: 100,
  h: 100
};
const LINE_A = 1055 / 1491;
function span(T, a, b) {
  return clamp((T - a) / (b - a), 0, 1);
}
function loopWave(T, total, amp, phase = 0) {
  return amp * (1 - Math.cos(2 * Math.PI * T / total + phase)) / 2;
}

// the finished colouring-pencil page sweeps in over the sketch on one soft, feathered diagonal
function ColourLayer({
  pair,
  T,
  tm,
  inPhoto
}) {
  const p = MOTION.draw(span(T, tm.c0, tm.c0 + (tm.c1 - tm.c0) * 0.85));
  if (p <= 0) return null;
  const F = pair.feather || 35,
    X = -F + p * (100 + 2 * F),
    m = `linear-gradient(105deg, #000 ${X - F}%, transparent ${X}%)`;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      overflow: 'hidden',
      WebkitMaskImage: m,
      maskImage: m
    }
  }, pair.cb && !inPhoto ? /*#__PURE__*/React.createElement("img", {
    src: pair.colour,
    alt: "",
    style: {
      position: 'absolute',
      left: pair.cb.l + '%',
      top: pair.cb.t + '%',
      width: pair.cb.w + '%',
      height: pair.cb.h + '%',
      display: 'block'
    }
  }) : /*#__PURE__*/React.createElement("img", {
    src: pair.colour,
    alt: "",
    style: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  }));
}

// photo -> line art -> coloured in -> back to photo, keyed to cue times
function Artwork({
  id = 'art',
  T,
  W,
  H,
  pair,
  a,
  la,
  fx = 0.5,
  fy = 0.5,
  zoom = 1,
  mode = 'wipe',
  origin = [50, 45],
  photo = true,
  returnSweep = true,
  keepSketch = false,
  t: tm
}) {
  a = a || pair.a;
  la = la || pair.la;
  const iw = Math.max(W, H * a) * zoom,
    ih = iw / a,
    left = (W - iw) * fx,
    top = (H - ih) * fy;
  const p = span(T, tm.s0, tm.s1),
    pe = MOTION.draw(p);
  const fade = 1 - MOTION.enter(span(T, tm.r0, tm.r1));
  // every transition uses the same feathered diagonal sweep
  const edge = null,
    X0 = -35 + pe * 170,
    m0 = `linear-gradient(105deg, #000 ${X0 - 35}%, transparent ${X0}%)`;
  const clip = p >= 1 || keepSketch ? {} : {
    WebkitMaskImage: m0,
    maskImage: m0
  };
  let retMask = {};
  if (returnSweep && T >= tm.r0) {
    // same feathered diagonal as the colour-in, sweeping the photo back across
    const F = pair.feather || 35,
      X = -F + MOTION.draw(span(T, tm.r0, tm.r1)) * (100 + 2 * F),
      m = `linear-gradient(105deg, transparent ${X - F}%, #000 ${X}%)`;
    retMask = {
      clipPath: 'none',
      WebkitMaskImage: m,
      maskImage: m
    };
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left,
      top,
      width: iw,
      height: ih
    }
  }, photo && /*#__PURE__*/React.createElement("img", {
    src: pair.photo,
    alt: "",
    style: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      ...(returnSweep ? {} : {
        opacity: fade
      }),
      ...clip,
      ...(keepSketch ? {} : retMask)
    }
  }, photo && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      background: '#fff'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: la.l + '%',
      top: la.t + '%',
      width: la.w + '%',
      height: la.h + '%'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: pair.line,
    alt: "",
    style: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      display: 'block'
    }
  }), (!photo || pair.colourSpace !== 'photo') && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      ...(keepSketch ? retMask : {})
    }
  }, /*#__PURE__*/React.createElement(ColourLayer, {
    pair: pair,
    T: T,
    tm: tm
  }))), photo && pair.colourSpace === 'photo' && /*#__PURE__*/React.createElement(ColourLayer, {
    pair: pair,
    T: T,
    tm: tm,
    inPhoto: true
  })), edge);
}
function useHeroTiming() {
  const {
    T,
    CUES,
    authoredTotal
  } = useComposition();
  const total = authoredTotal || 6;
  const tm = {
    s0: CUES.Sketch,
    s1: CUES.Colour,
    c0: CUES.Colour,
    c1: CUES.Return,
    r0: CUES.Return,
    r1: total
  };
  return {
    T,
    total,
    tm
  };
}
function Camera({
  T,
  total,
  children,
  zoom = 0.05,
  pan = 0,
  ox = '50%',
  oy = '45%'
}) {
  const s = 1 + loopWave(T, total, zoom),
    x = loopWave(T, total, pan);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      transform: `translateX(${-x}px) scale(${s})`,
      transformOrigin: `${ox} ${oy}`
    }
  }, children);
}
function HomeHero() {
  const {
    T,
    total,
    tm
  } = useHeroTiming();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Camera, {
    T: T,
    total: total,
    zoom: 0.06,
    pan: 40,
    oy: "40%"
  }, /*#__PURE__*/React.createElement(Artwork, {
    T: T,
    W: HERO_W,
    H: HERO_H,
    pair: HERO_PAIRS.family,
    fy: 0.42,
    mode: "wipe",
    t: tm
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      background: 'radial-gradient(ellipse at 50% 45%, rgba(0,0,0,0) 55%, rgba(20,28,60,.28) 100%)'
    }
  }));
}
function StoryHero() {
  const {
    T,
    total,
    tm
  } = useHeroTiming();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Camera, {
    T: T,
    total: total,
    zoom: 0.08,
    pan: -60,
    ox: "50%",
    oy: "42%"
  }, /*#__PURE__*/React.createElement(Artwork, {
    T: T,
    W: HERO_W,
    H: HERO_H,
    pair: HERO_PAIRS.grandad,
    zoom: 1.16,
    fx: 0.372,
    fy: 0.353,
    mode: "radial",
    origin: [52, 42],
    t: tm
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(180deg, rgba(231,129,85,.10), rgba(54,67,112,.18))',
      mixBlendMode: 'multiply'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      background: 'radial-gradient(ellipse at 45% 40%, rgba(0,0,0,0) 50%, rgba(30,24,20,.32) 100%)'
    }
  }));
}
const cardShadow = '0 40px 60px -30px rgba(40,30,20,.45), 0 8px 18px rgba(40,30,20,.12)';
function ColouringHero() {
  const {
    T,
    total,
    tm
  } = useHeroTiming();
  const lift = MOTION.enter(span(T, tm.s0 - 0.3, tm.s0 + 0.4)) * (1 - MOTION.enter(span(T, tm.r0, tm.r1)));
  const bookGlow = MOTION.enter(span(T, tm.c0 + 0.8, tm.r0)) * (1 - MOTION.enter(span(T, tm.r0, tm.r1)));
  const PW = 640,
    PH = PW / LINE_A;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      background: 'radial-gradient(ellipse at 45% 40%, #f7f1e7, #e9dfcf)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      opacity: 0.35,
      background: 'repeating-linear-gradient(90deg, rgba(120,90,60,.05) 0 2px, transparent 2px 7px)'
    }
  }), /*#__PURE__*/React.createElement(Camera, {
    T: T,
    total: total,
    zoom: 0.04,
    pan: 30
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 250,
      top: 250,
      width: 500,
      height: 625,
      padding: 20,
      background: '#fff',
      boxShadow: cardShadow,
      transform: `rotate(${-6 + lift * 1.5}deg) translateY(${-lift * 14}px)`
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: HERO_PAIRS.kitchen.photo,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 170,
      top: -22,
      width: 160,
      height: 44,
      background: 'rgba(240,189,160,.75)',
      transform: 'rotate(4deg)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 930,
      top: (HERO_H - PH) / 2,
      width: PW,
      height: PH,
      background: '#fff',
      boxShadow: cardShadow,
      transform: 'rotate(1.5deg)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Artwork, {
    T: T,
    W: PW,
    H: PH,
    pair: HERO_PAIRS.kitchen,
    a: LINE_A,
    la: LINE_ONLY,
    mode: "down",
    photo: false,
    keepSketch: true,
    t: tm
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 1760,
      top: 190,
      width: 520,
      height: 520 / LINE_A,
      boxShadow: `${cardShadow}, 0 0 ${bookGlow * 80}px rgba(231,129,85,${bookGlow * 0.45})`,
      transform: `rotate(${5 - bookGlow * 2}deg) translateY(${-bookGlow * 12}px)`,
      borderRadius: '2px 8px 8px 2px',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "img/luna-front.webp",
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: 26,
      background: 'linear-gradient(90deg, rgba(0,0,0,.28), rgba(0,0,0,0))'
    }
  }))));
}
function AlbumHero() {
  const {
    T,
    total,
    tm
  } = useHeroTiming();
  const SH = 960,
    PW = SH * LINE_A,
    PH = SH,
    SW = PW * 2;
  const photoW = 540,
    photoH = photoW / HERO_PAIRS.selfie.a;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      background: 'radial-gradient(ellipse at 50% 45%, #45528a, #262f55)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      opacity: 0.5,
      background: 'repeating-linear-gradient(45deg, rgba(255,255,255,.03) 0 2px, transparent 2px 5px), repeating-linear-gradient(-45deg, rgba(0,0,0,.05) 0 2px, transparent 2px 5px)'
    }
  }), /*#__PURE__*/React.createElement(Camera, {
    T: T,
    total: total,
    zoom: 0.045,
    pan: -30
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: (HERO_W - SW) / 2,
      top: (HERO_H - SH) / 2,
      width: SW,
      height: SH,
      display: 'flex',
      boxShadow: '0 50px 80px -30px rgba(0,0,0,.6)'
    }
  }, [0, 1].map(side => /*#__PURE__*/React.createElement("div", {
    key: side,
    style: {
      position: 'relative',
      flex: 1,
      background: side ? 'linear-gradient(90deg,#ebe4d6,#fbf8f2 8%)' : 'linear-gradient(270deg,#ebe4d6,#fbf8f2 8%)',
      borderRadius: side ? '0 6px 6px 0' : '6px 0 0 6px'
    }
  }, side === 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: (SW / 2 - photoW) / 2,
      top: (SH - photoH) / 2 - 40,
      width: photoW,
      height: photoH,
      background: '#fff',
      padding: 14,
      boxSizing: 'border-box',
      boxShadow: '0 12px 24px -12px rgba(40,30,20,.35)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: HERO_PAIRS.selfie.photo,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  }), [['left', 'top', 0], ['right', 'top', 90], ['right', 'bottom', 180], ['left', 'bottom', 270]].map(([h, v, r]) => /*#__PURE__*/React.createElement("div", {
    key: h + v,
    style: {
      position: 'absolute',
      [h]: -6,
      [v]: -6,
      width: 46,
      height: 46,
      background: '#364370',
      clipPath: 'polygon(0 0,100% 0,0 100%)',
      transform: `rotate(${r}deg)`
    }
  }))) : /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: PW,
      height: PH,
      background: '#fff',
      borderRadius: '0 6px 6px 0',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Artwork, {
    T: T,
    W: PW,
    H: PH,
    pair: HERO_PAIRS.selfie,
    a: LINE_A,
    la: LINE_ONLY,
    mode: "wipe",
    photo: false,
    keepSketch: true,
    t: tm
  })), side === 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: (SH - photoH) / 2 - 40 + photoH + 30,
      textAlign: 'center',
      fontFamily: '"Cormorant Garamond", Georgia, serif',
      fontStyle: 'italic',
      fontWeight: 500,
      fontSize: 64,
      letterSpacing: '0.01em',
      color: '#364370',
      transform: 'rotate(-1.5deg)'
    }
  }, "Christmas 2024"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: SW / 2 - 40,
      top: 0,
      bottom: 0,
      width: 80,
      zIndex: 2,
      background: 'linear-gradient(90deg, rgba(0,0,0,0), rgba(60,45,30,.18), rgba(0,0,0,0))'
    }
  }))));
}
function PartnerHero() {
  const {
    T,
    total,
    tm
  } = useHeroTiming();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Camera, {
    T: T,
    total: total,
    zoom: 0.05,
    pan: 30,
    oy: "35%"
  }, /*#__PURE__*/React.createElement(Artwork, {
    T: T,
    W: HERO_W,
    H: HERO_H,
    pair: HERO_PAIRS.school,
    zoom: 1.07,
    fx: 0,
    fy: 0.1,
    mode: "wipe",
    t: tm
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      background: 'radial-gradient(ellipse at 50% 45%, rgba(0,0,0,0) 55%, rgba(20,28,60,.28) 100%)'
    }
  }));
}
const HERO_VARIANTS = {
  partner: PartnerHero,
  home: HomeHero,
  colouring: ColouringHero,
  album: AlbumHero,
  story: StoryHero
};
function HeroPiece({
  page
}) {
  const {
    T
  } = useComposition();
  const V = HERO_VARIANTS[page] || HomeHero;
  return /*#__PURE__*/React.createElement("div", {
    "data-screen-label": `${page} ${Math.floor(T)}s`,
    style: {
      position: 'absolute',
      inset: 0,
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(V, null));
}
Object.assign(window, {
  HeroPiece,
  HERO_W,
  HERO_H,
  HERO_VARIANTS
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/hero/HeroScenes.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/hero/animations-v3.jsx
try { (() => {
// @ds-adherence-ignore -- omelette starter scaffold (raw elements/hex/px by design)
// Copied omelette starter. Re-running copy_starter_component with this kind overwrites this file with the latest version (page content is unaffected).

/* BEGIN USAGE */
// animations-v3.jsx — continuous-composition animation engine.
//
// THE MODEL: the animation is ONE element tree rendered as a pure function
// of one authored-time axis. Nothing mounts or unmounts at section
// boundaries, so any element can move, morph, or persist across them by
// ordinary interpolation. The scene list (OM_SCENES) is the user-control
// view — names, order, playback durations — and the engine derives the cue
// table from it, so structure has exactly one source and cannot drift.
//
// API INDEX (every export is a window global):
//   <CompositionStage width height scenes={window.OM_SCENES}
//                     playback={window.OM_PLAYBACK} bg>
//     <Piece />   — ONE component, the whole animation
//   </CompositionStage>
//   useComposition() -> {T, CUES, time, duration, authoredTotal, playing}
//     T: authored seconds (warped per-section by user trims/speeds) —
//        key ALL choreography to T, never to wall-clock time
//     CUES: {SectionName: authoredStart} derived from OM_SCENES; an unknown
//        name returns NaN and raises a preview-only badge (never exports);
//        duplicate section names bind to the first occurrence
//   <Shot from={CUES.Build} to={CUES.Close}> — children visible between two
//     authored times (an authored hard cut in one line); children stay
//     mounted (media keeps its readiness) and are hidden outside the window
//   <Captions items={[{at, until?, text}, ...]} /> — ONE caption element,
//     at most one visible at a time, keyed to T; 'until' defaults to the
//     next item's 'at'; a last item with no 'until' stays to the end
//   WATERCOLOR (only when the Watercolor illustration skill is active —
//   otherwise ignore these entries). A painting is a function(p) written
//   against the paint kit, on a width x height sheet; it needs
//   watercolor_kit.js loaded by a <script> tag before this engine, must
//   be a stable function defined once (module scope, never an inline
//   arrow), and every component below renders <img> elements, so it all
//   exports by construction.
//   <WatercolorPainting painting={fn} from={CUES.X} to={CUES.Y} width height
//     seed scale quality style /> — the painting assembled from its own
//     STROKES: each wash / ink line / splatter is a separate layer
//     stacked over the paper, appearing in painting order between two
//     authored times (washes bloom in, ink draws tip to tail). This is the
//     default way to show a watercolor being painted. It keeps the sheet's
//     aspect ratio (size it with style, e.g. {position:'absolute', left,
//     top, width}). scale is the layers' render resolution over width x
//     height (default 1, a deliberate weight-over-dpi trade — raise it
//     toward the zoom factor if the composition zooms into the painting,
//     or toward the devicePixelRatio for a hero-sized sheet); quality is
//     0..1 layer image quality (default 0.92; 1 is the encoder's maximum).
//   useWatercolorLayers(fn, {width, height, seed, scale, quality}) -> L
//     (null if the kit isn't loaded — load watercolor_kit.js before the
//     engine — or if the painting fails to build) — the painting taken apart into strokes, for
//     choreography beyond in-order painting: L.count strokes, L.kind(i)
//     ('wash' | 'gradedWash' | 'glaze' | 'ink' | 'hatch' | 'splatter' |
//     'dryStroke' | 'reserve' | 'caption'), L.span(i) = the stroke's
//     {from, to} share of the painting's 0..1 timeline; call L.warm()
//     once after load so finished strokes pre-render off the critical
//     path (WatercolorPainting does this itself). Compose with:
//   <WatercolorSheet layers={L} style>children</WatercolorSheet> — the
//     paper the strokes sit on (keeps the sheet's aspect ratio), and
//   <WatercolorStroke index={i} at={0..1} style /> — stroke i as its own
//     element, placed where it was painted; at is its painting progress
//     (0 hidden, 1 finished — drive it from T with animate()); style lets
//     you move, scale, rotate, or fade the stroke (transform / opacity).
//     Strokes are paint, so they multiply: overlapping strokes darken
//     where they cross, as in the still image, within a few 8-bit levels
//     (tighter still at quality 1). The sheet clips to its
//     box — for strokes that fly in from outside it, set
//     style={{overflow: 'visible'}} on the WatercolorSheet. 'reserve' strokes
//     are erasures (lifted paper) — keep them where they were painted and
//     reveal them in order after the strokes they erase; moving an erase
//     around has no sensible meaning.
//   <WatercolorReveal painting={fn} from={CUES.X} to={CUES.Y} width height
//     seed steps scale format quality style />, or <WatercolorReveal
//     frames={[src, ...]} from to /> — the whole painting as ONE flat
//     image that paints on (frames pre-baked in the background, so it is
//     the lightest option and the one to zoom or pan over as a single
//     picture). Prefer WatercolorPainting when the strokes themselves
//     should appear one by one or be individually animated. format is
//     the image MIME type (default image/jpeg), quality 0..1 (default
//     0.88). Frames bake at width x height times scale (default: the
//     device pixel ratio, capped at 2) — if the composition zooms INTO
//     the painting, raise scale toward the maximum zoom so frames stay
//     crisp. The kit caps a sheet at ~12M pixels and the components clamp
//     scale to stay under it; exported video sharpness also depends on
//     the export dialog's own resolution choice.
//   Motion: Easing.{linear, easeIn|Out|InOutQuad/Cubic/Quart/Expo/Sine,
//     easeIn|Out|InOutBack, easeOutElastic}, interpolate(input, output, ease),
//     animate({from, to, start, end, ease}) -> fn(T), clamp(v, min, max)
//   Plumbing (rarely needed): Stage, PlaybackBar, TimelineContext,
//     useTime, useTimeline
//   Seek event (host/export transport): 'data-om-seek-to-time-frame',
//     detail {time, sync, playing} — the stage owns it; never implement it
//     yourself
//
// THE AUTHORING CONTRACT — this is what makes the host timeline's trim and
// speed gestures write back into YOUR file, so follow it exactly:
//   1. Declare the scene list as a JSON string literal in a plain inline
//      <script> of the main document (NOT type="text/babel", NOT a sibling
//      .jsx — only vanilla inline scripts are addressable for write-back):
//        <script>window.OM_SCENES = '[{"name":"Opening","dur":3,"desc":"The logo fades in and the title settles"},{"name":"Build","dur":5,"desc":"Bars grow to their final values"}]';</script>
//      Give every entry a "desc": one short plain-words sentence saying
//      what happens in that section. The user reads it in the timeline's
//      section popover — keep it true whenever you edit the section.
//   2. Pass the string through untouched:
//        <CompositionStage scenes={window.OM_SCENES} ...>
//   3. ALSO declare the playback setting the same way:
//        <script>window.OM_PLAYBACK = '{"mode":"loop"}';</script>
//      and pass it through untouched (values: '{"mode":"loop"}' or
//      '{"mode":"times","count":N}'; omitting keeps loop behavior but
//      leaves the host Repeat control read-only for this document).
//   IMPORTANT — the exportable-video contract: CompositionStage/Stage OWNS
//   it (the data-om-exportable-video-with-duration-secs attribute, the
//   data-om-seek-to-time-frame listener, the svg/foreignObject wrapper,
//   and font inlining). NEVER put the exportable attribute on any other
//   element — a second "exportable root" makes the host timeline and the
//   video exporter bind to the wrong element, and playback control /
//   export silently break.
//
// HOW TIME WORKS: each OM_SCENES entry is a named slice of the authored
// timeline. CUES.Name is that section's authored start (the running sum of
// authored lengths, in literal order). useComposition().T is the authored
// clock: when the user trims or speeds a section on the host timeline, the
// engine replays that section's SAME authored slice over the new playback
// length — your choreography retimes, never cuts off. The optional "nat"
// field on an entry is the engine's authored-length anchor — the host
// timeline stamps it on the first retime; don't set it by hand.
//
// CUE-FIRST DISCIPLINE (what makes a piece read as one continuous video):
//   1. Write the OM_SCENES literal FIRST — it is the piece's outline.
//   2. One helper component per section for readability, but ALL of them
//      render ALL the time inside the one tree, keyed to CUES — never
//      conditionally mounted per section.
//   3. Define exactly three motion helpers up front (e.g.
//      MOTION = {enter, draw, pop} wrapping Easing curves) and use no
//      easing or transform outside them; one caption element, one visible
//      at a time (<Captions> has this built in).
//   A shared element that crosses a boundary is just motion whose start
//   and end straddle a cue: animate({from, to, start: CUES.Build - 0.4,
//   end: CUES.Build + 0.6})(T) glides through the boundary, and a user
//   slowing either section slows the glide without breaking it.
//
// RENDER FROM T ONLY: the exporter seeks each frame with a synchronous
// commit and may serialize the stage the moment the seek event returns —
// anything painted from useEffect or your own requestAnimationFrame lags
// that commit and exports stale. Render everything visible from T and this
// is automatic. A seeked frame is a deterministic render at that time.
//
// HARD CUTS are content now, not structure: wrap a shot's elements in
// <Shot from to> (visibility toggles at the cues; children stay mounted so
// images and videos hold their readiness). Shot also doubles as the
// perf gate for heavy far-away beats.
//
// LOOP SEAMS are the one surviving boundary rule: a looping piece shows
// its last authored frame immediately before its first — make them match
// (settle your choreography by authoredTotal, open it at 0).
//
// DIAGNOSTICS: choreography that references an unknown section name (a
// rename or deletion in OM_SCENES) shows a badge below the stage in the
// preview, outside the exportable svg — visible in preview screenshots,
// never in the exported video. An OM_SCENES section with no choreography
// keyed to it is a valid empty beat, not an error.
/* END USAGE */

// ─────────────────────────────────────────────────────────────────────────────

// ── Easing functions (hand-rolled, Popmotion-style) ─────────────────────────
// All easings take t ∈ [0,1] and return eased t ∈ [0,1] (may overshoot for back/elastic).
const Easing = {
  linear: t => t,
  // Quad
  easeInQuad: t => t * t,
  easeOutQuad: t => t * (2 - t),
  easeInOutQuad: t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
  // Cubic
  easeInCubic: t => t * t * t,
  easeOutCubic: t => --t * t * t + 1,
  easeInOutCubic: t => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
  // Quart
  easeInQuart: t => t * t * t * t,
  easeOutQuart: t => 1 - --t * t * t * t,
  easeInOutQuart: t => t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t,
  // Expo
  easeInExpo: t => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: t => t === 1 ? 1 : 1 - Math.pow(2, -10 * t),
  easeInOutExpo: t => {
    if (t === 0) return 0;
    if (t === 1) return 1;
    if (t < 0.5) return 0.5 * Math.pow(2, 20 * t - 10);
    return 1 - 0.5 * Math.pow(2, -20 * t + 10);
  },
  // Sine
  easeInSine: t => 1 - Math.cos(t * Math.PI / 2),
  easeOutSine: t => Math.sin(t * Math.PI / 2),
  easeInOutSine: t => -(Math.cos(Math.PI * t) - 1) / 2,
  // Back (overshoot)
  easeOutBack: t => {
    const c1 = 1.70158,
      c3 = c1 + 1;
    return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
  },
  easeInBack: t => {
    const c1 = 1.70158,
      c3 = c1 + 1;
    return c3 * t * t * t - c1 * t * t;
  },
  easeInOutBack: t => {
    const c1 = 1.70158,
      c2 = c1 * 1.525;
    return t < 0.5 ? Math.pow(2 * t, 2) * ((c2 + 1) * 2 * t - c2) / 2 : (Math.pow(2 * t - 2, 2) * ((c2 + 1) * (t * 2 - 2) + c2) + 2) / 2;
  },
  // Elastic
  easeOutElastic: t => {
    const c4 = 2 * Math.PI / 3;
    if (t === 0) return 0;
    if (t === 1) return 1;
    return Math.pow(2, -10 * t) * Math.sin((t * 10 - 0.75) * c4) + 1;
  }
};

// ── Core interpolation helpers ──────────────────────────────────────────────

// Clamp a value to [min, max]
const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

// interpolate([0, 0.5, 1], [0, 100, 50], ease?) -> fn(t)
// Popmotion-style: linearly maps t across input keyframes to output values,
// with optional easing per segment (single fn or array of fns).
function interpolate(input, output, ease = Easing.linear) {
  return t => {
    if (t <= input[0]) return output[0];
    if (t >= input[input.length - 1]) return output[output.length - 1];
    for (let i = 0; i < input.length - 1; i++) {
      if (t >= input[i] && t <= input[i + 1]) {
        const span = input[i + 1] - input[i];
        const local = span === 0 ? 0 : (t - input[i]) / span;
        const easeFn = Array.isArray(ease) ? ease[i] || Easing.linear : ease;
        const eased = easeFn(local);
        return output[i] + (output[i + 1] - output[i]) * eased;
      }
    }
    return output[output.length - 1];
  };
}

// animate({from, to, start, end, ease})(t) — simpler single-segment tween.
// Returns `from` before `start`, `to` after `end`.
function animate({
  from = 0,
  to = 1,
  start = 0,
  end = 1,
  ease = Easing.easeInOutCubic
}) {
  return t => {
    if (t <= start) return from;
    if (t >= end) return to;
    const local = (t - start) / (end - start);
    return from + (to - from) * ease(local);
  };
}

// ── Timeline context ────────────────────────────────────────────────────────

const TimelineContext = React.createContext({
  time: 0,
  duration: 10,
  playing: false
});
const useTime = () => React.useContext(TimelineContext).time;
const useTimeline = () => React.useContext(TimelineContext);

// How long a marked (detail.playing === true) host seek keeps the
// external-playback latch alive with no successor. The host play bar's
// seek pump is one-in-flight/latest-wins, so its inter-seek gap is tens
// of milliseconds in the worst case — 400ms is far above that, so a
// marked stream that dies mid-play decays the latch promptly.
var SS_EXT_PLAY_MS = 400;

// ── Font inlining ───────────────────────────────────────────────────────────
// Copy every @font-face rule from the page into a <style> inside the svg's
// foreignObject, with font URLs rewritten to data: URLs. Makes the svg
// self-describing so serializing it alone (video export fast path) still
// renders with the right fonts. Sets data-om-fonts-inlined on the svg when
// done so the exporter can wait for it.

function useInlineFontsInto(svgRef) {
  React.useEffect(() => {
    const svg = svgRef.current;
    const host = svg && svg.querySelector('foreignObject > div');
    if (!svg || !host) return;
    let cancelled = false;
    (async () => {
      const rules = [];
      for (const ss of document.styleSheets) {
        let cssRules;
        try {
          cssRules = ss.cssRules;
        } catch {
          // Cross-origin sheet without crossorigin attr (e.g. the standard
          // fonts.googleapis.com <link>) — fetch the CSS text directly and
          // regex-extract the @font-face blocks.
          if (ss.href) {
            try {
              const txt = await fetch(ss.href).then(r => {
                if (!r.ok) throw 0;
                return r.text();
              });
              for (const ff of txt.match(/@font-face\s*{[^}]*}/g) || []) rules.push({
                css: ff,
                base: ss.href
              });
            } catch {}
          }
          continue;
        }
        if (!cssRules) continue;
        for (const r of cssRules) {
          if (r.type === CSSRule.FONT_FACE_RULE) {
            rules.push({
              css: r.cssText,
              base: ss.href || location.href
            });
          }
        }
      }
      const toDataURL = url => fetch(url).then(r => {
        if (!r.ok) throw 0;
        return r.blob();
      }).then(b => new Promise(res => {
        const fr = new FileReader();
        fr.onload = () => res(fr.result);
        fr.onerror = () => res(url);
        fr.readAsDataURL(b);
      })).catch(() => url);
      const parts = await Promise.all(rules.map(async ({
        css,
        base
      }) => {
        const re = /url\((['"]?)([^'")]+)\1\)/g;
        let out = css,
          m;
        while (m = re.exec(css)) {
          const u = m[2];
          if (u.startsWith('data:')) continue;
          let abs;
          try {
            abs = new URL(u, base).href;
          } catch {
            continue;
          }
          out = out.split(m[0]).join(`url("${await toDataURL(abs)}")`);
        }
        return out;
      }));
      if (cancelled || !parts.length) {
        svg.setAttribute('data-om-fonts-inlined', 'true');
        return;
      }
      const style = document.createElement('style');
      style.textContent = parts.join('\n');
      host.insertBefore(style, host.firstChild);
      svg.setAttribute('data-om-fonts-inlined', 'true');
    })();
    return () => {
      cancelled = true;
    };
  }, []);
}
function Stage({
  width = 1280,
  height = 720,
  duration = 10,
  background = '#f6f4ef',
  fps = 60,
  loop = true,
  autoplay = true,
  // Parsed playback object ({mode:'loop'} | {mode:'times',count:N}) or
  // null. When present it overrides the legacy loop prop — CompositionStage
  // passes the validated value from the OM_PLAYBACK authoring contract.
  playback = null,
  persistKey = 'animstage-v3',
  children
}) {
  // Props arrive as strings when Stage is mounted via <x-import> (DC
  // projects) — coerce so style={{width}} gets a number React can px-ify.
  width = +width || 1280;
  height = +height || 720;
  duration = +duration || 10;
  fps = +fps || 60;
  if (typeof loop === 'string') loop = loop !== 'false';
  if (typeof autoplay === 'string') autoplay = autoplay !== 'false';
  const playTimes = playback && playback.mode === 'times' ? playback.count : null;
  const loopEff = playback ? playback.mode === 'loop' : loop;
  const [time, setTime] = React.useState(() => {
    try {
      const v = parseFloat(localStorage.getItem(persistKey + ':t') || '0');
      return isFinite(v) ? clamp(v, 0, duration) : 0;
    } catch {
      return 0;
    }
  });
  const [playing, setPlaying] = React.useState(autoplay);
  // The external-playback latch: true while the HOST play bar is driving
  // time forward as genuine continuous playback (its play-loop seeks
  // carry detail.playing === true). The engine's own clock stays paused
  // the whole time — exactly one clock ever drives — so this is a
  // separate bit, not a second meaning for `playing`. Set and cleared
  // in the seek handler below; decays via SS_EXT_PLAY_MS when the
  // marked stream stops without a parting unmarked seek.
  const [extPlay, setExtPlay] = React.useState(false);
  const extPlayTimerRef = React.useRef(null);
  const [hoverTime, setHoverTime] = React.useState(null);
  const [scale, setScale] = React.useState(1);
  const stageRef = React.useRef(null);
  const canvasRef = React.useRef(null);
  const rafRef = React.useRef(null);
  const lastTsRef = React.useRef(null);

  // Persist playhead
  React.useEffect(() => {
    try {
      localStorage.setItem(persistKey + ':t', String(time));
    } catch {}
  }, [time, persistKey]);

  // Auto-scale to fit viewport
  React.useEffect(() => {
    if (!stageRef.current) return;
    const el = stageRef.current;
    const measure = () => {
      const barH = document.documentElement.classList.contains('embed') ? 0 : 44; // playback bar height (hidden when embedded)
      const s = Math.min(el.clientWidth / width, (el.clientHeight - barH) / height);
      setScale(Math.max(0.05, s));
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    window.addEventListener('resize', measure);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [width, height]);

  // Passes completed since playback last started. Lives in a ref so the
  // per-frame wrap can count without re-running this effect; reset on
  // every (re)start so a fresh play (or a host restart) gets the full
  // run count again.
  const passesRef = React.useRef(0);

  // Animation loop
  React.useEffect(() => {
    if (!playing) {
      lastTsRef.current = null;
      return;
    }
    passesRef.current = 0;
    const step = ts => {
      if (lastTsRef.current == null) lastTsRef.current = ts;
      const dt = (ts - lastTsRef.current) / 1000;
      lastTsRef.current = ts;
      setTime(t => {
        let next = t + dt;
        if (next >= duration) {
          if (playTimes !== null) {
            // Play N times then hold the last frame — the partial pass a
            // mid-timeline start produces counts as a pass, so the piece
            // never runs longer than N full durations.
            passesRef.current += 1;
            if (passesRef.current >= playTimes) {
              next = duration;
              setPlaying(false);
            } else {
              next = next % duration;
            }
          } else if (loopEff) {
            next = next % duration;
          } else {
            next = duration;
            setPlaying(false);
          }
        }
        return next;
      });
      rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      lastTsRef.current = null;
    };
  }, [playing, duration, loopEff, playTimes]);

  // Keyboard: space = play/pause, ← → = seek
  React.useEffect(() => {
    const onKey = e => {
      if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) return;
      if (e.code === 'Space') {
        e.preventDefault();
        setPlaying(p => !p);
      } else if (e.code === 'ArrowLeft') {
        setTime(t => clamp(t - (e.shiftKey ? 1 : 0.1), 0, duration));
      } else if (e.code === 'ArrowRight') {
        setTime(t => clamp(t + (e.shiftKey ? 1 : 0.1), 0, duration));
      } else if (e.key === '0' || e.code === 'Home') {
        setTime(0);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [duration]);

  // Video-export protocol + the editor's play bar: hosts dispatch this
  // event per frame; pause + sync the playhead so the frame shows exactly
  // that timestamp. The host play bar marks its play-loop seeks with
  // detail.playing === true — the mark latches extPlay (playback is
  // playback even when a host clock drives it), while ANY unmarked seek
  // (scrub, step, export frame, the transport's pause park) clears the
  // latch in the same commit it retimes, so a seeked frame still renders
  // exactly one scene's state. The engine's own clock pauses either way.
  React.useEffect(() => {
    const el = canvasRef.current;
    if (!el) return;
    // Sync-seek capability: a dispatcher that marks its seek with
    // detail.sync === true gets the commit applied via ReactDOM.flushSync,
    // so the stage DOM reflects the seeked frame the moment dispatchEvent
    // returns. The video exporter keys off the data-om-sync-seek
    // advertisement to drop its two-display-refresh settle (that wait only
    // exists to let React's async commit land — serialization needs the
    // committed DOM, not the paint). Feature-detected: a runtime without
    // ReactDOM.flushSync never advertises and every seek takes the async
    // path. Unmarked seeks (scrubs, the host play bar) stay async — a
    // forced sync render per pointermove would tax the editor for no one.
    const canSyncSeek = typeof ReactDOM !== 'undefined' && typeof ReactDOM.flushSync === 'function';
    const onSeek = e => {
      const apply = () => {
        setPlaying(false);
        const hostPlay = !!(e.detail && e.detail.playing === true);
        if (extPlayTimerRef.current) {
          clearTimeout(extPlayTimerRef.current);
          extPlayTimerRef.current = null;
        }
        if (hostPlay) {
          // Watchdog: the latch is only as alive as its seek stream. If the
          // host stops without a parting seek (tab jank, bar unmount), the
          // latch decays on its own rather than stranding extPlaying true.
          extPlayTimerRef.current = setTimeout(() => {
            extPlayTimerRef.current = null;
            setExtPlay(false);
          }, SS_EXT_PLAY_MS);
        }
        setExtPlay(hostPlay);
        setTime(clamp(e.detail.time, 0, duration));
      };
      // flushSync is safe here: a native DOM listener runs outside React's
      // lifecycle, and the exporter's dispatchEvent is synchronous, so the
      // commit lands in the same JS task — the engine's own rAF loop can
      // never interleave between seek and serialize.
      if (canSyncSeek && e.detail && e.detail.sync === true) {
        ReactDOM.flushSync(apply);
      } else {
        apply();
      }
    };
    el.addEventListener('data-om-seek-to-time-frame', onSeek);
    if (canSyncSeek) el.setAttribute('data-om-sync-seek', 'true');
    return () => {
      el.removeEventListener('data-om-seek-to-time-frame', onSeek);
      el.removeAttribute('data-om-sync-seek');
      if (extPlayTimerRef.current) {
        clearTimeout(extPlayTimerRef.current);
        extPlayTimerRef.current = null;
      }
      // Drop the latch too: this cleanup runs on every duration change
      // (an agent edit can retime mid-host-play, no gesture involved) and
      // the new effect instance arms no watchdog — clearing only the
      // timer could strand extPlay true forever if the marked stream died
      // in the gap. Fail toward cut: the next marked seek re-latches.
      setExtPlay(false);
    };
  }, [duration]);

  // Inline @font-face rules into the svg's foreignObject so the svg is
  // self-describing — serializing it alone (for video export) then renders
  // with the right fonts. Sets data-om-fonts-inlined once done.
  useInlineFontsInto(canvasRef);
  const displayTime = hoverTime != null ? hoverTime : time;
  const ctxValue = React.useMemo(
  // extPlaying is ADDITIVE: "time is advancing under an external
  // driver's continuous playback". `playing` keeps meaning the
  // engine's OWN clock — the hidden PlaybackBar glyph (and through it
  // the host's clock-reporter/adoption channel) reads that — and
  // CompositionClock is the one consumer that widens to either.
  () => ({
    time: displayTime,
    duration,
    playing,
    extPlaying: extPlay,
    setTime,
    setPlaying
  }), [displayTime, duration, playing, extPlay]);
  return (
    /*#__PURE__*/
    // data-om-starter: inert presence marker — Claude Design's starter-usage
    // probe reads it; it renders nothing. Keep it on this root element.
    React.createElement("div", {
      ref: stageRef,
      "data-om-starter": "animations-v3",
      style: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: '#0a0a0a',
        fontFamily: 'Inter, system-ui, sans-serif'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        minHeight: 0
      }
    }, /*#__PURE__*/React.createElement("svg", {
      ref: canvasRef,
      width: width,
      height: height,
      "data-om-exportable-video-with-duration-secs": duration,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'center',
        flexShrink: 0,
        boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
        display: 'block'
      }
    }, /*#__PURE__*/React.createElement("foreignObject", {
      x: "0",
      y: "0",
      width: "100%",
      height: "100%"
    }, /*#__PURE__*/React.createElement("div", {
      xmlns: "http://www.w3.org/1999/xhtml",
      style: {
        width,
        height,
        background,
        position: 'relative',
        overflow: 'hidden'
      }
    }, /*#__PURE__*/React.createElement(TimelineContext.Provider, {
      value: ctxValue
    }, children))))), /*#__PURE__*/React.createElement(PlaybackBar, {
      time: displayTime,
      actualTime: time,
      duration: duration,
      playing: playing,
      onPlayPause: () => setPlaying(p => !p),
      onReset: () => {
        setTime(0);
      },
      onSeek: t => setTime(t),
      onHover: t => setHoverTime(t)
    }))
  );
}

// ── Playback bar ────────────────────────────────────────────────────────────
// Play/pause, return-to-begin, scrub track, time display.
// Uses fixed-width time fields so layout doesn't thrash.

function PlaybackBar({
  time,
  duration,
  playing,
  onPlayPause,
  onReset,
  onSeek,
  onHover
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  const timeFromEvent = React.useCallback(e => {
    const rect = trackRef.current.getBoundingClientRect();
    const x = clamp((e.clientX - rect.left) / rect.width, 0, 1);
    return x * duration;
  }, [duration]);
  const onTrackMove = e => {
    if (!trackRef.current) return;
    const t = timeFromEvent(e);
    if (dragging) {
      onSeek(t);
    } else {
      onHover(t);
    }
  };
  const onTrackLeave = () => {
    if (!dragging) onHover(null);
  };
  const onTrackDown = e => {
    setDragging(true);
    const t = timeFromEvent(e);
    onSeek(t);
    onHover(null);
  };
  React.useEffect(() => {
    if (!dragging) return;
    const onUp = () => setDragging(false);
    const onMove = e => {
      if (!trackRef.current) return;
      const t = timeFromEvent(e);
      onSeek(t);
    };
    window.addEventListener('mouseup', onUp);
    window.addEventListener('mousemove', onMove);
    return () => {
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('mousemove', onMove);
    };
  }, [dragging, timeFromEvent, onSeek]);
  const pct = duration > 0 ? time / duration * 100 : 0;
  const fmt = t => {
    const total = Math.max(0, t);
    const m = Math.floor(total / 60);
    const s = Math.floor(total % 60);
    const cs = Math.floor(total * 100 % 100);
    return `${String(m).padStart(1, '0')}:${String(s).padStart(2, '0')}.${String(cs).padStart(2, '0')}`;
  };
  const mono = 'JetBrains Mono, ui-monospace, SFMono-Regular, monospace';
  return /*#__PURE__*/React.createElement("div", {
    "data-omelette-chrome": true,
    style: {
      // Slimmed to visually match the host editor bar's basic row (the
      // single-scrubber look): transport first, tighter metrics, quieter
      // chrome. Shown only outside the app — the host bar suppresses this
      // whenever it is present.
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      padding: '6px 12px',
      background: 'rgba(20,20,20,0.92)',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      width: '100%',
      maxWidth: 680,
      alignSelf: 'center',
      borderRadius: 6,
      color: '#f6f4ef',
      fontFamily: 'Inter, system-ui, sans-serif',
      userSelect: 'none',
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onPlayPause,
    title: "Play/pause (space)"
  }, playing ? /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "2",
    width: "3",
    height: "10",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8",
    y: "2",
    width: "3",
    height: "10",
    fill: "currentColor"
  })) : /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 2l9 5-9 5V2z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement(IconButton, {
    onClick: onReset,
    title: "Return to start (0)"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 2v10M12 2L5 7l7 5V2z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: mono,
      fontSize: 12,
      fontVariantNumeric: 'tabular-nums',
      width: 64,
      textAlign: 'right',
      color: '#f6f4ef'
    }
  }, fmt(time)), /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    onMouseMove: onTrackMove,
    onMouseLeave: onTrackLeave,
    onMouseDown: onTrackDown,
    style: {
      flex: 1,
      height: 22,
      position: 'relative',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 4,
      background: 'rgba(255,255,255,0.12)',
      borderRadius: 2
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      width: `${pct}%`,
      height: 4,
      background: 'oklch(72% 0.12 250)',
      borderRadius: 2
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: `${pct}%`,
      top: '50%',
      width: 12,
      height: 12,
      marginLeft: -6,
      marginTop: -6,
      background: '#fff',
      borderRadius: 6,
      boxShadow: '0 2px 4px rgba(0,0,0,0.4)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: mono,
      fontSize: 12,
      fontVariantNumeric: 'tabular-nums',
      width: 64,
      textAlign: 'left',
      color: 'rgba(246,244,239,0.55)'
    }
  }, fmt(duration)), typeof VideoEncoder !== 'undefined' && /*#__PURE__*/React.createElement(IconButton, {
    title: "Export video",
    onClick: () => window.parent.postMessage({
      type: 'omelette:request-video-export'
    }, '*')
  }, /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 2v7m0 0L4 6m3 3l3-3M2 12h10",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
function IconButton({
  children,
  onClick,
  title
}) {
  const [hover, setHover] = React.useState(false);
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    title: title,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      width: 24,
      height: 24,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: hover ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.04)',
      border: '1px solid rgba(255,255,255,0.1)',
      borderRadius: 5,
      color: '#f6f4ef',
      cursor: 'pointer',
      padding: 0,
      transition: 'background 120ms'
    }
  }, children);
}

// ── Scene-list plumbing ──────────────────────────────────────────────────
// Guest-side validation of a scene list (the engine's own inputs: the
// authored prop, and host-dispatched updates). Mirrors the host parser's
// shape rules and constants — keep in sync with parseTimelineScenes in
// apps/web/src/shared/timeline.ts (16KB raw cap, 50 entries, dur finite in
// (0, 300]); returns null on any violation.
function ssParse(raw) {
  if (typeof raw !== 'string' || !raw || raw.length > 16 * 1024) return null;
  var parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (e) {
    return null;
  }
  if (!Array.isArray(parsed) || parsed.length === 0 || parsed.length > 50) return null;
  for (var i = 0; i < parsed.length; i++) {
    var s = parsed[i];
    if (typeof s !== 'object' || s === null) return null;
    if (typeof s.name !== 'string' || typeof s.dur !== 'number') return null;
    if (!isFinite(s.dur) || s.dur <= 0 || s.dur > 300) return null;
  }
  return parsed;
}

// Guest-side validation of the playback value — mirrors the host parser
// (shared/timeline.ts parseTimelinePlayback): {"mode":"loop"} or
// {"mode":"times","count":1..99}, strict all-or-nothing, null otherwise.
// Callers treat null as the loop default.
function ppParse(raw) {
  if (typeof raw !== 'string' || !raw || raw.length > 256) return null;
  var parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (e) {
    return null;
  }
  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return null;
  var keys = Object.keys(parsed);
  if (parsed.mode === 'loop') return keys.length === 1 ? {
    mode: 'loop'
  } : null;
  if (parsed.mode === 'times') {
    if (keys.length !== 2) return null;
    var c = parsed.count;
    if (typeof c !== 'number' || c !== Math.floor(c) || c < 1 || c > 99) return null;
    return {
      mode: 'times',
      count: c
    };
  }
  return null;
}

// Stamps the playback attribute VERBATIM from the authored raw string (the
// host's write-back anchors on that exact value) and listens for the
// host's post-write update event. Same shape as SceneSync; only rendered
// when the document authors a playback literal — an absent contract means
// the attribute stays absent and the document plays its default.
function PlaybackSync(props) {
  var ref = React.useRef(null);
  var raw = props.raw;
  var onUpdate = props.onUpdate;
  React.useEffect(function () {
    var el = ref.current;
    if (!el) return;
    var root = el.closest('[data-om-exportable-video-with-duration-secs]');
    if (!root) return;
    root.setAttribute('data-om-timeline-playback', raw);
    var onEvent = function (e) {
      var next = e && e.detail;
      if (ppParse(next)) onUpdate(next);
    };
    root.addEventListener('data-om-timeline-playback-update', onEvent);
    return function () {
      root.removeEventListener('data-om-timeline-playback-update', onEvent);
      root.removeAttribute('data-om-timeline-playback');
    };
  }, [raw, onUpdate]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      display: 'none'
    }
  });
}

// Renders inside the Stage (so it can reach the exportable root via
// closest()): stamps the scenes attribute VERBATIM from the current raw
// string — the host's write-back anchors on that exact value — and listens
// for the host's post-write update event.
function SceneSync(props) {
  var ref = React.useRef(null);
  var raw = props.raw;
  var onUpdate = props.onUpdate;
  React.useEffect(function () {
    var el = ref.current;
    if (!el) return;
    var root = el.closest('[data-om-exportable-video-with-duration-secs]');
    if (!root) return;
    root.setAttribute('data-om-timeline-scenes', raw);
    var onEvent = function (e) {
      var next = e && e.detail;
      // Ignore anything that doesn't validate — a bad update must not tear
      // down a working composition.
      if (ssParse(next)) onUpdate(next);
    };
    root.addEventListener('data-om-timeline-scenes-update', onEvent);
    return function () {
      root.removeEventListener('data-om-timeline-scenes-update', onEvent);
      root.removeAttribute('data-om-timeline-scenes');
    };
  }, [raw, onUpdate]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      display: 'none'
    }
  });
}

// ── Continuous composition ──────────────────────────────────────────────

var CompositionContext = React.createContext(null);
function useComposition() {
  var ctx = React.useContext(CompositionContext);
  if (!ctx) throw new Error('useComposition() must be called inside <CompositionStage>');
  return ctx;
}
function ccDerive(scenes) {
  var playStart = 0;
  var authStart = 0;
  var sections = [];
  var table = Object.create(null);
  for (var i = 0; i < scenes.length; i++) {
    var s = scenes[i];
    var nat = typeof s.nat === 'number' && isFinite(s.nat) && s.nat > 0 ? s.nat : s.dur;
    sections.push({
      name: s.name,
      playStart: playStart,
      dur: s.dur,
      authStart: authStart,
      nat: nat
    });
    if (!Object.prototype.hasOwnProperty.call(table, s.name)) {
      table[s.name] = Math.round(authStart * 1000) / 1000;
    }
    playStart += s.dur;
    authStart += nat;
  }
  return {
    sections: sections,
    table: table,
    total: Math.round(playStart * 1000) / 1000,
    authoredTotal: Math.round(authStart * 1000) / 1000
  };
}
function ccWarp(d, t) {
  var ss = d.sections;
  if (ss.length === 0) return 0;
  var idx = ss.length - 1;
  for (var i = 0; i < ss.length; i++) {
    if (t < ss[i].playStart + ss[i].dur) {
      idx = i;
      break;
    }
  }
  var s = ss[idx];
  var local = Math.min(Math.max(t - s.playStart, 0), s.dur);
  var T = s.authStart + (s.dur > 0 ? local * (s.nat / s.dur) : 0);
  return Math.min(T, d.authoredTotal);
}
var CC_META = Object.assign(Object.create(null), {
  toString: 1,
  toLocaleString: 1,
  valueOf: 1,
  toJSON: 1,
  then: 1,
  constructor: 1,
  hasOwnProperty: 1,
  isPrototypeOf: 1,
  propertyIsEnumerable: 1,
  default: 1
});
function ccCueProxy(table, unknownRef) {
  if (typeof Proxy !== 'function') return table;
  return new Proxy(table, {
    get: function (target, prop) {
      if (typeof prop !== 'string' || prop in target) return target[prop];
      if (CC_META[prop] || prop.indexOf('@@') === 0) return Object.prototype[prop];
      unknownRef.current[prop] = true;
      return NaN;
    }
  });
}
function CcUnknownWatch(props) {
  var tl = useTimeline();
  React.useEffect(function () {
    var next = Object.keys(props.unknownRef.current).sort().join(', ');
    if (next !== props.badge) props.setBadge(next);
  }, [tl.time]);
  return null;
}
function CompositionClock(props) {
  var tl = useTimeline();
  var d = props.derived;
  var T = ccWarp(d, tl.time);
  var value = React.useMemo(function () {
    return {
      T: T,
      CUES: props.cues,
      time: tl.time,
      duration: tl.duration,
      authoredTotal: d.authoredTotal,
      playing: tl.playing || tl.extPlaying === true
    };
  }, [T, props.cues, tl.time, tl.duration, d, tl.playing, tl.extPlaying]);
  return /*#__PURE__*/React.createElement(CompositionContext.Provider, {
    value: value
  }, props.children);
}
function Shot(props) {
  var c = useComposition();
  var from = +props.from;
  var to = props.to == null ? Infinity : +props.to;
  var on = isFinite(from) && c.T >= from && c.T < to;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      visibility: on ? 'visible' : 'hidden'
    }
  }, props.children);
}
var CAPTION_FADE = 0.18;
function Captions(props) {
  var c = useComposition();
  var t = c.T;
  var items = (props.items || []).filter(function (it) {
    return it && isFinite(+it.at);
  }).sort(function (a, b) {
    return a.at - b.at;
  });
  var active = null;
  var end = Infinity;
  for (var i = 0; i < items.length; i++) {
    if (t < items[i].at) break;
    active = items[i];
    end = typeof active.until === 'number' && isFinite(active.until) ? active.until : i + 1 < items.length ? items[i + 1].at : Infinity;
  }
  if (!active || t >= end) return null;
  var o = Math.min(1, (t - active.at) / CAPTION_FADE);
  if (isFinite(end)) o = Math.min(o, (end - t) / CAPTION_FADE);
  o = Math.max(0, Math.min(1, o));
  return /*#__PURE__*/React.createElement("div", {
    "data-om-caption": true,
    style: Object.assign({
      position: 'absolute',
      left: '8%',
      right: '8%',
      bottom: '7%',
      textAlign: 'center',
      opacity: o,
      pointerEvents: 'none',
      font: '500 30px Inter, system-ui, sans-serif',
      color: '#f6f4ef',
      textShadow: '0 1px 14px rgba(0,0,0,0.45)'
    }, props.style)
  }, active.text);
}
function CompositionStage(props) {
  var width = +props.width || 1280;
  var height = +props.height || 720;
  var bg = props.bg || '#0b0b0e';
  var autoplay = props.autoplay == null ? true : String(props.autoplay) !== 'false';
  var loop = props.loop == null ? true : String(props.loop) !== 'false';
  var state = React.useState(props.scenes);
  var raw = state[0];
  var setRaw = state[1];
  var scenes = React.useMemo(function () {
    return ssParse(raw);
  }, [raw]);
  var pstate = React.useState(props.playback);
  var praw = pstate[0];
  var setPraw = pstate[1];
  var pb = React.useMemo(function () {
    return ppParse(praw);
  }, [praw]);
  var unknownRef = React.useRef({});
  var badgeState = React.useState('');
  var badge = badgeState[0];
  var setBadge = badgeState[1];
  var derived = React.useMemo(function () {
    unknownRef.current = {};
    return scenes ? ccDerive(scenes) : null;
  }, [scenes]);
  var cues = React.useMemo(function () {
    return derived ? ccCueProxy(derived.table, unknownRef) : null;
  }, [derived]);
  React.useEffect(function () {
    var next = Object.keys(unknownRef.current).sort().join(', ');
    if (next !== badge) setBadge(next);
  });
  if (!scenes) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0b0b0e',
        color: '#c96442',
        font: '500 16px Inter, system-ui, sans-serif',
        textAlign: 'center'
      }
    }, "animations-v3: the scenes prop isn't a valid JSON scene list", /*#__PURE__*/React.createElement("br", null), "(expected '[", '{', "\"name\":\"\u2026\",\"dur\":N", '}', ", \u2026]')");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stage, {
    width: width,
    height: height,
    duration: derived.total,
    background: bg,
    autoplay: autoplay,
    loop: loop,
    playback: pb
  }, /*#__PURE__*/React.createElement(SceneSync, {
    raw: raw,
    onUpdate: setRaw
  }), typeof praw === 'string' && praw !== '' && /*#__PURE__*/React.createElement(PlaybackSync, {
    raw: praw,
    onUpdate: setPraw
  }), /*#__PURE__*/React.createElement(CompositionClock, {
    derived: derived,
    cues: cues
  }, props.children), /*#__PURE__*/React.createElement(CcUnknownWatch, {
    unknownRef: unknownRef,
    badge: badge,
    setBadge: setBadge
  })), badge !== '' &&
  /*#__PURE__*/
  // Sibling of Stage, outside the exportable <svg>: visible in the
  // preview (and its screenshots), never in the exported video.
  React.createElement("div", {
    "data-om-unknown-cues": true,
    style: {
      position: 'absolute',
      left: 12,
      bottom: 56,
      zIndex: 10,
      padding: '6px 10px',
      borderRadius: 6,
      background: 'rgba(0,0,0,0.72)',
      color: '#e8906a',
      font: '500 12px Inter, system-ui, sans-serif',
      pointerEvents: 'none'
    }
  }, "choreography references unknown section", badge.indexOf(',') >= 0 ? 's' : '', ": ", badge));
}

// Strokes as layers: paint multiplies, so stroke images stacked with
// mix-blend-mode:multiply over the paper reproduce the flat render.

var WC_PIXEL_CAP = 11000000;
function wcLayerOpts(props) {
  var w = +props.width || 900,
    h = +props.height || 1200;
  var askScale = +props.scale || 1;
  return {
    width: w,
    height: h,
    scale: Math.min(askScale, Math.sqrt(WC_PIXEL_CAP / (w * h))),
    seed: props.seed == null ? undefined : +props.seed,
    quality: props.quality == null ? undefined : +props.quality
  };
}
var wcWarned = {};
function wcWarnOnce(key, message, err) {
  if (wcWarned[key]) return;
  wcWarned[key] = true;
  console.warn(message, err);
}
function useWatercolorLayers(painting, opts) {
  var kit = window.WatercolorKit;
  if (typeof painting !== 'function' || !kit || typeof kit.layers !== 'function') return null;
  try {
    return kit.layers(painting, wcLayerOpts(opts || {}));
  } catch (e) {
    wcWarnOnce('layers:' + e, 'watercolor painting failed to build; rendering the fallback sheet', e);
    return null;
  }
}
var WatercolorSheetContext = React.createContext(null);
function WatercolorSheet(props) {
  var L = props.layers || null;
  var style = Object.assign({
    position: 'relative',
    display: 'block',
    width: '100%',
    aspectRatio: L ? L.width + ' / ' + L.height : '3 / 4',
    isolation: 'isolate',
    overflow: 'hidden'
  }, props.style);
  if (!L) {
    return /*#__PURE__*/React.createElement("div", {
      style: Object.assign(style, {
        background: '#f4f1e8',
        color: '#8a8270',
        font: '12px system-ui, sans-serif',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      })
    }, "watercolor-kit.js not loaded (or the painting failed to build)");
  }
  return /*#__PURE__*/React.createElement(WatercolorSheetContext.Provider, {
    value: L
  }, /*#__PURE__*/React.createElement("div", {
    style: style,
    "data-om-watercolor-sheet": true
  }, /*#__PURE__*/React.createElement("img", {
    src: L.paper,
    alt: props.alt || '',
    style: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      display: 'block'
    }
  }), props.children));
}
function WatercolorStroke(props) {
  var fromSheet = React.useContext(WatercolorSheetContext);
  var L = props.layers || fromSheet;
  if (!L) return null;
  var i = +props.index;
  if (!(i >= 0) || i >= L.count) return null;
  var at = props.at == null ? 1 : clamp(+props.at, 0, 1);
  if (!(at > 0)) return null;
  var box, src;
  try {
    box = L.box(i);
    src = box ? L.src(i, at) : null;
  } catch (e) {
    wcWarnOnce('stroke:' + i + ':' + e, 'watercolor stroke ' + i + ' failed to render; skipping it', e);
    return null;
  }
  if (!box || !src) return null;
  var style = Object.assign({
    position: 'absolute',
    display: 'block',
    left: box.x * 100 + '%',
    top: box.y * 100 + '%',
    width: box.w * 100 + '%',
    height: box.h * 100 + '%',
    mixBlendMode: L.kind(i) === 'reserve' ? 'normal' : 'multiply',
    pointerEvents: 'none'
  }, props.style);
  return /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: "",
    "data-om-watercolor-stroke": i,
    "data-om-stroke-kind": L.kind(i),
    style: style
  });
}

// The default watercolor moment: the painting assembled from its strokes,
// each appearing in painting order (a pure function of T).
function WatercolorPainting(props) {
  var c = useComposition();
  var from = +props.from || 0;
  var to = props.to == null ? from + 6 : +props.to;
  var u = clamp((c.T - from) / Math.max(to - from, 0.001), 0, 1);
  var eased = Easing.easeInOutQuad(u);
  var L = useWatercolorLayers(props.painting, props);
  var tick = React.useState(0)[1];
  var warmed = React.useRef(null);
  React.useEffect(function () {
    if (!L || typeof L.warm !== 'function') return;
    var p = L.warm();
    if (warmed.current === p) return;
    var live = true;
    p.then(function () {
      warmed.current = p;
      if (live) tick(function (x) {
        return x + 1;
      });
    });
    return function () {
      live = false;
    };
  }, [L && L.paper, props.painting]);
  var strokes = [];
  if (L) {
    for (var i = 0; i < L.count; i++) {
      var sp = L.span(i);
      var at = clamp((eased - sp.from) / Math.max(sp.to - sp.from, 1e-6), 0, 1);
      if (at <= 0) break;
      strokes.push(/*#__PURE__*/React.createElement(WatercolorStroke, {
        key: i,
        layers: L,
        index: i,
        at: at
      }));
    }
  }
  return /*#__PURE__*/React.createElement(WatercolorSheet, {
    layers: L,
    style: props.style,
    alt: props.alt
  }, strokes);
}

// Paint-on watercolor reveal as a pure function of T — an <img> with a data:
// URL (the exporter serializes those as-is; a live canvas would export blank).
function WatercolorReveal(props) {
  var c = useComposition();
  var from = +props.from || 0;
  var to = props.to == null ? from + 6 : +props.to;
  var u = clamp((c.T - from) / Math.max(to - from, 0.001), 0, 1);
  var style = Object.assign({
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  }, props.style);
  var frames = Array.isArray(props.frames) && props.frames.length ? props.frames : null;
  var steps = frames ? frames.length - 1 : Math.max(1, Math.round(+props.steps || 36));
  var i = Math.min(steps, Math.round(Easing.easeInOutQuad(u) * steps));
  var painting = typeof props.painting === 'function' ? props.painting : null;
  var kit = window.WatercolorKit;
  var w = +props.width || 900,
    h = +props.height || 1200;
  var askScale = +props.scale || Math.min(2, window.devicePixelRatio || 1);
  var opts = {
    width: w,
    height: h,
    scale: Math.min(askScale, Math.sqrt(11000000 / (w * h))),
    seed: props.seed == null ? undefined : +props.seed,
    steps: steps,
    type: props.format || 'image/jpeg',
    quality: props.quality == null ? 0.88 : +props.quality
  };
  var key = opts.width + 'x' + opts.height + '#' + opts.seed + '@' + opts.scale + '/' + steps + ':' + opts.type + '/' + opts.quality;
  var cache = React.useRef({
    fn: null,
    key: '',
    frames: {},
    baking: false
  }).current;
  var tick = React.useState(0)[1];
  if (cache.fn !== painting && String(cache.fn) !== String(painting) || cache.key !== key) {
    cache.key = key;
    cache.frames = {};
    cache.baking = false;
  }
  cache.fn = painting;
  React.useEffect(function () {
    if (frames || cache.baking || !painting || !kit || typeof kit.bake !== 'function') return;
    cache.baking = true;
    var target = cache.frames;
    try {
      kit.bake(painting, opts, function (n, _t, url) {
        target[n] = url;
      }).then(function (all) {
        if (cache.frames !== target) return;
        for (var n = 0; n < all.length; n++) target[n] = all[n];
        tick(function (x) {
          return x + 1;
        });
      }).catch(function () {
        /* failed bake: the guarded lazy path below still renders */
      });
    } catch (e) {
      /* oversized painting: the guarded lazy path below still renders */
    }
  });
  if (frames) return /*#__PURE__*/React.createElement("img", {
    src: frames[i],
    alt: props.alt || '',
    style: style
  });
  if (!kit || !painting) {
    return /*#__PURE__*/React.createElement("div", {
      style: Object.assign({
        width: '100%',
        height: '100%',
        background: '#f4f1e8',
        color: '#8a8270',
        font: '12px system-ui, sans-serif',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }, props.style)
    }, "watercolor-kit.js not loaded (or no painting function)");
  }
  if (!cache.frames[i]) {
    try {
      cache.frames[i] = kit.frame(painting, Object.assign({}, opts, {
        at: i / steps
      }));
    } catch (e) {
      return /*#__PURE__*/React.createElement("div", {
        style: Object.assign({
          width: '100%',
          height: '100%',
          background: '#f4f1e8',
          color: '#8a8270',
          font: '12px system-ui, sans-serif',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }, props.style)
      }, "painting too large to render (", String(e && e.message).slice(0, 80), ")");
    }
  }
  return /*#__PURE__*/React.createElement("img", {
    src: cache.frames[i],
    alt: props.alt || '',
    style: style
  });
}
Object.assign(window, {
  Easing,
  interpolate,
  animate,
  clamp,
  TimelineContext,
  useTime,
  useTimeline,
  Stage,
  PlaybackBar,
  CompositionStage,
  useComposition,
  Shot,
  Captions,
  WatercolorReveal,
  WatercolorPainting,
  WatercolorSheet,
  WatercolorStroke,
  useWatercolorLayers
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/hero/animations-v3.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/hero/tweaks-panel.jsx
try { (() => {
// @ds-adherence-ignore -- omelette starter scaffold (raw elements/hex/px by design)
// Copied omelette starter. Re-running copy_starter_component with this kind overwrites this file with the latest version (page content is unaffected).

/* BEGIN USAGE */
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
// Exports (to window): useTweaks, TweaksPanel, TweakSection, TweakRow, TweakSlider,
//   TweakToggle, TweakRadio, TweakSelect, TweakText, TweakNumber, TweakColor, TweakButton.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// TweakRadio is the segmented control for 2–3 short options (auto-falls-back to
// TweakSelect past ~16/~10 chars per label); reach for TweakSelect directly when
// options are many or long. For color tweaks always curate 3-4 options rather than
// a free picker; an option can also be a whole 2–5 color palette (the stored value
// is the array). The Tweak* controls are a floor, not a ceiling — build custom
// controls inside the panel if a tweak calls for UI they don't cover.
/* END USAGE */
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({
  title = 'Tweaks',
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };

  // data-om-starter: inert presence marker — Claude Design's starter-usage
  // probe reads it. The closed panel renders nothing, so the marker rides
  // the <html> element as an attribute instead of a rendered node — zero
  // elements added, so page CSS (even structural selectors like
  // :nth-child) can never observe it. It records that the page WIRES a
  // tweaks panel, whether or not the panel is open. Keep this effect.
  React.useEffect(() => {
    document.documentElement.setAttribute('data-om-starter', 'tweaks-panel');
    return () => document.documentElement.removeAttribute('data-om-starter');
  }, []);
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, __TWEAKS_STYLE), /*#__PURE__*/React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-omelette-chrome": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "twk-body"
  }, children)));
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label), value != null && /*#__PURE__*/React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-row twk-row-h"
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, /*#__PURE__*/React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return /*#__PURE__*/React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-num"
  }, /*#__PURE__*/React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && /*#__PURE__*/React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "twk-row twk-row-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "twk-lbl"
    }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && /*#__PURE__*/React.createElement("span", null, sup.map((c, j) => /*#__PURE__*/React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && /*#__PURE__*/React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/hero/tweaks-panel.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/tweaks-panel.jsx
try { (() => {
// @ds-adherence-ignore -- omelette starter scaffold (raw elements/hex/px by design)
// Copied omelette starter. Re-running copy_starter_component with this kind overwrites this file with the latest version (page content is unaffected).

/* BEGIN USAGE */
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
// Exports (to window): useTweaks, TweaksPanel, TweakSection, TweakRow, TweakSlider,
//   TweakToggle, TweakRadio, TweakSelect, TweakText, TweakNumber, TweakColor, TweakButton.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// TweakRadio is the segmented control for 2–3 short options (auto-falls-back to
// TweakSelect past ~16/~10 chars per label); reach for TweakSelect directly when
// options are many or long. For color tweaks always curate 3-4 options rather than
// a free picker; an option can also be a whole 2–5 color palette (the stored value
// is the array). The Tweak* controls are a floor, not a ceiling — build custom
// controls inside the panel if a tweak calls for UI they don't cover.
/* END USAGE */
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({
  title = 'Tweaks',
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };

  // data-om-starter: inert presence marker — Claude Design's starter-usage
  // probe reads it. The closed panel renders nothing, so the marker rides
  // the <html> element as an attribute instead of a rendered node — zero
  // elements added, so page CSS (even structural selectors like
  // :nth-child) can never observe it. It records that the page WIRES a
  // tweaks panel, whether or not the panel is open. Keep this effect.
  React.useEffect(() => {
    document.documentElement.setAttribute('data-om-starter', 'tweaks-panel');
    return () => document.documentElement.removeAttribute('data-om-starter');
  }, []);
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, __TWEAKS_STYLE), /*#__PURE__*/React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-omelette-chrome": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "twk-body"
  }, children)));
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label), value != null && /*#__PURE__*/React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-row twk-row-h"
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, /*#__PURE__*/React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return /*#__PURE__*/React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-num"
  }, /*#__PURE__*/React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && /*#__PURE__*/React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "twk-row twk-row-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "twk-lbl"
    }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && /*#__PURE__*/React.createElement("span", null, sup.map((c, j) => /*#__PURE__*/React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && /*#__PURE__*/React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/tweaks-panel.jsx", error: String((e && e.message) || e) }); }

__ds_ns.ArtworkCard = __ds_scope.ArtworkCard;

__ds_ns.CartDrawer = __ds_scope.CartDrawer;

__ds_ns.PersonalisationStepper = __ds_scope.PersonalisationStepper;

__ds_ns.PriceOptionsPanel = __ds_scope.PriceOptionsPanel;

__ds_ns.ProductCard = __ds_scope.ProductCard;

__ds_ns.StickyProductCTA = __ds_scope.StickyProductCTA;

__ds_ns.Badge = __ds_scope.Badge;

__ds_ns.BrushRule = __ds_scope.BrushRule;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Eyebrow = __ds_scope.Eyebrow;

__ds_ns.Icon = __ds_scope.Icon;

__ds_ns.IconButton = __ds_scope.IconButton;

__ds_ns.OneWordmark = __ds_scope.OneWordmark;

__ds_ns.Tag = __ds_scope.Tag;

__ds_ns.TextLink = __ds_scope.TextLink;

__ds_ns.TRANSFORMATIONS = __ds_scope.TRANSFORMATIONS;

__ds_ns.B2B_EXAMPLES = __ds_scope.B2B_EXAMPLES;

__ds_ns.BOOKS = __ds_scope.BOOKS;

__ds_ns.MOCKUPS = __ds_scope.MOCKUPS;

__ds_ns.ARTWORKS = __ds_scope.ARTWORKS;

__ds_ns.OBSIDIAN_WALL = __ds_scope.OBSIDIAN_WALL;

__ds_ns.LOGO_ROUNDEL = __ds_scope.LOGO_ROUNDEL;

__ds_ns.SIGNATURE = __ds_scope.SIGNATURE;

__ds_ns.REVIEWED = __ds_scope.REVIEWED;

__ds_ns.PRICING = __ds_scope.PRICING;

__ds_ns.FULFILMENT = __ds_scope.FULFILMENT;

__ds_ns.PHOTO_ALBUM = __ds_scope.PHOTO_ALBUM;

__ds_ns.ART_PRINTS = __ds_scope.ART_PRINTS;

__ds_ns.CASE_STUDIES = __ds_scope.CASE_STUDIES;

__ds_ns.SHOP_STATS = __ds_scope.SHOP_STATS;

__ds_ns.REVIEWS = __ds_scope.REVIEWS;

__ds_ns.AudienceSelector = __ds_scope.AudienceSelector;

__ds_ns.EditorialSplit = __ds_scope.EditorialSplit;

__ds_ns.FaqAccordion = __ds_scope.FaqAccordion;

__ds_ns.FounderFeature = __ds_scope.FounderFeature;

__ds_ns.FullBleedBanner = __ds_scope.FullBleedBanner;

__ds_ns.Hero = __ds_scope.Hero;

__ds_ns.HowItWorksTimeline = __ds_scope.HowItWorksTimeline;

__ds_ns.Manifesto = __ds_scope.Manifesto;

__ds_ns.TestimonialFeature = __ds_scope.TestimonialFeature;

__ds_ns.CookieNotice = __ds_scope.CookieNotice;

__ds_ns.EmptyState = __ds_scope.EmptyState;

__ds_ns.ErrorState = __ds_scope.ErrorState;

__ds_ns.MediaPlaceholder = __ds_scope.MediaPlaceholder;

__ds_ns.Skeleton = __ds_scope.Skeleton;

__ds_ns.Checkbox = __ds_scope.Checkbox;

__ds_ns.FormField = __ds_scope.FormField;

__ds_ns.Input = __ds_scope.Input;

__ds_ns.NewsletterForm = __ds_scope.NewsletterForm;

__ds_ns.Radio = __ds_scope.Radio;

__ds_ns.RadioCard = __ds_scope.RadioCard;

__ds_ns.Select = __ds_scope.Select;

__ds_ns.Textarea = __ds_scope.Textarea;

__ds_ns.AnnouncementBar = __ds_scope.AnnouncementBar;

__ds_ns.Footer = __ds_scope.Footer;

__ds_ns.Header = __ds_scope.Header;

__ds_ns.MobileNav = __ds_scope.MobileNav;

__ds_ns.BeforeAfterSlider = __ds_scope.BeforeAfterSlider;

__ds_ns.PhotoUploader = __ds_scope.PhotoUploader;

__ds_ns.TransformationTriptych = __ds_scope.TransformationTriptych;

})();
